const mapdata3 = [
  {
    "number": 2,
    "name": "강남하이퍼학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 강남대로92길 35 1층, 2층, 8층(역삼동)",
    "lat": "37.4995579",
    "lng": "127.0303052",
    "phoneNumber": "02-573-9001",
    "교습과정": "진학지도",
    "isFinish": ""
  },
  {
    "number": 3,
    "name": "강남삼육외국어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 학동로47길 15 , 3층, 4층 (논현동)",
    "lat": "37.5176824",
    "lng": "127.0384332",
    "phoneNumber": "02-512-3605",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 8,
    "name": "대림우등생학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 강남대로122길 26 , 3층 (논현동)",
    "lat": "37.508223",
    "lng": "127.025171",
    "phoneNumber": "02-3443-4597",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 11,
    "name": "중앙보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배로 211 , 3층 일부 (방배동)",
    "lat": "37.4919836",
    "lng": "126.9906036",
    "phoneNumber": "02-532-6292",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 13,
    "name": "동신보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 반포대로 93 , 2층 204호 (서초동, 해은빌딩)",
    "lat": "37.4884816",
    "lng": "127.0087965",
    "phoneNumber": "02-582-2248",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 15,
    "name": "엘브라운의대관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 165 , 5층 4~9호, 10호일부 (잠원동)",
    "lat": "37.5056721",
    "lng": "127.0019322",
    "phoneNumber": "02-593-0532",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 16,
    "name": "와이비엠어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 강남대로 408 , 5~8층 전체, 9층 901호 일부 (역삼동, YBM강남센터)",
    "lat": "37.499175",
    "lng": "127.0274801",
    "phoneNumber": "02-565-0509",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 23,
    "name": "남서울알리앙스프랑세즈어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 강남대로94길 27-15   2층 (역삼동)",
    "lat": "37.5006646",
    "lng": "127.0291099",
    "phoneNumber": "02-555-1125",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 25,
    "name": "스터디하우스잠원독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 서초구 잠원로8길 25    대림상가 4층 일부 (잠원동)",
    "lat": "37.5143551",
    "lng": "127.0116337",
    "phoneNumber": "02-591-2403",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 27,
    "name": "대치1관정상어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 영동대로 227 , 1층~3층 (대치동)",
    "lat": "37.4994104",
    "lng": "127.067582",
    "phoneNumber": "02-563-5946",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 28,
    "name": "피앤피아카데미(P&P Academy)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동광로 15 202호(방배동)",
    "lat": "37.4910525",
    "lng": "126.9845609",
    "phoneNumber": "02-534-5056",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 36,
    "name": "가나어학학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 신반포로 195  외5필지 반포쇼핑타운 제5동 5층 1호 2호 (잠원동)",
    "lat": "37.5065891",
    "lng": "127.0052661",
    "phoneNumber": "02-3478-0590",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 37,
    "name": "디와이비최선어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 남부순환로 2917 , 4층 (대치동,청실상가동)",
    "lat": "37.4931481",
    "lng": "127.0590766",
    "phoneNumber": "02-556-7094",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 38,
    "name": "페르마수학보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배로 90 4~5층(방배동)",
    "lat": "37.4825276",
    "lng": "126.9972852",
    "phoneNumber": "02-582-9996",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 39,
    "name": "비엠아이(BMI-Butterfly Math Institute)수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2936 , 406호 (대치동,대치동 507 제2종근린생활시설)",
    "lat": "37.4933573",
    "lng": "127.0619092",
    "phoneNumber": "02-555-5457",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 41,
    "name": "문예원글로피아보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 509 , 2층~4층 (대치동,문원빌딩)",
    "lat": "37.4995866",
    "lng": "127.0620542",
    "phoneNumber": "02-567-1038",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 44,
    "name": "아이캔보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배로43길 21 , 207호 (방배동,삼호아파트상가)",
    "lat": "37.4952076",
    "lng": "126.9871266",
    "phoneNumber": "02-591-8585",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 45,
    "name": "사관등용문진학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로64길 45   탐스코빌딩 5층 (대치동)",
    "lat": "37.500961",
    "lng": "127.0639352",
    "phoneNumber": "02-561-0465",
    "교습과정": "보통교과",
    "isFinish": ""
  },
  {
    "number": 46,
    "name": "신동아학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 효령로 164   신동아아파트 상가 202호 206호 207호 210호 211호 (방배동)",
    "lat": "37.4808701",
    "lng": "127.0009449",
    "phoneNumber": "02-584-7595",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 47,
    "name": "엔프렙학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로 108 , 3층 (신사동)",
    "lat": "37.5229191",
    "lng": "127.0205789",
    "phoneNumber": "02-546-7770",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 48,
    "name": "예일보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 사임당로 91 3층(서초동)",
    "lat": "37.4901381",
    "lng": "127.0198822",
    "phoneNumber": "02-3472-6637",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 49,
    "name": "해법수학해법영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 개포로22길 84 , 3층 (개포동)",
    "lat": "37.4747924",
    "lng": "127.0523316",
    "phoneNumber": "02-573-4787",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 50,
    "name": "다른학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 논현로175길 64   3층 (신사동)",
    "lat": "37.5242736",
    "lng": "127.0237639",
    "phoneNumber": "02-511-2948",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 51,
    "name": "지엘에스굿모닝영어영문학박사학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 344 , 3층 1호 (대치동)",
    "lat": "37.500753",
    "lng": "127.0746559",
    "phoneNumber": "02-563-3330",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 52,
    "name": "토탈에듀예일보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 영동대로57길 28 , 2층 203호 (대치동, 현대아파트상가동)",
    "lat": "37.4998959",
    "lng": "127.0652973",
    "phoneNumber": "02-555-6737",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 53,
    "name": "스터디플래닛대치2센터독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 삼성로58길 29 , 5층 (대치동)",
    "lat": "37.4992421",
    "lng": "127.0635885",
    "phoneNumber": "02-554-0919",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 54,
    "name": "준암보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배로26길 6 , 3층 (방배동)",
    "lat": "37.4889522",
    "lng": "126.9933621",
    "phoneNumber": "02-536-3653",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 56,
    "name": "수서정상어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 밤고개로 219 , 2층 205호~209호 (자곡동, 강남블루지움)",
    "lat": "37.4747226",
    "lng": "127.1070295",
    "phoneNumber": "02-445-6500",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 57,
    "name": "논현탑클래스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 학동로6길 51 , 2층 (논현동)",
    "lat": "37.5093446",
    "lng": "127.0266642",
    "phoneNumber": "02-514-7373",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 60,
    "name": "박정어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 서초중앙로20길 23 , 2층 전체 (서초동, 창원빌딩)",
    "lat": "37.492458",
    "lng": "127.0154455",
    "phoneNumber": "02-547-0509",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 61,
    "name": "정철어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 강남대로 456 , 4층 일부 (역삼동)",
    "lat": "37.5031806",
    "lng": "127.0256302",
    "phoneNumber": "02-555-0515",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 63,
    "name": "이씨씨대치어학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 역삼로 442 , 1층 일부, 2~3층 전체 (대치동)",
    "lat": "37.5018274",
    "lng": "127.0554252",
    "phoneNumber": "02-553-0509",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": "완료"
  },
  {
    "number": 65,
    "name": "역삼시사일본어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 테헤란로4길 28 , 2,4층 (역삼동,시사일본어사옥)",
    "lat": "37.4965132",
    "lng": "127.0300705",
    "phoneNumber": "02-555-1582",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 70,
    "name": "탑클래스독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 서초구 잠원로 204  한신상가 401호 402호 403호(잠원동)",
    "lat": "37.5192129",
    "lng": "127.0146576",
    "phoneNumber": "02-595-8657",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 76,
    "name": "(주)멘토르수학전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "",
    "학원주소\t": "서울특별시 강남구 남부순환로 2927 , 501호 일부(대치동, 대치 클래시아)",
    "lat": "37.4936595",
    "lng": "127.0603384",
    "phoneNumber": "02-564-5002",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 77,
    "name": "라이즈프리머스강남어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 도곡로37길 5 , 1층~5층 (역삼동)",
    "lat": "37.4941563",
    "lng": "127.0446536",
    "phoneNumber": "02-3453-2939",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 78,
    "name": "미래탐구세림1관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 422 , 5층 (대치동,세림빌딩)",
    "lat": "37.4972615",
    "lng": "127.0567378",
    "phoneNumber": "02-569-2183",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 79,
    "name": "행원독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 서초구 효령로2길 61  (방배동)",
    "lat": "37.4756846",
    "lng": "126.9897808",
    "phoneNumber": "02-521-9570",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 80,
    "name": "양재왕수학보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 바우뫼로7길 8   세신상가 5층 (우면동)",
    "lat": "37.4708489",
    "lng": "127.0253763",
    "phoneNumber": "02-576-4403",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 81,
    "name": "연세아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 바우뫼로7길 16  대화프라자 3층(우면동)",
    "lat": "37.4710863",
    "lng": "127.0250996",
    "phoneNumber": "02-573-6743",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 82,
    "name": "수이학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 영동대로57길 16 , 2층 (대치동)",
    "lat": "37.500019",
    "lng": "127.0661063",
    "phoneNumber": "02-562-8766",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 83,
    "name": "서초대광보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초대로65길 13-18 , 202호 및 203호 (서초동)",
    "lat": "37.4972735",
    "lng": "127.0184335",
    "phoneNumber": "02-591-0001",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 84,
    "name": "리드유(Leadu)영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로33길 7 , 6층 (반포동)",
    "lat": "37.501038",
    "lng": "127.0112258",
    "phoneNumber": "02-537-1333",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 85,
    "name": "강남에스엘피어학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 개포로 626 , 1층~4층 (일원동)",
    "lat": "37.4940137",
    "lng": "127.0813904",
    "phoneNumber": "02-445-4003",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 86,
    "name": "블루스카이학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 538 , 1층일부(101호), 2층~5층 (대치동, 블루스카이 보습학원)",
    "lat": "37.5038989",
    "lng": "127.0618841",
    "phoneNumber": "02-501-1631",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 87,
    "name": "영수전문지앤지학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 도구로 123-3   3층 1호 (방배동)",
    "lat": "37.4873749",
    "lng": "126.9858329",
    "phoneNumber": "02-595-5428",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 88,
    "name": "연세학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 415 2층(대치동)",
    "lat": "37.4975647",
    "lng": "127.0560022",
    "phoneNumber": "02-561-0097",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 89,
    "name": "한빛변리사학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "인문사회(대)",
    "학원주소\t": "서울특별시 강남구 논현로95길 29-14   한빛지적소유권센터 1층일부 2~6층 (역삼동)",
    "lat": "37.5011312",
    "lng": "127.0339046",
    "phoneNumber": "02-567-1657",
    "교습과정": "성인고시",
    "isFinish": ""
  },
  {
    "number": 90,
    "name": "수학전문강남수학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 일원로5길 51 , 2층 전체 (일원동)",
    "lat": "37.4922506",
    "lng": "127.0843017",
    "phoneNumber": "02-3411-0888",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 91,
    "name": "대은제이에스에이과학전문보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 42 , 2층 (개포동)",
    "lat": "37.4833383",
    "lng": "127.0601198",
    "phoneNumber": "02-571-2808",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 92,
    "name": "피에스에이서초어학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 효령로 388 , 1층~5층 (서초동)",
    "lat": "37.4875469",
    "lng": "127.0263602",
    "phoneNumber": "02-585-0509",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 94,
    "name": "강남대성학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 테헤란로4길 39 , 1층 일부,2~4층 (역삼동, 강남대성빌딩)",
    "lat": "37.4958611",
    "lng": "127.030904",
    "phoneNumber": "02-581-7888",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 95,
    "name": "헨리영어아이(i)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 반포대로 300 3층1호 일부 우측 (잠원동)",
    "lat": "37.505956",
    "lng": "127.0011819",
    "phoneNumber": "02-594-0505",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 96,
    "name": "개념폴리아방배관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초대로 39 , 2층, 3층 (방배동)",
    "lat": "37.4861454",
    "lng": "126.9866567",
    "phoneNumber": "02-592-0066",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 97,
    "name": "이소키즈클럽어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 동광로 95-2 , 1층~4층 전체 (방배동)",
    "lat": "37.4938209",
    "lng": "126.992953",
    "phoneNumber": "02-3476-3651",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 98,
    "name": "지혜의숲사고력보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로76길 14 , 1,2층전체 (대치동)",
    "lat": "37.5040153",
    "lng": "127.0595037",
    "phoneNumber": "02-508-0244",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 99,
    "name": "에스피이피(SPEP)어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 언주로 861 , 2층, 3층 (신사동)",
    "lat": "37.5274104999999",
    "lng": "127.0330945",
    "phoneNumber": "02-554-7762",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 102,
    "name": "경인학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 바우뫼로 91  경인프라자빌딩 402 403호일부 (양재동)",
    "lat": "37.4766176",
    "lng": "127.0294575",
    "phoneNumber": "02-575-6491",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 103,
    "name": "제이에스에치과학보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 504   대치빌딩 2층 (대치동)",
    "lat": "37.4988116",
    "lng": "127.0616425",
    "phoneNumber": "02-555-6924",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 105,
    "name": "엠코에듀학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동광로12가길 7 , 3층 (방배동)",
    "lat": "37.4873051",
    "lng": "126.9844973",
    "phoneNumber": "02-535-1107",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 106,
    "name": "하우스터디대치독서실",
    "학원종류": "평생직업교육학원",
    "분야구분": "",
    "학원주소\t": "서울특별시 강남구 삼성로51길 25 , 2층 (대치동, 대치SK-VIEW아파트)",
    "lat": "37.4957793",
    "lng": "127.060541",
    "phoneNumber": "02-554-4555",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 111,
    "name": "슈퍼멘토학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 일원로 41 , 3층 전체 (일원동)",
    "lat": "37.4902056",
    "lng": "127.081408",
    "phoneNumber": "02-3411-0582",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 112,
    "name": "미탐인학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 454 , 2층 (대치동, 알파마이티 대치빌딩)",
    "lat": "37.4982126",
    "lng": "127.0600967",
    "phoneNumber": "02-501-1776",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 113,
    "name": "선재보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 189 , 반포쇼핑타운4동 4층 5,6,7호 (잠원동)",
    "lat": "37.5064984",
    "lng": "127.0048372",
    "phoneNumber": "02-514-4636",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 116,
    "name": "스터디엔카페삼우독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 광평로31길 27 , 2층 206호일부·207호 (수서동, 삼성아파트)",
    "lat": "37.4848958",
    "lng": "127.0906778",
    "phoneNumber": "02-459-4024",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 117,
    "name": "해법수학교실대치학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 447 , 5층 (대치동,제일빌딩)",
    "lat": "37.4985572",
    "lng": "127.0593517",
    "phoneNumber": "02-6258-0031",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 118,
    "name": "정인보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 일원로 95 , 701호 일부 (일원동, 신영프라자)",
    "lat": "37.4856021",
    "lng": "127.0835726",
    "phoneNumber": "02-445-5777",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 119,
    "name": "수서엘리트독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 광평로 61   3층 (일원동)",
    "lat": "37.4828458",
    "lng": "127.0793538",
    "phoneNumber": "02-2226-9597",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 120,
    "name": "삼성탑독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 삼성로115길 45 , 4층 5층 (삼성동)",
    "lat": "37.513846",
    "lng": "127.0485817",
    "phoneNumber": "02-517-0420",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 122,
    "name": "생각하는수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 461 , 2층(대치동)",
    "lat": "37.503025",
    "lng": "127.0577849",
    "phoneNumber": "02-554-1978",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 123,
    "name": "수학과표현학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 38 , 406호 (개포동)",
    "lat": "37.4886736",
    "lng": "127.0668063",
    "phoneNumber": "02-459-8253",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 125,
    "name": "엘리트어학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 논현로168길 36 , 5층 (신사동)",
    "lat": "37.5232126999999",
    "lng": "127.0309526",
    "phoneNumber": "02-3444-6886",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 127,
    "name": "최강보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로29길 72-1  신사시장A동 3층-3호 (압구정동)",
    "lat": "37.5322509",
    "lng": "127.0283956",
    "phoneNumber": "02-543-1889",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 128,
    "name": "피엠지보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로 230   403호 404호 405호 (반포동)",
    "lat": "37.5022526",
    "lng": "127.0119876",
    "phoneNumber": "02-537-5858",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 129,
    "name": "솔로몬사고력영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 광평로10길 15 , 205호 (일원동,상록수아파트상가)",
    "lat": "37.482024",
    "lng": "127.0821324",
    "phoneNumber": "02-459-8855",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 130,
    "name": "반포한신보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로15길 29 , 3층 101호 (반포동,신반포상가)",
    "lat": "37.5054206",
    "lng": "126.9945515",
    "phoneNumber": "02-536-5001",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 132,
    "name": "다원수학2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로61길 16 1~2층(대치동)",
    "lat": "37.4992621",
    "lng": "127.0591244",
    "phoneNumber": "02-3454-0314",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 133,
    "name": "스카이학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 664  303동 304호(삼성동",
    "lat": "37.5158959",
    "lng": "127.0422861",
    "phoneNumber": "02-549-0582",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 134,
    "name": "상아학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 440 , 2층 전체 (대치동)",
    "lat": "37.4978753",
    "lng": "127.058633",
    "phoneNumber": "02-556-5869",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 135,
    "name": "한국스카이학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로63길 12 , 3층 304호, 305호 (대치동, 신농플라자)",
    "lat": "37.4978196",
    "lng": "127.0546022",
    "phoneNumber": "02-563-2518",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 136,
    "name": "피에스에이개포어학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 개포로 408 , 1층일부, 2층, 3층 (개포동,한국외국인학교)",
    "lat": "37.4851158",
    "lng": "127.0627405",
    "phoneNumber": "02-571-0509",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 137,
    "name": "청운보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 언주로167길 33-4 , 2층 (신사동)",
    "lat": "37.5260366",
    "lng": "127.0302465",
    "phoneNumber": "02-3443-1515",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 141,
    "name": "에스오티어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 서초중앙로31길 14-4 , 1층,2층 (반포동)",
    "lat": "37.4999292",
    "lng": "127.0108805",
    "phoneNumber": "02-594-0584",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 143,
    "name": "이찬이대학편입학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "인문사회(대)",
    "학원주소\t": "서울특별시 서초구 서초중앙로22길 53 , 2층202호, 4층전체 (서초동)",
    "lat": "37.4937052",
    "lng": "127.0168276",
    "phoneNumber": "02-536-1952",
    "교습과정": "성인고시",
    "isFinish": ""
  },
  {
    "number": 144,
    "name": "솔빛창의과학영재학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 536  401호 402호(대치동",
    "lat": "37.5037491",
    "lng": "127.0617296",
    "phoneNumber": "02-501-0830",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 145,
    "name": "미래탐구학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로63길 12 403-1호, 404호, 405호(대치동)",
    "lat": "37.4978196",
    "lng": "127.0546022",
    "phoneNumber": "02-501-1599",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 146,
    "name": "영재과학보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 주흥길 3 , 401호 (반포동)",
    "lat": "37.5037848",
    "lng": "127.0207503",
    "phoneNumber": "02-548-5010",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 147,
    "name": "생각비타민국어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 313 , 3층 (대치동,운지빌딩)",
    "lat": "37.4998263",
    "lng": "127.0600673",
    "phoneNumber": "02-568-6675",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 149,
    "name": "파고다원강남학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 강남대로 419 ,19층 일부(서초동, 파고다타워)",
    "lat": "37.4998564",
    "lng": "127.0261723",
    "phoneNumber": "02-538-4020",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 150,
    "name": "이제이유플랜(EJUplan)시사일본어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 테헤란로4길 28 , 3층 (역삼동,시사일본어사옥)",
    "lat": "37.4965132",
    "lng": "127.0300705",
    "phoneNumber": "02-558-9582",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 151,
    "name": "씨앤에이논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 450 , 2층 (대치동,덕산빌딩)",
    "lat": "37.4981124",
    "lng": "127.0597594",
    "phoneNumber": "02-562-1211",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 152,
    "name": "멘토(Mentor)독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 서초구 동광로19길 19   3층 (방배동)",
    "lat": "37.493438",
    "lng": "126.9889159",
    "phoneNumber": "02-536-1255",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 153,
    "name": "정진수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로78길 22   대치아파트 상가 201~203 311~313호 (대치동)",
    "lat": "37.4963866",
    "lng": "127.058402",
    "phoneNumber": "02-3453-6277",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 155,
    "name": "에밀튼리딩타운어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 삼성로51길 8 , 1층일부,2층,3층 (대치동)",
    "lat": "37.4968411",
    "lng": "127.0610624",
    "phoneNumber": "02-555-7171",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 156,
    "name": "세정방배캠퍼스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동작대로 188 , 2층전체 (방배동, 액센빌딩)",
    "lat": "37.4932966999999",
    "lng": "126.983124",
    "phoneNumber": "02-532-6552",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 157,
    "name": "영독대치학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로4길 5 3층(개포동)",
    "lat": "37.482396",
    "lng": "127.0616862",
    "phoneNumber": "02-576-6589",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 158,
    "name": "설리번스쿨어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 도산대로17길 21 , 2층~4층 (신사동)",
    "lat": "37.5200501",
    "lng": "127.0243309",
    "phoneNumber": "02-544-4445",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 159,
    "name": "시대인재엠(M)3학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 527 1층, 2층(대치동)",
    "lat": "37.5003121",
    "lng": "127.0639729",
    "phoneNumber": "02-567-2823",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 160,
    "name": "명석학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 도곡로 447 , 3층 (대치동, 제일빌딩)",
    "lat": "37.4985572",
    "lng": "127.0593517",
    "phoneNumber": "02-2051-6464",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 161,
    "name": "프리미어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2935 , 대치프라자6층 (대치동)",
    "lat": "37.4940247",
    "lng": "127.0613442",
    "phoneNumber": "02-539-3372",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 162,
    "name": "조엘통찰수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 438 2층일부 202호(대치동)",
    "lat": "37.4978146",
    "lng": "127.0584142",
    "phoneNumber": "02-501-5284",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 163,
    "name": "현재어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 서초중앙로33길 14 , 아싸빌딩2,3층 (반포동)",
    "lat": "37.5010747",
    "lng": "127.0106354",
    "phoneNumber": "02-595-4177",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 164,
    "name": "청담해법수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 학동로 419 , 3층 (청담동,대륭빌딩)",
    "lat": "37.5183507",
    "lng": "127.0459641",
    "phoneNumber": "02-3443-8900",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 165,
    "name": "시대인재해석관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 231   301호 (대치동)",
    "lat": "37.4978276999999",
    "lng": "127.0610138",
    "phoneNumber": "02-562-7749",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 166,
    "name": "시대인재에이치알디(HRD)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 227   태륭빌딩 301호 (대치동)",
    "lat": "37.4973781",
    "lng": "127.0612967",
    "phoneNumber": "02-3454-0314",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 169,
    "name": "에이원아카데미보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 논현로175길 109 , 5층일부 (신사동,컨템포빌딩)",
    "lat": "37.5222786",
    "lng": "127.0205958",
    "phoneNumber": "02-569-0909",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 170,
    "name": "대치필학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 150 , 202-1-1A호 일부 한보종합상가 (대치동, 한보미도맨션)",
    "lat": "37.4933928",
    "lng": "127.0673501",
    "phoneNumber": "02-542-7474",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 171,
    "name": "에스엔티(SNT)영재관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로71길 16   3층 (대치동)",
    "lat": "37.5021692",
    "lng": "127.0575619",
    "phoneNumber": "02-508-0586",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 172,
    "name": "메디치보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 잠원로 148 , 303~305호 (잠원동,잠원한신아파트)",
    "lat": "37.5159680999999",
    "lng": "127.0107817",
    "phoneNumber": "02-596-4369",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 173,
    "name": "렉스김어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 도곡로 519 , 4층·5층 (대치동, 구공빌딩)",
    "lat": "37.5000709",
    "lng": "127.0629888",
    "phoneNumber": "02-555-7807",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 174,
    "name": "올마이티캠퍼스2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 328 , 3층 1-1호 (대치동)",
    "lat": "37.500753",
    "lng": "127.0746559",
    "phoneNumber": "02-554-7274",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 175,
    "name": "퍼스널학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로 230   동화반포프라자 502호 일부(반포동)",
    "lat": "37.5022526",
    "lng": "127.0119876",
    "phoneNumber": "02-537-7372",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 177,
    "name": "현대에이플러스보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로115길 46   2층 (삼성동)",
    "lat": "37.5140146",
    "lng": "127.0483999",
    "phoneNumber": "02-546-0543",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 178,
    "name": "생각이크는학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 언주로 110 , 상가동 2층 2호,3호,7호,8호 (개포동,경남아파트)",
    "lat": "37.4845146",
    "lng": "127.054174",
    "phoneNumber": "02-574-0089",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 179,
    "name": "대치수재보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로77길 14 , 301호 (대치동,양지빌딩)",
    "lat": "37.4992943",
    "lng": "127.0585913",
    "phoneNumber": "02-566-0796",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 180,
    "name": "이비보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로 122   2층 (신사동)",
    "lat": "37.5236605",
    "lng": "127.0220714",
    "phoneNumber": "02-545-6794",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 181,
    "name": "수서신동아독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 광평로47길 17 , 3층 (수서동,신동아아파트관리소동)",
    "lat": "37.4870719",
    "lng": "127.0983474",
    "phoneNumber": "02-459-8786",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 182,
    "name": "인사이트영재학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 515 , 4층 403호 (대치동,한도산업사옥)",
    "lat": "37.4998352",
    "lng": "127.0626495",
    "phoneNumber": "02-508-7853",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 184,
    "name": "오예스영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 효령로34길 66 , 2층 (방배동)",
    "lat": "37.4788321",
    "lng": "127.0007252",
    "phoneNumber": "02-586-7518",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 185,
    "name": "이엠보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로29길 67 외1필지 2층",
    "lat": "37.5319894",
    "lng": "127.0269384",
    "phoneNumber": "02-515-3350",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 189,
    "name": "송림학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 반포대로 300-3 , 3층 전체 (잠원동, 상화빌딩)",
    "lat": "37.505789",
    "lng": "127.0012603",
    "phoneNumber": "02-508-1245",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 190,
    "name": "진선생어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 고무래로10길 10 , 4층(반포동)",
    "lat": "37.5018993",
    "lng": "127.0104491",
    "phoneNumber": "02-591-7396",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 191,
    "name": "슈파스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 307 , 3층 (대치동)",
    "lat": "37.4994104",
    "lng": "127.0602933",
    "phoneNumber": "02-565-9993",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 193,
    "name": "대치상아보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로78길 9 , 2층 (대치동)",
    "lat": "37.4975137",
    "lng": "127.0593835",
    "phoneNumber": "02-2051-8780",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 194,
    "name": "에스이에이어학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 서초중앙로31길 14-13   5층 (반포동)",
    "lat": "37.5007214",
    "lng": "127.010468",
    "phoneNumber": "02-3477-4280",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 195,
    "name": "대치청담어학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 도곡로 456 , 1층,2층 (대치동)",
    "lat": "37.4982956",
    "lng": "127.0603287",
    "phoneNumber": "02-561-0270",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 197,
    "name": "원탑보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2936 , 4층 403호·408호 (대치동, 윈플러스상가)",
    "lat": "37.4933573",
    "lng": "127.0619092",
    "phoneNumber": "02-539-3779",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 198,
    "name": "수행과수능학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 선릉로64길 14 , 5층 (대치동)",
    "lat": "37.497798",
    "lng": "127.0534412",
    "phoneNumber": "02-3452-3450",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 199,
    "name": "유진벨어학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 서초대로60길 25   3-4층 (서초동)",
    "lat": "37.4939292",
    "lng": "127.0185884",
    "phoneNumber": "02-525-5558",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 200,
    "name": "두각오름관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로77길 26 , 5층(대치동)",
    "lat": "37.4999822",
    "lng": "127.058129",
    "phoneNumber": "02-556-2700",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 204,
    "name": "수찬학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 444 , 302호 (대치동,일억조빌딩)",
    "lat": "37.4979898",
    "lng": "127.0591563",
    "phoneNumber": "02-567-9116",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 205,
    "name": "김수희과학보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 사평대로 126 , 7층일부 (반포동)",
    "lat": "37.4998132",
    "lng": "126.9983097",
    "phoneNumber": "02-599-0477",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 206,
    "name": "강신백국어보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동작대로 222 , 4층 (방배동, 목은빌딩)",
    "lat": "37.496349",
    "lng": "126.983221",
    "phoneNumber": "02-534-0726",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 207,
    "name": "시대인재A관2학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 삼성로 324   3층 301호 (대치동)",
    "lat": "37.5008476",
    "lng": "127.0601302",
    "phoneNumber": "02-555-4501",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 209,
    "name": "깊은생각중등수학캠퍼스보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 445 , 3층 (대치동)",
    "lat": "37.4986522",
    "lng": "127.059031",
    "phoneNumber": "02-539-7772",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 210,
    "name": "고래의도약학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 524 , 2층 (대치동,남성빌딩)",
    "lat": "37.4995124",
    "lng": "127.0637515",
    "phoneNumber": "02-567-7705",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 211,
    "name": "랭귀지큐브역삼어학학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 역삼로17길 64   3층 (역삼동)",
    "lat": "37.4988924",
    "lng": "127.0366102",
    "phoneNumber": "02-594-1105",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 212,
    "name": "새움8관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 511 , 5층 (대치동,대진빌딩)",
    "lat": "37.4996664",
    "lng": "127.0622284",
    "phoneNumber": "02-569-7440",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 214,
    "name": "에스디영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 516 3층 308호(대치동)",
    "lat": "37.4992034",
    "lng": "127.0630995",
    "phoneNumber": "02-6207-4040",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 215,
    "name": "박문각강남고시학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "인문사회(대)",
    "학원주소\t": "서울특별시 서초구 강남대로61길 19 , 2층 (서초동)",
    "lat": "37.4985124",
    "lng": "127.0247111",
    "phoneNumber": "02-3476-3670",
    "교습과정": "성인고시",
    "isFinish": ""
  },
  {
    "number": 219,
    "name": "랭귀지윌학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 언주로168길 5 , 3층전체 (신사동)",
    "lat": "37.5266272",
    "lng": "127.0340253",
    "phoneNumber": "02-562-8222",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 221,
    "name": "다함영재원학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 515 , 5층 일부 (대치동,한도산업사옥)",
    "lat": "37.4998352",
    "lng": "127.0626495",
    "phoneNumber": "02-563-4388",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 222,
    "name": "천지인학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로126길 16 , 3층,4층 (삼성동)",
    "lat": "37.5153246",
    "lng": "127.0434625",
    "phoneNumber": "02-3445-8998",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 223,
    "name": "프리미엄아인슈타인학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로 130 , 401호 (신사동, 종화빌딩)",
    "lat": "37.5240736",
    "lng": "127.0228897",
    "phoneNumber": "02-542-4201",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 224,
    "name": "유토마학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 삼성로72길 64   3층 (대치동)",
    "lat": "37.5007902",
    "lng": "127.0633786",
    "phoneNumber": "02-501-2422",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 225,
    "name": "체리군단국어논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 명달로4길 4   3층 일부 (서초동)",
    "lat": "37.4798686",
    "lng": "127.0061381",
    "phoneNumber": "02-3487-3660",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 226,
    "name": "뉴탑보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 반포대로21길 17 , 3층 전체 (서초동, 선업빌딩)",
    "lat": "37.4879339",
    "lng": "127.0085799",
    "phoneNumber": "02-3472-3479",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 227,
    "name": "랭귀지큐브압구정어학학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 논현로 824 , 2층 (신사동,동양빌딩)",
    "lat": "37.5220349",
    "lng": "127.0285827",
    "phoneNumber": "02-558-1105",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 228,
    "name": "대제학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로34길 11  406호(신사동)",
    "lat": "37.5273895",
    "lng": "127.030957",
    "phoneNumber": "02-541-9662",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 229,
    "name": "크레버스영재교육센터압구정제1지점학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 논현로175길 25  다보빌딩 4층전체 (신사동)",
    "lat": "37.5254304",
    "lng": "127.0266876",
    "phoneNumber": "02-3445-1288",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 230,
    "name": "매쓰큐보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로33길 7 , 4층전체 (반포동)",
    "lat": "37.501038",
    "lng": "127.0112258",
    "phoneNumber": "02-534-4280",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 231,
    "name": "원스탑프렙(One-Stop Prep)어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 언주로 861 , 4층 (신사동)",
    "lat": "37.5274104999999",
    "lng": "127.0330945",
    "phoneNumber": "02-554-7762",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 232,
    "name": "깊은생각필연의길1관보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 457 , 3층 (대치동, 진흥빌딩)",
    "lat": "37.4990346",
    "lng": "127.0602191",
    "phoneNumber": "02-562-4070",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 234,
    "name": "애니킴영어수학전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동산로 73-1 , 2층 (양재동)",
    "lat": "37.4725123",
    "lng": "127.0466008",
    "phoneNumber": "02-571-1914",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 235,
    "name": "심지영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2936  윈플러스상가 4층 401호 (대치동)",
    "lat": "37.4933573",
    "lng": "127.0619092",
    "phoneNumber": "02-563-0544",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 236,
    "name": "지오보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 봉은사로55길 47 ,2층 (삼성동)",
    "lat": "37.5136238",
    "lng": "127.0434105",
    "phoneNumber": "02-511-6956",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 237,
    "name": "수학페이지학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로 90-7 , 4층 7,9,10,11호 (서초동,서초쇼핑)",
    "lat": "37.4999482",
    "lng": "127.0174429",
    "phoneNumber": "02-532-6044",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 238,
    "name": "미래탐구별관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로63길 13 , 2층, 3층 전체 (대치동)",
    "lat": "37.4978091",
    "lng": "127.0540217",
    "phoneNumber": "02-538-3372",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 240,
    "name": "엠프라이머리수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 338 , 2층전체 (대치동)",
    "lat": "37.5018392",
    "lng": "127.0597125",
    "phoneNumber": "02-572-5992",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 241,
    "name": "시매쓰압구정학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로42길 13 , 3층,4층 (신사동)",
    "lat": "37.5279668",
    "lng": "127.0355374",
    "phoneNumber": "02-545-1033",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 242,
    "name": "대치세진사탐전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로72길 64  서주빌딩 5층 (대치동)",
    "lat": "37.5007498",
    "lng": "127.0633594",
    "phoneNumber": "02-555-3271",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 244,
    "name": "신어지학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 남부순환로 2941 , 501호,504호,505호 (대치동, 대치탑프라자)",
    "lat": "37.4942268",
    "lng": "127.0617852",
    "phoneNumber": "02-539-7518",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 246,
    "name": "(주)세한아카데미외국어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 테헤란로64길 16-9 , 3층,4층 (대치동)",
    "lat": "37.5035994",
    "lng": "127.0506315",
    "phoneNumber": "02-3453-3422",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 249,
    "name": "세정대치관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로63길 15-3 1-3층(대치동)",
    "lat": "37.499511",
    "lng": "127.0589958",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 250,
    "name": "명인학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 408 , 207호~211호 (대치동,디마크 빌딩)",
    "lat": "37.4966877",
    "lng": "127.0552639",
    "phoneNumber": "02-567-9966",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 251,
    "name": "윤도영본관2학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로61길 22   2층 (대치동)",
    "lat": "37.4991092",
    "lng": "127.058612",
    "phoneNumber": "02-567-4767",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 252,
    "name": "바우뫼보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 바우뫼로 23  501동 502호(우면동",
    "lat": "37.4704112999999",
    "lng": "127.0252539",
    "phoneNumber": "02-572-3248",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 253,
    "name": "한스영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배중앙로 212 , 4층 (방배동)",
    "lat": "37.4979898",
    "lng": "126.9853212",
    "phoneNumber": "02-536-5347",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 254,
    "name": "제일테마보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로363길 11   동신빌딩 3층 (도곡동)",
    "lat": "37.4859244",
    "lng": "127.0379017",
    "phoneNumber": "02-576-3278",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 255,
    "name": "상위권수학본원학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 반포대로 300 , 5층(361.64㎡)의 일부 1/2 (180.82㎡) (잠원동,덕성빌딩)",
    "lat": "37.505956",
    "lng": "127.0011819",
    "phoneNumber": "02-534-0064",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 256,
    "name": "중국명문대입시학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 도곡로 519 , 6층 (대치동,구공빌딩)",
    "lat": "37.5000709",
    "lng": "127.0629888",
    "phoneNumber": "02-557-2356",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 257,
    "name": "레벨업아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 192   호삼빌딩 3층 302호 303호 (도곡동)",
    "lat": "37.4897242",
    "lng": "127.0520231",
    "phoneNumber": "02-529-8713",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 258,
    "name": "해커스편입학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "인문사회(대)",
    "학원주소\t": "서울특별시 서초구 서초대로77길 27 , 4층, 5층 (서초동, 서초동유빌딩)",
    "lat": "37.5000702",
    "lng": "127.0254235",
    "phoneNumber": "02-569-7467",
    "교습과정": "대학편입",
    "isFinish": ""
  },
  {
    "number": 259,
    "name": "한뉘수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서운로 220 , 204, 205, 206호 (서초동, 대지스포츠프라자)",
    "lat": "37.5026545",
    "lng": "127.0217726",
    "phoneNumber": "02-588-8795",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 260,
    "name": "함영원수학경시학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2941 , 2층 202호 (대치동,대치탑프라자)",
    "lat": "37.4942268",
    "lng": "127.0617852",
    "phoneNumber": "02-567-4566",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 261,
    "name": "이스피릿어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 서초대로42길 69 , 1층~3층 (서초동,스카이빌딩)",
    "lat": "37.4890866",
    "lng": "127.0099701",
    "phoneNumber": "02-525-7522",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 262,
    "name": "반포시매쓰학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로31길 14-13 , 603호 (반포동)",
    "lat": "37.5007214",
    "lng": "127.010468",
    "phoneNumber": "02-535-3636",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 263,
    "name": "한동원영어전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배천로 158 2층(방배동)",
    "lat": "37.4892211",
    "lng": "126.9872954",
    "phoneNumber": "02-594-9337",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 264,
    "name": "한석만수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 457 , 5층 (대치동,진흥빌딩)",
    "lat": "37.4990346",
    "lng": "127.0602191",
    "phoneNumber": "02-558-8909",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 266,
    "name": "다원영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 406 , 5층 (대치동, 서림빌딩)",
    "lat": "37.5035054",
    "lng": "127.0587764",
    "phoneNumber": "02-501-0306",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 268,
    "name": "잉코어보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 반포대로 300 , 6층일부 (잠원동)",
    "lat": "37.505956",
    "lng": "127.0011819",
    "phoneNumber": "02-533-7738",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 270,
    "name": "서초티오티서초1관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 명달로8길 10 , 3층 301호 (서초동, 세림빌딩)",
    "lat": "37.4815705",
    "lng": "127.0057322",
    "phoneNumber": "02-535-0473",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 271,
    "name": "김영플러스학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "인문사회(대)",
    "학원주소\t": "서울특별시 서초구 강남대로 419 , 10층 (서초동, 파고다타워)",
    "lat": "37.4998564",
    "lng": "127.0261723",
    "phoneNumber": "02-591-7033",
    "교습과정": "대학편입",
    "isFinish": ""
  },
  {
    "number": 272,
    "name": "리더스엠비에이어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 압구정로30길 17 , 201호,202호,203호일부 (신사동)",
    "lat": "37.5263249",
    "lng": "127.0295435",
    "phoneNumber": "02-512-7666",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 275,
    "name": "이알피어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 테헤란로1길 19 , 4층,5층 (역삼동, 로하스애비뉴빌딩)",
    "lat": "37.4996075",
    "lng": "127.0275466",
    "phoneNumber": "02-538-1516",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 276,
    "name": "미래탐구별관3학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로63길 13 , 5층전체·6층전체 (대치동)",
    "lat": "37.4978091",
    "lng": "127.0540217",
    "phoneNumber": "02-538-3372",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 277,
    "name": "헥사곤수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 일원로3길 34 , 2층 (일원동)",
    "lat": "37.4919468",
    "lng": "127.0831146",
    "phoneNumber": "02-3411-3772",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 278,
    "name": "모닝에듀어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 강남대로94길 36 2층 일부, 3~7층(역삼동)",
    "lat": "37.4998161",
    "lng": "127.0302147",
    "phoneNumber": "02-6253-2004",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 279,
    "name": "비엘씨(BLC)영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 227 , 401호 (도곡동,진달래상가)",
    "lat": "37.4958321",
    "lng": "127.0527291",
    "phoneNumber": "02-556-0039",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 280,
    "name": "잔디학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로64길 47   희망빌딩 401 (대치동)",
    "lat": "37.5009055",
    "lng": "127.0641019",
    "phoneNumber": "02-445-0883",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 281,
    "name": "기파랑문해원대치점학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 306   아이비타워 6층 (대치동)",
    "lat": "37.4994476",
    "lng": "127.0608995",
    "phoneNumber": "02-555-6554",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 283,
    "name": "해강맥학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로10길 4-4   2층 (개포동)",
    "lat": "37.4829996",
    "lng": "127.0607906",
    "phoneNumber": "02-579-3727",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 284,
    "name": "본수학전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 327 , 4층 (대치동)",
    "lat": "37.5008825",
    "lng": "127.0594779",
    "phoneNumber": "02-562-4345",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 287,
    "name": "세정학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 306 , 3층(대치동)",
    "lat": "37.4994476",
    "lng": "127.0608995",
    "phoneNumber": "02-567-0606",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 288,
    "name": "제1청담어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 학동로 411 , 3층 (청담동)",
    "lat": "37.5181161",
    "lng": "127.0446457",
    "phoneNumber": "02-516-9407",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 289,
    "name": "시대인재엣지관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 454 3층, 6층(대치동)",
    "lat": "37.498302",
    "lng": "127.0600906",
    "phoneNumber": "02-556-2171",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 291,
    "name": "일등급플러스과학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 225 , 302호 (대치동)",
    "lat": "37.4971742",
    "lng": "127.0613516",
    "phoneNumber": "02-538-3010",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 292,
    "name": "이루리학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 440   청운빌딩 4층일부 (대치동)",
    "lat": "37.4978753",
    "lng": "127.058633",
    "phoneNumber": "02-558-8520",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 293,
    "name": "오종기수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 반포대로 300 , 2층 (잠원동, 덕성빌딩)",
    "lat": "37.505956",
    "lng": "127.0011819",
    "phoneNumber": "02-594-1057",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 295,
    "name": "와이스톤인터내셔널어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 고무래로 18-4 , 3층, 5층 (반포동, 송암아쿠아센터)",
    "lat": "37.5029862",
    "lng": "127.0101362",
    "phoneNumber": "02-533-3353",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 296,
    "name": "프리미어세즈마학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로58길 29 , 4층 402호 (대치동)",
    "lat": "37.4992421",
    "lng": "127.0635885",
    "phoneNumber": "02-558-1452",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 297,
    "name": "송준하수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 225   201호 (대치동)",
    "lat": "37.4971742",
    "lng": "127.0613516",
    "phoneNumber": "02-501-5550",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 298,
    "name": "미래탐구청은2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 434 , 5층 일부 (대치동)",
    "lat": "37.4976364",
    "lng": "127.0579549",
    "phoneNumber": "02-555-4001",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 299,
    "name": "개념상상에스엠(SM)관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 511 , 4층 (대치동,대진빌딩)",
    "lat": "37.4996664",
    "lng": "127.0622284",
    "phoneNumber": "02-569-7440",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 300,
    "name": "에이펙스프리미엄학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로64길 35 , 3층 일부 (대치동)",
    "lat": "37.5007014",
    "lng": "127.0631946",
    "phoneNumber": "02-508-0921",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 301,
    "name": "천개의고원초등2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 327 , 6층일부 (대치동)",
    "lat": "37.5008825",
    "lng": "127.0594779",
    "phoneNumber": "02-555-2157",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 302,
    "name": "천개의고원초등관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 327 , 5층 (대치동,아람빌딩)",
    "lat": "37.5008776",
    "lng": "127.0594912",
    "phoneNumber": "02-501-5727",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 303,
    "name": "수학까페학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 영동대로57길 14   3층 (대치동)",
    "lat": "37.5001181",
    "lng": "127.0660585",
    "phoneNumber": "02-566-1608",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 304,
    "name": "서초에스엘피어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 고무래로 6-10 , 1,2,3층 (반포동)",
    "lat": "37.5038822",
    "lng": "127.0091071",
    "phoneNumber": "02-596-7117",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 305,
    "name": "국어샘학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2917 , 201-아호, 307-가호, 307-나호(대치동)",
    "lat": "37.4931481",
    "lng": "127.0590766",
    "phoneNumber": "02-555-5754",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 306,
    "name": "유에스씨어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 남부순환로 2909 , 506호,507호 (대치동)",
    "lat": "37.4922077",
    "lng": "127.0573813",
    "phoneNumber": "02-553-4344",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 307,
    "name": "피에스에이압구정어학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 압구정로 206 , 2층, 3층 (신사동)",
    "lat": "37.5273244",
    "lng": "127.0295867",
    "phoneNumber": "02-738-0509",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 308,
    "name": "아이쥐에스이윤선생서초학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 효령로46길 5 2층 207호, 3층 308호 (서초동)",
    "lat": "37.483309",
    "lng": "127.0090104",
    "phoneNumber": "02-523-0582",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 309,
    "name": "세정5층학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 306 , 5층 (대치동,IVY TOWER)",
    "lat": "37.4994476",
    "lng": "127.0608995",
    "phoneNumber": "02-555-6554",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 310,
    "name": "프레지던트학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동산로 73-1 , 3층 (양재동)",
    "lat": "37.4725123",
    "lng": "127.0466008",
    "phoneNumber": "02-557-1552",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 312,
    "name": "반포아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동작대로 168 , 2층 전체, 3층 일부 (방배동)",
    "lat": "37.4915041",
    "lng": "126.9830564",
    "phoneNumber": "02-592-5105",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 313,
    "name": "씨에이치(CH)영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 225   301호 (대치동)",
    "lat": "37.4971742",
    "lng": "127.0613516",
    "phoneNumber": "02-508-6859",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 314,
    "name": "류지혜국어논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 423 , 4층 일부(506호) (대치동, 윤성빌딩)",
    "lat": "37.497826",
    "lng": "127.0567677",
    "phoneNumber": "02-566-0019",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 315,
    "name": "엘앤엘(LnL)어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 선릉로 225 , 503-1호,503-2호,503-3호 (도곡동, 도곡렉슬상가)",
    "lat": "37.4953404",
    "lng": "127.0526522",
    "phoneNumber": "02-553-0066",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 317,
    "name": "더힐링교육학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로72길 64 , 4층일부 (대치동)",
    "lat": "37.5007902",
    "lng": "127.0633786",
    "phoneNumber": "02-555-0936",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 318,
    "name": "서초메가스터디학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 서초중앙로22길 17 , 5층, 8층 전체, 9층 일부 (서초동)",
    "lat": "37.4933187",
    "lng": "127.014641",
    "phoneNumber": "02-535-5678",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 320,
    "name": "이안어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 영동대로137길 6 , 3층 일부 (청담동)",
    "lat": "37.522023",
    "lng": "127.0549623",
    "phoneNumber": "02-517-4517",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 321,
    "name": "노블영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로 90-7   서초쇼핑 503호 (서초동)",
    "lat": "37.4999482",
    "lng": "127.0174429",
    "phoneNumber": "02-537-7291",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 322,
    "name": "오투존골든벨독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 개포로22길 27 , 3,4층 (개포동,두로빌딩)",
    "lat": "37.4773413",
    "lng": "127.0489937",
    "phoneNumber": "02-572-4152",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 323,
    "name": "김현정수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 225 , 304,305,306호 (대치동)",
    "lat": "37.4971742",
    "lng": "127.0613516",
    "phoneNumber": "02-562-5050",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 324,
    "name": "대치에이프릴어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 언주로 118 2층 133호, 201호 (도곡동,우성캐릭터199)",
    "lat": "37.4873663",
    "lng": "127.0434354",
    "phoneNumber": "02-572-4105",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 325,
    "name": "대한논리논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 205 , 5층 1호, 2호, 17호, 18호, 19호 일부(잠원동)",
    "lat": "37.5069447",
    "lng": "127.0061471",
    "phoneNumber": "02-537-7181",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 326,
    "name": "프라임수학1관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로119길 39   2층 (삼성동)",
    "lat": "37.5152379",
    "lng": "127.0483656",
    "phoneNumber": "02-541-0209",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 328,
    "name": "대치청솔학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로51길 11  대학빌딩 2층 일부 (대치동)",
    "lat": "37.496256",
    "lng": "127.060622",
    "phoneNumber": "02-558-1007",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 329,
    "name": "클라우스수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 논현로159길 18 , 5층 (신사동)",
    "lat": "37.5231664999999",
    "lng": "127.0266166",
    "phoneNumber": "02-3445-8444",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 330,
    "name": "케이엔에스(KNS)고등2관영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로83길 5   4층 (대치동)",
    "lat": "37.4998553",
    "lng": "127.0621345",
    "phoneNumber": "02-501-0306",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 331,
    "name": "막강수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 논현로175길 40   4층 (신사동)",
    "lat": "37.5250912",
    "lng": "127.0253317",
    "phoneNumber": "02-541-8549",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 332,
    "name": "서초청담어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 고무래로10길 19 , 3층~5층 (반포동)",
    "lat": "37.5010172",
    "lng": "127.0102811",
    "phoneNumber": "02-596-9407",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 335,
    "name": "엘브라운학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로83길 5   5층 (대치동)",
    "lat": "37.4998553",
    "lng": "127.0621345",
    "phoneNumber": "02-554-5504",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 336,
    "name": "시대인재더블유(W)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 337 101호, 6층, 7층, 8층(대치동)",
    "lat": "37.4991887",
    "lng": "127.0633458",
    "phoneNumber": "02-2052-4001",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 337,
    "name": "엠에스(MS)수학과학전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 효령로 181 , 4층 (서초동,영일빌딩)",
    "lat": "37.4828834",
    "lng": "127.0038799",
    "phoneNumber": "02-598-7094",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 338,
    "name": "대치스템(STEM)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 510   302호 (대치동)",
    "lat": "37.4989119",
    "lng": "127.0619546",
    "phoneNumber": "02-561-3312",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 339,
    "name": "독수리수학전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 225   아주빌딩 202호 (대치동)",
    "lat": "37.4971742",
    "lng": "127.0613516",
    "phoneNumber": "02-553-6556",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 340,
    "name": "아이엘이어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 삼성로 238 , 501~514호 및 601~608호 (대치동, 태원 리치타운상가)",
    "lat": "37.4986835",
    "lng": "127.0613244",
    "phoneNumber": "02-552-6003",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 341,
    "name": "아인스일원학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 개포로 642 , 202호 일부 (일원동,영남빌딩)",
    "lat": "37.4945455",
    "lng": "127.0831558",
    "phoneNumber": "02-3412-2033",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 342,
    "name": "시대인재신관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로51길 11 , 2층 일부, 3층 일부(대치동)",
    "lat": "37.496256",
    "lng": "127.060622",
    "phoneNumber": "02-554-2772",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 343,
    "name": "예섬프론티어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 430 , 1층, 2층 (대치동)",
    "lat": "37.4975062",
    "lng": "127.0575512",
    "phoneNumber": "02-562-3676",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 344,
    "name": "시대인재수학스쿨별관3학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 434 , 6층 (대치동,청은빌딩)",
    "lat": "37.4976364",
    "lng": "127.0579549",
    "phoneNumber": "02-501-6619",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 345,
    "name": "일원열린학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 일원로3길 54 , 3층 (일원동)",
    "lat": "37.4924024",
    "lng": "127.0842333",
    "phoneNumber": "02-445-2204",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 346,
    "name": "서초분원씨앤에이논술보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 219 , 3층14호~17호 (잠원동,반포쇼핑타운)",
    "lat": "37.5074568",
    "lng": "127.0078376",
    "phoneNumber": "02-533-0120",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 347,
    "name": "장수경어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 사임당로 173   서전빌딩 701호 (서초동)",
    "lat": "37.4927943",
    "lng": "127.0285544",
    "phoneNumber": "02-3474-6070",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 348,
    "name": "원(元)수학4관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로57길 22 , 2층 (대치동)",
    "lat": "37.4978398",
    "lng": "127.0592568",
    "phoneNumber": "02-508-1626",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 349,
    "name": "수학세상학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 논현로175길 59-6 , 3층 (신사동)",
    "lat": "37.5239546",
    "lng": "127.0242293",
    "phoneNumber": "02-542-8961",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 350,
    "name": "브릭앤멘사영재학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 사평대로 18 , 302호 (방배동)",
    "lat": "37.4981855",
    "lng": "126.9863984",
    "phoneNumber": "02-6338-6383",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 351,
    "name": "다솔학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 329 , 6층 (대치동, 진선빌딩)",
    "lat": "37.5010216",
    "lng": "127.0594045",
    "phoneNumber": "02-501-0306",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 353,
    "name": "강남중국어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 테헤란로5길 18 , 1,2층 (역삼동)",
    "lat": "37.500001",
    "lng": "127.0292231",
    "phoneNumber": "02-501-7300",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 354,
    "name": "탑브레인학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 강남대로 627 , 2층 (잠원동)",
    "lat": "37.5176791",
    "lng": "127.0186716",
    "phoneNumber": "02-3445-3110",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 355,
    "name": "파워플러스영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로33길 6-6 , 4층일부 (반포동, 두원빌딩)",
    "lat": "37.5017832",
    "lng": "127.0111446",
    "phoneNumber": "02-532-4910",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 356,
    "name": "매쓰무적학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2912 , 203호 일부 (대치동)",
    "lat": "37.4908388",
    "lng": "127.0572409",
    "phoneNumber": "02-562-1939",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 357,
    "name": "애플트리압구정어학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 압구정로 206 , 1층 (신사동)",
    "lat": "37.5273244",
    "lng": "127.0295867",
    "phoneNumber": "02-502-0509",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 358,
    "name": "프라우드세븐학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로51길 8 , 4층 (대치동)",
    "lat": "37.4968411",
    "lng": "127.0610624",
    "phoneNumber": "02-566-0505",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 359,
    "name": "로고스논술구술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 삼성로 238 , 308호,309호,310호,311호,412호,413호,414호 (대치동, 태원 리치타운 상가)",
    "lat": "37.4986375",
    "lng": "127.0614624",
    "phoneNumber": "02-552-3113",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 360,
    "name": "반포탐구와은유학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로8길 9 , 4층 (반포동)",
    "lat": "37.5019759",
    "lng": "127.0102486",
    "phoneNumber": "02-537-5274",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 361,
    "name": "대치정상수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 영동대로 229 , 4층 전체 (대치동, 메디다스벤처타운)",
    "lat": "37.4994334999999",
    "lng": "127.0673516",
    "phoneNumber": "02-552-3575",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 364,
    "name": "시그마베스트학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 184 , 301호 (도곡동, 신호빌딩)",
    "lat": "37.4917395",
    "lng": "127.0396045",
    "phoneNumber": "02-562-7705",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 366,
    "name": "강남하이클래스보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 언주로 118 , 123호 (도곡동,우성캐릭터 199)",
    "lat": "37.4869807",
    "lng": "127.0517581",
    "phoneNumber": "02-574-2530",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 368,
    "name": "조미선국어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 317   5층 (대치동)",
    "lat": "37.5002043",
    "lng": "127.0598326",
    "phoneNumber": "02-567-2808",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 369,
    "name": "압구정파인만초등관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로32길 11 , 5층 (신사동, 캐럴라인타워)",
    "lat": "37.5269161",
    "lng": "127.0302159",
    "phoneNumber": "02-548-1755",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 370,
    "name": "이-스페셜리스트영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 521   대치프라자 502호 (대치동)",
    "lat": "37.5000321",
    "lng": "127.0632277",
    "phoneNumber": "02-508-6306",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 371,
    "name": "이앤이학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 강남대로120길 46 , 2층 (논현동)",
    "lat": "37.5077473",
    "lng": "127.0269038",
    "phoneNumber": "02-3442-4676",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 372,
    "name": "어셔어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 잠원로3길 40 , 202-A호, 206호, 207호, 208호, 209호 (잠원동, 태남홀딩스)",
    "lat": "37.5081523",
    "lng": "127.0037071",
    "phoneNumber": "02-595-5679",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 373,
    "name": "청출어람학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로62길 29 , 2층 전체 (대치동)",
    "lat": "37.4979282",
    "lng": "127.054936",
    "phoneNumber": "02-557-0223",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 374,
    "name": "시대인재스톤관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로77길 3 1층과 8층(대치동)",
    "lat": "37.4984471",
    "lng": "127.0584639",
    "phoneNumber": "02-557-3371",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 376,
    "name": "브이에스(VS)비상학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2936 , 510호 (대치동)",
    "lat": "37.4933573",
    "lng": "127.0619092",
    "phoneNumber": "02-6349-4900",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 377,
    "name": "압구정국어논술전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 논현로164길 6 , 2층,4층 (신사동)",
    "lat": "37.5236143",
    "lng": "127.0288819",
    "phoneNumber": "02-3444-1776",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 379,
    "name": "대치탑영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 225   아주빌딩 402호 (대치동)",
    "lat": "37.4971742",
    "lng": "127.0613516",
    "phoneNumber": "-",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 380,
    "name": "지혜의샘학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로77길 26 , 2층 (대치동)",
    "lat": "37.4999822",
    "lng": "127.058129",
    "phoneNumber": "02-558-2531",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 381,
    "name": "맨하탄어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 강남대로94길 11 , 4층일부,5층일부 (역삼동)",
    "lat": "37.4995341",
    "lng": "127.0282641",
    "phoneNumber": "02-3288-0505",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 382,
    "name": "대치원(元)수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로78길 7 , 2층 (대치동)",
    "lat": "37.4976259",
    "lng": "127.0593292",
    "phoneNumber": "02-563-8852",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 383,
    "name": "(주)산에듀김영준국어논술전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 409 , 2층, 5층 1호 (대치동, 타워엠프리스)",
    "lat": "37.4973819",
    "lng": "127.0551699",
    "phoneNumber": "02-501-0575",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 384,
    "name": "이현우고도수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로365길 36 , 3층 (도곡동)",
    "lat": "37.4876018",
    "lng": "127.0398772",
    "phoneNumber": "02-6083-1400",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 385,
    "name": "더오름수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로10길 17 , 7층일부 (반포동,동호빌딩)",
    "lat": "37.5012315",
    "lng": "127.0104245",
    "phoneNumber": "02-3476-8219",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 387,
    "name": "한우리서초독서논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로 6-7   2층 (반포동)",
    "lat": "37.5035792",
    "lng": "127.0092796",
    "phoneNumber": "02-534-8064",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 388,
    "name": "최고수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 22 , H동 303호 (반포동)",
    "lat": "37.5010953",
    "lng": "126.9872022",
    "phoneNumber": "02-599-9110",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 389,
    "name": "원헌드레드클래식스(100CLASSICS)어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 언주로 861 , 5층전체, 6층일부 (신사동)",
    "lat": "37.5274104999999",
    "lng": "127.0330945",
    "phoneNumber": "02-517-7762",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 390,
    "name": "에스에이(SA)쎈학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 영동대로112길 5 , 201호 및 202호 (삼성동, 대광빌딩)",
    "lat": "37.5151738",
    "lng": "127.0606537",
    "phoneNumber": "02-543-3119",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 391,
    "name": "팝스터디학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로23길 30 , 204호, 207호 전체 (잠원동, 반원상가)",
    "lat": "37.5087874",
    "lng": "127.0035738",
    "phoneNumber": "02-3477-5663",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 392,
    "name": "이아이이(EIE)매쓰캔학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 개포로22길 94 , 3층 (개포동)",
    "lat": "37.475177",
    "lng": "127.0529859",
    "phoneNumber": "02-3462-0577",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 393,
    "name": "체험수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로72길 20 , 2층,3층 (대치동)",
    "lat": "37.500342",
    "lng": "127.0528515",
    "phoneNumber": "02-3452-9392",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 395,
    "name": "펠리스스페인어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 서초대로77길 48 8층, 9층(서초동)",
    "lat": "37.5019405",
    "lng": "127.02507",
    "phoneNumber": "02-565-5488",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 396,
    "name": "미래탐구별관2학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로63길 13 , 4층전체 (대치동)",
    "lat": "37.4978091",
    "lng": "127.0540217",
    "phoneNumber": "02-538-3372",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 397,
    "name": "와이즈만압구정학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로34길 11 , 403호,404호 (신사동,압구정스퀘어)",
    "lat": "37.5273895",
    "lng": "127.030957",
    "phoneNumber": "02-3443-4111",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 399,
    "name": "월스트리트잉글리시삼성센터어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 테헤란로 447 2층(삼성동)",
    "lat": "37.5072075",
    "lng": "127.0560352",
    "phoneNumber": "02-568-7606",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 401,
    "name": "와이즈만영재교육방배본원학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 남부순환로 2219 , 3층 일부 A호 (방배동, 방배동나노빌딩)",
    "lat": "37.4739173",
    "lng": "126.9949451",
    "phoneNumber": "02-2088-2530",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 402,
    "name": "미래탐구초등학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 308 201호, 202호, 203호, 204호(대치동)",
    "lat": "37.4997202",
    "lng": "127.0608292",
    "phoneNumber": "070-4924-1186",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 403,
    "name": "반포세정3관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 165 , 3층 38호 일부, 39~42호, 43호 일부, 4층 10~12호, 13호 일부 (잠원동, 반포쇼핑타운)",
    "lat": "37.5056721",
    "lng": "127.0019322",
    "phoneNumber": "02-6242-0909",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 404,
    "name": "아벨수학영어전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 효령로 36 , 2층 (방배동, 세중빌딩)",
    "lat": "37.4781115",
    "lng": "126.9887873",
    "phoneNumber": "02-525-2346",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 405,
    "name": "더스콜라스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 압구정로30길 17 , 502호 (신사동, 이소니프라자)",
    "lat": "37.5262629",
    "lng": "127.0294934",
    "phoneNumber": "02-538-2229",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 406,
    "name": "헨리영어전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 반포대로 300 3층 1호의 일부 좌측(잠원동)",
    "lat": "37.505789",
    "lng": "127.0012603",
    "phoneNumber": "02-594-0505",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 407,
    "name": "에스이레아카데미원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 테헤란로86길 15 , 351호 (대치동, 동구빌딩)",
    "lat": "37.5064486",
    "lng": "127.0595016",
    "phoneNumber": "02-554-8209",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 408,
    "name": "기파랑문해원서초학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로 6-3 , 301호 (반포동,삼공빌딩)",
    "lat": "37.5037609",
    "lng": "127.009859",
    "phoneNumber": "02-6203-5750",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 409,
    "name": "네오과학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 명달로 51 , 5층 (방배동)",
    "lat": "37.4819435",
    "lng": "127.004645",
    "phoneNumber": "02-588-5525",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 410,
    "name": "압구정파인만중3관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 언주로167길 37 , 3층,4층 (신사동)",
    "lat": "37.5263835",
    "lng": "127.0300741",
    "phoneNumber": "02-548-1774",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 411,
    "name": "압구정파인만중2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 언주로167길 37 , 1층 전체 및 2층 일부 (신사동)",
    "lat": "37.5263835",
    "lng": "127.0300741",
    "phoneNumber": "02-548-1755",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 412,
    "name": "피아이어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 삼성로64길 51 1층 일부(좌측), 2층(대치동)",
    "lat": "37.5011262",
    "lng": "127.0644719",
    "phoneNumber": "02-501-7550",
    "교습과정": "외국어",
    "isFinish": ""
  },
  {
    "number": 414,
    "name": "대치소마학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 314 , 2층, 3층 (대치동, 보양빌딩)",
    "lat": "37.5000166",
    "lng": "127.0606578",
    "phoneNumber": "02-555-1201",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 415,
    "name": "새움6관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 301 , 6층 (대치동)",
    "lat": "37.499102",
    "lng": "127.0604069",
    "phoneNumber": "02-552-2373",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 416,
    "name": "에듀타임보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로63길 6   아리랑빌딩3층전부 301호 (대치동)",
    "lat": "37.5000722",
    "lng": "127.0595746",
    "phoneNumber": "02-508-7911",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 417,
    "name": "은빛보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동산로 62   부광빌딩 2층 일부 (양재동)",
    "lat": "37.4717408",
    "lng": "127.0456099",
    "phoneNumber": "02-579-8285",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 418,
    "name": "제2한빛변리사학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "인문사회(대)",
    "학원주소\t": "서울특별시 강남구 논현로95길 29-8   2층 (역삼동)",
    "lat": "37.5014469",
    "lng": "127.0338649",
    "phoneNumber": "02-567-1657",
    "교습과정": "성인고시",
    "isFinish": ""
  },
  {
    "number": 419,
    "name": "토킹스타경기학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 봉은사로67길 30 , 2층 (삼성동)",
    "lat": "37.513696",
    "lng": "127.0480768",
    "phoneNumber": "02-541-0599",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 420,
    "name": "알아이에스키즈어학원(Ris Kids Academy)",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 도곡로 157 , 1층~5층 (역삼동,원빌딩)",
    "lat": "37.4914833",
    "lng": "127.0370101",
    "phoneNumber": "02-571-2185",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 422,
    "name": "지이에스성인고시학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "인문사회(대)",
    "학원주소\t": "서울특별시 서초구 남부순환로333길 36   해원빌딩 2층 3층일부 (서초동)",
    "lat": "37.484057",
    "lng": "127.0210845",
    "phoneNumber": "02-525-2275",
    "교습과정": "성인고시",
    "isFinish": ""
  },
  {
    "number": 423,
    "name": "엔에프에이(NFA)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 영동대로50길 10 , 수성빌딩 3층 (대치동)",
    "lat": "37.4985403",
    "lng": "127.0699374",
    "phoneNumber": "02-558-7440",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 424,
    "name": "엠아이어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 선릉로 305 , 4~5층 (역삼동)",
    "lat": "37.4966422",
    "lng": "127.0524101",
    "phoneNumber": "02-563-2400",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 425,
    "name": "세계로학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 430 , 3층 일부 (대치동)",
    "lat": "37.4975062",
    "lng": "127.0575512",
    "phoneNumber": "02-501-3231",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 427,
    "name": "서초탑클래스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 명달로9길 6   3층 일부 (방배동)",
    "lat": "37.4821422",
    "lng": "127.0042854",
    "phoneNumber": "02-598-7094",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 428,
    "name": "개념상상학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 도곡로 418 , 4층 (대치동)",
    "lat": "37.4970089",
    "lng": "127.0562594",
    "phoneNumber": "02-567-0508",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 430,
    "name": "케이엔에스(KNS)영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 238 , 304호, 401~406호 (대치동, 태원 리치타운상가)",
    "lat": "37.4986835",
    "lng": "127.0613244",
    "phoneNumber": "02-555-4569",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 431,
    "name": "백상국어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 348   2층 (대치동)",
    "lat": "37.5026803",
    "lng": "127.0591664",
    "phoneNumber": "02-568-2135",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 435,
    "name": "천개의고원심화관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 307 , 2층, 4층 (대치동)",
    "lat": "37.4994104",
    "lng": "127.0602933",
    "phoneNumber": "02-501-5201",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 436,
    "name": "콴다일로큐나학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로67길 22   명문빌딩 3층 (대치동)",
    "lat": "37.5008433",
    "lng": "127.057656",
    "phoneNumber": "02-556-3228",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 437,
    "name": "만지학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 348   3층 (대치동)",
    "lat": "37.5026803",
    "lng": "127.0591664",
    "phoneNumber": "02-557-9533",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 438,
    "name": "대치해냄학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로71길 12 , 3층 (대치동,주원빌딩)",
    "lat": "37.5022678",
    "lng": "127.0578621",
    "phoneNumber": "02-558-5369",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 439,
    "name": "케이엔에스에듀초중등1관어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 도곡로 517 , 5층 전체·6층 일부 (대치동, 서진빌딩)",
    "lat": "37.4998422",
    "lng": "127.0629444",
    "phoneNumber": "02-508-0921",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 440,
    "name": "김태호과학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로77길 7   금강빌딩 6층 (대치동)",
    "lat": "37.4988033",
    "lng": "127.0583171",
    "phoneNumber": "02-563-3123",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 441,
    "name": "대치베스트다빈치2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로64길 20   3층 (대치동)",
    "lat": "37.4997609",
    "lng": "127.0531188",
    "phoneNumber": "-",
    "교습과정": "보습",
    "isFinish": "완료"
  },
  {
    "number": 442,
    "name": "악어에듀학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 역삼로64길 11 , 2층 (대치동)",
    "lat": "37.5003384",
    "lng": "127.0531944",
    "phoneNumber": "02-555-2053",
    "교습과정": "기타(소)",
    "isFinish": "완료"
  },
  {
    "number": 443,
    "name": "선경어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 남부순환로 2936 , 207호·209호·210호·308-1호·407호 (대치동, 윈플러스상가)",
    "lat": "37.4933573",
    "lng": "127.0619092",
    "phoneNumber": "02-568-9001",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 444,
    "name": "제이앤피영어전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 잠원로 204 , 4층 404호~406호 (잠원동)",
    "lat": "37.5192129",
    "lng": "127.0146576",
    "phoneNumber": "02-536-1190",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 445,
    "name": "대치올스터디학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 458   5층 (대치동)",
    "lat": "37.5024983",
    "lng": "127.0574222",
    "phoneNumber": "-",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 446,
    "name": "진체크패스영어보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배로 196  외1필지 2층 일부 204호 204-2호(방배동)",
    "lat": "37.4910962",
    "lng": "126.9918822",
    "phoneNumber": "02-536-8805",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 447,
    "name": "글로벌퍼스트학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로57길 19 , 3층 (대치동)",
    "lat": "37.4976226",
    "lng": "127.0595092",
    "phoneNumber": "02-569-6212",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 448,
    "name": "디비니티에듀보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 언주로 118   우성캐릭터199 125호 (도곡동)",
    "lat": "37.4877415",
    "lng": "127.0417847",
    "phoneNumber": "02-3461-4453",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 453,
    "name": "원인학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 310 , 301호일부 (대치동)",
    "lat": "37.4972908",
    "lng": "127.0527881",
    "phoneNumber": "02-538-1144",
    "교습과정": "보습",
    "isFinish": "완료"
  },
  {
    "number": 455,
    "name": "공감입시학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 311 , 5층 (대치동,제동빌딩)",
    "lat": "37.4996",
    "lng": "127.0601579",
    "phoneNumber": "02-538-1933",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 456,
    "name": "빅스영어보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 225   도곡렉슬상가 315호 (도곡동)",
    "lat": "37.4953504",
    "lng": "127.0527143",
    "phoneNumber": "02-574-2789",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 457,
    "name": "미래탐구논증과추론학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 436 , 2층전체 (대치동)",
    "lat": "37.4976943",
    "lng": "127.0581602",
    "phoneNumber": "02-501-1599",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 458,
    "name": "하이스트독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 서초구 효령로72길 15 , 4층일부, 5층 (서초동)",
    "lat": "37.4872522",
    "lng": "127.026207",
    "phoneNumber": "-",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 459,
    "name": "김민정막강수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로63길 6   2층 (대치동)",
    "lat": "37.5001238",
    "lng": "127.0596183",
    "phoneNumber": "02-2051-0389",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 460,
    "name": "애플트리서초어학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 사임당로 102-5 , 1층일부, 2층, 3층일부 (서초동, 신우빌딩)",
    "lat": "37.4901117",
    "lng": "127.0212358",
    "phoneNumber": "02-516-0509",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 462,
    "name": "드림하이본원학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로58길 7 , 2층 (대치동)",
    "lat": "37.4986625",
    "lng": "127.0618033",
    "phoneNumber": "02-543-6339",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 464,
    "name": "개념과유형보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 광평로 63  4층 401호(일원동)",
    "lat": "37.4828777",
    "lng": "127.0796221",
    "phoneNumber": "02-6403-5262",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 465,
    "name": "한국영재학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 선릉로 225 , 224호일부,225호 (도곡동,도곡렉슬상가)",
    "lat": "37.4953504",
    "lng": "127.0527143",
    "phoneNumber": "02-578-1946",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 466,
    "name": "러셀대치학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 남부순환로 2942 , 2층 전체, 601-1호, 701-2호  (대치동, 풍림프라자)",
    "lat": "37.4935818",
    "lng": "127.0623994",
    "phoneNumber": "02-2138-1010",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 468,
    "name": "큐브어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 삼성로71길 41 , 3층,4층 (대치동)",
    "lat": "37.5012117",
    "lng": "127.0555697",
    "phoneNumber": "02-558-5272",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 469,
    "name": "위자듀학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 326 , 303호,304호 (대치동)",
    "lat": "37.4987628",
    "lng": "127.0520992",
    "phoneNumber": "02-556-6580",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 470,
    "name": "해냄학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로71길 12 , 2층,4층,5층 (대치동,주원빌딩)",
    "lat": "37.5022678",
    "lng": "127.0578621",
    "phoneNumber": "02-3453-7192",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 472,
    "name": "손광균학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로8길 8 , 2층 (반포동)",
    "lat": "37.5024131",
    "lng": "127.010193",
    "phoneNumber": "02-591-0920",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 473,
    "name": "반포파인만학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로31길 14-13   201호 401호 (반포동)",
    "lat": "37.5007214",
    "lng": "127.010468",
    "phoneNumber": "02-537-7919",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 474,
    "name": "위드매스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로132길 60   2층 (청담동)",
    "lat": "37.5187461",
    "lng": "127.0461253",
    "phoneNumber": "02-541-9971",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 475,
    "name": "아카로드블루엠학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 영동대로 229 , 5층 (대치동)",
    "lat": "37.4995718",
    "lng": "127.0674703",
    "phoneNumber": "02-6203-5588",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 476,
    "name": "스와튼인터내셔널아카데미어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 도곡로 430 , 5층 (대치동,단우빌딩)",
    "lat": "37.4975062",
    "lng": "127.0575512",
    "phoneNumber": "02-578-9550",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 478,
    "name": "메릭스수학영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 강남대로66길 32   2층 (역삼동)",
    "lat": "37.4922802",
    "lng": "127.0334257",
    "phoneNumber": "02-565-9336",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 479,
    "name": "애플트리개포어학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 개포로 408 , 1층일부 (개포동)",
    "lat": "37.4858037",
    "lng": "127.0634758",
    "phoneNumber": "02-423-0509",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 482,
    "name": "압구정크라센2관어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 압구정로34길 30 , 1~4층 (신사동)",
    "lat": "37.5262165",
    "lng": "127.0305175",
    "phoneNumber": "02-541-8280",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 483,
    "name": "에이급수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 311 , 4층 (대치동,제동빌딩)",
    "lat": "37.4996",
    "lng": "127.0601579",
    "phoneNumber": "02-501-3883",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 484,
    "name": "반포대학나무학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 219 , 8동 5층 1~4호 (잠원동,반포쇼핑타운)",
    "lat": "37.5074568",
    "lng": "127.0078376",
    "phoneNumber": "02-536-0588",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 485,
    "name": "현재스토리학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로20길 34-6   5층 (서초동)",
    "lat": "37.4922602",
    "lng": "127.0158853",
    "phoneNumber": "02-522-2021",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 487,
    "name": "대치에프엠(FM)수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 효령로 214   3층 (서초동)",
    "lat": "37.4831243",
    "lng": "127.0077129",
    "phoneNumber": "02-585-5616",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 488,
    "name": "두각누리관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로63길 25 , 2층(대치동)",
    "lat": "37.4993918",
    "lng": "127.058098",
    "phoneNumber": "02-556-2114",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 490,
    "name": "피앤이어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 도산대로92길 6 , 201호 일부(청담동)",
    "lat": "37.5240654",
    "lng": "127.0502594",
    "phoneNumber": "02-3442-3128",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 491,
    "name": "청담에이프릴어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 삼성로119길 14 , 2층,3층 (삼성동, 주호빌딩)",
    "lat": "37.5160444",
    "lng": "127.0503312",
    "phoneNumber": "02-511-0511",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 494,
    "name": "도곡시매쓰보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로13길 5 , 2층 (역삼동)",
    "lat": "37.4914904",
    "lng": "127.0364388",
    "phoneNumber": "02-508-5218",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 495,
    "name": "명인입시컨설팅학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로62길 32-2 , 4층 (대치동)",
    "lat": "37.49768",
    "lng": "127.0550939",
    "phoneNumber": "02-567-5005",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 496,
    "name": "비티비(BTB)아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 남부순환로315길 104 , 4층 (서초동)",
    "lat": "37.4830805",
    "lng": "127.0075157",
    "phoneNumber": "02-586-2487",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 497,
    "name": "대오교육이진선과학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 349 202호, 302호(대치동)",
    "lat": "37.502675",
    "lng": "127.0584806",
    "phoneNumber": "02-000-2608",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 498,
    "name": "세정4층학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 306 , 4층 (대치동,IVY TOWER)",
    "lat": "37.4994476",
    "lng": "127.0608995",
    "phoneNumber": "02-555-6922",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 500,
    "name": "반포아너스영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동작대로 222 , 3층전체 (방배동, 목은빌딩)",
    "lat": "37.4963703",
    "lng": "126.9832599",
    "phoneNumber": "02-599-7752",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 502,
    "name": "상상력발전소보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로68길 9 2층",
    "lat": "37.4991433",
    "lng": "127.0524738",
    "phoneNumber": "02-538-1122",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 503,
    "name": "일프로아카데미(1%Academy)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로71길 41 , 2층 (대치동)",
    "lat": "37.5012117",
    "lng": "127.0555697",
    "phoneNumber": "02-3453-1011",
    "교습과정": "보습",
    "isFinish": "완료"
  },
  {
    "number": 504,
    "name": "에스엠논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로70길 28 , 3층(진선빌딩) (대치동)",
    "lat": "37.4996713",
    "lng": "127.054138",
    "phoneNumber": "02-511-2782",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 505,
    "name": "김&김학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배로 121 , 4층 (방배동,미광빌딩)",
    "lat": "37.4848787",
    "lng": "126.9951037",
    "phoneNumber": "02-521-5488",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 507,
    "name": "홍매쓰수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 효령로46길 5  외1필지 4층 502호(서초동)",
    "lat": "37.483309",
    "lng": "127.0090104",
    "phoneNumber": "02-522-2282",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 508,
    "name": "개포닥터정이클래스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 개포로 512 , 403호 (개포동, 개포종합상가)",
    "lat": "37.4893133",
    "lng": "127.0689409",
    "phoneNumber": "02-459-0933",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 511,
    "name": "여상진수리논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 445 , 2층 (대치동,현민빌딩)",
    "lat": "37.4985924",
    "lng": "127.0590243",
    "phoneNumber": "02-569-7134",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 514,
    "name": "에이원(A1)과학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로64길 11-5   301호 (대치동)",
    "lat": "37.4983086",
    "lng": "127.0528655",
    "phoneNumber": "02-565-0110",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 515,
    "name": "이룸스터디학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로78길 15 , 3층, 4층 (대치동)",
    "lat": "37.5015424",
    "lng": "127.057313",
    "phoneNumber": "02-3446-3404",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 516,
    "name": "지피에스압구정어학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 압구정로18길 25 , 4층일부 (신사동,제이유빌딩)",
    "lat": "37.5235062",
    "lng": "127.0253026",
    "phoneNumber": "02-775-0509",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 517,
    "name": "프라우드7학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 도곡로 418 , 6층 (대치동, 강원빌딩)",
    "lat": "37.4970089",
    "lng": "127.0562594",
    "phoneNumber": "02-566-0505",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 518,
    "name": "피오르에듀학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로77길 26 , 4층 (대치동, 대치빌딩)",
    "lat": "37.4999822",
    "lng": "127.058129",
    "phoneNumber": "02-6941-1098",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 519,
    "name": "시대인재수학스쿨학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 450 6층(대치동)",
    "lat": "37.4981124",
    "lng": "127.0597594",
    "phoneNumber": "02-583-4877",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 520,
    "name": "고래수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 봉은사로71길 31   3층 (삼성동)",
    "lat": "37.5142387",
    "lng": "127.0491914",
    "phoneNumber": "02-540-5403",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 521,
    "name": "버캔아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 선릉로112길 7 , 1~5층 (삼성동)",
    "lat": "37.5114073",
    "lng": "127.0442188",
    "phoneNumber": "02-3444-6106",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 522,
    "name": "입시연구소길학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로63길 17   2층 (대치동)",
    "lat": "37.4995695",
    "lng": "127.0587383",
    "phoneNumber": "02-556-2114",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 523,
    "name": "그린관리형독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 선릉로126길 12  3층 4층(삼성동)",
    "lat": "37.5152338",
    "lng": "127.043076",
    "phoneNumber": "02-511-1660",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 524,
    "name": "왕의아이들(KCLA)어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 봉은사로48길 30 , 1,2층 (역삼동)",
    "lat": "37.5076352",
    "lng": "127.0419298",
    "phoneNumber": "02-564-1270",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 525,
    "name": "반디과학전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동광로 82-1 , 2층,4층 (방배동, 한일빌딩)",
    "lat": "37.4930896",
    "lng": "126.9915737",
    "phoneNumber": "02-592-5234",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 526,
    "name": "해커스어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 강남대로61길 23 , 1층일부 (서초동,현대성우주상복합아파트)",
    "lat": "37.4984713",
    "lng": "127.0242506",
    "phoneNumber": "02-566-0001",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 527,
    "name": "옳음국어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로64길 35   4층 (대치동)",
    "lat": "37.5007014",
    "lng": "127.0631946",
    "phoneNumber": "02-555-0582",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 529,
    "name": "서초에이프릴어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 서초중앙로33길 6-6 , 2층, 3층 전체 (반포동, 신청담빌딩)",
    "lat": "37.5017832",
    "lng": "127.0111446",
    "phoneNumber": "02-537-4105",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 530,
    "name": "글로벌수학전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 언남길 43 , 2층  (양재동,언남빌딩)",
    "lat": "37.4731585",
    "lng": "127.0422992",
    "phoneNumber": "02-529-4122",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 531,
    "name": "게이트압구정어학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 압구정로 206 , 4층,5층 (신사동)",
    "lat": "37.5273244",
    "lng": "127.0295867",
    "phoneNumber": "02-525-0509",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 532,
    "name": "수마쿰라우데수학전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로6길 12 , 2층 전체 (개포동)",
    "lat": "37.4827689",
    "lng": "127.0619685",
    "phoneNumber": "02-529-7758",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 533,
    "name": "올가교육대치올가국어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로63길 15   3층 전체 (대치동)",
    "lat": "37.4996341",
    "lng": "127.0589335",
    "phoneNumber": "02-552-1231",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 534,
    "name": "플라즈마학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 450 , 4층 (대치동,덕산빌딩)",
    "lat": "37.4981124",
    "lng": "127.0597594",
    "phoneNumber": "02-557-5440",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 535,
    "name": "해커스어학원강남제1별관학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 강남대로61길 19   대우벨라채 101호 304호 (서초동)",
    "lat": "37.4985124",
    "lng": "127.0247111",
    "phoneNumber": "02-569-7467",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 536,
    "name": "생각하는황소학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 영동대로 302 , 6층(대치동)",
    "lat": "37.5016415",
    "lng": "127.0677666",
    "phoneNumber": "02-568-5496",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 537,
    "name": "반포세정스카이관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 반포대로 306 , 1층 (잠원동)",
    "lat": "37.5064327",
    "lng": "127.0009517",
    "phoneNumber": "02-567-2514",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 538,
    "name": "세명학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로3길 8  603동 612호(반포동",
    "lat": "37.5021022",
    "lng": "126.9869475",
    "phoneNumber": "02-599-7082",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 539,
    "name": "엘리트서초어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 고무래로10길 27 , 301호 (반포동,주호빌딩)",
    "lat": "37.5003314",
    "lng": "127.0101783",
    "phoneNumber": "02-536-6885",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 540,
    "name": "프레임수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로73길 13   2층 (대치동)",
    "lat": "37.498738",
    "lng": "127.0569719",
    "phoneNumber": "02-566-6668",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 542,
    "name": "무한도전수학과학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 광평로 63 , 301호,302호 (일원동)",
    "lat": "37.4828777",
    "lng": "127.0796221",
    "phoneNumber": "02-6052-7890",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 544,
    "name": "해를학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 327 , 2층 (대치동)",
    "lat": "37.5008825",
    "lng": "127.0594779",
    "phoneNumber": "02-501-1377",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 545,
    "name": "(주)방배청담어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 방배로28길 53 , 3층 (방배동)",
    "lat": "37.4913581",
    "lng": "126.9948899",
    "phoneNumber": "02-595-0599",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 546,
    "name": "방배에이프릴어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 방배로28길 53 , 2층 (방배동)",
    "lat": "37.4913581",
    "lng": "126.9948899",
    "phoneNumber": "02-594-9599",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 547,
    "name": "엑셀어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 논현로 816 , 3층일부 302호 (신사동, ICL빌딩)",
    "lat": "37.5212655",
    "lng": "127.02852",
    "phoneNumber": "02-544-7989",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 548,
    "name": "지엘에듀어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 사임당로 173 , 12층 (서초동, 서전빌딩)",
    "lat": "37.4927943",
    "lng": "127.0285544",
    "phoneNumber": "02-538-9552",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 550,
    "name": "이지스재수학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배로 76 , 301호전체, 302호일부(우측) (방배동, 머리재빌딩)",
    "lat": "37.4811934",
    "lng": "126.9983361",
    "phoneNumber": "02-598-0124",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 551,
    "name": "펜덕스영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로 134   304호 (신사동)",
    "lat": "37.5243611",
    "lng": "127.0234522",
    "phoneNumber": "02-517-0509",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 552,
    "name": "세터스어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 논현로159길 16 , 3층 (신사동)",
    "lat": "37.5231597",
    "lng": "127.0268071",
    "phoneNumber": "02-511-2677",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 553,
    "name": "(주)지이에스어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 도곡로 408  디마크빌딩 705 706호 (대치동)",
    "lat": "37.4966281",
    "lng": "127.055214",
    "phoneNumber": "02-508-2445",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 554,
    "name": "미강학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 448 , 3층 2호 (대치동, 동서빌딩)",
    "lat": "37.4980552",
    "lng": "127.0595812",
    "phoneNumber": "02-568-6060",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 556,
    "name": "케이채수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 155 , 513, 514호 (대치동)",
    "lat": "37.4957886",
    "lng": "127.0717955",
    "phoneNumber": "02-561-5312",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 558,
    "name": "적중코아스쿨학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로34길 26   2층 (신사동)",
    "lat": "37.5263722",
    "lng": "127.0305276",
    "phoneNumber": "02-545-5112",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 559,
    "name": "해커스어학원강남제6별관학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 서초대로73길 42 , 2층 (서초동, 강남역리가스퀘어)",
    "lat": "37.5011628",
    "lng": "127.0244129",
    "phoneNumber": "02-569-7467",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 560,
    "name": "대치이안어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 삼성로 323 , 2~3층 (대치동,삼주빌딩)",
    "lat": "37.5006127",
    "lng": "127.0596197",
    "phoneNumber": "02-568-4517",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 561,
    "name": "심앤김국수시대학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 명달로 52-7 , 3층(서초동)",
    "lat": "37.4823385",
    "lng": "127.0052473",
    "phoneNumber": "02-536-0959",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 562,
    "name": "베블렌수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동작대로 118 , 6층 606호~608호 (방배동,방배동예다인프라자빌딩)",
    "lat": "37.4869655",
    "lng": "126.9827324",
    "phoneNumber": "02-533-9184",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 563,
    "name": "파르테논어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 남부순환로 2927 , 4층전체 (대치동, 대치 클래시아)",
    "lat": "37.4936595",
    "lng": "127.0603384",
    "phoneNumber": "02-557-9688",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 565,
    "name": "정수학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로63길 31   2층 (대치동)",
    "lat": "37.4990059",
    "lng": "127.0534922",
    "phoneNumber": "02-558-3357",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 566,
    "name": "원바이원잉글리쉬아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 언주로167길 34 , 2층 (신사동, 우리빌딩)",
    "lat": "37.5266094",
    "lng": "127.0304576",
    "phoneNumber": "02-511-9656",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 567,
    "name": "모니카김영어스타일학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 테헤란로8길 22   화인빌딩 301호 (역삼동)",
    "lat": "37.4974156",
    "lng": "127.0315615",
    "phoneNumber": "02-558-8626",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 568,
    "name": "크레버스영재교육센터대치제1지점학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 456 , 3층전체,5층전체 (대치동)",
    "lat": "37.4982956",
    "lng": "127.0603287",
    "phoneNumber": "02-563-5600",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 569,
    "name": "강남김정학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 147 , 6층전체 (역삼동, 비봉빌딩)",
    "lat": "37.4911644",
    "lng": "127.0360184",
    "phoneNumber": "02-3477-3095",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 570,
    "name": "에스엔티(SNT)어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 삼성로64길 41 , 3층 (대치동)",
    "lat": "37.5010033999999",
    "lng": "127.063646",
    "phoneNumber": "02-508-0582",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 571,
    "name": "대현학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 301 , 5층 (대치동,하늘도시)",
    "lat": "37.499102",
    "lng": "127.0604069",
    "phoneNumber": "02-567-1575",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 572,
    "name": "플라즈마영재학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 450 , 3층 (대치동, 덕산빌딩)",
    "lat": "37.4981124",
    "lng": "127.0597594",
    "phoneNumber": "02-555-7600",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 573,
    "name": "비아이에스어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 서초중앙로31길 6-3 , 2층 (반포동, 지지반포빌딩)",
    "lat": "37.5000996",
    "lng": "127.0113176",
    "phoneNumber": "02-553-2684",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 574,
    "name": "엘티엘일류영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 봉은사로71길 32 , 2층 (삼성동)",
    "lat": "37.5143115",
    "lng": "127.0494309",
    "phoneNumber": "02-553-5332",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 576,
    "name": "프뢰벨영어은물어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 압구정로32길 11 , 301호~308호 (신사동)",
    "lat": "37.5269161",
    "lng": "127.0302159",
    "phoneNumber": "02-3450-5375",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 577,
    "name": "대치프라임독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 선릉로 314 , 301호 (대치동)",
    "lat": "37.4978251",
    "lng": "127.052405",
    "phoneNumber": "02-555-9500",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": "완료"
  },
  {
    "number": 579,
    "name": "시매쓰학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 남부순환로315길 104 , 5층 전체 (서초동)",
    "lat": "37.4830805",
    "lng": "127.0075157",
    "phoneNumber": "02-3486-2005",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 580,
    "name": "비채수학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로73길 14   2층 (대치동)",
    "lat": "37.4988032",
    "lng": "127.0571972",
    "phoneNumber": "02-558-4033",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 581,
    "name": "산에듀김영준국어논술학원신관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로62길 33 , 2층 (대치동, 장성빌딩)",
    "lat": "37.4980816",
    "lng": "127.0550538",
    "phoneNumber": "02-501-0575",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 583,
    "name": "대치카리스영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로67길 49 , 201호 (대치동, 오성 빌라)",
    "lat": "37.4999305",
    "lng": "127.0556143",
    "phoneNumber": "02-555-4310",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 584,
    "name": "서초소마학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로 14  외2필지 베뉴타워 4층 (반포동)",
    "lat": "37.50329",
    "lng": "127.0101243",
    "phoneNumber": "02-535-1205",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 585,
    "name": "와이즈만영재교육대치학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 영동대로 231 , 2층 일부 (대치동)",
    "lat": "37.4997861",
    "lng": "127.0673274",
    "phoneNumber": "02-554-3455",
    "교습과정": "보통교과",
    "isFinish": ""
  },
  {
    "number": 586,
    "name": "보람과학수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 영동대로 210 , 203호전체204호전체205호일부 (대치동)",
    "lat": "37.4980827",
    "lng": "127.0712194",
    "phoneNumber": "02-539-9533",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 588,
    "name": "멘토스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로64길 22 4층 401호 (대치동, 드림빌딩)",
    "lat": "37.4995919",
    "lng": "127.0532085",
    "phoneNumber": "02-557-0027",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 589,
    "name": "지피에이(GPA)영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로365길 38   2층 (도곡동)",
    "lat": "37.4877892",
    "lng": "127.039948",
    "phoneNumber": "02-6013-8129",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 590,
    "name": "삼성힐학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로119길 29 , 3층 (삼성동)",
    "lat": "37.5154511",
    "lng": "127.0490909",
    "phoneNumber": "02-3446-2090",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 591,
    "name": "호안천리프리미엄학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로58길 29 , 대치빌딩 202호 (대치동)",
    "lat": "37.4992421",
    "lng": "127.0635885",
    "phoneNumber": "02-566-2357",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 592,
    "name": "압구정파인만고등1관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로 152 , 102호,103호,104호105호 (신사동)",
    "lat": "37.5255760999999",
    "lng": "127.0260348",
    "phoneNumber": "02-548-1755",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 593,
    "name": "가인학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로31길 12 , 2층3층 전체 (반포동)",
    "lat": "37.4997272",
    "lng": "127.0109093",
    "phoneNumber": "02-532-8522",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 594,
    "name": "예섬2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 418 , 3층 (대치동, 강원빌딩)",
    "lat": "37.4970089",
    "lng": "127.0562594",
    "phoneNumber": "02-558-8822",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 595,
    "name": "김대균어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 봉은사로 474 , 209호 (삼성동,쌍용 플래티넘)",
    "lat": "37.5123174",
    "lng": "127.0518299",
    "phoneNumber": "02-556-0582",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 596,
    "name": "강남비상에듀학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로62길 5 , 5층 전체 (대치동)",
    "lat": "37.497328",
    "lng": "127.0530862",
    "phoneNumber": "02-525-2599",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 597,
    "name": "스칼라(scholar)어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 언주로151길 21 , 3층,4층,5층일부 (신사동)",
    "lat": "37.5217152",
    "lng": "127.0316867",
    "phoneNumber": "02-545-5430",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 598,
    "name": "스카이로드학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로64길 15-5 , 2층 (대치동)",
    "lat": "37.4984195",
    "lng": "127.0533033",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 599,
    "name": "이에스씨아카데미어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 압구정로30길 17 , 603호~606호 (신사동, 이소니프라자)",
    "lat": "37.5262629",
    "lng": "127.0294934",
    "phoneNumber": "02-552-2211",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 600,
    "name": "엑시터어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 논현로159길 14 , 2층 전체 (신사동)",
    "lat": "37.5231524",
    "lng": "127.0269962",
    "phoneNumber": "02-518-3822",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 601,
    "name": "블루큐브어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 압구정로28길 22-5 , 5,6층 (신사동)",
    "lat": "37.5250123",
    "lng": "127.0271808",
    "phoneNumber": "02-558-5278",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 603,
    "name": "아이엘이(별관)어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 도곡로 454 , 4층,5층 (대치동,알파마이티 대치빌딩)",
    "lat": "37.4982126",
    "lng": "127.0600967",
    "phoneNumber": "02-552-6003",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": "완료"
  },
  {
    "number": 604,
    "name": "휴브레인입시컨설팅센터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 462 , 1층, 2층 (대치동)",
    "lat": "37.502626",
    "lng": "127.0578107",
    "phoneNumber": "02-558-9283",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 605,
    "name": "강남하이퍼의대관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 강남대로94길 30 1~2층, 3층 일부(역삼동)",
    "lat": "37.4996884",
    "lng": "127.0298007",
    "phoneNumber": "02-875-9001",
    "교습과정": "진학지도",
    "isFinish": ""
  },
  {
    "number": 606,
    "name": "비와이피(BYP)보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동광로 6 , 2층 (방배동, 한덕빌딩)",
    "lat": "37.4907108",
    "lng": "126.9834989",
    "phoneNumber": "02-593-0588",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 607,
    "name": "케이엠지수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 340 , 4층 전체 (대치동, 앨포트빌딩)",
    "lat": "37.5019708",
    "lng": "127.0595756",
    "phoneNumber": "02-3316-0083",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 609,
    "name": "엠브릿지학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 일원로3길 10   2층 (일원동)",
    "lat": "37.4912196",
    "lng": "127.0815636",
    "phoneNumber": "02-2226-9905",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 610,
    "name": "게이트서초어학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 사임당로 102-5 , 3층일부, 4~6층 (서초동, 신우빌딩)",
    "lat": "37.4901117",
    "lng": "127.0212358",
    "phoneNumber": "02-997-0509",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 613,
    "name": "케이엔에스(KNS)고등3관영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로83길 5   3층 (대치동)",
    "lat": "37.4998553",
    "lng": "127.0621345",
    "phoneNumber": "02-501-4127",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 614,
    "name": "미퍼스트학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 212 , A블럭 317호 (대치동,은마아파트상가)",
    "lat": "37.495511",
    "lng": "127.0637579",
    "phoneNumber": "02-558-1088",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 615,
    "name": "앤버스영어전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 404   5층 (대치동)",
    "lat": "37.5005204",
    "lng": "127.0514247",
    "phoneNumber": "02-556-1571",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 616,
    "name": "프리셀영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로31길 14-11 , 4층 (반포동)",
    "lat": "37.5004952",
    "lng": "127.010461",
    "phoneNumber": "02-532-1936",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 618,
    "name": "메이저수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로 10-6   상영빌딩 2층2호 (반포동)",
    "lat": "37.5035613",
    "lng": "127.0097219",
    "phoneNumber": "02-599-0888",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 621,
    "name": "습관만들기학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로132길 60   3층 (청담동)",
    "lat": "37.5187461",
    "lng": "127.0461253",
    "phoneNumber": "02-541-9972",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 622,
    "name": "피아이서초어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 서초중앙로31길 6-3 , 1층일부, 3층 (반포동, 지지반포빌딩)",
    "lat": "37.5000996",
    "lng": "127.0113176",
    "phoneNumber": "02-594-7030",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 623,
    "name": "엘앤비프랩학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 언주로157길 26 , 4층 전체 (신사동)",
    "lat": "37.5240945",
    "lng": "127.030768",
    "phoneNumber": "02-588-5656",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 625,
    "name": "더원수능관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로71길 14 , 4층 (대치동)",
    "lat": "37.5022183",
    "lng": "127.0577128",
    "phoneNumber": "02-568-5336",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 627,
    "name": "이튼교육강남독학재수학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 사임당로 175 , 1001호일부,1002호 (서초동, 갤럭시타워)",
    "lat": "37.4928947",
    "lng": "127.0287118",
    "phoneNumber": "02-584-4300",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 628,
    "name": "논현해법영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 강남대로120길 31   2층 (논현동)",
    "lat": "37.5076551",
    "lng": "127.0256975",
    "phoneNumber": "02-515-0582",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 629,
    "name": "시대인재반포센터해냄관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 165 , 2동 522~525호 (잠원동, 반포쇼핑타운)",
    "lat": "37.5056721",
    "lng": "127.0019322",
    "phoneNumber": "02-596-9555",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 630,
    "name": "이루트학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동산로 66 4층(양재동)",
    "lat": "37.4718739",
    "lng": "127.0459807",
    "phoneNumber": "02-571-1083",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 631,
    "name": "리드101잠원반원학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로23길 30 , 209호, 226호 (잠원동,반원상가)",
    "lat": "37.5087874",
    "lng": "127.0035738",
    "phoneNumber": "02-593-4044",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 632,
    "name": "선제영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 150 , 201-2,201-3호 (대치동, 한보미도맨션)",
    "lat": "37.4925906",
    "lng": "127.066184",
    "phoneNumber": "02-508-1217",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 633,
    "name": "부엉이학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로78길 7  나호 한광빌딩 3층 (대치동)",
    "lat": "37.4976259",
    "lng": "127.0593292",
    "phoneNumber": "02-554-2400",
    "교습과정": "보습",
    "isFinish": "완료"
  },
  {
    "number": 635,
    "name": "킹스타운서초어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 동광로 88 , 3층 (방배동,부운빌딩)",
    "lat": "37.4932797",
    "lng": "126.9921729",
    "phoneNumber": "02-599-8770",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 636,
    "name": "로고스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 238 609호 610호 611호 312호 313호 314호 (대치동)",
    "lat": "37.4986375",
    "lng": "127.0614624",
    "phoneNumber": "02-556-3955",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 637,
    "name": "언어논술나무는학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로61길 10 , 1,2층 (대치동)",
    "lat": "37.4994045",
    "lng": "127.0595613",
    "phoneNumber": "02-555-9420",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 638,
    "name": "해커스어학원강남제3별관학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 서초대로73길 12 , 5층 (서초동,세계빌딩)",
    "lat": "37.4985905",
    "lng": "127.0258499",
    "phoneNumber": "02-569-7467",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 639,
    "name": "알앤디잉글리쉬(R&D English)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로33길 15   3층 (반포동)",
    "lat": "37.5008215",
    "lng": "127.0101975",
    "phoneNumber": "02-536-0022",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 640,
    "name": "펀수학본원학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 개포로 512   401호 (개포동)",
    "lat": "37.4892714",
    "lng": "127.0688177",
    "phoneNumber": "02-6414-9023",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 641,
    "name": "노정현수학반포본원학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로8길 2   4층 (반포동)",
    "lat": "37.5027909999999",
    "lng": "127.0104913",
    "phoneNumber": "02-537-7372",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 642,
    "name": "대치이르키움학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로71길 29 , 3층 (대치동)",
    "lat": "37.5015299",
    "lng": "127.0565389",
    "phoneNumber": "02-508-8088",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 643,
    "name": "미래탐구미래영재학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 325 , 5층, 6층 (대치동, 광오빌딩)",
    "lat": "37.5007467",
    "lng": "127.059549",
    "phoneNumber": "02-554-0161",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 645,
    "name": "티비티(TBT)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로83길 5   3층 (대치동)",
    "lat": "37.5038877",
    "lng": "127.0597523",
    "phoneNumber": "02-2051-9011",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 649,
    "name": "내가하는수학수학하마학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로72길 18   2층 (대치동)",
    "lat": "37.5002844",
    "lng": "127.05266",
    "phoneNumber": "02-6737-0701",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 650,
    "name": "배선영국어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로64길 15-3   2층 (대치동)",
    "lat": "37.4982954",
    "lng": "127.0533635",
    "phoneNumber": "02-566-5673",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 651,
    "name": "강남합격의법학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "인문사회(대)",
    "학원주소\t": "서울특별시 강남구 강남대로94길 71 , 2층,3층일부 (역삼동)",
    "lat": "37.5009066",
    "lng": "127.0329879",
    "phoneNumber": "02-555-5920",
    "교습과정": "성인고시",
    "isFinish": ""
  },
  {
    "number": 653,
    "name": "피씨비브레인코칭학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로71길 9 2층, 3층(대치동)",
    "lat": "37.5020912",
    "lng": "127.0581508",
    "phoneNumber": "02-557-9864",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 654,
    "name": "쌩뚱영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2921  외1필지 남서울종합상가 3층 2호(대치동)",
    "lat": "37.4934619",
    "lng": "127.0597692",
    "phoneNumber": "02-508-5093",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 655,
    "name": "두각대성세림관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 422 , 6층 (대치동,세림빌딩)",
    "lat": "37.4972615",
    "lng": "127.0567378",
    "phoneNumber": "02-569-2148",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 656,
    "name": "엠플러스수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 도구로 123-2   201호 (방배동)",
    "lat": "37.4876684",
    "lng": "126.9857887",
    "phoneNumber": "02-593-0943",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 657,
    "name": "서초1관정상어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 서초중앙로 217 , 2층,3층일부 (반포동, 대동빌딩)",
    "lat": "37.5010949",
    "lng": "127.0115982",
    "phoneNumber": "02-532-7676",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 658,
    "name": "압구정소마학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 언주로 844   윤당빌딩 3층 좌측 (신사동)",
    "lat": "37.5256241",
    "lng": "127.0337152",
    "phoneNumber": "02-3444-1209",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 659,
    "name": "입시투데이교육컨설팅학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 521   2층 (대치동)",
    "lat": "37.5037986",
    "lng": "127.0602481",
    "phoneNumber": "02-555-9601",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 661,
    "name": "에델린아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로32길 25  구원빌딩 3층(신사동)",
    "lat": "37.5260448",
    "lng": "127.0300503",
    "phoneNumber": "02-515-0966",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 662,
    "name": "강남케이에스보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 광평로51길 6-11   문암빌딩 6층 (수서동)",
    "lat": "37.4885196",
    "lng": "127.1032564",
    "phoneNumber": "02-400-8585",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 663,
    "name": "지아이에이(GIA)어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 학동로19길 22 , 1층,2층 (논현동, 조엔리빌딩)",
    "lat": "37.5143739",
    "lng": "127.0273364",
    "phoneNumber": "02-546-5300",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 664,
    "name": "서순영국어논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동작대로 74   3층 (방배동)",
    "lat": "37.4831577",
    "lng": "126.9823536",
    "phoneNumber": "02-523-4005",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 665,
    "name": "블루북스리딩학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 잠원로 24   반포자이플라자 502호 (반포동)",
    "lat": "37.5071264",
    "lng": "127.0098413",
    "phoneNumber": "02-596-5050",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 666,
    "name": "시리우스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 역삼로 505 , 1층일부·4층·5층 (대치동)",
    "lat": "37.5034652999999",
    "lng": "127.0591428",
    "phoneNumber": "02-553-5202",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 667,
    "name": "대치수과모학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 336   한림빌딩 301호 (대치동)",
    "lat": "37.5016654",
    "lng": "127.0598058",
    "phoneNumber": "02-562-5502",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 668,
    "name": "아드지스영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 212 , 은마상가 편의동 307호 (대치동, 은마아파트)",
    "lat": "37.495511",
    "lng": "127.0637579",
    "phoneNumber": "02-569-0579",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 669,
    "name": "이해국어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로64길 45   탐스코빌딩6층 (대치동)",
    "lat": "37.500961",
    "lng": "127.0639352",
    "phoneNumber": "02-538-1990",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 671,
    "name": "아레네스(R&S)수학전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초대로25길 16-1   2층 (방배동)",
    "lat": "37.4887053",
    "lng": "126.9940708",
    "phoneNumber": "02-596-7072",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 672,
    "name": "에이치씨엠에스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 청두곶6길 4   1층 (방배동)",
    "lat": "37.4792003",
    "lng": "126.9855079",
    "phoneNumber": "02-582-1226",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 673,
    "name": "세린(S.E.C)어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 방배로 189 , 3층 전체 (방배동)",
    "lat": "37.4902156",
    "lng": "126.9917009",
    "phoneNumber": "02-535-0542",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 674,
    "name": "정영어학원아이비학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2941 , 401호,401-1호 (대치동,대치탑프라자)",
    "lat": "37.4942268",
    "lng": "127.0617852",
    "phoneNumber": "02-3414-3388",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 675,
    "name": "에프엑스(f(x))수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 213   317~324 (잠원동)",
    "lat": "37.5072627",
    "lng": "127.0071911",
    "phoneNumber": "02-594-4888",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 676,
    "name": "예섬본관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 418 , 2층 (대치동,강원빌딩)",
    "lat": "37.4970089",
    "lng": "127.0562594",
    "phoneNumber": "02-558-8822",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 677,
    "name": "대한논리방배학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배로 113 , 202호 (방배동)",
    "lat": "37.4841699",
    "lng": "126.9956129",
    "phoneNumber": "02-583-8214",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 678,
    "name": "리더스아카데미어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 언주로 311 , 4층 (역삼동, 로즈1타워)",
    "lat": "37.4952625",
    "lng": "127.045625",
    "phoneNumber": "02-562-9799",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 679,
    "name": "알파잉글리쉬학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2941 , 303호 (대치동,대치탑프라자)",
    "lat": "37.4942268",
    "lng": "127.0617852",
    "phoneNumber": "02-563-7746",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 680,
    "name": "에이플영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동산로13길 6 , 3층 (양재동)",
    "lat": "37.472202",
    "lng": "127.0453938",
    "phoneNumber": "02-6083-2006",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 681,
    "name": "대찬2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 428 , 201호,301호일부 (대치동)",
    "lat": "37.4974415999999",
    "lng": "127.0573512",
    "phoneNumber": "02-554-2779",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 682,
    "name": "잉글리쉬부띠끄어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 고무래로10길 19   반곡빌딩 1층 (반포동)",
    "lat": "37.5009601",
    "lng": "127.010246",
    "phoneNumber": "02-596-0509",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 683,
    "name": "티앤비에듀케이션학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로34길 32 , 1층 (신사동)",
    "lat": "37.5260396",
    "lng": "127.0305058",
    "phoneNumber": "02-511-8388",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 684,
    "name": "김하연국어의고수학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 212  은마종합상가 에이블럭 310호 (대치동)",
    "lat": "37.4954127",
    "lng": "127.0636485",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 685,
    "name": "이지솔루션학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 명달로 52-7 2층 전부  (서초동)",
    "lat": "37.4823385",
    "lng": "127.0052473",
    "phoneNumber": "02-598-0953",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 686,
    "name": "문사탐학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초대로55길 19   5층 (서초동)",
    "lat": "37.4963888",
    "lng": "127.0150433",
    "phoneNumber": "02-594-6901",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 690,
    "name": "강남정보학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 670 , 402호 (삼성동,해운빌딩)",
    "lat": "37.5124317",
    "lng": "127.0541859",
    "phoneNumber": "02-517-0689",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 691,
    "name": "수아체학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배로 104 , 302호 (방배동)",
    "lat": "37.4835791",
    "lng": "126.9965625",
    "phoneNumber": "02-3472-3004",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 692,
    "name": "케이디(KD)영어전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 효령로 222 , 2층일부(201호) (서초동)",
    "lat": "37.4832501",
    "lng": "127.0083575",
    "phoneNumber": "02-597-0579",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 693,
    "name": "눈높이러닝센터개포일원학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 일원로 45 , 2층 (일원동,대훈빌딩)",
    "lat": "37.4899165",
    "lng": "127.0815425",
    "phoneNumber": "02-3411-9109",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 694,
    "name": "이이엘씨(eelc)킨더어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 고무래로 10-5 , 5층일부,6층일부 (반포동)",
    "lat": "37.5033799",
    "lng": "127.0098048",
    "phoneNumber": "02-6482-4856",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 695,
    "name": "위즈아일랜드압구정어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 선릉로 820 , 102호, 103호 (청담동, 남한강빌딩)",
    "lat": "37.5290064",
    "lng": "127.0483347",
    "phoneNumber": "02-543-3266",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 696,
    "name": "강남대치동토마토스쿨입시컨설팅X재수재종전일학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 458 , 3층 (대치동, 영미빌딩)",
    "lat": "37.5024983",
    "lng": "127.0574222",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 697,
    "name": "탑아너스잉글리쉬(TOPHONORSENGLISH)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 212 , A블럭 306-3호 (대치동,은마아파트상가)",
    "lat": "37.495511",
    "lng": "127.0637579",
    "phoneNumber": "02-501-0571",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 700,
    "name": "강의하는아이들압구정학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로29길 72-1  3층 2호(압구정동)",
    "lat": "37.5322852",
    "lng": "127.0283977",
    "phoneNumber": "02-543-8209",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 701,
    "name": "대치일타학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로57길 40   2층 (대치동)",
    "lat": "37.4973852",
    "lng": "127.057859",
    "phoneNumber": "02-417-7734",
    "교습과정": "보습",
    "isFinish": "완료"
  },
  {
    "number": 703,
    "name": "제네시스수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 41 반포상가 K동 306호(반포동)",
    "lat": "37.5033106",
    "lng": "126.9896744",
    "phoneNumber": "02-537-9915",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 705,
    "name": "키즈12리더스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 학동로97길 42 , 5층 (청담동)",
    "lat": "37.5224946",
    "lng": "127.0547327",
    "phoneNumber": "070-7405-0644",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 706,
    "name": "청담아이가르텐어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 학동로97길 42 , 1~3층 전체 (청담동, 청담동교육연구시설)",
    "lat": "37.5224946",
    "lng": "127.0547327",
    "phoneNumber": "02-591-0564",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 707,
    "name": "베테랑스어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 도산대로6길 14 3층, 4층(논현동)",
    "lat": "37.5157284",
    "lng": "127.0216975",
    "phoneNumber": "02-3444-5944",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 708,
    "name": "예감학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 433 , 2층 (대치동)",
    "lat": "37.4981056",
    "lng": "127.0576582",
    "phoneNumber": "02-556-0039",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 712,
    "name": "박신영국어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로61길 34   2층 (대치동)",
    "lat": "37.4988187",
    "lng": "127.0576772",
    "phoneNumber": "02-555-9622",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 714,
    "name": "디케이(DK)수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로63길 7-5 1층,4층,5층(대치동)",
    "lat": "37.4995822",
    "lng": "127.0596698",
    "phoneNumber": "02-539-2279",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 717,
    "name": "이상수학안쌤영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서운로 207    삼호종합상가 307호(서초동)",
    "lat": "37.5014324",
    "lng": "127.0217449",
    "phoneNumber": "02-596-1718",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 718,
    "name": "반포비전매쓰학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 213 , 3층 1호 (잠원동,반포쇼핑타운)",
    "lat": "37.5072627",
    "lng": "127.0071911",
    "phoneNumber": "02-599-8936",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 719,
    "name": "탑1%영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 546 , 301호 (대치동)",
    "lat": "37.5042425",
    "lng": "127.0628906",
    "phoneNumber": "02-567-8411",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 720,
    "name": "에듀-퍼스트학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로78길 18 , 2층 (대치동)",
    "lat": "37.501327",
    "lng": "127.0571143",
    "phoneNumber": "02-501-5825",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 721,
    "name": "덕스어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 영동대로 231 , 5층 일부 (대치동)",
    "lat": "37.4997861",
    "lng": "127.0673274",
    "phoneNumber": "02-563-3349",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 722,
    "name": "권박사학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 반포대로 300   4층 (잠원동)",
    "lat": "37.505956",
    "lng": "127.0011819",
    "phoneNumber": "02-593-7871",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 723,
    "name": "이에스엘(E.S.L)영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 효령로74길 4 , 2층 (서초동, 우담빌딩)",
    "lat": "37.4877119999999",
    "lng": "127.0265226",
    "phoneNumber": "02-584-0579",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 724,
    "name": "토나아카데미(TONAacademy)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로71길 19 , 5층 (대치동)",
    "lat": "37.5018308",
    "lng": "127.0573774",
    "phoneNumber": "070-7520-1661",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 725,
    "name": "아우라에듀학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 462 , 5층 전체 (대치동)",
    "lat": "37.502626",
    "lng": "127.0578107",
    "phoneNumber": "070-1698-8282",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 726,
    "name": "알바트로스영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로64길 45   탐스코빌딩 4층 (대치동)",
    "lat": "37.500961",
    "lng": "127.0639352",
    "phoneNumber": "02-6074-5657",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 727,
    "name": "메이커스어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 언주로 844 , 2층일부 (신사동, 윤당빌딩)",
    "lat": "37.5256241",
    "lng": "127.0337152",
    "phoneNumber": "02-6925-0038",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 728,
    "name": "대치우리학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 526   남평빌딩 2층 (대치동)",
    "lat": "37.4995573",
    "lng": "127.0639286",
    "phoneNumber": "02-567-4566",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 729,
    "name": "드림에듀학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 개포로 221  네비스빌딩 4층 (개포동)",
    "lat": "37.4789383",
    "lng": "127.0470902",
    "phoneNumber": "02-577-8555",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 730,
    "name": "알타이탈리아어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 서초대로56길 28 , 4층 (서초동)",
    "lat": "37.4932896",
    "lng": "127.0172356",
    "phoneNumber": "02-522-5747",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 731,
    "name": "가람하지혜언어전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배로 134 , 301호 (방배동)",
    "lat": "37.486199",
    "lng": "126.994952",
    "phoneNumber": "02-3482-2588",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 732,
    "name": "서연고학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 효령로 183 , 3층 일부 (서초동,혜성빌딩)",
    "lat": "37.4829288",
    "lng": "127.0041056",
    "phoneNumber": "02-522-1357",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 733,
    "name": "에이원레거씨리퍼블릭학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 도곡로 408  디마크빌딩 5층 501 502 503호 (대치동)",
    "lat": "37.4966281",
    "lng": "127.055214",
    "phoneNumber": "070-8672-5350",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 735,
    "name": "신미래탐구학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 436 , 3층전체 (대치동)",
    "lat": "37.4976943",
    "lng": "127.0581602",
    "phoneNumber": "02-538-3372",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 736,
    "name": "스카이엠(SKYM)수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동산로13길 42 , 3층 (양재동,부전빌딩)",
    "lat": "37.4735193",
    "lng": "127.0440249",
    "phoneNumber": "02-577-2213",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 738,
    "name": "필영재학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 519   2층 (대치동)",
    "lat": "37.503799",
    "lng": "127.0600592",
    "phoneNumber": "02-558-6990",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 739,
    "name": "신아크로학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 38   602호 (개포동)",
    "lat": "37.4886736",
    "lng": "127.0668063",
    "phoneNumber": "02-573-8170",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 740,
    "name": "클라디학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로77길 14 , 4층, 5층 일부 (대치동, 양지빌딩)",
    "lat": "37.4992943",
    "lng": "127.0585913",
    "phoneNumber": "02-537-3222",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 743,
    "name": "압구정아이엘츠어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 논현로176길 20   화영빌딩 4층 5층 (신사동)",
    "lat": "37.5272323",
    "lng": "127.0301438",
    "phoneNumber": "02-517-6200",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 744,
    "name": "깊은생각256학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 501 , 6층 (대치동,SM TOWER)",
    "lat": "37.4993898",
    "lng": "127.061127",
    "phoneNumber": "02-556-7787",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 745,
    "name": "눈높이러닝센터방배제1보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배로 125   3층 일부 (방배동)",
    "lat": "37.4851004",
    "lng": "126.9949623",
    "phoneNumber": "02-584-3400",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 746,
    "name": "이지엠학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 논현로7길 34   3층 (양재동)",
    "lat": "37.4724488",
    "lng": "127.0474453",
    "phoneNumber": "02-6053-2232",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 747,
    "name": "파인로드영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 언주로167길 35 , 5층 (신사동)",
    "lat": "37.5263754",
    "lng": "127.0302672",
    "phoneNumber": "02-2135-7663",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 748,
    "name": "수학전문순수학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 522   2층 (대치동)",
    "lat": "37.4994597",
    "lng": "127.063584",
    "phoneNumber": "02-501-1238",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 751,
    "name": "시대인재특목센터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 329 , 4층,5층 (대치동)",
    "lat": "37.5010216",
    "lng": "127.0594045",
    "phoneNumber": "02-565-2373",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 752,
    "name": "매쓰몽수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 120 , 1층,2층 (대치동, 우성아파트11동 11)",
    "lat": "37.491125",
    "lng": "127.059896",
    "phoneNumber": "02-553-1743",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 753,
    "name": "능률주니어랩학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 강남대로8길 69   2층 (양재동)",
    "lat": "37.4698212",
    "lng": "127.0440916",
    "phoneNumber": "02-6677-7769",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 754,
    "name": "라미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 논현로10길 16 , 2층 (개포동)",
    "lat": "37.4743159",
    "lng": "127.0499485",
    "phoneNumber": "02-577-5779",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 755,
    "name": "소자수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 334 , 203호 (대치동)",
    "lat": "37.4995931",
    "lng": "127.0516807",
    "phoneNumber": "02-597-2303",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 756,
    "name": "디오영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 212  은마상가 311호 (대치동)",
    "lat": "37.4974176",
    "lng": "127.0653272",
    "phoneNumber": "02-3452-8875",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 758,
    "name": "한올국어논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동작대로 198 , 국제빌딩 3층 (방배동)",
    "lat": "37.4942847",
    "lng": "126.9831867",
    "phoneNumber": "02-3477-1053",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 761,
    "name": "토토빌놀이학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 고무래로10길 27 , 2층일부 201호 (반포동, 주호빌딩)",
    "lat": "37.5003314",
    "lng": "127.0101783",
    "phoneNumber": "02-537-1146",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 765,
    "name": "다원매쓰아이(Math i)2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 521   대치프라자Ⅱ 503호 (대치동)",
    "lat": "37.5000321",
    "lng": "127.0632277",
    "phoneNumber": "02-3454-0492",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 766,
    "name": "시매쓰영재중등관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 409   타워엠프리스 3층 303호 (대치동)",
    "lat": "37.4973819",
    "lng": "127.0551699",
    "phoneNumber": "02-6365-0815",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 767,
    "name": "에듀플렉스에듀코치개별지도대치은마학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 삼성로 212 , 301-C호일부,312-2호(은마상가B블럭) (대치동, 은마아파트)",
    "lat": "37.495511",
    "lng": "127.0637579",
    "phoneNumber": "02-555-1651",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 768,
    "name": "퍼스널잉글리쉬어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 테헤란로1길 10 , 5층 전체 (역삼동, 세경빌딩)",
    "lat": "37.4989555",
    "lng": "127.0282257",
    "phoneNumber": "02-2051-5050",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 769,
    "name": "에이엔키즈어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 압구정로18길 25 , 2층 전체 (신사동, 한국산업양행빌딩)",
    "lat": "37.5233078",
    "lng": "127.0254152",
    "phoneNumber": "02-542-7152",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 770,
    "name": "리틀팍스어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 역삼로 447 , 3층 1호, 4층 1호 (대치동, 리틀팍스 빌딩)",
    "lat": "37.5023983",
    "lng": "127.0559204",
    "phoneNumber": "02-6933-0579",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 774,
    "name": "칼론(KALON)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로34길 34   2층 (신사동)",
    "lat": "37.5258633",
    "lng": "127.0304942",
    "phoneNumber": "02-515-2677",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 775,
    "name": "센티움학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 논현로175길 25 5층 A(신사동)",
    "lat": "37.5254304",
    "lng": "127.0266876",
    "phoneNumber": "02-516-9094",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 776,
    "name": "김상호이엠케이학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로 132  302호(신사동)",
    "lat": "37.5242325",
    "lng": "127.0232383",
    "phoneNumber": "02-536-6751",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 777,
    "name": "진선생제2관영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 고무래로10길 10 3층 (반포동)",
    "lat": "37.5018993",
    "lng": "127.0104491",
    "phoneNumber": "02-591-7937",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 780,
    "name": "영재사관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 554 , 4층 (대치동)",
    "lat": "37.5045268999999",
    "lng": "127.0637441",
    "phoneNumber": "02-569-3311",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 782,
    "name": "페디아플러스청담학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로130길 20 , 306,307호 (삼성동,래미안 삼성2차상가)",
    "lat": "37.5161513",
    "lng": "127.0434365",
    "phoneNumber": "02-549-0579",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 783,
    "name": "케이엠오원(KMO1)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 349 , 4층 일부(동쪽) (대치동, 우진빌딩)",
    "lat": "37.502675",
    "lng": "127.0584806",
    "phoneNumber": "02-561-3088",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 784,
    "name": "에듀플렉스에듀코치개별지도방배학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동광로 106 , 3층 301호 (방배동)",
    "lat": "37.4936207",
    "lng": "126.9938509",
    "phoneNumber": "02-3476-1651",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 785,
    "name": "새움9관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로77길 7 , 4층전체 (대치동)",
    "lat": "37.4988033",
    "lng": "127.0583171",
    "phoneNumber": "02-539-1496",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 786,
    "name": "초월시간학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로71길 25   2층 (대치동)",
    "lat": "37.5016615",
    "lng": "127.0569384",
    "phoneNumber": "02-3453-5551",
    "교습과정": "보습",
    "isFinish": "완료"
  },
  {
    "number": 788,
    "name": "라트학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 논현로 164 , 2층(도곡동)",
    "lat": "37.4842964",
    "lng": "127.0424336",
    "phoneNumber": "02-573-0575",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 789,
    "name": "위드유영어(WithUEnglish)전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초대로1길 30 , A동 401호일부 (방배동, 방배1차현대아파트)",
    "lat": "37.4885501",
    "lng": "126.9838383",
    "phoneNumber": "02-522-1800",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 790,
    "name": "지이엠(GEM)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 306  개나리래미안상가 308 309호 (역삼동)",
    "lat": "37.4985708",
    "lng": "127.0464187",
    "phoneNumber": "02-501-0450",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 791,
    "name": "김종철국어수학전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 효령로 184   유신빌딩 4층 (방배동)",
    "lat": "37.4824614",
    "lng": "127.0041881",
    "phoneNumber": "02-525-5577",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 792,
    "name": "메사(MESA)특목자사관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 212 , B블럭 301-9호 (대치동,은마아파트상가)",
    "lat": "37.495511",
    "lng": "127.0637579",
    "phoneNumber": "02-3454-0101",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 793,
    "name": "반석수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 잠원로4길 33-2 , 202호, 301호, 303호 일부, 304호 (잠원동, 잠원동 스타빌딩)",
    "lat": "37.5127866",
    "lng": "127.0104965",
    "phoneNumber": "02-532-8831",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 794,
    "name": "이희정영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 213  7동 212호(잠원동",
    "lat": "37.5072627",
    "lng": "127.0071911",
    "phoneNumber": "02-567-4260",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 795,
    "name": "해커스어학원강남제5별관학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 서초대로73길 40 , 2층전체 (서초동)",
    "lat": "37.5009346",
    "lng": "127.0245823",
    "phoneNumber": "02-569-7467",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 796,
    "name": "대치파인만학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 3032 , 305호,312호,313호,314호 (대치동)",
    "lat": "37.5445026",
    "lng": "127.0613966",
    "phoneNumber": "02-548-9230",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 797,
    "name": "압구정점아이엘이어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 논현로 842 , 4층 (신사동,압구정빌딩)",
    "lat": "37.5240000999999",
    "lng": "127.0287323",
    "phoneNumber": "02-3445-6003",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 798,
    "name": "수림(秀林)수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 212  은마상가 B블럭 301-20호 (대치동)",
    "lat": "37.4954127",
    "lng": "127.0636485",
    "phoneNumber": "02-555-5383",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 801,
    "name": "레드매쓰수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 531   3층 (대치동)",
    "lat": "37.5003211999999",
    "lng": "127.0644992",
    "phoneNumber": "02-565-1365",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 803,
    "name": "프로세스논술컨설팅학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 도곡로 408 , 309호,310호,311호(디마크빌딩) (대치동)",
    "lat": "37.4966877",
    "lng": "127.0552639",
    "phoneNumber": "02-565-1172",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 804,
    "name": "수미사대치학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 319 , 4층, 7층(대치동) (대치동, 금강빌딩)",
    "lat": "37.5003433",
    "lng": "127.059761",
    "phoneNumber": "02-2202-4567",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 806,
    "name": "대치선탑학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 464-2   1층 (대치동)",
    "lat": "37.5025331999999",
    "lng": "127.0580578",
    "phoneNumber": "02-562-3315",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 809,
    "name": "김영편입강남단과캠퍼스학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 강남대로78길 8 , 5층~7층 (역삼동)",
    "lat": "37.4947875",
    "lng": "127.0300669",
    "phoneNumber": "02-553-8711",
    "교습과정": "대학편입",
    "isFinish": ""
  },
  {
    "number": 810,
    "name": "상상사진학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 테헤란로8길 26   테헤란빌딩 5층 (역삼동)",
    "lat": "37.4971925",
    "lng": "127.0316861",
    "phoneNumber": "02-556-2785",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 812,
    "name": "남혁학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 212  은마상가B블럭 301-23호 (대치동)",
    "lat": "37.4954127",
    "lng": "127.0636485",
    "phoneNumber": "02-568-0712",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 813,
    "name": "성산학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 212 , 은마상가 3층 10호,13호  (대치동,은마아파트)",
    "lat": "37.4966263",
    "lng": "127.0708462",
    "phoneNumber": "02-569-5511",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 814,
    "name": "케이투수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 212  은마상가B블럭 301-7호 일부 (대치동)",
    "lat": "37.4954127",
    "lng": "127.0636485",
    "phoneNumber": "02-538-4347",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 821,
    "name": "야누아학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 212  은마상가B블럭 301-7호 일부 앞쪽 (대치동)",
    "lat": "37.4954127",
    "lng": "127.0636485",
    "phoneNumber": "02-568-8433",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 823,
    "name": "서원신관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로62길 33 , 3층 (대치동)",
    "lat": "37.4980816",
    "lng": "127.0550538",
    "phoneNumber": "02-556-1104",
    "교습과정": "보통교과",
    "isFinish": ""
  },
  {
    "number": 824,
    "name": "프린서플어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 강남대로94길 19   3~5층 (역삼동)",
    "lat": "37.4996863",
    "lng": "127.028764",
    "phoneNumber": "02-539-8963",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 825,
    "name": "알토어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 언주로 201 , 203호, 204호, 206호 (도곡동, 에스케이리더스뷰)",
    "lat": "37.48814",
    "lng": "127.0487557",
    "phoneNumber": "02-577-7448",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 827,
    "name": "파인만고수학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 150 , 203-4호 (대치동, 한보미도맨션208동)",
    "lat": "37.4925906",
    "lng": "127.066184",
    "phoneNumber": "02-548-1755",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 829,
    "name": "(주)산에듀김영준국어논술전문별관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로62길 27 , 1~4층 (대치동)",
    "lat": "37.4978682",
    "lng": "127.0547501",
    "phoneNumber": "02-501-0575",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 830,
    "name": "이루리3관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 233 , 4층일부 (대치동,신사빌딩)",
    "lat": "37.4977699",
    "lng": "127.0606416",
    "phoneNumber": "02-553-9124",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 831,
    "name": "효자학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 삼성로72길 3   2층 (대치동)",
    "lat": "37.502669",
    "lng": "127.0593989",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 832,
    "name": "반포새움학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 195   반포쇼핑타운 503호 504호 505호 513호 514호 515호 (잠원동)",
    "lat": "37.5065891",
    "lng": "127.0052661",
    "phoneNumber": "02-535-8561",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 833,
    "name": "에스아이비(SIB)교육센터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 압구정로34길 11 , 306호 (신사동)",
    "lat": "37.5273895",
    "lng": "127.030957",
    "phoneNumber": "02-545-7116",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 834,
    "name": "이제헌아이엘츠어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 강남대로94길 27-11 , 삼정빌딩4층 일부 (역삼동)",
    "lat": "37.5004733",
    "lng": "127.029237",
    "phoneNumber": "02-553-8927",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 836,
    "name": "윤선생영어숲반포학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초대로51길 13   3층 일부 (서초동)",
    "lat": "37.4951450999999",
    "lng": "127.0140554",
    "phoneNumber": "02-592-6101",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 838,
    "name": "비씨컬리지잇서초어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 반포대로4길 58 , 지하1층~지상6층 (서초동, 케이탑리츠 서초빌딩)",
    "lat": "37.4818776",
    "lng": "127.0160777",
    "phoneNumber": "02-2135-2000",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 839,
    "name": "씨엠에스서초제2본원학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동작대로 234 , 1층~2층 전체 (방배동, CMS M)",
    "lat": "37.4972729",
    "lng": "126.9837363",
    "phoneNumber": "02-537-1288",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 840,
    "name": "종로신중성어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 테헤란로5길 31 , 4층,6층 (역삼동)",
    "lat": "37.5006999999999",
    "lng": "127.0287234",
    "phoneNumber": "02-2051-8279",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 842,
    "name": "블루키프렙어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 압구정로30길 17 , 304호, 305호, 306호 (신사동)",
    "lat": "37.5263249",
    "lng": "127.0295435",
    "phoneNumber": "02-3443-2228",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 843,
    "name": "연세수능매니아학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 409 , 3층 301호 (대치동, 타워엠프리스)",
    "lat": "37.4973819",
    "lng": "127.0551699",
    "phoneNumber": "02-577-8111",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 844,
    "name": "피아이에프(PIF)서초관영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 효령로 183 , 4층 401호 (서초동)",
    "lat": "37.4829288",
    "lng": "127.0041056",
    "phoneNumber": "02-525-8584",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 845,
    "name": "대치퍼스트학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 519 , 2층 2호 (대치동)",
    "lat": "37.503799",
    "lng": "127.0600592",
    "phoneNumber": "02-553-6220",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 847,
    "name": "미키어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 서초대로50길 62-11 2~4층(서초동)",
    "lat": "37.490346",
    "lng": "127.0129258",
    "phoneNumber": "02-523-2789",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 848,
    "name": "아이비라인압구정학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로153길 5 , 3층 전체 (신사동, 보성빌딩)",
    "lat": "37.5244639",
    "lng": "127.0389008",
    "phoneNumber": "02-556-2052",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 849,
    "name": "해빛나인어학원2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 도곡로 517 , 3층 (대치동,서진빌딩)",
    "lat": "37.4998422",
    "lng": "127.0629444",
    "phoneNumber": "02-3453-0579",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 850,
    "name": "메테오에듀학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 456-2   2층 (대치동)",
    "lat": "37.5022767",
    "lng": "127.0572869",
    "phoneNumber": "02-553-0051",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 851,
    "name": "수력학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로77길 14 , 501호 (대치동, 양지빌딩)",
    "lat": "37.4992943",
    "lng": "127.0585913",
    "phoneNumber": "02-508-1617",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 852,
    "name": "바른입시가인학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로31길 12 , 4층 전체 (반포동)",
    "lat": "37.4997272",
    "lng": "127.0109093",
    "phoneNumber": "02-591-8522",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 853,
    "name": "페디아플러스서초학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로 238   가든리체상가 303호 304호 (반포동)",
    "lat": "37.5029529",
    "lng": "127.0120638",
    "phoneNumber": "02-535-3224",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 854,
    "name": "홍익학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 212 , 305-1 (대치동,은마아파트)",
    "lat": "37.4974576",
    "lng": "127.0653265",
    "phoneNumber": "02-553-3220",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 855,
    "name": "올인아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로81길 5 , 2층(대치동)",
    "lat": "37.5036562",
    "lng": "127.0590709",
    "phoneNumber": "02-565-9688",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 856,
    "name": "역삼해법수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 언주로 314   3층 307호 (역삼동)",
    "lat": "37.4959548",
    "lng": "127.0466573",
    "phoneNumber": "02-565-3117",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 857,
    "name": "생각과표현국어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로61길 12 , 3층 (대치동)",
    "lat": "37.499362",
    "lng": "127.0594333",
    "phoneNumber": "02-501-6751",
    "교습과정": "보습",
    "isFinish": "완료"
  },
  {
    "number": 859,
    "name": "호연지기(浩然之氣)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로69길 11 , 4층 (대치동)",
    "lat": "37.501608",
    "lng": "127.0584095",
    "phoneNumber": "02-555-0783",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 861,
    "name": "퀸즈영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 논현로171길 15 , 2층 203호·204호 (신사동, 카로시티1)",
    "lat": "37.5255134",
    "lng": "127.0270724",
    "phoneNumber": "070-4531-0509",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 862,
    "name": "반포지니엠국어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 반포대로 300 , 6층 일부 (잠원동, 덕성빌딩)",
    "lat": "37.505956",
    "lng": "127.0011819",
    "phoneNumber": "02-535-2148",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 863,
    "name": "와이즈클래스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 184  4층 402호(도곡동)",
    "lat": "37.4916885",
    "lng": "127.0397809",
    "phoneNumber": "02-3463-5258",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 865,
    "name": "김범식독일어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 강남대로92길 17 6층 전체, 7층 전체 (역삼동)",
    "lat": "37.4991227",
    "lng": "127.0287852",
    "phoneNumber": "02-552-7937",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 866,
    "name": "리드앤톡영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로363길 17   3층 (도곡동)",
    "lat": "37.486376",
    "lng": "127.0377377",
    "phoneNumber": "02-3462-8181",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 868,
    "name": "반디학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도산대로25길 39   3층 (신사동)",
    "lat": "37.5220641",
    "lng": "127.0260237",
    "phoneNumber": "02-516-9955",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 870,
    "name": "김현정수학개념학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 510 , 3층 301호 (대치동)",
    "lat": "37.4989119",
    "lng": "127.0619546",
    "phoneNumber": "02-563-6669",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 872,
    "name": "리얼수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로33길 7 , 5층 (반포동)",
    "lat": "37.501038",
    "lng": "127.0112258",
    "phoneNumber": "02-3476-2357",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 875,
    "name": "솔학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로72길 19 4층(대치동)",
    "lat": "37.5005421",
    "lng": "127.0526435",
    "phoneNumber": "02-557-5288",
    "교습과정": "보습",
    "isFinish": "완료"
  },
  {
    "number": 877,
    "name": "가인아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 536 , 2층 (대치동)",
    "lat": "37.5037491",
    "lng": "127.0617296",
    "phoneNumber": "02-565-2800",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 879,
    "name": "브리티시어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 테헤란로5길 31 , 2층 전체 (역삼동)",
    "lat": "37.5006999999999",
    "lng": "127.0287234",
    "phoneNumber": "02-3476-2255",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 880,
    "name": "강남멘토학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 347   3층 301호 (대치동)",
    "lat": "37.5025385",
    "lng": "127.0585559",
    "phoneNumber": "02-556-6771",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 881,
    "name": "창의수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 212  은마상가B블럭 301-14호 (대치동)",
    "lat": "37.4954127",
    "lng": "127.0636485",
    "phoneNumber": "02-565-9001",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 882,
    "name": "시대인재2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 510 2층 7호(대치동)",
    "lat": "37.4989119",
    "lng": "127.0619546",
    "phoneNumber": "02-555-1353",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 884,
    "name": "케이유유이씨(KUUEC)어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 서초중앙로28길 2 , 5층 (서초동, 승원빌딩)",
    "lat": "37.4967959",
    "lng": "127.0143395",
    "phoneNumber": "02-3478-2585",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 886,
    "name": "강남종로학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 역삼로 534 , 1~5층 (대치동)",
    "lat": "37.5037457",
    "lng": "127.0614632",
    "phoneNumber": "02-541-1881",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 888,
    "name": "메가로스쿨강남캠퍼스학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "인문사회(대)",
    "학원주소\t": "서울특별시 서초구 서초대로78길 48 , 6층, 7층 (서초동, 송림빌딩)",
    "lat": "37.4934895",
    "lng": "127.0285991",
    "phoneNumber": "02-538-2445",
    "교습과정": "대학편입",
    "isFinish": ""
  },
  {
    "number": 889,
    "name": "조앤북영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 184 , 3층 302호 및 305호 (도곡동, 신호빌딩)",
    "lat": "37.4874678",
    "lng": "127.0477965",
    "phoneNumber": "02-572-0554",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 890,
    "name": "이엠에스(EMS)어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 언주로172길 11 , 2층 전체 (신사동)",
    "lat": "37.5279482",
    "lng": "127.0347797",
    "phoneNumber": "02-516-6100",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 891,
    "name": "쎄비앙프랑스어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 논현로161길 13 , 3층 (신사동)",
    "lat": "37.523335",
    "lng": "127.0270202",
    "phoneNumber": "02-545-5251",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 892,
    "name": "강남최강학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로71길 32 , 2층 전체 (대치동)",
    "lat": "37.5017175",
    "lng": "127.056292",
    "phoneNumber": "02-547-7144",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 893,
    "name": "투탑과학전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 효령로 184 , 2층 (방배동,유신빌딩)",
    "lat": "37.4824614",
    "lng": "127.0041881",
    "phoneNumber": "02-585-7909",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 894,
    "name": "깊은생각로두스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로58길 9 3층(대치동)",
    "lat": "37.498729",
    "lng": "127.0620103",
    "phoneNumber": "02-564-0620",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 895,
    "name": "더쌤(Sam)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로64길 9 , 3층 (대치동, 대성빌딩)",
    "lat": "37.5004504",
    "lng": "127.0531429",
    "phoneNumber": "02-3453-7200",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 896,
    "name": "시리우스베타학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 505 , 3층전체 (대치동)",
    "lat": "37.5034652999999",
    "lng": "127.0591428",
    "phoneNumber": "02-553-5202",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 898,
    "name": "프랙탈학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로92길 7 (대치동)",
    "lat": "37.5040155",
    "lng": "127.0629798",
    "phoneNumber": "02-2051-8288",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 899,
    "name": "대치파인만의치대관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 212 , A블럭 309호 (대치동,은마아파트상가)",
    "lat": "37.495511",
    "lng": "127.0637579",
    "phoneNumber": "02-552-0969",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 900,
    "name": "페디아플러스(paedea plus)역삼학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 310 , 2층 6호 (역삼동, 한솔필리아)",
    "lat": "37.499217",
    "lng": "127.0484398",
    "phoneNumber": "02-2051-0579",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 902,
    "name": "압구정지니엠국어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로34길 11 , 407호 (신사동, 압구정스퀘어)",
    "lat": "37.5273895",
    "lng": "127.030957",
    "phoneNumber": "02-552-2148",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 903,
    "name": "서준학원채움관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 효령로 182-7 , 3층 (방배동)",
    "lat": "37.4823166",
    "lng": "127.0042319",
    "phoneNumber": "02-3472-3005",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 904,
    "name": "정수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 개포로22길 92 3층(개포동)",
    "lat": "37.4750941",
    "lng": "127.0528549",
    "phoneNumber": "02-571-7797",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 905,
    "name": "서초덕스어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 서초중앙로31길 6-9 , 202호, 301호 (반포동)",
    "lat": "37.5005049",
    "lng": "127.0112256",
    "phoneNumber": "02-538-3328",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 906,
    "name": "대치올스터디독재학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 458 , 4층 (대치동,영미빌딩)",
    "lat": "37.5024983",
    "lng": "127.0574222",
    "phoneNumber": "02-539-0225",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 907,
    "name": "뷰티풀마인드수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로64길 11-2 , 3층 전체 (대치동)",
    "lat": "37.4980851",
    "lng": "127.0532687",
    "phoneNumber": "02-6338-1210",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 908,
    "name": "원(元)수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로57길 19 , 1층, 2층, 4층(대치동)",
    "lat": "37.4976226",
    "lng": "127.0595092",
    "phoneNumber": "02-563-8852",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 909,
    "name": "에스온수리영재아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 548 , 2층, 3층 (대치동, 한국빌딩)",
    "lat": "37.5043051",
    "lng": "127.0630781",
    "phoneNumber": "02-6203-6203",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 910,
    "name": "대치베스트영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로64길 8 , 4층 (대치동)",
    "lat": "37.4977228",
    "lng": "127.0531038",
    "phoneNumber": "02-3446-7280",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 911,
    "name": "범수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로75길 7 , 2층 (대치동)",
    "lat": "37.5034549",
    "lng": "127.0576865",
    "phoneNumber": "02-552-6680",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 912,
    "name": "코렉트영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 잠원로 24 , 반포자이주구중심상가 1동 503호 (반포동,반포자이주구중심상가1동)",
    "lat": "37.5071093",
    "lng": "127.0098804",
    "phoneNumber": "02-537-5317",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 913,
    "name": "리드101영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 100 , 501호~504호 (반포동,래미안 퍼스티지 신반포역상가)",
    "lat": "37.5030753",
    "lng": "126.9956677",
    "phoneNumber": "02-557-5101",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 917,
    "name": "리든어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 도산대로6길 9 , 토마스빌딩 2층 (논현동)",
    "lat": "37.5161239",
    "lng": "127.0218306",
    "phoneNumber": "02-543-0924",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 918,
    "name": "씨엠에스(CMS)대치입시센터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 삼성로 334 , 2층,3층,4층 (대치동)",
    "lat": "37.5015069",
    "lng": "127.0599056",
    "phoneNumber": "02-563-5050",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 920,
    "name": "엘에스에이에듀영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 사평대로 18 , 2층 201호(방배동)",
    "lat": "37.4981855",
    "lng": "126.9863984",
    "phoneNumber": "02-535-8084",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 921,
    "name": "타임퍼더(TiME further)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로93길 9 , 7층 (대치동)",
    "lat": "37.5008373",
    "lng": "127.0645016",
    "phoneNumber": "02-555-7011",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 923,
    "name": "청담에이스어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 학동로67길 14 , 2층 (청담동)",
    "lat": "37.5192426",
    "lng": "127.0468262",
    "phoneNumber": "02-511-3379",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 924,
    "name": "에이지아이(AGI)어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 봉은사로26길 11 , 3층,4층 (역삼동)",
    "lat": "37.5062117",
    "lng": "127.0333566",
    "phoneNumber": "02-3444-0506",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 925,
    "name": "강남탑브레인학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 강남대로 627 , 3층~4층 (잠원동)",
    "lat": "37.5176791",
    "lng": "127.0186716",
    "phoneNumber": "02-3443-3401",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 926,
    "name": "게이트대치어학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 도곡로 313 , 2층, 4~7층 (역삼동)",
    "lat": "37.495791",
    "lng": "127.0501929",
    "phoneNumber": "02-491-0509",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 927,
    "name": "정연완전학습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 417 , 5층일부(501호) (대치동)",
    "lat": "37.5013862",
    "lng": "127.0526773",
    "phoneNumber": "02-501-3357",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 929,
    "name": "퓰리처국어논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로72길 18 , 3층 (대치동)",
    "lat": "37.5002844",
    "lng": "127.05266",
    "phoneNumber": "02-564-6110",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 932,
    "name": "잠룡승천반포캠퍼스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로 229 , 5층 일부 (반포동)",
    "lat": "37.502108",
    "lng": "127.0113454",
    "phoneNumber": "02-577-0043",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 935,
    "name": "게이트프렙스어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 논현로168길 36 , 4층 일부 (신사동)",
    "lat": "37.5232126999999",
    "lng": "127.0309526",
    "phoneNumber": "02-511-7094",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 936,
    "name": "서율학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로31길 6-9 , 6층 601호 (반포동)",
    "lat": "37.5005049",
    "lng": "127.0112256",
    "phoneNumber": "02-533-1118",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 937,
    "name": "최상독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 삼성로69길 12 , 2층,3층 (대치동)",
    "lat": "37.5016211",
    "lng": "127.0581185",
    "phoneNumber": "070-7443-3090",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 938,
    "name": "인생의보람수학과학서초관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 나루터로 43 , 5층1호 (잠원동)",
    "lat": "37.5152578",
    "lng": "127.0146863",
    "phoneNumber": "02-532-5124",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 939,
    "name": "이창용어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 테헤란로4길 28 , 6층 (역삼동,시사일본어사옥)",
    "lat": "37.4965132",
    "lng": "127.0300705",
    "phoneNumber": "02-567-9977",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 941,
    "name": "에이치엠에이(HMA)수학전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로33길 62 , 301호(잠원동)",
    "lat": "37.5135798",
    "lng": "127.0093129",
    "phoneNumber": "02-532-5977",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 943,
    "name": "디엑스수학시즌투학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로3길 8 , 304동 320호 (반포동, 반포프라자)",
    "lat": "37.5021153",
    "lng": "126.9869086",
    "phoneNumber": "02-537-0650",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 944,
    "name": "짱솔학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2935 , 4층 (대치동, 대치 프라자)",
    "lat": "37.4940247",
    "lng": "127.0613442",
    "phoneNumber": "02-556-2501",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 945,
    "name": "에듀모스트어학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 역삼로 415 , 6층 일부 (대치동,성진빌딩)",
    "lat": "37.501434",
    "lng": "127.052328",
    "phoneNumber": "02-2051-9999",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 946,
    "name": "웅진씽크빅학습센터방배학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배로 232 , 3층일부 (방배동)",
    "lat": "37.4939466",
    "lng": "126.9901012",
    "phoneNumber": "02-534-0327",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 947,
    "name": "조은모수학초등관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 444 , 502호 (대치동,진경빌딩)",
    "lat": "37.501894",
    "lng": "127.055663",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 948,
    "name": "엠아이디(MID)정시관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로61길 20 , 2층 (대치동)",
    "lat": "37.4991647",
    "lng": "127.0587869",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습",
    "isFinish": "완료"
  },
  {
    "number": 949,
    "name": "에이엠씨스터디(aMCstudy)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 논현로175길 60 , 3층 (신사동)",
    "lat": "37.524382",
    "lng": "127.0239773",
    "phoneNumber": "02-544-5124",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 951,
    "name": "웨이즈비수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2936 , 405호 (대치동,대치동 507 제2종근린생활시설)",
    "lat": "37.4933573",
    "lng": "127.0619092",
    "phoneNumber": "02-508-5546",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 952,
    "name": "샤크에듀학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 213 , 반포쇼핑타운 7동 4층 2호 일부,3호,4호,5호,6호 일부 (잠원동,반포쇼핑타운)",
    "lat": "37.5072287",
    "lng": "127.0072503",
    "phoneNumber": "02-533-1623",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 953,
    "name": "철벽수학인터넷학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 언주로167길 25 , 4층 (신사동)",
    "lat": "37.5263659",
    "lng": "127.0310718",
    "phoneNumber": "02-3442-0007",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 955,
    "name": "비탑영어그릿수학831학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2936 , 305호,503호 (대치동, 윈플러스상가)",
    "lat": "37.4933573",
    "lng": "127.0619092",
    "phoneNumber": "02-553-5595",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 956,
    "name": "수학의흐름학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로63길 34 , 1층 전체 (대치동, 요안빌딩)",
    "lat": "37.4991366",
    "lng": "127.0537643",
    "phoneNumber": "02-565-1175",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 958,
    "name": "멘토수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배중앙로 48 , 1층 (방배동)",
    "lat": "37.4842957",
    "lng": "126.9913895",
    "phoneNumber": "070-4118-7508",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 961,
    "name": "네오스터디학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 219 , 8동 4층 5호, 5층 18,19호 (잠원동,반포쇼핑타운)",
    "lat": "37.5074568",
    "lng": "127.0078376",
    "phoneNumber": "02-535-4585",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 963,
    "name": "해빛나인어학원1관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 도곡로 517 , 4층 (대치동,서진빌딩)",
    "lat": "37.4998422",
    "lng": "127.0629444",
    "phoneNumber": "02-3453-0579",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 964,
    "name": "플레이팩토강남학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로62길 39 , 2층 일부 (대치동)",
    "lat": "37.4982592",
    "lng": "127.0555379",
    "phoneNumber": "070-7562-1395",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 965,
    "name": "수이수능학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 영동대로57길 16 , 3층, 4층 (대치동)",
    "lat": "37.500019",
    "lng": "127.0661063",
    "phoneNumber": "02-562-8766",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 966,
    "name": "온어스에듀학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 언주로167길 34 , 3층 (신사동, 우리빌딩)",
    "lat": "37.5266094",
    "lng": "127.0304576",
    "phoneNumber": "02-543-7417",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 967,
    "name": "(주)케이미디어텍원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 논현로 854 , B동 4층 일부 (신사동,KT신사지사)",
    "lat": "37.5254187",
    "lng": "127.028869",
    "phoneNumber": "02-3448-4500",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 968,
    "name": "비전과멘토학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로66길 9 , 2층 (대치동)",
    "lat": "37.4986482",
    "lng": "127.0527102",
    "phoneNumber": "02-529-2927",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 969,
    "name": "이끌림수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 417 , 3층 일부 (대치동)",
    "lat": "37.5013862",
    "lng": "127.0526773",
    "phoneNumber": "02-542-2660",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 970,
    "name": "해커스로스쿨학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 강남대로 428 , 5층 일부 (역삼동, 만이빌딩)",
    "lat": "37.5007937",
    "lng": "127.0268277",
    "phoneNumber": "02-598-5000",
    "교습과정": "성인고시",
    "isFinish": ""
  },
  {
    "number": 971,
    "name": "제이에이치에스(JHS)영재교육학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배로 244 , 3층 (방배동)",
    "lat": "37.4948595",
    "lng": "126.9894596",
    "phoneNumber": "02-532-2789",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 974,
    "name": "해커스어학원강남제2별관학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 강남대로61길 13 , 3층 (서초동)",
    "lat": "37.4988351",
    "lng": "127.0254016",
    "phoneNumber": "02-569-7467",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 975,
    "name": "공감영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동광로 17-1 , 2층 (방배동, 수림빌딩)",
    "lat": "37.4910141",
    "lng": "126.9849551",
    "phoneNumber": "02-533-0931",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 976,
    "name": "엠피(MP)수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로62길 32-3 , 1층,2층 (대치동)",
    "lat": "37.4976541",
    "lng": "127.055336",
    "phoneNumber": "02-566-7865",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 977,
    "name": "개념폴리아학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2911-1 , 7층전체 (대치동)",
    "lat": "37.4927102",
    "lng": "127.0577477",
    "phoneNumber": "02-557-4808",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 978,
    "name": "더프라임수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 521 , 301호,302호,303호 (대치동)",
    "lat": "37.5000321",
    "lng": "127.0632277",
    "phoneNumber": "02-567-9550",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 981,
    "name": "엠(M)클래스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로62길 39 , 201호의 일부(좌측) (대치동)",
    "lat": "37.4982592",
    "lng": "127.0555379",
    "phoneNumber": "02-6494-2528",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 982,
    "name": "세정우전관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 446 2층 6층(대치동)",
    "lat": "37.4979979",
    "lng": "127.059403",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 983,
    "name": "개념원리원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 테헤란로8길 37 , 6층 일부 (역삼동, 한동빌딩 사옥)",
    "lat": "37.4965443",
    "lng": "127.032494",
    "phoneNumber": "02-3415-0700",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 984,
    "name": "루키업스마트해법학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 남부순환로339길 60 , 2층(202호, 203호) (서초동, HJ타워)",
    "lat": "37.4857215",
    "lng": "127.021693",
    "phoneNumber": "02-585-0579",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 985,
    "name": "삼성영어방배직영학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배로 248 , 3층 (방배동)",
    "lat": "37.4951307",
    "lng": "126.9893167",
    "phoneNumber": "02-595-3405",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 986,
    "name": "엠에스씨수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 영동대로50길 10 , 4층,5층 (대치동)",
    "lat": "37.4985403",
    "lng": "127.0699374",
    "phoneNumber": "02-557-9864",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 987,
    "name": "뉴(NEW)이선생수학전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 광평로10길 6 , 304호 (일원동, 한솔마을아파트)",
    "lat": "37.4821885",
    "lng": "127.077953",
    "phoneNumber": "02-445-0966",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 988,
    "name": "노바(NOVA)수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 개포로 615 , 605-3호,606호,608호 (개포동, 석탑프라자)",
    "lat": "37.4926193",
    "lng": "127.0755689",
    "phoneNumber": "02-2226-8286",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 989,
    "name": "펨토스에듀학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 552 , 2층 (대치동, KM 빌딩)",
    "lat": "37.5044438",
    "lng": "127.0634946",
    "phoneNumber": "02-555-4082",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 990,
    "name": "리드101대치영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 531 , 2층 (대치동, 대치빌딩)",
    "lat": "37.5003211999999",
    "lng": "127.0644992",
    "phoneNumber": "02-567-7101",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 991,
    "name": "라하잉글리시강남개포직영학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 개포로 615 , 801-1호,810호,810-1호 (개포동, 석탑프라자)",
    "lat": "37.4926936",
    "lng": "127.0756284",
    "phoneNumber": "02-3412-1105",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 995,
    "name": "사이버제이엘에스원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 영동대로 227 , 4층 (대치동)",
    "lat": "37.4994104",
    "lng": "127.067582",
    "phoneNumber": "02-1644-0500",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 996,
    "name": "지스트수학전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로363길 12-53 , 2층 (도곡동,호영빌딩)",
    "lat": "37.4866201",
    "lng": "127.0388676",
    "phoneNumber": "070-8200-4572",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 997,
    "name": "지메스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 강남대로18길 16-7 , 2층 (양재동)",
    "lat": "37.4716196",
    "lng": "127.0398867",
    "phoneNumber": "-",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 998,
    "name": "미래의학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 삼성로 350-5 , 4층,5층 (대치동)",
    "lat": "37.5029035",
    "lng": "127.0594249",
    "phoneNumber": "02-1599-8884",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 999,
    "name": "영독대치캠퍼스어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 선릉로4길 5 , 4층, 5층(개포동)",
    "lat": "37.482396",
    "lng": "127.0616862",
    "phoneNumber": "02-576-6589",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1001,
    "name": "메가스터디원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 효령로 321 , 3층전체, 9층일부(서초동)",
    "lat": "37.4861473",
    "lng": "127.0191221",
    "phoneNumber": "02-3489-8200",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1002,
    "name": "엠베스트원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 효령로 321 , 4층전체 (서초동, 메가스터디)",
    "lat": "37.4861473",
    "lng": "127.0191221",
    "phoneNumber": "02-3489-8200",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1003,
    "name": "정현영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 405 , 208호,209호 (대치동,삼환 아르누보2)",
    "lat": "37.4974385",
    "lng": "127.0546376",
    "phoneNumber": "02-552-8253",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1004,
    "name": "그루샘수학보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 532 , 6층 일부 (대치동, 태안빌딩)",
    "lat": "37.4997795",
    "lng": "127.0645688",
    "phoneNumber": "02-564-1889",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1006,
    "name": "로드맵학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 225 , 408호 일부, 508호(도곡동)",
    "lat": "37.4953404",
    "lng": "127.0526522",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1008,
    "name": "에이매쓰학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 언주로30길 10 , 407-1호 (도곡동, 현대비젼21)",
    "lat": "37.4873616",
    "lng": "127.0513255",
    "phoneNumber": "02-562-0309",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1009,
    "name": "바로새김학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 331 , 2층 (대치동)",
    "lat": "37.5011637",
    "lng": "127.0593306",
    "phoneNumber": "02-6951-1828",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1010,
    "name": "센텀수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로64길 26 , 2층 (대치동)",
    "lat": "37.4994478",
    "lng": "127.0533138",
    "phoneNumber": "02-564-1030",
    "교습과정": "보습",
    "isFinish": "완료"
  },
  {
    "number": 1013,
    "name": "달에서온토끼학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로 95 , 5층 (서초동,거북빌딩)",
    "lat": "37.4903629999999",
    "lng": "127.0139508",
    "phoneNumber": "02-588-7245",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1015,
    "name": "케이비즈수학과학1관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로57길 5 , 5,6층 (대치동)",
    "lat": "37.4980215",
    "lng": "127.0606264",
    "phoneNumber": "02-508-3349",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1016,
    "name": "이챕터스도곡학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 225 , 506-1호,506-2호 (도곡동,도곡렉슬상가)",
    "lat": "37.4953404",
    "lng": "127.0526522",
    "phoneNumber": "02-573-0577",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1017,
    "name": "하이매쓰큐학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 212 , 301호일부(301-21호) (대치동,은마아파트상가)",
    "lat": "37.495511",
    "lng": "127.0637579",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1018,
    "name": "페디아플러스대치학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 212 , 302호 (대치동,은마아파트상가)",
    "lat": "37.495511",
    "lng": "127.0637579",
    "phoneNumber": "02-3454-0673",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1020,
    "name": "이원학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로115길 33 , 1층 (논현동)",
    "lat": "37.5114869",
    "lng": "127.040304",
    "phoneNumber": "02-515-6521",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1021,
    "name": "에듀플렉스에듀코치개별지도서초학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 고무래로10길 17 , 4층 일부 (반포동, 동호빌딩)",
    "lat": "37.5012315",
    "lng": "127.0104245",
    "phoneNumber": "02-533-1651",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1022,
    "name": "황쌤수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로64길 8 , 6층 (대치동)",
    "lat": "37.4977228",
    "lng": "127.0531038",
    "phoneNumber": "02-525-0982",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1023,
    "name": "유패스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로76길 16 , 2층 전체 (대치동)",
    "lat": "37.5040636",
    "lng": "127.0596603",
    "phoneNumber": "02-557-5493",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1024,
    "name": "두각입시센터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로77길 5 , 4층(대치동)",
    "lat": "37.4986723",
    "lng": "127.058384",
    "phoneNumber": "02-556-3349",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 1027,
    "name": "에이플러스독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 도곡로 183 , 5층 (역삼동,현진빌딩)",
    "lat": "37.49227",
    "lng": "127.039393",
    "phoneNumber": "02-557-7787",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1028,
    "name": "양파아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 212 , 306호 (대치동,은마아파트)",
    "lat": "37.4974576",
    "lng": "127.0653265",
    "phoneNumber": "02-555-6599",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1031,
    "name": "이투스원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 남부순환로 2547 , 6층 전체(서초동)",
    "lat": "37.4843054",
    "lng": "127.0290946",
    "phoneNumber": "070-7464-9121",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1032,
    "name": "세븐에듀원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 헌릉로 176 , 4층 406~408호,409호일부 (내곡동)",
    "lat": "37.4564771999999",
    "lng": "127.0593952",
    "phoneNumber": "02-1544-7827",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1035,
    "name": "디지털대성원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배로 181 , 3층·4층·5층 전체, 6층 일부  (방배동, 단우빌딩)",
    "lat": "37.4895404",
    "lng": "126.991913",
    "phoneNumber": "02-3470-8555",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1038,
    "name": "그림숲키즈어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 논현로38길 32-5 , 1층~3층 (도곡동)",
    "lat": "37.4852139",
    "lng": "127.0446505",
    "phoneNumber": "02-576-2744",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1039,
    "name": "안보라언어독해학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 318 203호, 204호(대치동)",
    "lat": "37.4980894",
    "lng": "127.0524088",
    "phoneNumber": "02-556-8383",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1042,
    "name": "경선식에듀원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로 56 , 8층 (서초동,상보빌딩)",
    "lat": "37.4868706",
    "lng": "127.0154068",
    "phoneNumber": "02-597-6582",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1045,
    "name": "해커스공인중개사주택관리사감정평가사학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "인문사회(대)",
    "학원주소\t": "서울특별시 서초구 서초대로73길 12 , 6층 (서초동,세계빌딩)",
    "lat": "37.4985905",
    "lng": "127.0258499",
    "phoneNumber": "02-597-9000",
    "교습과정": "성인고시",
    "isFinish": ""
  },
  {
    "number": 1046,
    "name": "토즈도곡이(2)스마트독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 언주로 311 , 301호, 302호 (역삼동,로즈I타워)",
    "lat": "37.4952625",
    "lng": "127.045625",
    "phoneNumber": "02-2052-0040",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1049,
    "name": "대치수학의바다학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로69길 11 , 2층 전체 (대치동)",
    "lat": "37.501608",
    "lng": "127.0584095",
    "phoneNumber": "070-7443-3099",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1051,
    "name": "세정방배캠퍼스3층학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동작대로 188 , 3층전체 (방배동, 액센빌딩)",
    "lat": "37.4932966999999",
    "lng": "126.983124",
    "phoneNumber": "02-532-6552",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1052,
    "name": "크레버스원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 테헤란로 521 , 21층 (삼성동, 파르나스타워)",
    "lat": "37.5100567",
    "lng": "127.0613285",
    "phoneNumber": "02-3429-9407",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1053,
    "name": "한솔강남브레인학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 압구정로28길 22-5 , 2층 (신사동)",
    "lat": "37.5250123",
    "lng": "127.0271808",
    "phoneNumber": "02-518-7085",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 1054,
    "name": "하이매쓰학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 409 , 7층 (대치동,타워엠프리스)",
    "lat": "37.4973819",
    "lng": "127.0551699",
    "phoneNumber": "02-552-0707",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1055,
    "name": "아이엠수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로3길 8 , 506,507호 (반포동, 반포프라자)",
    "lat": "37.5021153",
    "lng": "126.9869086",
    "phoneNumber": "02-537-5560",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1057,
    "name": "반포스피커스(Banpospeakers)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 고무래로10길 25 , 1층, 3층 (반포동)",
    "lat": "37.5004954",
    "lng": "127.0101838",
    "phoneNumber": "02-3477-1433",
    "교습과정": "외국어",
    "isFinish": ""
  },
  {
    "number": 1058,
    "name": "에스이(SE)원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 강남대로94길 71-9 , 1층일부 (역삼동)",
    "lat": "37.5012184",
    "lng": "127.032793",
    "phoneNumber": "070-7450-1962",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1062,
    "name": "수학의정석원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 강남대로 202 , 지하2층,7층 (양재동,모산빌딩)",
    "lat": "37.4823239",
    "lng": "127.0368273",
    "phoneNumber": "02-574-1357",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1064,
    "name": "보카퍼스트학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로93길 9 , 4층 (대치동)",
    "lat": "37.5008373",
    "lng": "127.0645016",
    "phoneNumber": "02-555-3025",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1069,
    "name": "대치위더스입시관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로77길 5 , 3층일부 (대치동)",
    "lat": "37.4986723",
    "lng": "127.058384",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1072,
    "name": "김영일교육컨설팅학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 155 , 2층 201호 (역삼동, 명빌딩)",
    "lat": "37.4914239",
    "lng": "127.0368158",
    "phoneNumber": "070-8672-9225",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 1074,
    "name": "블루스카이수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 잠원로3길 40 , 402호 및 403호 (잠원동)",
    "lat": "37.5081523",
    "lng": "127.0037071",
    "phoneNumber": "02-535-0630",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1075,
    "name": "형진영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2936 , 301호(대치동,윈플러스상가)",
    "lat": "37.4933573",
    "lng": "127.0619092",
    "phoneNumber": "02-508-7380",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1078,
    "name": "지엘아이진학컨설팅학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 405 , 304-1호,305호 (대치동, 삼환 아르누보2)",
    "lat": "37.4974385",
    "lng": "127.0546376",
    "phoneNumber": "02-553-7278",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 1079,
    "name": "선경제니스어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 남부순환로 2936 , 303호, 308호일부, 309호, 409호, 410호 (대치동, 윈플러스상가)",
    "lat": "37.4933573",
    "lng": "127.0619092",
    "phoneNumber": "02-568-9001",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1080,
    "name": "아레테아카데미(Arete Academy)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도산대로27길 25 , 301호 (신사동)",
    "lat": "37.5215747",
    "lng": "127.0272808",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1081,
    "name": "뮤엠영어세곡학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 헌릉로570길 34 , 리엔파크프라자 504호 (세곡동)",
    "lat": "37.463185",
    "lng": "127.1035643",
    "phoneNumber": "02-2226-0582",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1083,
    "name": "도무스링구아학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 성촌1길 20 , 4층 전체 (우면동)",
    "lat": "37.4655124",
    "lng": "127.021701",
    "phoneNumber": "02-572-0202",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1084,
    "name": "아이리스(IRIS)영어전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초대로1길 14 , 3층 (방배동)",
    "lat": "37.4875126",
    "lng": "126.9832553",
    "phoneNumber": "02-593-0106",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1085,
    "name": "스터디코드원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 남부순환로333길 32 , 402호 (서초동, 영일빌딩)",
    "lat": "37.4838134",
    "lng": "127.0208344",
    "phoneNumber": "02-512-6049",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1086,
    "name": "리더스어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 논현로168길 18 , 2층, 7층 (신사동,동신빌딩)",
    "lat": "37.5238067",
    "lng": "127.0296884",
    "phoneNumber": "02-541-7890",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1087,
    "name": "디에스(DS)교육학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 언주로167길 33-4 , 3층 (신사동)",
    "lat": "37.5260366",
    "lng": "127.0302465",
    "phoneNumber": "02-1533-3423",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1089,
    "name": "더코어패러다임학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 536 , 502호 (대치동, 동성빌딩)",
    "lat": "37.5037491",
    "lng": "127.0617296",
    "phoneNumber": "02-558-8556",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1090,
    "name": "리틀러너스어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 서래로5길 61 , 지하1층일부,1층,2층 (반포동)",
    "lat": "37.4978066",
    "lng": "126.994758",
    "phoneNumber": "02-565-7979",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1091,
    "name": "에이치비아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 태봉로2길 65 , 네이처힐4단지상가 202-2호 (우면동)",
    "lat": "37.463634",
    "lng": "127.0262336",
    "phoneNumber": "02-2057-0701",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1092,
    "name": "에스피(SP)수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 사평대로45길 10-25 , 501,503,504호 (반포동)",
    "lat": "37.5066782",
    "lng": "127.013939",
    "phoneNumber": "02-591-9070",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1093,
    "name": "김필립수학전문원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 413 , 204호 (대치동,삼환 SO GOOD)",
    "lat": "37.4975956",
    "lng": "127.0557613",
    "phoneNumber": "02-552-5504",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1095,
    "name": "박희종논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 414 , 4층 (대치동,국민은행)",
    "lat": "37.4968866",
    "lng": "127.0558815",
    "phoneNumber": "02-566-7911",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1096,
    "name": "콴다일로4관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 311 , 2층 (대치동, 제동빌딩)",
    "lat": "37.4996",
    "lng": "127.0601579",
    "phoneNumber": "02-557-6699",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1097,
    "name": "킹스키즈어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 영동대로50길 14 , 1층,2층 (대치동)",
    "lat": "37.4986674",
    "lng": "127.0703297",
    "phoneNumber": "02-3453-3453",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1098,
    "name": "티엔아카데미원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 논현로 813 , 본관2층일부 (신사동, 영석빌딩)",
    "lat": "37.5212017",
    "lng": "127.027746",
    "phoneNumber": "02-538-3933",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 1099,
    "name": "시대인재엔(N)관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 505 B1층의 일부(후면부 및 B102호) 및 3층 전체(대치동)",
    "lat": "37.4995633",
    "lng": "127.0616676",
    "phoneNumber": "02-558-1060",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1100,
    "name": "지식학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로30길 17 , 401호 (신사동,이소니프라자)",
    "lat": "37.5262629",
    "lng": "127.0294934",
    "phoneNumber": "02-3444-4412",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1101,
    "name": "엠스퀘어수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로30길 17 802호(신사동)",
    "lat": "37.5263249",
    "lng": "127.0295435",
    "phoneNumber": "02-515-9621",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1102,
    "name": "노아알오아이학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 도산대로35길 50 , 1층 전체, 2층 전체 (신사동)",
    "lat": "37.5241023",
    "lng": "127.030624",
    "phoneNumber": "02-566-5571",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1106,
    "name": "렉시스강남캠퍼스학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 강남대로53길 7 , 2층일부(203,204), 11층(1101일부, 1102-~1104)(서초동)",
    "lat": "37.494251",
    "lng": "127.0282336",
    "phoneNumber": "02-588-4900",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 1109,
    "name": "강남잉글리쉬아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 언주로164길 12 , 5층 (신사동, 명진빌딩)",
    "lat": "37.525153",
    "lng": "127.0343807",
    "phoneNumber": "02-511-9864",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1111,
    "name": "한국국제어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 역삼로9길 21 , 1층, 2층, 3층 일부(301호)(역삼동)",
    "lat": "37.4954602",
    "lng": "127.0336576",
    "phoneNumber": "02-555-1739",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1113,
    "name": "맑은숲국어논술전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배로37길 7 , 5층 (방배동)",
    "lat": "37.4935825",
    "lng": "126.9892965",
    "phoneNumber": "02-3477-4240",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1116,
    "name": "로드맵어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 선릉로 225 , 215호~217호,407-3호일부,408호일부 (도곡동)",
    "lat": "37.4953404",
    "lng": "127.0526522",
    "phoneNumber": "02-529-5243",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1117,
    "name": "아담리즈수학대치센터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 선릉로64길 19 , 3층 (대치동)",
    "lat": "37.4982405",
    "lng": "127.0538602",
    "phoneNumber": "02-565-9090",
    "교습과정": "기타(소)",
    "isFinish": "완료"
  },
  {
    "number": 1118,
    "name": "최상위영수학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초대로51길 28 , 5층 (서초동,진성빌딩)",
    "lat": "37.4964488",
    "lng": "127.0140242",
    "phoneNumber": "02-537-4784",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1119,
    "name": "반포스마트보카학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 219 , 306,307,308호 (잠원동, 반포쇼핑타운)",
    "lat": "37.5074568",
    "lng": "127.0078376",
    "phoneNumber": "02-537-4919",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1120,
    "name": "에센셜아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로18길 8 , 4층 (신사동)",
    "lat": "37.5242768",
    "lng": "127.0242794",
    "phoneNumber": "02-3443-1516",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1121,
    "name": "고구려와허박사학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 225 , 206호 (대치동)",
    "lat": "37.4971742",
    "lng": "127.0613516",
    "phoneNumber": "02-557-7339",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1122,
    "name": "프리매쓰학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로64길 15-14 , 2층 (대치동,기흥빌딩)",
    "lat": "37.4989487",
    "lng": "127.0533074",
    "phoneNumber": "02-569-5006",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1123,
    "name": "대치리얼수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 420 , 4층 (대치동)",
    "lat": "37.4972019",
    "lng": "127.0565523",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 1124,
    "name": "씨엠에스반포학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 동작대로 234 , 3층~4층 (방배동, CMS M)",
    "lat": "37.4972729",
    "lng": "126.9837363",
    "phoneNumber": "02-537-1288",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1125,
    "name": "키즈닥터창의성영재학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 고무래로10길 10 , 2층 (반포동,청구빌딩)",
    "lat": "37.5018993",
    "lng": "127.0104491",
    "phoneNumber": "02-400-1545",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 1126,
    "name": "마루국어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 155 , 309,310,311,312,517,518호 (대치동, 대치퍼스트)",
    "lat": "37.4938284",
    "lng": "127.062941",
    "phoneNumber": "02-2057-7737",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1127,
    "name": "아토즈아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 460 , 5층 (대치동,동선빌딩)",
    "lat": "37.4983942",
    "lng": "127.0606446",
    "phoneNumber": "02-565-0715",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 1128,
    "name": "두뇌가뛰어노는논술,브레이닝학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로8길 9 , 2층 (반포동)",
    "lat": "37.5019759",
    "lng": "127.0102486",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1129,
    "name": "주니어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 도곡로 184 , 502,503호 (도곡동,신호빌딩)",
    "lat": "37.4917395",
    "lng": "127.0396045",
    "phoneNumber": "02-3463-8747",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1131,
    "name": "세정스카이3층학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 446 , 3층 전체 (대치동, 우전빌딩)",
    "lat": "37.4979979",
    "lng": "127.059403",
    "phoneNumber": "02-552-2373",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1132,
    "name": "뉴청샘학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로34길 11 , 207호 (신사동,압구정스퀘어)",
    "lat": "37.5273895",
    "lng": "127.030957",
    "phoneNumber": "02-511-5665",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1133,
    "name": "케이앤(KN)영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로8길 5 , 2층 (반포동)",
    "lat": "37.5023134",
    "lng": "127.0104645",
    "phoneNumber": "02-599-0516",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1134,
    "name": "스터디브릭스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 삼성로 315 , 2층, 3층 (대치동, 청하빌딩)",
    "lat": "37.4999536",
    "lng": "127.059922",
    "phoneNumber": "02-558-5166",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1135,
    "name": "K2I수학올림피아드학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로67길 22 , 2층 (대치동)",
    "lat": "37.5008433",
    "lng": "127.057656",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1136,
    "name": "하이앤드에듀(HighEnd Edu.)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 462 , 4층 (대치동)",
    "lat": "37.502626",
    "lng": "127.0578107",
    "phoneNumber": "070-4206-0900",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1137,
    "name": "비탑키즈학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 고무래로10길 42 , 2층전체 (반포동)",
    "lat": "37.4989437",
    "lng": "127.009725",
    "phoneNumber": "02-599-6997",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1139,
    "name": "압구정에듀홀릭학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로34길 11 , 2층 206호 (신사동, 압구정스퀘어)",
    "lat": "37.5273895",
    "lng": "127.030957",
    "phoneNumber": "02-6324-1453",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1141,
    "name": "오르비클래스원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 테헤란로55길 17 , 3층 (역삼동)",
    "lat": "37.5056561",
    "lng": "127.0470619",
    "phoneNumber": "00-000-0000",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1142,
    "name": "에디센어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 선릉로 319 , 3층,4층,5층일부 (역삼동)",
    "lat": "37.4980257",
    "lng": "127.0517245",
    "phoneNumber": "02-501-3252",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1143,
    "name": "에쓰앤유과학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 영동대로57길 28 , 3층 (대치동, 현대아파트상가동)",
    "lat": "37.4998959",
    "lng": "127.0652973",
    "phoneNumber": "02-556-4824",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1144,
    "name": "꼭시넬그림책학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 서래로2길 27 , 2층 (반포동)",
    "lat": "37.4961277",
    "lng": "126.9997466",
    "phoneNumber": "-",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 1145,
    "name": "서초이안어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 서초중앙로33길 1 , 3,4층 (반포동,서석빌딩)",
    "lat": "37.5012992",
    "lng": "127.0115384",
    "phoneNumber": "02-534-4517",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1149,
    "name": "서준학원미래관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 효령로 182-8 , 2층 전체 (방배동, 우진빌딩)",
    "lat": "37.4822015",
    "lng": "127.0040161",
    "phoneNumber": "02-525-0766",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1152,
    "name": "일공학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 강남대로 368 , 3층전체,401호 (역삼동, 동인빌딩)",
    "lat": "37.4957163",
    "lng": "127.0292141",
    "phoneNumber": "02-540-1096",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1154,
    "name": "진아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로76길 34 , 2층 (대치동, 다영빌딩)",
    "lat": "37.5020325",
    "lng": "127.0534169",
    "phoneNumber": "02-566-3624",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1155,
    "name": "읽기혁신논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로58길 39 , 201호 (대치동)",
    "lat": "37.4994486",
    "lng": "127.0642747",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1156,
    "name": "플라즈마고등1관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 341 , 3층,4층 (대치동, 인애빌딩)",
    "lat": "37.5019016",
    "lng": "127.0589304",
    "phoneNumber": "02-557-5442",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1158,
    "name": "씨엠에스(CMS)대치입시센터2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 334 , 6층 (대치동)",
    "lat": "37.5015069",
    "lng": "127.0599056",
    "phoneNumber": "02-557-0815",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1159,
    "name": "프라이드제이어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 논현로168길 36 , 1층 (신사동)",
    "lat": "37.5232126999999",
    "lng": "127.0309526",
    "phoneNumber": "02-511-2684",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1162,
    "name": "영어나무학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2941 , 2층 204호 (대치동, 대치탑프라자)",
    "lat": "37.4942268",
    "lng": "127.0617852",
    "phoneNumber": "02-562-3123",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1164,
    "name": "대치삼보어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 남부순환로 2911-1 , 4층,5층 (대치동,성보2빌딩)",
    "lat": "37.4927102",
    "lng": "127.0577477",
    "phoneNumber": "02-562-3630",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1168,
    "name": "방배아벨수학전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배천로 36 , 3층 전체 (방배동, 삼남빌딩)",
    "lat": "37.4798003",
    "lng": "126.9826874",
    "phoneNumber": "02-525-2348",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1169,
    "name": "하이웨이어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 효령로29길 39 , 2층 (방배동)",
    "lat": "37.4831876999999",
    "lng": "126.9946688",
    "phoneNumber": "02-523-0306",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1170,
    "name": "리드101삼성영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 학동로68길 7 , 211호,212호 (삼성동,삼성동 힐스테이트)",
    "lat": "37.5174448",
    "lng": "127.0467984",
    "phoneNumber": "02-5152-101",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1172,
    "name": "와이즈만서초학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로 215 , 홍익대학교 강남관 2층 (반포동)",
    "lat": "37.5008237",
    "lng": "127.0116599",
    "phoneNumber": "02-535-1511",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1173,
    "name": "강의하는아이들대치학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 319 , 6층,7층일부 (역삼동)",
    "lat": "37.4980257",
    "lng": "127.0517245",
    "phoneNumber": "02-561-8181",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1174,
    "name": "리드101압구정영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로46길 30 , 2층 (신사동,암강빌딩)",
    "lat": "37.5267516",
    "lng": "127.0360833",
    "phoneNumber": "02-517-3101",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1175,
    "name": "강남리더스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 헌릉로 569 , 601호, 602호 일부 (세곡동)",
    "lat": "37.4657816",
    "lng": "127.1011914",
    "phoneNumber": "02-459-2998",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1176,
    "name": "레베라어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 논현로168길 18 , 3층 (신사동,동신빌딩)",
    "lat": "37.5238067",
    "lng": "127.0296884",
    "phoneNumber": "02-6959-9991",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1177,
    "name": "시대인재에이(A)관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 324 , 3층 (대치동,신해청아파트)",
    "lat": "37.5008476",
    "lng": "127.0601302",
    "phoneNumber": "02-554-9897",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1182,
    "name": "제비울학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 잠원로 148 , 401호 (잠원동,잠원한신아파트)",
    "lat": "37.5159680999999",
    "lng": "127.0107817",
    "phoneNumber": "070-7553-9575",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 1183,
    "name": "인터프렙어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 역삼로 424 , 4층 일부 (대치동, 진영빌딩)",
    "lat": "37.5010752",
    "lng": "127.0534432",
    "phoneNumber": "02-547-2039",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1185,
    "name": "트윈클어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 도곡로63길 29 , 1층,2층 (대치동)",
    "lat": "37.4988949",
    "lng": "127.0535437",
    "phoneNumber": "02-565-9773",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1186,
    "name": "폴아카데미어학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 삼성로85길 32 , 3층,4층 (대치동)",
    "lat": "37.5047177",
    "lng": "127.0546534",
    "phoneNumber": "02-558-2715",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1189,
    "name": "수학일치학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로 138 , 702호 (서초동,우림빌딩)",
    "lat": "37.4856009",
    "lng": "127.0164403",
    "phoneNumber": "02-6442-9932",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1190,
    "name": "강남캠벨아카데미어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 사임당로 174 , 1202호 전체 (서초동, 강남미래타워)",
    "lat": "37.4924056",
    "lng": "127.0286494",
    "phoneNumber": "02-533-6270",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1193,
    "name": "고도문예창작학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로18길 43 , 5층 (서초동)",
    "lat": "37.4916995",
    "lng": "127.0167151",
    "phoneNumber": "02-584-3323",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1195,
    "name": "다원중등2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 521 , 501호 (대치동,프라자II)",
    "lat": "37.5000321",
    "lng": "127.0632277",
    "phoneNumber": "02-538-8841",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1198,
    "name": "유씨국제교육개발원어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 테헤란로83길 33 , 2층,3층 (삼성동)",
    "lat": "37.5095176",
    "lng": "127.0567841",
    "phoneNumber": "070-8633-9239",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 1199,
    "name": "비전21네오관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로61길 18 , 1층, 2층 (대치동)",
    "lat": "37.4991996",
    "lng": "127.0589307",
    "phoneNumber": "02-567-9901",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1200,
    "name": "시대인재5학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 338 3층(대치동)",
    "lat": "37.5018392",
    "lng": "127.0597125",
    "phoneNumber": "02-552-2373",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1201,
    "name": "반포스마트러닝센터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 서초중앙로31길 16 , 1층 및 2층 (반포동, 에덴스위트A)",
    "lat": "37.4996861",
    "lng": "127.010493",
    "phoneNumber": "02-533-0608",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 1203,
    "name": "뿌리깊은수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 225 , 401호,407-1호 (도곡동,도곡렉슬상가)",
    "lat": "37.4953504",
    "lng": "127.0527143",
    "phoneNumber": "02-6265-0909",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1204,
    "name": "엠에스인스티튜트학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로78길 18 , 4층 (대치동)",
    "lat": "37.501327",
    "lng": "127.0571143",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1205,
    "name": "리핏학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로77길 7 , 7층 (대치동)",
    "lat": "37.4988033",
    "lng": "127.0583171",
    "phoneNumber": "02-2051-6464",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1206,
    "name": "스칼라스아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 압구정로 208 , 4층일부 (신사동, 본경빌딩)",
    "lat": "37.527596",
    "lng": "127.0298545",
    "phoneNumber": "02-6082-0603",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1208,
    "name": "김현정수학플러스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 225 , 403호 (대치동)",
    "lat": "37.4971742",
    "lng": "127.0613516",
    "phoneNumber": "02-562-5050",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1210,
    "name": "운성학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 233 , 301-304호 (대치동, 신사빌딩)",
    "lat": "37.4977699",
    "lng": "127.0606416",
    "phoneNumber": "02-564-0012",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1211,
    "name": "이맥스6789학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로51길 42 , 3층 일부 (대치동,남선빌딩)",
    "lat": "37.4955965",
    "lng": "127.0586987",
    "phoneNumber": "02-3280-0400",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1212,
    "name": "달공사이버원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 319 , 7층일부 (역삼동)",
    "lat": "37.4980257",
    "lng": "127.0517245",
    "phoneNumber": "02-1600-5290",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1214,
    "name": "대찬영재의대센터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로57길 28 , 3층 (대치동)",
    "lat": "37.4976861",
    "lng": "127.0587286",
    "phoneNumber": "02-501-0110",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1216,
    "name": "수학캠프수학전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 100 , 505호~507호 (반포동,래미안 퍼스티지 신반포역상가)",
    "lat": "37.5030753",
    "lng": "126.9956677",
    "phoneNumber": "02-591-1550",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1217,
    "name": "박현국어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 448 , 4층 401호 (대치동, 동서빌딩)",
    "lat": "37.4980552",
    "lng": "127.0595812",
    "phoneNumber": "02-566-0336",
    "교습과정": "보습",
    "isFinish": "완료"
  },
  {
    "number": 1218,
    "name": "청담아이가르텐학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 고무래로10길 27 , 5층,6층601호 (반포동)",
    "lat": "37.5003314",
    "lng": "127.0101783",
    "phoneNumber": "02-2219-7470",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1219,
    "name": "반포세정2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 반포대로 300 , 4층 일부(남쪽, 북동쪽) (잠원동, 덕성빌딩)",
    "lat": "37.505956",
    "lng": "127.0011819",
    "phoneNumber": "02-532-1430",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1220,
    "name": "지를향하여학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 516 , 302호, 303호 (대치동)",
    "lat": "37.4992034",
    "lng": "127.0630995",
    "phoneNumber": "02-577-6003",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1222,
    "name": "와이즈만영재입시센터중등학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로 215 , 홍익대학교 강남관 2층 (반포동)",
    "lat": "37.5008237",
    "lng": "127.0116599",
    "phoneNumber": "02-6925-0069",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1223,
    "name": "함영원보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2937 , 4층 (대치동,까치빌딩)",
    "lat": "37.4941325",
    "lng": "127.0615797",
    "phoneNumber": "02-501-5702",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1224,
    "name": "함영원영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 남부순환로 2937 , 5층전체·6층일부 (대치동, 까치빌딩)",
    "lat": "37.4941325",
    "lng": "127.0615797",
    "phoneNumber": "02-501-1711",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1225,
    "name": "비바스터디센터압구정독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 논현로167길 19 , 5층일부 (신사동,근린생활시설)",
    "lat": "37.5244905",
    "lng": "127.026487",
    "phoneNumber": "02-3443-2221",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1226,
    "name": "청명학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로130길 20 , 501호, 502호 일부, 504호 (삼성동, 래미안삼성2차아파트)",
    "lat": "37.5161513",
    "lng": "127.0434365",
    "phoneNumber": "02-547-0588",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1227,
    "name": "스티븐아카데미원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로86길 15 , 404호 (대치동,현대 선릉 GOLD TOWER)",
    "lat": "37.503546",
    "lng": "127.0508294",
    "phoneNumber": "02-538-6018",
    "교습과정": "보습",
    "isFinish": "완료"
  },
  {
    "number": 1229,
    "name": "다비오학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 태봉로 70 , 403호 (우면동)",
    "lat": "37.4645285",
    "lng": "127.0255453",
    "phoneNumber": "02-571-0607",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1230,
    "name": "다함에듀원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 515 , 5층 일부 (대치동,한도산업사옥)",
    "lat": "37.4998352",
    "lng": "127.0626495",
    "phoneNumber": "02-563-4388",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1231,
    "name": "서승원국어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 논현로175길 40 , 3층, 5층 (신사동)",
    "lat": "37.5250912",
    "lng": "127.0253317",
    "phoneNumber": "02-541-8549",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1233,
    "name": "쌤과통하는학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도산대로85길 30 , 2층 (청담동)",
    "lat": "37.5264323",
    "lng": "127.0496672",
    "phoneNumber": "02-546-0100",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1235,
    "name": "라즈원격교습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 광평로 224 , 1층(수서동)",
    "lat": "37.4849763",
    "lng": "127.0974104",
    "phoneNumber": "02-5140-509",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1236,
    "name": "생각하는영재학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로77길 8 , 4~5층(대치동)",
    "lat": "37.5030791",
    "lng": "127.0565483",
    "phoneNumber": "02-554-1979",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1237,
    "name": "대치에이닷영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 423 , 2층 (대치동, 윤성빌딩)",
    "lat": "37.4978224",
    "lng": "127.0568527",
    "phoneNumber": "02-553-5466",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1238,
    "name": "지아이에스(GIS)어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 언남11길 7-9 201호 202호 301호(양재동)",
    "lat": "37.4742958",
    "lng": "127.043479",
    "phoneNumber": "02-544-6818",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1239,
    "name": "대치중심본원학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로58길 29 , 401호 (대치동)",
    "lat": "37.4977381",
    "lng": "127.0768468",
    "phoneNumber": "02-553-3191",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1241,
    "name": "수학쟁이들학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 143 , 5층 10호 (반포동,반포경남쇼핑센타)",
    "lat": "37.5038883",
    "lng": "126.9964541",
    "phoneNumber": "02-537-2666",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1242,
    "name": "라임매쓰(Lime Math)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배로 98 , 5층(방배동)",
    "lat": "37.483137",
    "lng": "126.9968595",
    "phoneNumber": "02-535-5868",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1244,
    "name": "세정양지관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로77길 14 1층 전체 (대치동)",
    "lat": "37.4992943",
    "lng": "127.0585913",
    "phoneNumber": "02-6205-0909",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1245,
    "name": "예섬초등관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 414 , 3층 (대치동,삼성빌딩)",
    "lat": "37.4968866",
    "lng": "127.0558815",
    "phoneNumber": "02-562-3676",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 1246,
    "name": "거인의어깨교육연구소학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 546 , 7층 (대치동,덕일빌딩)",
    "lat": "37.5042425",
    "lng": "127.0628906",
    "phoneNumber": "02-564-2188",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 1247,
    "name": "잉글리쉬&매쓰매니저학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 642 , 2층 (삼성동, 서경빌딩)",
    "lat": "37.5139798",
    "lng": "127.0428133",
    "phoneNumber": "02-6213-1250",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1248,
    "name": "매쓰홀릭학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 사평대로28길 22 , 301호 (반포동)",
    "lat": "37.4995949",
    "lng": "126.9999533",
    "phoneNumber": "02-3477-0903",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1249,
    "name": "여상진수리논술원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 445 , 2층 일부 (대치동, 현민빌딩)",
    "lat": "37.4985924",
    "lng": "127.0590243",
    "phoneNumber": "02-337-7033",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 1250,
    "name": "올림피아드함수학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 양재대로2길 116-6 , 501호,502호 (우면동)",
    "lat": "37.4564765999999",
    "lng": "127.0154524",
    "phoneNumber": "02-577-0201",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1251,
    "name": "토즈도곡타워팰리스스마트독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 언주로 120 , 2층1호일부 (도곡동)",
    "lat": "37.4867517",
    "lng": "127.051259",
    "phoneNumber": "02-576-0905",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1252,
    "name": "대치소마2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 515 , 201호, 205호 전체 (대치동, 한도산업사옥)",
    "lat": "37.4998352",
    "lng": "127.0626495",
    "phoneNumber": "02-556-1206",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1254,
    "name": "열정스토리입시컨설팅학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 409 , 403호 (대치동,타워엠프리스)",
    "lat": "37.4973819",
    "lng": "127.0551699",
    "phoneNumber": "02-501-7115",
    "교습과정": "진학상담지도",
    "isFinish": "완료"
  },
  {
    "number": 1256,
    "name": "아담리즈수학압구정직영학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 언주로168길 15 , 401호 (신사동)",
    "lat": "37.5264494",
    "lng": "127.0348867",
    "phoneNumber": "02-540-8280",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 1257,
    "name": "와이어트어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 동광로33길 10-6 , 1층,2층 (반포동)",
    "lat": "37.495055",
    "lng": "126.9969816",
    "phoneNumber": "02-535-7988",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1259,
    "name": "손과학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로64길 12 , 2층 (대치동)",
    "lat": "37.5002182",
    "lng": "127.0529095",
    "phoneNumber": "02-554-1330",
    "교습과정": "보습",
    "isFinish": "완료"
  },
  {
    "number": 1262,
    "name": "아우다키아보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로10길 19 , 2층 (반포동)",
    "lat": "37.5010172",
    "lng": "127.0102811",
    "phoneNumber": "02-3281-2824",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1265,
    "name": "케이엔에스(KNS)중등특목관어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 519 , 2층 (대치동, 구공빌딩)",
    "lat": "37.5000709",
    "lng": "127.0629888",
    "phoneNumber": "02-6925-3337",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1266,
    "name": "이루리2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로77길 5 , 5층 전체 (대치동)",
    "lat": "37.4986723",
    "lng": "127.058384",
    "phoneNumber": "02-565-0595",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 1268,
    "name": "콴다일로7관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 458 , 501호, 502호 (대치동)",
    "lat": "37.4984543",
    "lng": "127.0604313",
    "phoneNumber": "02-553-3110",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1270,
    "name": "이룸프리미엄스터디독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 선릉로 227 , 5층 일부 (도곡동, 진달래상가)",
    "lat": "37.4958321",
    "lng": "127.0527291",
    "phoneNumber": "02-578-1177",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1271,
    "name": "정영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2941 , 304호 (대치동, 대치탑프라자)",
    "lat": "37.4942268",
    "lng": "127.0617852",
    "phoneNumber": "02-3414-3388",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1276,
    "name": "몬테키즈어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 논현로152길 30 , 1층일부,2~4층전체 (신사동)",
    "lat": "37.5213096",
    "lng": "127.0306916",
    "phoneNumber": "02-517-2231",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1277,
    "name": "사이다관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로63길 5 , 2층,3층 (대치동, 예영빌딩)",
    "lat": "37.499872",
    "lng": "127.059668",
    "phoneNumber": "02-538-3372",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 1279,
    "name": "수학의열쇠학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 404 , 6층 (대치동, 재석빌딩)",
    "lat": "37.5005204",
    "lng": "127.0514247",
    "phoneNumber": "02-508-0451",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1283,
    "name": "필수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로68길 10 , 2층,3층 (대치동)",
    "lat": "37.4989656",
    "lng": "127.052559",
    "phoneNumber": "02-3412-9555",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 1284,
    "name": "지엠그리핀수학보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2936 , 504호, 505호 (대치동, 대치동 507 제2종근린생활시설)",
    "lat": "37.4933573",
    "lng": "127.0619092",
    "phoneNumber": "02-2052-0678",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1285,
    "name": "그리핀수학보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2936 , 507호 (대치동, 대치동 507 제2종근린생활시설)",
    "lat": "37.4933573",
    "lng": "127.0619092",
    "phoneNumber": "02-539-0678",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1286,
    "name": "세곡스마트해법수학영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 헌릉로  569, 706호 (세곡동)",
    "lat": "37.4657816",
    "lng": "127.1011914",
    "phoneNumber": "02-445-5008",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1288,
    "name": "미투스카이학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 325 , 3층 (대치동)",
    "lat": "37.5007467",
    "lng": "127.059549",
    "phoneNumber": "02-539-9511",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1290,
    "name": "크리스스튜디오영어어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 논현로159길 20 , 2층 (신사동, 동방빌딩)",
    "lat": "37.5231816999999",
    "lng": "127.0264172",
    "phoneNumber": "02-548-8888",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1291,
    "name": "서초우리들학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초대로51길 23 , 4층 (서초동, 서강빌딩)",
    "lat": "37.4959763",
    "lng": "127.0138271",
    "phoneNumber": "02-593-6650",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1292,
    "name": "그레잇에듀학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초대로1길 30 , A동 201호 일부 (방배동, 방배1차현대아파트)",
    "lat": "37.4885501",
    "lng": "126.9838383",
    "phoneNumber": "02-3481-0003",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1293,
    "name": "에스플러스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 테헤란로6길 48 , 3층 전체 (역삼동)",
    "lat": "37.4955524",
    "lng": "127.0316041",
    "phoneNumber": "02-508-8209",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1294,
    "name": "서울엘리트학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 420 , 3층 (대치동)",
    "lat": "37.5010257",
    "lng": "127.0528917",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습",
    "isFinish": "완료"
  },
  {
    "number": 1295,
    "name": "엠제이스터디독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 헌릉로 569  , 405호 (세곡동)",
    "lat": "37.4657816",
    "lng": "127.1011914",
    "phoneNumber": "02-3477-7677",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1296,
    "name": "필립영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로62길 33 , 4층 (대치동)",
    "lat": "37.4980816",
    "lng": "127.0550538",
    "phoneNumber": "02-3454-0509",
    "교습과정": "보습",
    "isFinish": "완료"
  },
  {
    "number": 1298,
    "name": "미래의1관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 삼성로72길 3 , 4층 (대치동)",
    "lat": "37.502669",
    "lng": "127.0593989",
    "phoneNumber": "02-577-1777",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1300,
    "name": "나다어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 501 , 201호,202호 (대치동, SM TOWER)",
    "lat": "37.4993898",
    "lng": "127.061127",
    "phoneNumber": "02-552-6005",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1302,
    "name": "엘피(LP)댄스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 테헤란로5길 11 , 4층일부,5층일부 (역삼동)",
    "lat": "37.4995267",
    "lng": "127.0292602",
    "phoneNumber": "02-2052-0151",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 1303,
    "name": "하이터치수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 봉은사로57길 59 , 3층 (삼성동)",
    "lat": "37.5146018",
    "lng": "127.0437307",
    "phoneNumber": "02-6213-1248",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1305,
    "name": "깊은생각초등수학보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 321 , 2층 (대치동)",
    "lat": "37.500479",
    "lng": "127.0596904",
    "phoneNumber": "02-539-7706",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1306,
    "name": "상위권수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로29길 65 , 2층일부 (압구정동)",
    "lat": "37.5317386",
    "lng": "127.0270157",
    "phoneNumber": "02-548-1700",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1307,
    "name": "시대인재브릿지관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 503 2~3층(대치동)",
    "lat": "37.4993869",
    "lng": "127.061403",
    "phoneNumber": "02-554-1952",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1309,
    "name": "다원교육특목관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 301 , 3층 (대치동, 하늘도시)",
    "lat": "37.499102",
    "lng": "127.0604069",
    "phoneNumber": "02-501-0306",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1310,
    "name": "수학과학의미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초대로 355 , 204호, 205호 (서초동, 서초메이플라워맴버스빌)",
    "lat": "37.4960319",
    "lng": "127.0201421",
    "phoneNumber": "02-521-8839",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1311,
    "name": "책읽기와글쓰기리딩엠도곡학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 225 , 407-2호 (도곡동, 도곡렉슬상가)",
    "lat": "37.4953504",
    "lng": "127.0527143",
    "phoneNumber": "02-573-2161",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1312,
    "name": "바른공부독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 삼성로58길 11 , 2층, 3층 (대치동)",
    "lat": "37.4987999",
    "lng": "127.0622312",
    "phoneNumber": "02-553-9876",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1313,
    "name": "실마리수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 헌릉로 569  , 703-1호 (세곡동)",
    "lat": "37.4657816",
    "lng": "127.1011914",
    "phoneNumber": "02-459-5885",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1315,
    "name": "퍼스트인(First 人)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 308 , 3층 (대치동, 성원빌딩)",
    "lat": "37.5055713",
    "lng": "127.0491588",
    "phoneNumber": "02-5534-353",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1318,
    "name": "토즈스터디센터교대역독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 서초구 서초중앙로24길 19 , 4층일부 (서초동)",
    "lat": "37.4950608",
    "lng": "127.0156971",
    "phoneNumber": "02-3477-9773",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1319,
    "name": "대치세인트엘프렙관리형독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 서초구 방배중앙로29길 3 , 3층 일부 (방배동)",
    "lat": "37.4964183",
    "lng": "126.9852741",
    "phoneNumber": "02-533-1059",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1320,
    "name": "기파랑문해원대치원중등관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로64길 5 , 4층 전체 (대치동, 라이온스빌딩)",
    "lat": "37.497902",
    "lng": "127.0526595",
    "phoneNumber": "02-555-8100",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1322,
    "name": "비전21앤(N)관독서실",
    "학원종류": "평생직업교육학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 삼성로63길 21 , 2층,3층 (대치동)",
    "lat": "37.4994418",
    "lng": "127.0584264",
    "phoneNumber": "02-556-2055",
    "교습과정": "독서실(일반인)",
    "isFinish": ""
  },
  {
    "number": 1323,
    "name": "버밍엄영어전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 나루터로 43 , 5층 일부 (잠원동)",
    "lat": "37.5152578",
    "lng": "127.0146863",
    "phoneNumber": "02-537-8553",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1324,
    "name": "주한영국문화원영러너서초어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 서초중앙로24길 27 , 122호일부,123호일부,135호~139호 (서초동)",
    "lat": "37.4954055",
    "lng": "127.0164657",
    "phoneNumber": "02-3702-0600",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1325,
    "name": "해커스해외대학입시전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 서초대로73길 12 , 7층 일부 (서초동, 세계빌딩)",
    "lat": "37.4985905",
    "lng": "127.0258499",
    "phoneNumber": "02-569-7467",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1326,
    "name": "마루국어논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 잠원로 24 , 308호 (반포동, 반포자이주구중심상가1동)",
    "lat": "37.5071093",
    "lng": "127.0098804",
    "phoneNumber": "02-537-5397",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1327,
    "name": "씨엠에스(CMS)대치고등1관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 336 201호, 401호 일부, 402호 (대치동, 한림빌딩)",
    "lat": "37.5016654",
    "lng": "127.0598058",
    "phoneNumber": "02-565-1833",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1328,
    "name": "나무독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 도곡로18길 4 , 2층~4층 (도곡동)",
    "lat": "37.4911515999999",
    "lng": "127.0379446",
    "phoneNumber": "02-3461-9188",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1329,
    "name": "피아이국제관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 삼성로64길 51 3층 일부, 4층 일부(대치동)",
    "lat": "37.5011262",
    "lng": "127.0644719",
    "phoneNumber": "02-554-7550",
    "교습과정": "외국어",
    "isFinish": ""
  },
  {
    "number": 1331,
    "name": "집단지성학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로 245 , 5층 (반포동)",
    "lat": "37.5033532",
    "lng": "127.0107932",
    "phoneNumber": "02-532-1213",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1334,
    "name": "용문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초대로51길 16 , 4층 (서초동, 영림)",
    "lat": "37.4953718",
    "lng": "127.0144585",
    "phoneNumber": "02-3486-8637",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1337,
    "name": "아이비셉트학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 논현로175길 63 , 3층 일부 (신사동)",
    "lat": "37.5240154",
    "lng": "127.0239103",
    "phoneNumber": "02-544-9302",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1338,
    "name": "하우투스터디과학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로8길 13 , 1층 (반포동, 항교빌딩)",
    "lat": "37.5017655",
    "lng": "127.0101071",
    "phoneNumber": "070-7724-7020",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1339,
    "name": "스카이로학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 일원로 95 , 602호 (일원동, 신영프라자)",
    "lat": "37.4856021",
    "lng": "127.0835726",
    "phoneNumber": "02-445-7790",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1340,
    "name": "폴라나어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 학동로97길 20 , 4층 일부 (청담동, 성호빌딩)",
    "lat": "37.5212011",
    "lng": "127.0554736",
    "phoneNumber": "02-514-0573",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1343,
    "name": "닥터필로스대치학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로16길 6 , 2층전체 (개포동)",
    "lat": "37.4838236999999",
    "lng": "127.0601066",
    "phoneNumber": "02-577-4960",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1344,
    "name": "대치프라우드7학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 도곡로 418 , 7층 (대치동, 강원빌딩)",
    "lat": "37.4970089",
    "lng": "127.0562594",
    "phoneNumber": "02-566-0509",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1345,
    "name": "아하김일래수학전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2909 , 402호, 403호, 405호 (대치동, 여천빌딩)",
    "lat": "37.4922077",
    "lng": "127.0573813",
    "phoneNumber": "02-555-3276",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1346,
    "name": "숙명킨더아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 강남대로8길 23-11 , 1층,2층,3층,4층 (양재동)",
    "lat": "37.4686639",
    "lng": "127.0416845",
    "phoneNumber": "02-574-3293",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1348,
    "name": "원일아이숲어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 광평로10길 15 , 1층,2층 (일원동)",
    "lat": "37.482024",
    "lng": "127.0821324",
    "phoneNumber": "02-574-2646",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1349,
    "name": "고수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로 229 , 4층일부 (반포동)",
    "lat": "37.502108",
    "lng": "127.0113454",
    "phoneNumber": "02-595-3177",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1350,
    "name": "스페라학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동작대로 160 , 201호 (방배동)",
    "lat": "37.4906572",
    "lng": "126.9829888",
    "phoneNumber": "-",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1352,
    "name": "대치전진학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로64길 9 , 4층 (대치동, 대성빌딩)",
    "lat": "37.5004504",
    "lng": "127.0531429",
    "phoneNumber": "02-567-0203",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1353,
    "name": "신대산영어전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 효령로 184 , 3층 (방배동, 유신빌딩)",
    "lat": "37.4824614",
    "lng": "127.0041881",
    "phoneNumber": "02-3473-2185",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1354,
    "name": "더엠브릿지영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 양재대로2길 116-6  , 401호 (우면동)",
    "lat": "37.4564765999999",
    "lng": "127.0154524",
    "phoneNumber": "02-592-5111",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1355,
    "name": "상신학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 개포로22길 40 , 2층 (개포동)",
    "lat": "37.4765464",
    "lng": "127.0493226",
    "phoneNumber": "02-804-2236",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1356,
    "name": "이룸학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로78길 22 , 206호 (대치동, 대치삼성아파트)",
    "lat": "37.4965682",
    "lng": "127.0588507",
    "phoneNumber": "02-555-4720",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1358,
    "name": "링크(LINK)물리학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로71길 16 , 4층 (대치동)",
    "lat": "37.5021692",
    "lng": "127.0575619",
    "phoneNumber": "02-558-1868",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1359,
    "name": "이지에듀학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 강남대로10길 23 , 2층 (양재동)",
    "lat": "37.4687339",
    "lng": "127.0406548",
    "phoneNumber": "02-571-8170",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 1360,
    "name": "소도스카이학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 반포대로26길 75 , 2층 (서초동)",
    "lat": "37.4916863",
    "lng": "127.0130819",
    "phoneNumber": "02-6053-3131",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1362,
    "name": "아이큐브학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로52길 14 , 302호, 303호 (역삼동, 도곡프라자)",
    "lat": "37.4985291",
    "lng": "127.0479489",
    "phoneNumber": "02-555-5105",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1363,
    "name": "신대찬학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 50 , 3층 307호 (반포동)",
    "lat": "37.5017761999999",
    "lng": "126.9901541",
    "phoneNumber": "02-537-6281",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1364,
    "name": "오은정국어논술전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 219 , 8동 4층 6~8호 (잠원동, 반포쇼핑타운)",
    "lat": "37.5074568",
    "lng": "127.0078376",
    "phoneNumber": "02-536-1686",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1365,
    "name": "김동하영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 도곡로 450 , 5층 (대치동, 덕산빌딩)",
    "lat": "37.4981124",
    "lng": "127.0597594",
    "phoneNumber": "02-564-9515",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": "완료"
  },
  {
    "number": 1367,
    "name": "러닝포리스트(Learning Forest)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로30길 17 , 804호 (신사동, 이소니프라자)",
    "lat": "37.5262629",
    "lng": "127.0294934",
    "phoneNumber": "02-547-1025",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1368,
    "name": "소도스카이원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 반포대로26길 75 , 4층 (서초동)",
    "lat": "37.4916863",
    "lng": "127.0130819",
    "phoneNumber": "02-6053-3131",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1371,
    "name": "강남대성별관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 서초대로52길 28 , 1층일부, 4층,5층,6층 (서초동, 대성학원)",
    "lat": "37.4925569",
    "lng": "127.0144617",
    "phoneNumber": "02-585-9600",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1372,
    "name": "옥스포드아카데미(OXFORD ACADEMY)어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 언주로172길 13 , 2층 (신사동)",
    "lat": "37.5279252",
    "lng": "127.0350059",
    "phoneNumber": "02-511-7155",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1374,
    "name": "엠에스씨브레인컨설팅학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 영동대로50길 10 , 2층 (대치동)",
    "lat": "37.4985403",
    "lng": "127.0699374",
    "phoneNumber": "02-557-9864",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1375,
    "name": "서준학원지혜관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 효령로 186 , 2층 (방배동)",
    "lat": "37.482492",
    "lng": "127.0043567",
    "phoneNumber": "02-525-1229",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1377,
    "name": "포워드싱킹(ForwardThinking)독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 서초구 고무래로 22 , 5층일부 (반포동, 쌍동빌딩 서관)",
    "lat": "37.5025115",
    "lng": "127.0107221",
    "phoneNumber": "02-593-5911",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1378,
    "name": "자유의날개국어논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 효령로46길 5 , 4층501호 (서초동)",
    "lat": "37.483309",
    "lng": "127.0090104",
    "phoneNumber": "02-525-0982",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1381,
    "name": "그린램프라이브러리개포독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 개포로 615 , 8층 일부 (개포동, 석탑프라자)",
    "lat": "37.4926936",
    "lng": "127.0756284",
    "phoneNumber": "02-459-5911",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1382,
    "name": "동의엠성인고시학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "인문사회(대)",
    "학원주소\t": "서울특별시 강남구 언주로81길 56 , 2층 (역삼동, 대명빌딩)",
    "lat": "37.4992522999999",
    "lng": "127.0391658",
    "phoneNumber": "02-3453-7419",
    "교습과정": "대학편입",
    "isFinish": ""
  },
  {
    "number": 1383,
    "name": "박문각강남고시1별관학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "인문사회(대)",
    "학원주소\t": "서울특별시 서초구 강남대로61길 19 , 301호,302호,305호 (서초동)",
    "lat": "37.4985124",
    "lng": "127.0247111",
    "phoneNumber": "02-3476-3670",
    "교습과정": "성인고시",
    "isFinish": ""
  },
  {
    "number": 1384,
    "name": "매쓰포인트수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로34길 11 , 405호 (신사동, 압구정스퀘어)",
    "lat": "37.5273895",
    "lng": "127.030957",
    "phoneNumber": "02-557-9864",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1385,
    "name": "이수정국어논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로62길 29 , 4층 (대치동)",
    "lat": "37.4979282",
    "lng": "127.054936",
    "phoneNumber": "02-563-1471",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 1387,
    "name": "컬쳐컴플렉스어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 테헤란로20길 15 , 201호 일부 (역삼동, 메이플라워멤버스빌오피스텔)",
    "lat": "37.4987108",
    "lng": "127.0347437",
    "phoneNumber": "02-000-0000",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 1389,
    "name": "마풀원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 선릉로119길 15 , 4층일부 (논현동)",
    "lat": "37.5132325999999",
    "lng": "127.0413396",
    "phoneNumber": "02-1670-8853",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1390,
    "name": "휴몬랩에듀8학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로69길 20 , 2층 (대치동)",
    "lat": "37.501505",
    "lng": "127.0575296",
    "phoneNumber": "02-6486-8882",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 1391,
    "name": "더(The)강한학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 323 , 6층 (대치동, 삼주빌딩)",
    "lat": "37.5006127",
    "lng": "127.0596197",
    "phoneNumber": "02-417-0909",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1395,
    "name": "스파크어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 고무래로 14 , 2층 (반포동, 베뉴타워)",
    "lat": "37.50329",
    "lng": "127.0101243",
    "phoneNumber": "02-594-5030",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1396,
    "name": "서초관러닝어취브수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 효령로 182-7 2층(방배동)",
    "lat": "37.4823166",
    "lng": "127.0042319",
    "phoneNumber": "02-586-0603",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1399,
    "name": "미래한국인학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 444 , 5층 (대치동, 일억조빌딩)",
    "lat": "37.4979898",
    "lng": "127.0591563",
    "phoneNumber": "02-555-4434",
    "교습과정": "보습",
    "isFinish": "완료"
  },
  {
    "number": 1400,
    "name": "베르나더스아카데미(BERNARDUS ACADEMY)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로 108 , 204호 (신사동)",
    "lat": "37.5229191",
    "lng": "127.0205789",
    "phoneNumber": "02-516-0164",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1401,
    "name": "세정스카이학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 446 , 4층 (대치동, 우전타워)",
    "lat": "37.4979979",
    "lng": "127.059403",
    "phoneNumber": "02-553-1010",
    "교습과정": "보습",
    "isFinish": "완료"
  },
  {
    "number": 1403,
    "name": "대치마스터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 336 , 202호 (대치동, 한림빌딩)",
    "lat": "37.506127",
    "lng": "127.0600466",
    "phoneNumber": "02-565-1152",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1000,
    "name": "귀큰여우창작소미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 선릉로 225 , 501호,502호 (도곡동,도곡렉슬상가)",
    "lat": "37.4953404",
    "lng": "127.0526522",
    "phoneNumber": "02-578-5781",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1001,
    "name": "메가스터디원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 효령로 321 , 3층전체, 9층일부(서초동)",
    "lat": "37.4861473",
    "lng": "127.0191221",
    "phoneNumber": "02-3489-8200",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1002,
    "name": "엠베스트원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 효령로 321 , 4층전체 (서초동, 메가스터디)",
    "lat": "37.4861473",
    "lng": "127.0191221",
    "phoneNumber": "02-3489-8200",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1003,
    "name": "정현영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 405 , 208호,209호 (대치동,삼환 아르누보2)",
    "lat": "37.4974385",
    "lng": "127.0546376",
    "phoneNumber": "02-552-8253",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1004,
    "name": "그루샘수학보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 532 , 6층 일부 (대치동, 태안빌딩)",
    "lat": "37.4997795",
    "lng": "127.0645688",
    "phoneNumber": "02-564-1889",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1005,
    "name": "에이비씨(ABC)항공승무원학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 논현로 416 , 2층 전체 (역삼동, 운기빌딩)",
    "lat": "37.4974055",
    "lng": "127.0388822",
    "phoneNumber": "02-577-8777",
    "교습과정": "항공승무원",
    "isFinish": ""
  },
  {
    "number": 1006,
    "name": "로드맵학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 225 , 408호 일부, 508호(도곡동)",
    "lat": "37.4953404",
    "lng": "127.0526522",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1007,
    "name": "강남커피바리스타학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 학동로47길 16 , 3층 (논현동)",
    "lat": "37.5177226",
    "lng": "127.0386898",
    "phoneNumber": "02-511-1352",
    "교습과정": "식음료품(바리스타,소믈리에)",
    "isFinish": ""
  },
  {
    "number": 1008,
    "name": "에이매쓰학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 언주로30길 10 , 407-1호 (도곡동, 현대비젼21)",
    "lat": "37.4873616",
    "lng": "127.0513255",
    "phoneNumber": "02-562-0309",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1009,
    "name": "바로새김학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 331 , 2층 (대치동)",
    "lat": "37.5011637",
    "lng": "127.0593306",
    "phoneNumber": "02-6951-1828",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1010,
    "name": "센텀수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로64길 26 , 2층 (대치동)",
    "lat": "37.4994478",
    "lng": "127.0533138",
    "phoneNumber": "02-564-1030",
    "교습과정": "보습",
    "isFinish": "완료"
  },
  {
    "number": 1011,
    "name": "강남부동산아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 서초구 법원로2길 21 , 302호일부(B), 303호일부(A) (서초동, 칠보빌딩)",
    "lat": "37.494387",
    "lng": "127.0131049",
    "phoneNumber": "02-516-7788",
    "교습과정": "부동산",
    "isFinish": ""
  },
  {
    "number": 1012,
    "name": "ANC크루팩토리승무원학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 강남대로 584 , 지하1층일부 (논현동)",
    "lat": "37.513958",
    "lng": "127.0206632",
    "phoneNumber": "02-2038-0023",
    "교습과정": "항공승무원",
    "isFinish": ""
  },
  {
    "number": 1013,
    "name": "달에서온토끼학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로 95 , 5층 (서초동,거북빌딩)",
    "lat": "37.4903629999999",
    "lng": "127.0139508",
    "phoneNumber": "02-588-7245",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1014,
    "name": "매경케이알피엠에듀센터학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 테헤란로70길 16 , 3층 A호 일부 (대치동)",
    "lat": "37.5043909",
    "lng": "127.0533488",
    "phoneNumber": "02-515-0078",
    "교습과정": "부동산",
    "isFinish": ""
  },
  {
    "number": 1015,
    "name": "케이비즈수학과학1관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로57길 5 , 5,6층 (대치동)",
    "lat": "37.4980215",
    "lng": "127.0606264",
    "phoneNumber": "02-508-3349",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1016,
    "name": "이챕터스도곡학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 225 , 506-1호,506-2호 (도곡동,도곡렉슬상가)",
    "lat": "37.4953404",
    "lng": "127.0526522",
    "phoneNumber": "02-573-0577",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1017,
    "name": "하이매쓰큐학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 212 , 301호일부(301-21호) (대치동,은마아파트상가)",
    "lat": "37.495511",
    "lng": "127.0637579",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1018,
    "name": "페디아플러스대치학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 212 , 302호 (대치동,은마아파트상가)",
    "lat": "37.495511",
    "lng": "127.0637579",
    "phoneNumber": "02-3454-0673",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1019,
    "name": "에스와이액팅연기학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 봉은사로74길 15 , 2층 (삼성동, 호경타워)",
    "lat": "37.5115428",
    "lng": "127.0520441",
    "phoneNumber": "02-3443-1012",
    "교습과정": "연기(연극,뮤지컬,오페라)",
    "isFinish": ""
  },
  {
    "number": 1020,
    "name": "이원학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로115길 33 , 1층 (논현동)",
    "lat": "37.5114869",
    "lng": "127.040304",
    "phoneNumber": "02-515-6521",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1021,
    "name": "에듀플렉스에듀코치개별지도서초학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 고무래로10길 17 , 4층 일부 (반포동, 동호빌딩)",
    "lat": "37.5012315",
    "lng": "127.0104245",
    "phoneNumber": "02-533-1651",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1022,
    "name": "황쌤수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로64길 8 , 6층 (대치동)",
    "lat": "37.4977228",
    "lng": "127.0531038",
    "phoneNumber": "02-525-0982",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1023,
    "name": "유패스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로76길 16 , 2층 전체 (대치동)",
    "lat": "37.5040636",
    "lng": "127.0596603",
    "phoneNumber": "02-557-5493",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1024,
    "name": "두각입시센터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로77길 5 , 4층(대치동)",
    "lat": "37.4986723",
    "lng": "127.058384",
    "phoneNumber": "02-556-3349",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 1025,
    "name": "한국글로벌널리지학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 언주로 425 , 3층일부 (역삼동,아레나빌딩)",
    "lat": "37.5011085",
    "lng": "127.0428933",
    "phoneNumber": "02-562-7349",
    "교습과정": "컴퓨터(정보처리,통신기기,인터넷,소프트웨어)",
    "isFinish": ""
  },
  {
    "number": 1026,
    "name": "아틈학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 봉은사로61길 12 , 2층,3층 (삼성동)",
    "lat": "37.5120285",
    "lng": "127.0464417",
    "phoneNumber": "070-4060-0051",
    "교습과정": "컴퓨터(정보처리,통신기기,인터넷,소프트웨어)",
    "isFinish": ""
  },
  {
    "number": 1027,
    "name": "에이플러스독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 도곡로 183 , 5층 (역삼동,현진빌딩)",
    "lat": "37.49227",
    "lng": "127.039393",
    "phoneNumber": "02-557-7787",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1028,
    "name": "양파아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 212 , 306호 (대치동,은마아파트)",
    "lat": "37.4974576",
    "lng": "127.0653265",
    "phoneNumber": "02-555-6599",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1029,
    "name": "조이클래식음악학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 헌릉로570길 34 , 404호 (세곡동)",
    "lat": "37.4631419",
    "lng": "127.1034644",
    "phoneNumber": "02-2226-2333",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1030,
    "name": "데브기어교육학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 서초구 사평대로 359 , 3층 (반포동)",
    "lat": "37.5041039",
    "lng": "127.0222145",
    "phoneNumber": "02-595-4288",
    "교습과정": "컴퓨터(정보처리,통신기기,인터넷,소프트웨어)",
    "isFinish": ""
  },
  {
    "number": 1031,
    "name": "이투스원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 남부순환로 2547 , 6층 전체(서초동)",
    "lat": "37.4843054",
    "lng": "127.0290946",
    "phoneNumber": "070-7464-9121",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1032,
    "name": "세븐에듀원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 헌릉로 176 , 4층 406~408호,409호일부 (내곡동)",
    "lat": "37.4564771999999",
    "lng": "127.0593952",
    "phoneNumber": "02-1544-7827",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1033,
    "name": "애플공인교육센터MFK학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 서초구 강남대로97길 17 , 4층 (잠원동,신일빌딩)",
    "lat": "37.5145898",
    "lng": "127.0188046",
    "phoneNumber": "02-512-3492",
    "교습과정": "컴퓨터(정보처리,통신기기,인터넷,소프트웨어)",
    "isFinish": ""
  },
  {
    "number": 1034,
    "name": "넘버원헤어아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 서초구 명달로20길 60 , 402호 (서초동,서초타운)",
    "lat": "37.4863908",
    "lng": "127.007697",
    "phoneNumber": "02-582-4042",
    "교습과정": "이·미용",
    "isFinish": ""
  },
  {
    "number": 1035,
    "name": "디지털대성원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배로 181 , 3층·4층·5층 전체, 6층 일부  (방배동, 단우빌딩)",
    "lat": "37.4895404",
    "lng": "126.991913",
    "phoneNumber": "02-3470-8555",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1036,
    "name": "더브아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 삼성로95길 23 , 2층 (삼성동,남양빌딩)",
    "lat": "37.5074425",
    "lng": "127.0539355",
    "phoneNumber": "02-546-1113",
    "교습과정": "화술",
    "isFinish": ""
  },
  {
    "number": 1037,
    "name": "펀액터스화술학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 서초구 남부순환로337가길 9 , 1,2,3층 (서초동)",
    "lat": "37.4836848",
    "lng": "127.0220161",
    "phoneNumber": "02-561-7300",
    "교습과정": "화술",
    "isFinish": ""
  },
  {
    "number": 1038,
    "name": "그림숲키즈어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 논현로38길 32-5 , 1층~3층 (도곡동)",
    "lat": "37.4852139",
    "lng": "127.0446505",
    "phoneNumber": "02-576-2744",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1039,
    "name": "안보라언어독해학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 318 203호, 204호(대치동)",
    "lat": "37.4980894",
    "lng": "127.0524088",
    "phoneNumber": "02-556-8383",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1040,
    "name": "로뎀나무음악학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 서초구 태봉로 62 , 402호 (우면동,네이처프라자)",
    "lat": "37.4640472",
    "lng": "127.0250245",
    "phoneNumber": "02-577-0501",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1041,
    "name": "더블유(W)액팅연기학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 압구정로4길 11 , 2층 (신사동)",
    "lat": "37.5220956",
    "lng": "127.0203446",
    "phoneNumber": "02-6925-1020",
    "교습과정": "연극",
    "isFinish": ""
  },
  {
    "number": 1042,
    "name": "경선식에듀원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로 56 , 8층 (서초동,상보빌딩)",
    "lat": "37.4868706",
    "lng": "127.0154068",
    "phoneNumber": "02-597-6582",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1043,
    "name": "아트인게임아트(Art in GameArt)학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 서초구 방배중앙로 20 6층(방배동)",
    "lat": "37.4818979",
    "lng": "126.9927212",
    "phoneNumber": "070-7772-4344",
    "교습과정": "컴퓨터(정보처리,통신기기,인터넷,소프트웨어)",
    "isFinish": ""
  },
  {
    "number": 1044,
    "name": "강남천년의미소예비관미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 선릉로86길 6-5 , 2층 (대치동,프라임빌딩)",
    "lat": "37.5028138",
    "lng": "127.0506214",
    "phoneNumber": "070-4065-0565",
    "교습과정": "미술",
    "isFinish": "완료"
  },
  {
    "number": 1045,
    "name": "해커스공인중개사주택관리사감정평가사학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "인문사회(대)",
    "학원주소\t": "서울특별시 서초구 서초대로73길 12 , 6층 (서초동,세계빌딩)",
    "lat": "37.4985905",
    "lng": "127.0258499",
    "phoneNumber": "02-597-9000",
    "교습과정": "성인고시",
    "isFinish": ""
  },
  {
    "number": 1046,
    "name": "토즈도곡이(2)스마트독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 언주로 311 , 301호, 302호 (역삼동,로즈I타워)",
    "lat": "37.4952625",
    "lng": "127.045625",
    "phoneNumber": "02-2052-0040",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1047,
    "name": "에스에프필름컴퓨터아트학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 논현로79길 71 , 5층, 7층 (역삼동)",
    "lat": "37.4957379",
    "lng": "127.0332593",
    "phoneNumber": "02-501-5111",
    "교습과정": "디자인",
    "isFinish": ""
  },
  {
    "number": 1048,
    "name": "케이액팅스튜디오(K Acting Studio)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 도곡로 146 , 2층 (도곡동, 삼공빌딩)",
    "lat": "37.4905556",
    "lng": "127.0361111",
    "phoneNumber": "02-6083-2468",
    "교습과정": "연극",
    "isFinish": ""
  },
  {
    "number": 1049,
    "name": "대치수학의바다학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로69길 11 , 2층 전체 (대치동)",
    "lat": "37.501608",
    "lng": "127.0584095",
    "phoneNumber": "070-7443-3099",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1050,
    "name": "준오아카데미미용학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 삼성로 710 , 4~7층 (청담동, 아카데미 준오)",
    "lat": "37.5195567",
    "lng": "127.0501612",
    "phoneNumber": "02-548-0605",
    "교습과정": "이·미용",
    "isFinish": ""
  },
  {
    "number": 1051,
    "name": "세정방배캠퍼스3층학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동작대로 188 , 3층전체 (방배동, 액센빌딩)",
    "lat": "37.4932966999999",
    "lng": "126.983124",
    "phoneNumber": "02-532-6552",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1052,
    "name": "크레버스원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 테헤란로 521 , 21층 (삼성동, 파르나스타워)",
    "lat": "37.5100567",
    "lng": "127.0613285",
    "phoneNumber": "02-3429-9407",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1053,
    "name": "한솔강남브레인학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 압구정로28길 22-5 , 2층 (신사동)",
    "lat": "37.5250123",
    "lng": "127.0271808",
    "phoneNumber": "02-518-7085",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 1054,
    "name": "하이매쓰학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 409 , 7층 (대치동,타워엠프리스)",
    "lat": "37.4973819",
    "lng": "127.0551699",
    "phoneNumber": "02-552-0707",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1055,
    "name": "아이엠수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로3길 8 , 506,507호 (반포동, 반포프라자)",
    "lat": "37.5021153",
    "lng": "126.9869086",
    "phoneNumber": "02-537-5560",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1056,
    "name": "케이뎀(KDEM)전자실용음악학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 봉은사로7길 13 , 2층 (논현동)",
    "lat": "37.5063616",
    "lng": "127.0272445",
    "phoneNumber": "02-546-7024",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1057,
    "name": "반포스피커스(Banpospeakers)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 고무래로10길 25 , 1층, 3층 (반포동)",
    "lat": "37.5004954",
    "lng": "127.0101838",
    "phoneNumber": "02-3477-1433",
    "교습과정": "외국어",
    "isFinish": ""
  },
  {
    "number": 1058,
    "name": "에스이(SE)원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 강남대로94길 71-9 , 1층일부 (역삼동)",
    "lat": "37.5012184",
    "lng": "127.032793",
    "phoneNumber": "070-7450-1962",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1059,
    "name": "아트본(Art本)미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 남부순환로359길 27 , 2층 전체 (도곡동)",
    "lat": "37.4865226",
    "lng": "127.035873",
    "phoneNumber": "070-8129-3812",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1060,
    "name": "보컬프렌즈실용음악학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 선릉로129길 16 , 6층 (논현동)",
    "lat": "37.5163586",
    "lng": "127.0402263",
    "phoneNumber": "070-7799-9499",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1061,
    "name": "에이아이아이(Aii)미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 언주로157길 26 , 2층 전체 (신사동)",
    "lat": "37.5240945",
    "lng": "127.030768",
    "phoneNumber": "02-422-0993",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1062,
    "name": "수학의정석원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 강남대로 202 , 지하2층,7층 (양재동,모산빌딩)",
    "lat": "37.4823239",
    "lng": "127.0368273",
    "phoneNumber": "02-574-1357",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1063,
    "name": "피아노이야기학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 개포로22길 104 , 2층 (개포동)",
    "lat": "37.4755914",
    "lng": "127.053641",
    "phoneNumber": "02-578-5376",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1064,
    "name": "보카퍼스트학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로93길 9 , 4층 (대치동)",
    "lat": "37.5008373",
    "lng": "127.0645016",
    "phoneNumber": "02-555-3025",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1065,
    "name": "극예술연기학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 사평대로55길 140 , 2층 (반포동)",
    "lat": "37.5100023",
    "lng": "127.0202992",
    "phoneNumber": "02-6339-4911",
    "교습과정": "연극",
    "isFinish": ""
  },
  {
    "number": 1066,
    "name": "키즈스피치마루지웅변학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 선릉로 225 , 309-1호, 310호 (도곡동,도곡렉슬상가)",
    "lat": "37.4924224",
    "lng": "127.0542711",
    "phoneNumber": "070-8834-4203",
    "교습과정": "웅변",
    "isFinish": ""
  },
  {
    "number": 1067,
    "name": "에스원(S1)아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 역삼로3길 17 , 5층 (역삼동)",
    "lat": "37.4946226",
    "lng": "127.031054",
    "phoneNumber": "02-3453-4080",
    "교습과정": "게임",
    "isFinish": ""
  },
  {
    "number": 1068,
    "name": "창업오케이아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "인문사회(대)",
    "학원주소\t": "서울특별시 강남구 강남대로156길 20 , 1층일부,2층일부 (신사동)",
    "lat": "37.5182433",
    "lng": "127.0208133",
    "phoneNumber": "02-716-5600",
    "교습과정": "경영",
    "isFinish": ""
  },
  {
    "number": 1069,
    "name": "대치위더스입시관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로77길 5 , 3층일부 (대치동)",
    "lat": "37.4986723",
    "lng": "127.058384",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1070,
    "name": "네이처힐음악학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 서초구 태봉로2길 65 , 4단지상가 202호일부 (우면동)",
    "lat": "37.463634",
    "lng": "127.0262336",
    "phoneNumber": "02-579-4926",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1071,
    "name": "관인뮤직트리음악학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 서초구 신반포로 100 , 306호~311호,510호~511호 (반포동)",
    "lat": "37.5030753",
    "lng": "126.9956677",
    "phoneNumber": "02-592-0772",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1072,
    "name": "김영일교육컨설팅학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 155 , 2층 201호 (역삼동, 명빌딩)",
    "lat": "37.4914239",
    "lng": "127.0368158",
    "phoneNumber": "070-8672-9225",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 1073,
    "name": "아뜰리에수목유학미술학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 도산대로27길 26 , 301호 (신사동)",
    "lat": "37.5213596",
    "lng": "127.0275947",
    "phoneNumber": "00-000-0000",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1074,
    "name": "블루스카이수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 잠원로3길 40 , 402호 및 403호 (잠원동)",
    "lat": "37.5081523",
    "lng": "127.0037071",
    "phoneNumber": "02-535-0630",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1075,
    "name": "형진영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2936 , 301호(대치동,윈플러스상가)",
    "lat": "37.4933573",
    "lng": "127.0619092",
    "phoneNumber": "02-508-7380",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1076,
    "name": "한양플러스음악학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 서초구 태봉로 70 , 501호 (우면동)",
    "lat": "37.4645285",
    "lng": "127.0255453",
    "phoneNumber": "02-529-2995",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1077,
    "name": "한솔전기학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 강남대로42길 13 , 2층 (도곡동)",
    "lat": "37.4855463",
    "lng": "127.0351487",
    "phoneNumber": "02-575-7113",
    "교습과정": "전기",
    "isFinish": ""
  },
  {
    "number": 1078,
    "name": "지엘아이진학컨설팅학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 405 , 304-1호,305호 (대치동, 삼환 아르누보2)",
    "lat": "37.4974385",
    "lng": "127.0546376",
    "phoneNumber": "02-553-7278",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 1079,
    "name": "선경제니스어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 남부순환로 2936 , 303호, 308호일부, 309호, 409호, 410호 (대치동, 윈플러스상가)",
    "lat": "37.4933573",
    "lng": "127.0619092",
    "phoneNumber": "02-568-9001",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1080,
    "name": "아레테아카데미(Arete Academy)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도산대로27길 25 , 301호 (신사동)",
    "lat": "37.5215747",
    "lng": "127.0272808",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1081,
    "name": "뮤엠영어세곡학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 헌릉로570길 34 , 리엔파크프라자 504호 (세곡동)",
    "lat": "37.463185",
    "lng": "127.1035643",
    "phoneNumber": "02-2226-0582",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1082,
    "name": "비티씨아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 논현로145길 28 , 1층 일부 (논현동)",
    "lat": "37.5174635",
    "lng": "127.0264711",
    "phoneNumber": "02-571-5358",
    "교습과정": "식음료품(바리스타,소믈리에)",
    "isFinish": ""
  },
  {
    "number": 1083,
    "name": "도무스링구아학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 성촌1길 20 , 4층 전체 (우면동)",
    "lat": "37.4655124",
    "lng": "127.021701",
    "phoneNumber": "02-572-0202",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1084,
    "name": "아이리스(IRIS)영어전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초대로1길 14 , 3층 (방배동)",
    "lat": "37.4875126",
    "lng": "126.9832553",
    "phoneNumber": "02-593-0106",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1085,
    "name": "스터디코드원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 남부순환로333길 32 , 402호 (서초동, 영일빌딩)",
    "lat": "37.4838134",
    "lng": "127.0208344",
    "phoneNumber": "02-512-6049",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1086,
    "name": "리더스어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 논현로168길 18 , 2층, 7층 (신사동,동신빌딩)",
    "lat": "37.5238067",
    "lng": "127.0296884",
    "phoneNumber": "02-541-7890",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1087,
    "name": "디에스(DS)교육학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 언주로167길 33-4 , 3층 (신사동)",
    "lat": "37.5260366",
    "lng": "127.0302465",
    "phoneNumber": "02-1533-3423",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1088,
    "name": "안테나미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 선릉로86길 10 , 4-A호 (대치동)",
    "lat": "37.5030598",
    "lng": "127.0506839",
    "phoneNumber": "02-568-8270",
    "교습과정": "미술",
    "isFinish": "완료"
  },
  {
    "number": 1089,
    "name": "더코어패러다임학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 536 , 502호 (대치동, 동성빌딩)",
    "lat": "37.5037491",
    "lng": "127.0617296",
    "phoneNumber": "02-558-8556",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1090,
    "name": "리틀러너스어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 서래로5길 61 , 지하1층일부,1층,2층 (반포동)",
    "lat": "37.4978066",
    "lng": "126.994758",
    "phoneNumber": "02-565-7979",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1091,
    "name": "에이치비아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 태봉로2길 65 , 네이처힐4단지상가 202-2호 (우면동)",
    "lat": "37.463634",
    "lng": "127.0262336",
    "phoneNumber": "02-2057-0701",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1092,
    "name": "에스피(SP)수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 사평대로45길 10-25 , 501,503,504호 (반포동)",
    "lat": "37.5066782",
    "lng": "127.013939",
    "phoneNumber": "02-591-9070",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1093,
    "name": "김필립수학전문원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 413 , 204호 (대치동,삼환 SO GOOD)",
    "lat": "37.4975956",
    "lng": "127.0557613",
    "phoneNumber": "02-552-5504",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1094,
    "name": "올댓뷰티아카데미미용학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 서초구 강남대로69길 8 , 11층 일부, 12층 일부 (서초동)",
    "lat": "37.5018395",
    "lng": "127.0246454",
    "phoneNumber": "02-555-2040",
    "교습과정": "이·미용",
    "isFinish": ""
  },
  {
    "number": 1095,
    "name": "박희종논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 414 , 4층 (대치동,국민은행)",
    "lat": "37.4968866",
    "lng": "127.0558815",
    "phoneNumber": "02-566-7911",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1096,
    "name": "콴다일로4관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 311 , 2층 (대치동, 제동빌딩)",
    "lat": "37.4996",
    "lng": "127.0601579",
    "phoneNumber": "02-557-6699",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1097,
    "name": "킹스키즈어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 영동대로50길 14 , 1층,2층 (대치동)",
    "lat": "37.4986674",
    "lng": "127.0703297",
    "phoneNumber": "02-3453-3453",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1098,
    "name": "티엔아카데미원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 논현로 813 , 본관2층일부 (신사동, 영석빌딩)",
    "lat": "37.5212017",
    "lng": "127.027746",
    "phoneNumber": "02-538-3933",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 1099,
    "name": "시대인재엔(N)관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 505 B1층의 일부(후면부 및 B102호) 및 3층 전체(대치동)",
    "lat": "37.4995633",
    "lng": "127.0616676",
    "phoneNumber": "02-558-1060",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1100,
    "name": "지식학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로30길 17 , 401호 (신사동,이소니프라자)",
    "lat": "37.5262629",
    "lng": "127.0294934",
    "phoneNumber": "02-3444-4412",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1101,
    "name": "엠스퀘어수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로30길 17 802호(신사동)",
    "lat": "37.5263249",
    "lng": "127.0295435",
    "phoneNumber": "02-515-9621",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1102,
    "name": "노아알오아이학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 도산대로35길 50 , 1층 전체, 2층 전체 (신사동)",
    "lat": "37.5241023",
    "lng": "127.030624",
    "phoneNumber": "02-566-5571",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1103,
    "name": "송영지음악학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 학동로101길 26 , 204호,207호407호 (청담동, 청담 삼익상가)",
    "lat": "37.5223046",
    "lng": "127.0577361",
    "phoneNumber": "02-544-4349",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1104,
    "name": "박준영논리속독학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 광평로10길 15 212호(일원동,상록수아파트)",
    "lat": "37.482024",
    "lng": "127.0821324",
    "phoneNumber": "02-3412-1153",
    "교습과정": "건축",
    "isFinish": ""
  },
  {
    "number": 1105,
    "name": "인큐학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 테헤란로84길 14 , 2층 (대치동)",
    "lat": "37.5062549",
    "lng": "127.0584323",
    "phoneNumber": "02-517-1920",
    "교습과정": "화술",
    "isFinish": ""
  },
  {
    "number": 1106,
    "name": "렉시스강남캠퍼스학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 강남대로53길 7 , 2층일부(203,204), 11층(1101일부, 1102-~1104)(서초동)",
    "lat": "37.494251",
    "lng": "127.0282336",
    "phoneNumber": "02-588-4900",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 1107,
    "name": "후스토연기학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 논현로128길 20 , 2층 (논현동,SSC빌딩)",
    "lat": "37.5136758",
    "lng": "127.0327682",
    "phoneNumber": "02-548-4587",
    "교습과정": "연기(연극,뮤지컬,오페라)",
    "isFinish": ""
  },
  {
    "number": 1108,
    "name": "사람인아트스튜디오학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 서초구 서초대로53길 19 , 402호 (서초동, 상인빌딩)",
    "lat": "37.4959392",
    "lng": "127.0144439",
    "phoneNumber": "02-555-1280",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1109,
    "name": "강남잉글리쉬아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 언주로164길 12 , 5층 (신사동, 명진빌딩)",
    "lat": "37.525153",
    "lng": "127.0343807",
    "phoneNumber": "02-511-9864",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1110,
    "name": "더포트폴리오유학미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 압구정로30길 70 , 4층 (신사동)",
    "lat": "37.5228207",
    "lng": "127.0288295",
    "phoneNumber": "02-515-1707",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1111,
    "name": "한국국제어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 역삼로9길 21 , 1층, 2층, 3층 일부(301호)(역삼동)",
    "lat": "37.4954602",
    "lng": "127.0336576",
    "phoneNumber": "02-555-1739",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1112,
    "name": "서울국제크리스천아카데미(SICA)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 강남대로6길 90-23 , 1층~3층 전체 (양재동)",
    "lat": "37.4685839",
    "lng": "127.0462977",
    "phoneNumber": "02-557-7710",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1113,
    "name": "맑은숲국어논술전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배로37길 7 , 5층 (방배동)",
    "lat": "37.4935825",
    "lng": "126.9892965",
    "phoneNumber": "02-3477-4240",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1114,
    "name": "뮤직아카데미물댄동산음악학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 서초구 동광로12가길 2 , 2층 (방배동)",
    "lat": "37.487731",
    "lng": "126.9848043",
    "phoneNumber": "02-533-1159",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1115,
    "name": "움뮤직센터음악학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 서초구 서초중앙로33길 8 , 2층 (반포동)",
    "lat": "37.5013204",
    "lng": "127.0110911",
    "phoneNumber": "02-1577-2952",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1116,
    "name": "로드맵어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 선릉로 225 , 215호~217호,407-3호일부,408호일부 (도곡동)",
    "lat": "37.4953404",
    "lng": "127.0526522",
    "phoneNumber": "02-529-5243",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1117,
    "name": "아담리즈수학대치센터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 선릉로64길 19 , 3층 (대치동)",
    "lat": "37.4982405",
    "lng": "127.0538602",
    "phoneNumber": "02-565-9090",
    "교습과정": "기타(소)",
    "isFinish": "완료"
  },
  {
    "number": 1118,
    "name": "최상위영수학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초대로51길 28 , 5층 (서초동,진성빌딩)",
    "lat": "37.4964488",
    "lng": "127.0140242",
    "phoneNumber": "02-537-4784",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1119,
    "name": "반포스마트보카학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 219 , 306,307,308호 (잠원동, 반포쇼핑타운)",
    "lat": "37.5074568",
    "lng": "127.0078376",
    "phoneNumber": "02-537-4919",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1120,
    "name": "에센셜아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로18길 8 , 4층 (신사동)",
    "lat": "37.5242768",
    "lng": "127.0242794",
    "phoneNumber": "02-3443-1516",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1121,
    "name": "고구려와허박사학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 225 , 206호 (대치동)",
    "lat": "37.4971742",
    "lng": "127.0613516",
    "phoneNumber": "02-557-7339",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1122,
    "name": "프리매쓰학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로64길 15-14 , 2층 (대치동,기흥빌딩)",
    "lat": "37.4989487",
    "lng": "127.0533074",
    "phoneNumber": "02-569-5006",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1123,
    "name": "대치리얼수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 420 , 4층 (대치동)",
    "lat": "37.4972019",
    "lng": "127.0565523",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 1124,
    "name": "씨엠에스반포학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 동작대로 234 , 3층~4층 (방배동, CMS M)",
    "lat": "37.4972729",
    "lng": "126.9837363",
    "phoneNumber": "02-537-1288",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1125,
    "name": "키즈닥터창의성영재학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 고무래로10길 10 , 2층 (반포동,청구빌딩)",
    "lat": "37.5018993",
    "lng": "127.0104491",
    "phoneNumber": "02-400-1545",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 1126,
    "name": "마루국어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 155 , 309,310,311,312,517,518호 (대치동, 대치퍼스트)",
    "lat": "37.4938284",
    "lng": "127.062941",
    "phoneNumber": "02-2057-7737",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1127,
    "name": "아토즈아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 460 , 5층 (대치동,동선빌딩)",
    "lat": "37.4983942",
    "lng": "127.0606446",
    "phoneNumber": "02-565-0715",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 1128,
    "name": "두뇌가뛰어노는논술,브레이닝학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로8길 9 , 2층 (반포동)",
    "lat": "37.5019759",
    "lng": "127.0102486",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1129,
    "name": "주니어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 도곡로 184 , 502,503호 (도곡동,신호빌딩)",
    "lat": "37.4917395",
    "lng": "127.0396045",
    "phoneNumber": "02-3463-8747",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1130,
    "name": "인바스켓학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "인문사회(대)",
    "학원주소\t": "서울특별시 서초구 서초중앙로22길 122 , 2층 (서초동)",
    "lat": "37.4945317",
    "lng": "127.0204531",
    "phoneNumber": "02-730-8668",
    "교습과정": "행정",
    "isFinish": ""
  },
  {
    "number": 1131,
    "name": "세정스카이3층학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 446 , 3층 전체 (대치동, 우전빌딩)",
    "lat": "37.4979979",
    "lng": "127.059403",
    "phoneNumber": "02-552-2373",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1132,
    "name": "뉴청샘학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로34길 11 , 207호 (신사동,압구정스퀘어)",
    "lat": "37.5273895",
    "lng": "127.030957",
    "phoneNumber": "02-511-5665",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1133,
    "name": "케이앤(KN)영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로8길 5 , 2층 (반포동)",
    "lat": "37.5023134",
    "lng": "127.0104645",
    "phoneNumber": "02-599-0516",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1134,
    "name": "스터디브릭스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 삼성로 315 , 2층, 3층 (대치동, 청하빌딩)",
    "lat": "37.4999536",
    "lng": "127.059922",
    "phoneNumber": "02-558-5166",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1135,
    "name": "K2I수학올림피아드학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로67길 22 , 2층 (대치동)",
    "lat": "37.5008433",
    "lng": "127.057656",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1136,
    "name": "하이앤드에듀(HighEnd Edu.)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 462 , 4층 (대치동)",
    "lat": "37.502626",
    "lng": "127.0578107",
    "phoneNumber": "070-4206-0900",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1137,
    "name": "비탑키즈학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 고무래로10길 42 , 2층전체 (반포동)",
    "lat": "37.4989437",
    "lng": "127.009725",
    "phoneNumber": "02-599-6997",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1138,
    "name": "뮤닥터실용음악학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 강남대로94길 70 , 2층전체 (역삼동)",
    "lat": "37.5006547",
    "lng": "127.0328462",
    "phoneNumber": "02-1661-4369",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1139,
    "name": "압구정에듀홀릭학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로34길 11 , 2층 206호 (신사동, 압구정스퀘어)",
    "lat": "37.5273895",
    "lng": "127.030957",
    "phoneNumber": "02-6324-1453",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1140,
    "name": "골근위수영뷰티아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 도산대로 539 , 3층 (청담동,금원빌딩)",
    "lat": "37.5251555",
    "lng": "127.0526252",
    "phoneNumber": "02-3446-2999",
    "교습과정": "이·미용",
    "isFinish": ""
  },
  {
    "number": 1141,
    "name": "오르비클래스원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 테헤란로55길 17 , 3층 (역삼동)",
    "lat": "37.5056561",
    "lng": "127.0470619",
    "phoneNumber": "00-000-0000",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1142,
    "name": "에디센어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 선릉로 319 , 3층,4층,5층일부 (역삼동)",
    "lat": "37.4980257",
    "lng": "127.0517245",
    "phoneNumber": "02-501-3252",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1143,
    "name": "에쓰앤유과학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 영동대로57길 28 , 3층 (대치동, 현대아파트상가동)",
    "lat": "37.4998959",
    "lng": "127.0652973",
    "phoneNumber": "02-556-4824",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1144,
    "name": "꼭시넬그림책학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 서래로2길 27 , 2층 (반포동)",
    "lat": "37.4961277",
    "lng": "126.9997466",
    "phoneNumber": "-",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 1145,
    "name": "서초이안어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 서초중앙로33길 1 , 3,4층 (반포동,서석빌딩)",
    "lat": "37.5012992",
    "lng": "127.0115384",
    "phoneNumber": "02-534-4517",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1146,
    "name": "코리아승무원학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 서초구 서초대로78길 26 , 11층 (서초동, 강남선인빌딩)",
    "lat": "37.4954073",
    "lng": "127.0278263",
    "phoneNumber": "02-3486-0089",
    "교습과정": "항공승무원",
    "isFinish": ""
  },
  {
    "number": 1147,
    "name": "코리아항공운항과학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 서초대로78길 26 , 12층~13층 (서초동)",
    "lat": "37.4954073",
    "lng": "127.0278263",
    "phoneNumber": "02-3486-0089",
    "교습과정": "항공승무원",
    "isFinish": ""
  },
  {
    "number": 1148,
    "name": "르씨(R.se)무용전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 서초구 효령로 276 , 4층일부(우측) (서초동,덕암빌딩)",
    "lat": "37.4843873",
    "lng": "127.0144634",
    "phoneNumber": "02-581-7077",
    "교습과정": "무용",
    "isFinish": ""
  },
  {
    "number": 1149,
    "name": "서준학원미래관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 효령로 182-8 , 2층 전체 (방배동, 우진빌딩)",
    "lat": "37.4822015",
    "lng": "127.0040161",
    "phoneNumber": "02-525-0766",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1150,
    "name": "커피바리스타교육학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 논현로94길 25-4 , 1,2층 (역삼동)",
    "lat": "37.5031343",
    "lng": "127.0383786",
    "phoneNumber": "00-000-0000",
    "교습과정": "식음료품(바리스타,소믈리에)",
    "isFinish": ""
  },
  {
    "number": 1151,
    "name": "배우앤배움아트센터학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 서초구 사평대로55길 126 , 2층,3층 (반포동)",
    "lat": "37.5094533",
    "lng": "127.0205611",
    "phoneNumber": "02-540-3988",
    "교습과정": "연기(연극,뮤지컬,오페라)",
    "isFinish": ""
  },
  {
    "number": 1152,
    "name": "일공학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 강남대로 368 , 3층전체,401호 (역삼동, 동인빌딩)",
    "lat": "37.4957163",
    "lng": "127.0292141",
    "phoneNumber": "02-540-1096",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1153,
    "name": "프랜차이즈아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "인문사회(대)",
    "학원주소\t": "서울특별시 서초구 신반포로 314 , 501호 (반포동,임송빌딩)",
    "lat": "37.5098809",
    "lng": "127.0180076",
    "phoneNumber": "02-2233-4777",
    "교습과정": "경영",
    "isFinish": ""
  },
  {
    "number": 1154,
    "name": "진아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로76길 34 , 2층 (대치동, 다영빌딩)",
    "lat": "37.5020325",
    "lng": "127.0534169",
    "phoneNumber": "02-566-3624",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1155,
    "name": "읽기혁신논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로58길 39 , 201호 (대치동)",
    "lat": "37.4994486",
    "lng": "127.0642747",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1156,
    "name": "플라즈마고등1관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 341 , 3층,4층 (대치동, 인애빌딩)",
    "lat": "37.5019016",
    "lng": "127.0589304",
    "phoneNumber": "02-557-5442",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1157,
    "name": "르씨(R.se)무용전문센터학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 서초구 효령로 276 , 4층일부(좌측) (서초동,덕암빌딩)",
    "lat": "37.4843873",
    "lng": "127.0144634",
    "phoneNumber": "02-571-6900",
    "교습과정": "무용(전통무용,현대무용)",
    "isFinish": ""
  },
  {
    "number": 1158,
    "name": "씨엠에스(CMS)대치입시센터2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 334 , 6층 (대치동)",
    "lat": "37.5015069",
    "lng": "127.0599056",
    "phoneNumber": "02-557-0815",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1159,
    "name": "프라이드제이어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 논현로168길 36 , 1층 (신사동)",
    "lat": "37.5232126999999",
    "lng": "127.0309526",
    "phoneNumber": "02-511-2684",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1160,
    "name": "줄리아발레아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 서초구 고무래로 26 , 6층 일부 (반포동)",
    "lat": "37.5023326",
    "lng": "127.0111857",
    "phoneNumber": "070-7124-1706",
    "교습과정": "무용",
    "isFinish": ""
  },
  {
    "number": 1161,
    "name": "아이코어이앤씨학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 서초구 논현로27길 104 , 2층(양재동,코너스톤A)",
    "lat": "37.4776034",
    "lng": "127.039596",
    "phoneNumber": "02-6959-3839",
    "교습과정": "컴퓨터(정보처리,통신기기,인터넷,소프트웨어)",
    "isFinish": ""
  },
  {
    "number": 1162,
    "name": "영어나무학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2941 , 2층 204호 (대치동, 대치탑프라자)",
    "lat": "37.4942268",
    "lng": "127.0617852",
    "phoneNumber": "02-562-3123",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1163,
    "name": "픽스웨이브컨셉아트아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 서초구 강남대로37길 59 , 2층 (서초동,승명빌딩)",
    "lat": "37.4846175",
    "lng": "127.030336",
    "phoneNumber": "02-6959-4747",
    "교습과정": "디자인",
    "isFinish": ""
  },
  {
    "number": 1164,
    "name": "대치삼보어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 남부순환로 2911-1 , 4층,5층 (대치동,성보2빌딩)",
    "lat": "37.4927102",
    "lng": "127.0577477",
    "phoneNumber": "02-562-3630",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1165,
    "name": "양일훈코스메틱아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 테헤란로8길 11-7 , 2층 (역삼동)",
    "lat": "37.4983451",
    "lng": "127.0320713",
    "phoneNumber": "02-564-8834",
    "교습과정": "이·미용",
    "isFinish": ""
  },
  {
    "number": 1166,
    "name": "이루다스피치학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 서초구 서초중앙로 18 , 207호 전체 (서초동, 서초쌍용플래티넘)",
    "lat": "37.4840138",
    "lng": "127.0173415",
    "phoneNumber": "02-6959-2923",
    "교습과정": "화술",
    "isFinish": ""
  },
  {
    "number": 1167,
    "name": "나비스쿰유학미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 서초구 서초대로78길 48 , 4층 일부 (서초동)",
    "lat": "37.4934895",
    "lng": "127.0285991",
    "phoneNumber": "02-517-2207",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1168,
    "name": "방배아벨수학전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배천로 36 , 3층 전체 (방배동, 삼남빌딩)",
    "lat": "37.4798003",
    "lng": "126.9826874",
    "phoneNumber": "02-525-2348",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1169,
    "name": "하이웨이어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 효령로29길 39 , 2층 (방배동)",
    "lat": "37.4831876999999",
    "lng": "126.9946688",
    "phoneNumber": "02-523-0306",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1170,
    "name": "리드101삼성영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 학동로68길 7 , 211호,212호 (삼성동,삼성동 힐스테이트)",
    "lat": "37.5174448",
    "lng": "127.0467984",
    "phoneNumber": "02-5152-101",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1171,
    "name": "풍경소리미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 압구정로36길 18 ,103호 (신사동)",
    "lat": "37.5273897",
    "lng": "127.031324",
    "phoneNumber": "070-4233-2294",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1172,
    "name": "와이즈만서초학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로 215 , 홍익대학교 강남관 2층 (반포동)",
    "lat": "37.5008237",
    "lng": "127.0116599",
    "phoneNumber": "02-535-1511",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1173,
    "name": "강의하는아이들대치학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 319 , 6층,7층일부 (역삼동)",
    "lat": "37.4980257",
    "lng": "127.0517245",
    "phoneNumber": "02-561-8181",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1174,
    "name": "리드101압구정영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로46길 30 , 2층 (신사동,암강빌딩)",
    "lat": "37.5267516",
    "lng": "127.0360833",
    "phoneNumber": "02-517-3101",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1175,
    "name": "강남리더스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 헌릉로 569 , 601호, 602호 일부 (세곡동)",
    "lat": "37.4657816",
    "lng": "127.1011914",
    "phoneNumber": "02-459-2998",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1176,
    "name": "레베라어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 논현로168길 18 , 3층 (신사동,동신빌딩)",
    "lat": "37.5238067",
    "lng": "127.0296884",
    "phoneNumber": "02-6959-9991",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1177,
    "name": "시대인재에이(A)관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 324 , 3층 (대치동,신해청아파트)",
    "lat": "37.5008476",
    "lng": "127.0601302",
    "phoneNumber": "02-554-9897",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1178,
    "name": "비바음악학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 헌릉로569 , 강남리더스프라자 702호 (세곡동)",
    "lat": "37.4657816",
    "lng": "127.1011914",
    "phoneNumber": "02-3411-7729",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1179,
    "name": "책읽는미술관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 삼성로 212 제에이블럭 3층 306-1호, 306-2호(대치동,은마아파트)",
    "lat": "37.4974176",
    "lng": "127.0653272",
    "phoneNumber": "02-547-4547",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1180,
    "name": "글로벌마케터교육학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 논현로149길 75 , 2층 (논현동)",
    "lat": "37.5163563",
    "lng": "127.0227561",
    "phoneNumber": "02-546-0110",
    "교습과정": "전자상거래",
    "isFinish": ""
  },
  {
    "number": 1181,
    "name": "아이비퓨전댄스학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 선릉로93길 7 , 3층 (역삼동)",
    "lat": "37.5052722",
    "lng": "127.0478332",
    "phoneNumber": "02-564-4445",
    "교습과정": "댄스",
    "isFinish": ""
  },
  {
    "number": 1182,
    "name": "제비울학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 잠원로 148 , 401호 (잠원동,잠원한신아파트)",
    "lat": "37.5159680999999",
    "lng": "127.0107817",
    "phoneNumber": "070-7553-9575",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 1183,
    "name": "인터프렙어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 역삼로 424 , 4층 일부 (대치동, 진영빌딩)",
    "lat": "37.5010752",
    "lng": "127.0534432",
    "phoneNumber": "02-547-2039",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1184,
    "name": "마이티애견미용학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 논현로 613 , 301호 (논현동)",
    "lat": "37.5085121",
    "lng": "127.032959",
    "phoneNumber": "02-3445-5502",
    "교습과정": "애견미용",
    "isFinish": ""
  },
  {
    "number": 1185,
    "name": "트윈클어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 도곡로63길 29 , 1층,2층 (대치동)",
    "lat": "37.4988949",
    "lng": "127.0535437",
    "phoneNumber": "02-565-9773",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1186,
    "name": "폴아카데미어학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 삼성로85길 32 , 3층,4층 (대치동)",
    "lat": "37.5047177",
    "lng": "127.0546534",
    "phoneNumber": "02-558-2715",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1187,
    "name": "박샘다비드조소학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 선릉로82길 5 , 2층, 3층 (대치동, 캥거루 빌딩)",
    "lat": "37.5025845",
    "lng": "127.0505041",
    "phoneNumber": "070-4218-2235",
    "교습과정": "미술",
    "isFinish": "완료"
  },
  {
    "number": 1188,
    "name": "서하미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 논현로114길 11 , 1층 (논현동, 해광빌딩)",
    "lat": "37.5088395",
    "lng": "127.0343136",
    "phoneNumber": "02-515-2097",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1189,
    "name": "수학일치학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로 138 , 702호 (서초동,우림빌딩)",
    "lat": "37.4856009",
    "lng": "127.0164403",
    "phoneNumber": "02-6442-9932",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1190,
    "name": "강남캠벨아카데미어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 사임당로 174 , 1202호 전체 (서초동, 강남미래타워)",
    "lat": "37.4924056",
    "lng": "127.0286494",
    "phoneNumber": "02-533-6270",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1191,
    "name": "레코드팩토리학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 서초구 효령로52길 57 , 1층~3층 (서초동)",
    "lat": "37.4818004",
    "lng": "127.0131853",
    "phoneNumber": "02-539-7335",
    "교습과정": "음반",
    "isFinish": ""
  },
  {
    "number": 1192,
    "name": "서초씨앤씨미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 서초구 방배로 88 , 3층 일부 (방배동)",
    "lat": "37.4823501",
    "lng": "126.9974003",
    "phoneNumber": "02-588-2855",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1193,
    "name": "고도문예창작학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로18길 43 , 5층 (서초동)",
    "lat": "37.4916995",
    "lng": "127.0167151",
    "phoneNumber": "02-584-3323",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1194,
    "name": "네오캣(NEO CAT)창의관미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 선릉로87길 10 , 2층 (역삼동)",
    "lat": "37.5032255",
    "lng": "127.0486827",
    "phoneNumber": "02-501-5524",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1195,
    "name": "다원중등2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 521 , 501호 (대치동,프라자II)",
    "lat": "37.5000321",
    "lng": "127.0632277",
    "phoneNumber": "02-538-8841",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1196,
    "name": "카페바리스타아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 테헤란로10길 43 , 4층 (역삼동)",
    "lat": "37.4963867",
    "lng": "127.0334773",
    "phoneNumber": "02-739-8220",
    "교습과정": "식음료품(바리스타,소믈리에)",
    "isFinish": ""
  },
  {
    "number": 1197,
    "name": "오즈액팅연기학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 효령로31길 58 , 2층 (방배동)",
    "lat": "37.4836880999999",
    "lng": "126.9954938",
    "phoneNumber": "02-523-8026",
    "교습과정": "연극",
    "isFinish": ""
  },
  {
    "number": 1198,
    "name": "유씨국제교육개발원어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 테헤란로83길 33 , 2층,3층 (삼성동)",
    "lat": "37.5095176",
    "lng": "127.0567841",
    "phoneNumber": "070-8633-9239",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 1199,
    "name": "비전21네오관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로61길 18 , 1층, 2층 (대치동)",
    "lat": "37.4991996",
    "lng": "127.0589307",
    "phoneNumber": "02-567-9901",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1200,
    "name": "시대인재5학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 338 3층(대치동)",
    "lat": "37.5018392",
    "lng": "127.0597125",
    "phoneNumber": "02-552-2373",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1201,
    "name": "반포스마트러닝센터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 서초중앙로31길 16 , 1층 및 2층 (반포동, 에덴스위트A)",
    "lat": "37.4996861",
    "lng": "127.010493",
    "phoneNumber": "02-533-0608",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 1202,
    "name": "스타하우스트레이닝센터연기학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 역삼로 555 , 101호 일부 (대치동)",
    "lat": "37.5050022",
    "lng": "127.0633734",
    "phoneNumber": "02-557-7501",
    "교습과정": "연극",
    "isFinish": ""
  },
  {
    "number": 1203,
    "name": "뿌리깊은수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 225 , 401호,407-1호 (도곡동,도곡렉슬상가)",
    "lat": "37.4953504",
    "lng": "127.0527143",
    "phoneNumber": "02-6265-0909",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1204,
    "name": "엠에스인스티튜트학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로78길 18 , 4층 (대치동)",
    "lat": "37.501327",
    "lng": "127.0571143",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1205,
    "name": "리핏학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로77길 7 , 7층 (대치동)",
    "lat": "37.4988033",
    "lng": "127.0583171",
    "phoneNumber": "02-2051-6464",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1206,
    "name": "스칼라스아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 압구정로 208 , 4층일부 (신사동, 본경빌딩)",
    "lat": "37.527596",
    "lng": "127.0298545",
    "phoneNumber": "02-6082-0603",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1207,
    "name": "창조적소수미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 서초구 서초중앙로 251 , 3층 (반포동)",
    "lat": "37.5038239",
    "lng": "127.0105378",
    "phoneNumber": "02-532-5324",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1208,
    "name": "김현정수학플러스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 225 , 403호 (대치동)",
    "lat": "37.4971742",
    "lng": "127.0613516",
    "phoneNumber": "02-562-5050",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1209,
    "name": "케이에스(KS)연기학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 선릉로 815 , 401호~403호 (신사동)",
    "lat": "37.5248974",
    "lng": "127.0392938",
    "phoneNumber": "02-6212-2468",
    "교습과정": "연기(연극,뮤지컬,오페라)",
    "isFinish": ""
  },
  {
    "number": 1210,
    "name": "운성학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 233 , 301-304호 (대치동, 신사빌딩)",
    "lat": "37.4977699",
    "lng": "127.0606416",
    "phoneNumber": "02-564-0012",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1211,
    "name": "이맥스6789학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로51길 42 , 3층 일부 (대치동,남선빌딩)",
    "lat": "37.4955965",
    "lng": "127.0586987",
    "phoneNumber": "02-3280-0400",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1212,
    "name": "달공사이버원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 319 , 7층일부 (역삼동)",
    "lat": "37.4980257",
    "lng": "127.0517245",
    "phoneNumber": "02-1600-5290",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1213,
    "name": "홍익명문미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 서초구 신반포로 100 , 515호~517호 (반포동,래미안 퍼스티지 신반포역상가)",
    "lat": "37.5030753",
    "lng": "126.9956677",
    "phoneNumber": "02-532-6512",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1214,
    "name": "대찬영재의대센터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로57길 28 , 3층 (대치동)",
    "lat": "37.4976861",
    "lng": "127.0587286",
    "phoneNumber": "02-501-0110",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1215,
    "name": "미즈노블청담글로벌뷰티아트센터미용학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 도산대로57길 13-4 , 1층 일부, 3층 (청담동)",
    "lat": "37.5246889",
    "lng": "127.0409872",
    "phoneNumber": "02-511-3777",
    "교습과정": "이·미용",
    "isFinish": ""
  },
  {
    "number": 1216,
    "name": "수학캠프수학전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 100 , 505호~507호 (반포동,래미안 퍼스티지 신반포역상가)",
    "lat": "37.5030753",
    "lng": "126.9956677",
    "phoneNumber": "02-591-1550",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1217,
    "name": "박현국어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 448 , 4층 401호 (대치동, 동서빌딩)",
    "lat": "37.4980552",
    "lng": "127.0595812",
    "phoneNumber": "02-566-0336",
    "교습과정": "보습",
    "isFinish": "완료"
  },
  {
    "number": 1218,
    "name": "청담아이가르텐학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 고무래로10길 27 , 5층,6층601호 (반포동)",
    "lat": "37.5003314",
    "lng": "127.0101783",
    "phoneNumber": "02-2219-7470",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1219,
    "name": "반포세정2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 반포대로 300 , 4층 일부(남쪽, 북동쪽) (잠원동, 덕성빌딩)",
    "lat": "37.505956",
    "lng": "127.0011819",
    "phoneNumber": "02-532-1430",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1220,
    "name": "지를향하여학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 516 , 302호, 303호 (대치동)",
    "lat": "37.4992034",
    "lng": "127.0630995",
    "phoneNumber": "02-577-6003",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1221,
    "name": "유지씨엠비에이(UGC MBA)전문학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "인문사회(대)",
    "학원주소\t": "서울특별시 서초구 서초대로52길 23 , 3층 (서초동, 현우빌딩)",
    "lat": "37.4927754",
    "lng": "127.0147853",
    "phoneNumber": "02-569-5290",
    "교습과정": "경영",
    "isFinish": ""
  },
  {
    "number": 1222,
    "name": "와이즈만영재입시센터중등학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로 215 , 홍익대학교 강남관 2층 (반포동)",
    "lat": "37.5008237",
    "lng": "127.0116599",
    "phoneNumber": "02-6925-0069",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1223,
    "name": "함영원보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2937 , 4층 (대치동,까치빌딩)",
    "lat": "37.4941325",
    "lng": "127.0615797",
    "phoneNumber": "02-501-5702",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1224,
    "name": "함영원영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 남부순환로 2937 , 5층전체·6층일부 (대치동, 까치빌딩)",
    "lat": "37.4941325",
    "lng": "127.0615797",
    "phoneNumber": "02-501-1711",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1225,
    "name": "비바스터디센터압구정독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 논현로167길 19 , 5층일부 (신사동,근린생활시설)",
    "lat": "37.5244905",
    "lng": "127.026487",
    "phoneNumber": "02-3443-2221",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1226,
    "name": "청명학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로130길 20 , 501호, 502호 일부, 504호 (삼성동, 래미안삼성2차아파트)",
    "lat": "37.5161513",
    "lng": "127.0434365",
    "phoneNumber": "02-547-0588",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1227,
    "name": "스티븐아카데미원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로86길 15 , 404호 (대치동,현대 선릉 GOLD TOWER)",
    "lat": "37.503546",
    "lng": "127.0508294",
    "phoneNumber": "02-538-6018",
    "교습과정": "보습",
    "isFinish": "완료"
  },
  {
    "number": 1228,
    "name": "도르레아트창작소미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 서초구 고무래로 90-7 , 507호, 508호 (서초동,서초쇼핑)",
    "lat": "37.4999482",
    "lng": "127.0174429",
    "phoneNumber": "02-337-7033",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1229,
    "name": "다비오학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 태봉로 70 , 403호 (우면동)",
    "lat": "37.4645285",
    "lng": "127.0255453",
    "phoneNumber": "02-571-0607",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1230,
    "name": "다함에듀원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 515 , 5층 일부 (대치동,한도산업사옥)",
    "lat": "37.4998352",
    "lng": "127.0626495",
    "phoneNumber": "02-563-4388",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1231,
    "name": "서승원국어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 논현로175길 40 , 3층, 5층 (신사동)",
    "lat": "37.5250912",
    "lng": "127.0253317",
    "phoneNumber": "02-541-8549",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1232,
    "name": "플로아트 플로리스트 아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 서초구 반포대로22길 14-4 , 2층 (서초동,태성빌딩)",
    "lat": "37.4887413",
    "lng": "127.0102219",
    "phoneNumber": "02-6404-5319",
    "교습과정": "공예(종이접기,꽃꽂이,꽃기예)",
    "isFinish": ""
  },
  {
    "number": 1233,
    "name": "쌤과통하는학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도산대로85길 30 , 2층 (청담동)",
    "lat": "37.5264323",
    "lng": "127.0496672",
    "phoneNumber": "02-546-0100",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1234,
    "name": "정샘물아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 도산대로81길 25 , 4층 (청담동)",
    "lat": "37.5260266",
    "lng": "127.0470695",
    "phoneNumber": "02-6242-8100",
    "교습과정": "이·미용",
    "isFinish": ""
  },
  {
    "number": 1235,
    "name": "라즈원격교습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 광평로 224 , 1층(수서동)",
    "lat": "37.4849763",
    "lng": "127.0974104",
    "phoneNumber": "02-5140-509",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1236,
    "name": "생각하는영재학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로77길 8 , 4~5층(대치동)",
    "lat": "37.5030791",
    "lng": "127.0565483",
    "phoneNumber": "02-554-1979",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1237,
    "name": "대치에이닷영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 423 , 2층 (대치동, 윤성빌딩)",
    "lat": "37.4978224",
    "lng": "127.0568527",
    "phoneNumber": "02-553-5466",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1238,
    "name": "지아이에스(GIS)어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 언남11길 7-9 201호 202호 301호(양재동)",
    "lat": "37.4742958",
    "lng": "127.043479",
    "phoneNumber": "02-544-6818",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1239,
    "name": "대치중심본원학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로58길 29 , 401호 (대치동)",
    "lat": "37.4977381",
    "lng": "127.0768468",
    "phoneNumber": "02-553-3191",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1240,
    "name": "마리엠아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 도산대로11길 22 , 3층 (신사동,명성빌딩)",
    "lat": "37.5188771",
    "lng": "127.0226683",
    "phoneNumber": "02-000-0000",
    "교습과정": "이·미용",
    "isFinish": ""
  },
  {
    "number": 1241,
    "name": "수학쟁이들학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 143 , 5층 10호 (반포동,반포경남쇼핑센타)",
    "lat": "37.5038883",
    "lng": "126.9964541",
    "phoneNumber": "02-537-2666",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1242,
    "name": "라임매쓰(Lime Math)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배로 98 , 5층(방배동)",
    "lat": "37.483137",
    "lng": "126.9968595",
    "phoneNumber": "02-535-5868",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1243,
    "name": "씨오엘아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 서초구 신반포로45길 18 , 지하1층 (잠원동)",
    "lat": "37.5113375",
    "lng": "127.0189607",
    "phoneNumber": "02-3445-9633",
    "교습과정": "모델",
    "isFinish": ""
  },
  {
    "number": 1244,
    "name": "세정양지관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로77길 14 1층 전체 (대치동)",
    "lat": "37.4992943",
    "lng": "127.0585913",
    "phoneNumber": "02-6205-0909",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1245,
    "name": "예섬초등관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 414 , 3층 (대치동,삼성빌딩)",
    "lat": "37.4968866",
    "lng": "127.0558815",
    "phoneNumber": "02-562-3676",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 1246,
    "name": "거인의어깨교육연구소학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 546 , 7층 (대치동,덕일빌딩)",
    "lat": "37.5042425",
    "lng": "127.0628906",
    "phoneNumber": "02-564-2188",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 1247,
    "name": "잉글리쉬&매쓰매니저학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 642 , 2층 (삼성동, 서경빌딩)",
    "lat": "37.5139798",
    "lng": "127.0428133",
    "phoneNumber": "02-6213-1250",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1248,
    "name": "매쓰홀릭학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 사평대로28길 22 , 301호 (반포동)",
    "lat": "37.4995949",
    "lng": "126.9999533",
    "phoneNumber": "02-3477-0903",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1249,
    "name": "여상진수리논술원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 445 , 2층 일부 (대치동, 현민빌딩)",
    "lat": "37.4985924",
    "lng": "127.0590243",
    "phoneNumber": "02-337-7033",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 1250,
    "name": "올림피아드함수학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 양재대로2길 116-6 , 501호,502호 (우면동)",
    "lat": "37.4564765999999",
    "lng": "127.0154524",
    "phoneNumber": "02-577-0201",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1251,
    "name": "토즈도곡타워팰리스스마트독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 언주로 120 , 2층1호일부 (도곡동)",
    "lat": "37.4867517",
    "lng": "127.051259",
    "phoneNumber": "02-576-0905",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1252,
    "name": "대치소마2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 515 , 201호, 205호 전체 (대치동, 한도산업사옥)",
    "lat": "37.4998352",
    "lng": "127.0626495",
    "phoneNumber": "02-556-1206",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1253,
    "name": "방배스즈키음악학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 서초구 방배로8길 4 , 201호,203호 (방배동)",
    "lat": "37.479729",
    "lng": "126.9991672",
    "phoneNumber": "02-3474-3667",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1254,
    "name": "열정스토리입시컨설팅학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 409 , 403호 (대치동,타워엠프리스)",
    "lat": "37.4973819",
    "lng": "127.0551699",
    "phoneNumber": "02-501-7115",
    "교습과정": "진학상담지도",
    "isFinish": "완료"
  },
  {
    "number": 1255,
    "name": "씨앤씨스쿨연기학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 언주로129길 17 , 2층3층 302호 (논현동)",
    "lat": "37.5139249",
    "lng": "127.0338449",
    "phoneNumber": "02-546-4040",
    "교습과정": "연극",
    "isFinish": ""
  },
  {
    "number": 1256,
    "name": "아담리즈수학압구정직영학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 언주로168길 15 , 401호 (신사동)",
    "lat": "37.5264494",
    "lng": "127.0348867",
    "phoneNumber": "02-540-8280",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 1257,
    "name": "와이어트어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 동광로33길 10-6 , 1층,2층 (반포동)",
    "lat": "37.495055",
    "lng": "126.9969816",
    "phoneNumber": "02-535-7988",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1258,
    "name": "(주)엠제이재즈피아노실용음악학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 테헤란로1길 28-14 , 3층 301호 (역삼동)",
    "lat": "37.5003749",
    "lng": "127.0284593",
    "phoneNumber": "02-553-3768",
    "교습과정": "실용음악(성악)",
    "isFinish": ""
  },
  {
    "number": 1259,
    "name": "손과학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로64길 12 , 2층 (대치동)",
    "lat": "37.5002182",
    "lng": "127.0529095",
    "phoneNumber": "02-554-1330",
    "교습과정": "보습",
    "isFinish": "완료"
  },
  {
    "number": 1260,
    "name": "윈저로얄학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 언주로150길 14 , 1층,2층 (논현동)",
    "lat": "37.5210154",
    "lng": "127.0355075",
    "phoneNumber": "02-512-8209",
    "교습과정": "예능(중)",
    "isFinish": ""
  },
  {
    "number": 1261,
    "name": "케이티케이(KTK)아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 테헤란로34길 19 , 2층 201호 (역삼동, 영빌딩)",
    "lat": "37.5002916",
    "lng": "127.0407025",
    "phoneNumber": "02-565-1552",
    "교습과정": "번역(성인)",
    "isFinish": ""
  },
  {
    "number": 1262,
    "name": "아우다키아보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로10길 19 , 2층 (반포동)",
    "lat": "37.5010172",
    "lng": "127.0102811",
    "phoneNumber": "02-3281-2824",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1263,
    "name": "디자인나스강남점학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 선릉로132길 17 , 2층, 3층(청담동)",
    "lat": "37.5183489",
    "lng": "127.0426141",
    "phoneNumber": "02-542-3082",
    "교습과정": "디자인",
    "isFinish": ""
  },
  {
    "number": 1264,
    "name": "시사쿡요리아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 테헤란로4길 28 , 14층 (역삼동, 송민빌딩)",
    "lat": "37.4965132",
    "lng": "127.0300705",
    "phoneNumber": "-",
    "교습과정": "식음료품(바리스타,소믈리에)",
    "isFinish": ""
  },
  {
    "number": 1265,
    "name": "케이엔에스(KNS)중등특목관어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 519 , 2층 (대치동, 구공빌딩)",
    "lat": "37.5000709",
    "lng": "127.0629888",
    "phoneNumber": "02-6925-3337",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1266,
    "name": "이루리2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로77길 5 , 5층 전체 (대치동)",
    "lat": "37.4986723",
    "lng": "127.058384",
    "phoneNumber": "02-565-0595",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 1267,
    "name": "잘큼센터청담학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 학동로97길 42 , 4층 일부 (청담동, 청담동교육연구시설)",
    "lat": "37.5224946",
    "lng": "127.0547327",
    "phoneNumber": "02-512-7330",
    "교습과정": "무용",
    "isFinish": ""
  },
  {
    "number": 1268,
    "name": "콴다일로7관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 458 , 501호, 502호 (대치동)",
    "lat": "37.4984543",
    "lng": "127.0604313",
    "phoneNumber": "02-553-3110",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1269,
    "name": "압구정이지댄스아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 압구정로28길 22-10 , 2층 일부 (신사동)",
    "lat": "37.5252628",
    "lng": "127.0268712",
    "phoneNumber": "02-516-0211",
    "교습과정": "무용(전통무용,현대무용)",
    "isFinish": ""
  },
  {
    "number": 1270,
    "name": "이룸프리미엄스터디독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 선릉로 227 , 5층 일부 (도곡동, 진달래상가)",
    "lat": "37.4958321",
    "lng": "127.0527291",
    "phoneNumber": "02-578-1177",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1271,
    "name": "정영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2941 , 304호 (대치동, 대치탑프라자)",
    "lat": "37.4942268",
    "lng": "127.0617852",
    "phoneNumber": "02-3414-3388",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1272,
    "name": "오렌지큐브서울학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 도산대로89길 41 , 2층, 4층 전체 (청담동)",
    "lat": "37.5269785",
    "lng": "127.0521599",
    "phoneNumber": "02-547-8622",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1273,
    "name": "애니포스만화학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 선릉로86길 7 , 5층전체 (대치동)",
    "lat": "37.503303",
    "lng": "127.0503179",
    "phoneNumber": "02-554-6070",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1274,
    "name": "리세움댄스스포츠학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 서초구 남부순환로 2634-8 , 201호 (양재동, 단성빌딩)",
    "lat": "37.4844683",
    "lng": "127.0386519",
    "phoneNumber": "02-578-4749",
    "교습과정": "댄스",
    "isFinish": ""
  },
  {
    "number": 1275,
    "name": "커리어칼리지학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "인문사회(대)",
    "학원주소\t": "서울특별시 서초구 사임당로 173 , 9층 전체 (서초동, 서전빌딩)",
    "lat": "37.4927943",
    "lng": "127.0285544",
    "phoneNumber": "02-587-5205",
    "교습과정": "경영",
    "isFinish": ""
  },
  {
    "number": 1276,
    "name": "몬테키즈어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 논현로152길 30 , 1층일부,2~4층전체 (신사동)",
    "lat": "37.5213096",
    "lng": "127.0306916",
    "phoneNumber": "02-517-2231",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1277,
    "name": "사이다관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로63길 5 , 2층,3층 (대치동, 예영빌딩)",
    "lat": "37.499872",
    "lng": "127.059668",
    "phoneNumber": "02-538-3372",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 1278,
    "name": "유나이티드영재음악학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 서초구 남부순환로339길 13 , 5층,6층 (서초동)",
    "lat": "37.4837964",
    "lng": "127.0223837",
    "phoneNumber": "02-3486-7233",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1279,
    "name": "수학의열쇠학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 404 , 6층 (대치동, 재석빌딩)",
    "lat": "37.5005204",
    "lng": "127.0514247",
    "phoneNumber": "02-508-0451",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1280,
    "name": "부자뱅크부동산경매학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 서초구 반포대로30길 72 , 4층 (서초동)",
    "lat": "37.4925038",
    "lng": "127.0124956",
    "phoneNumber": "02-2634-2580",
    "교습과정": "부동산",
    "isFinish": ""
  },
  {
    "number": 1281,
    "name": "다솔음악학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 서초구 방배중앙로 111 , 2층 (방배동)",
    "lat": "37.4890898",
    "lng": "126.9876857",
    "phoneNumber": "02-534-4710",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1282,
    "name": "이례연기학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 도곡로1길 14 , 201호 일부 (역삼동, 삼일프라자오피스텔)",
    "lat": "37.4908189",
    "lng": "127.0326637",
    "phoneNumber": "02-1800-6625",
    "교습과정": "댄스",
    "isFinish": ""
  },
  {
    "number": 1283,
    "name": "필수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로68길 10 , 2층,3층 (대치동)",
    "lat": "37.4989656",
    "lng": "127.052559",
    "phoneNumber": "02-3412-9555",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 1284,
    "name": "지엠그리핀수학보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2936 , 504호, 505호 (대치동, 대치동 507 제2종근린생활시설)",
    "lat": "37.4933573",
    "lng": "127.0619092",
    "phoneNumber": "02-2052-0678",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1285,
    "name": "그리핀수학보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2936 , 507호 (대치동, 대치동 507 제2종근린생활시설)",
    "lat": "37.4933573",
    "lng": "127.0619092",
    "phoneNumber": "02-539-0678",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1286,
    "name": "세곡스마트해법수학영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 헌릉로  569, 706호 (세곡동)",
    "lat": "37.4657816",
    "lng": "127.1011914",
    "phoneNumber": "02-445-5008",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1287,
    "name": "트렌미미용학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 봉은사로 119 , 7층 (논현동)",
    "lat": "37.5054446",
    "lng": "127.0266779",
    "phoneNumber": "02-6335-5353",
    "교습과정": "이·미용",
    "isFinish": ""
  },
  {
    "number": 1288,
    "name": "미투스카이학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 325 , 3층 (대치동)",
    "lat": "37.5007467",
    "lng": "127.059549",
    "phoneNumber": "02-539-9511",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1289,
    "name": "오하운폴댄스학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 봉은사로6길 34 , 3층, 4층 (역삼동)",
    "lat": "37.502838",
    "lng": "127.027394",
    "phoneNumber": "02-556-8285",
    "교습과정": "댄스",
    "isFinish": ""
  },
  {
    "number": 1290,
    "name": "크리스스튜디오영어어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 논현로159길 20 , 2층 (신사동, 동방빌딩)",
    "lat": "37.5231816999999",
    "lng": "127.0264172",
    "phoneNumber": "02-548-8888",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1291,
    "name": "서초우리들학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초대로51길 23 , 4층 (서초동, 서강빌딩)",
    "lat": "37.4959763",
    "lng": "127.0138271",
    "phoneNumber": "02-593-6650",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1292,
    "name": "그레잇에듀학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초대로1길 30 , A동 201호 일부 (방배동, 방배1차현대아파트)",
    "lat": "37.4885501",
    "lng": "126.9838383",
    "phoneNumber": "02-3481-0003",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1293,
    "name": "에스플러스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 테헤란로6길 48 , 3층 전체 (역삼동)",
    "lat": "37.4955524",
    "lng": "127.0316041",
    "phoneNumber": "02-508-8209",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1294,
    "name": "서울엘리트학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 420 , 3층 (대치동)",
    "lat": "37.5010257",
    "lng": "127.0528917",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습",
    "isFinish": "완료"
  },
  {
    "number": 1295,
    "name": "엠제이스터디독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 헌릉로 569  , 405호 (세곡동)",
    "lat": "37.4657816",
    "lng": "127.1011914",
    "phoneNumber": "02-3477-7677",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1296,
    "name": "필립영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로62길 33 , 4층 (대치동)",
    "lat": "37.4980816",
    "lng": "127.0550538",
    "phoneNumber": "02-3454-0509",
    "교습과정": "보습",
    "isFinish": "완료"
  },
  {
    "number": 1297,
    "name": "강남원비트실용음악학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 학동로4길 20 , 4층 일부 (논현동, 명진빌딩)",
    "lat": "37.5101077",
    "lng": "127.0232326",
    "phoneNumber": "02-514-0719",
    "교습과정": "실용음악(성악)",
    "isFinish": ""
  },
  {
    "number": 1298,
    "name": "미래의1관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 삼성로72길 3 , 4층 (대치동)",
    "lat": "37.502669",
    "lng": "127.0593989",
    "phoneNumber": "02-577-1777",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1299,
    "name": "디제이소사이어티학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 압구정로12길 13 , 4층 (신사동)",
    "lat": "37.5265851",
    "lng": "127.0373028",
    "phoneNumber": "02-514-3136",
    "교습과정": "실용음악(성악)",
    "isFinish": ""
  },
  {
    "number": 1300,
    "name": "나다어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 501 , 201호,202호 (대치동, SM TOWER)",
    "lat": "37.4993898",
    "lng": "127.061127",
    "phoneNumber": "02-552-6005",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1301,
    "name": "어린이현대미술교육연구소빅피쉬아트도곡본원미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 선릉로 225 , 403호 (도곡동, 도곡렉슬상가)",
    "lat": "37.4953504",
    "lng": "127.0527143",
    "phoneNumber": "02-573-5630",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1302,
    "name": "엘피(LP)댄스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 테헤란로5길 11 , 4층일부,5층일부 (역삼동)",
    "lat": "37.4995267",
    "lng": "127.0292602",
    "phoneNumber": "02-2052-0151",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 1303,
    "name": "하이터치수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 봉은사로57길 59 , 3층 (삼성동)",
    "lat": "37.5146018",
    "lng": "127.0437307",
    "phoneNumber": "02-6213-1248",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1304,
    "name": "이화뮤직스프링음악학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 선릉로 225 , 308호 (도곡동, 도곡렉슬상가)",
    "lat": "37.4953504",
    "lng": "127.0527143",
    "phoneNumber": "02-5775-456",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1305,
    "name": "깊은생각초등수학보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 321 , 2층 (대치동)",
    "lat": "37.500479",
    "lng": "127.0596904",
    "phoneNumber": "02-539-7706",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1306,
    "name": "상위권수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로29길 65 , 2층일부 (압구정동)",
    "lat": "37.5317386",
    "lng": "127.0270157",
    "phoneNumber": "02-548-1700",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1307,
    "name": "시대인재브릿지관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 503 2~3층(대치동)",
    "lat": "37.4993869",
    "lng": "127.061403",
    "phoneNumber": "02-554-1952",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1308,
    "name": "더큐브아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 강남대로 617 , 1층 전체 (잠원동, 대양빌딩)",
    "lat": "37.5166805",
    "lng": "127.0189392",
    "phoneNumber": "02-540-7535",
    "교습과정": "이·미용",
    "isFinish": ""
  },
  {
    "number": 1309,
    "name": "다원교육특목관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 301 , 3층 (대치동, 하늘도시)",
    "lat": "37.499102",
    "lng": "127.0604069",
    "phoneNumber": "02-501-0306",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1310,
    "name": "수학과학의미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초대로 355 , 204호, 205호 (서초동, 서초메이플라워맴버스빌)",
    "lat": "37.4960319",
    "lng": "127.0201421",
    "phoneNumber": "02-521-8839",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1311,
    "name": "책읽기와글쓰기리딩엠도곡학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 225 , 407-2호 (도곡동, 도곡렉슬상가)",
    "lat": "37.4953504",
    "lng": "127.0527143",
    "phoneNumber": "02-573-2161",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1312,
    "name": "바른공부독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 삼성로58길 11 , 2층, 3층 (대치동)",
    "lat": "37.4987999",
    "lng": "127.0622312",
    "phoneNumber": "02-553-9876",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1313,
    "name": "실마리수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 헌릉로 569  , 703-1호 (세곡동)",
    "lat": "37.4657816",
    "lng": "127.1011914",
    "phoneNumber": "02-459-5885",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1314,
    "name": "아이엠바리스타커피학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 테헤란로4길 38-5 , 2층 (역삼동)",
    "lat": "37.4957184",
    "lng": "127.0301516",
    "phoneNumber": "02-6959-7901",
    "교습과정": "식음료품(바리스타,소믈리에)",
    "isFinish": ""
  },
  {
    "number": 1315,
    "name": "퍼스트인(First 人)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 308 , 3층 (대치동, 성원빌딩)",
    "lat": "37.5055713",
    "lng": "127.0491588",
    "phoneNumber": "02-5534-353",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1316,
    "name": "옐로우커브(YELLOCURVE)패턴학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 강남대로162길 41 , 3층 (신사동, 동원빌딩)",
    "lat": "37.5209918",
    "lng": "127.0216068",
    "phoneNumber": "02-543-3593",
    "교습과정": "의복",
    "isFinish": ""
  },
  {
    "number": 1317,
    "name": "댄스바이미아카데미(DANCEBYMEACADEMY)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 도곡로27길 5 2층 전체(역삼동)",
    "lat": "37.4933111",
    "lng": "127.0419811",
    "phoneNumber": "-",
    "교습과정": "무용",
    "isFinish": ""
  },
  {
    "number": 1318,
    "name": "토즈스터디센터교대역독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 서초구 서초중앙로24길 19 , 4층일부 (서초동)",
    "lat": "37.4950608",
    "lng": "127.0156971",
    "phoneNumber": "02-3477-9773",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1319,
    "name": "대치세인트엘프렙관리형독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 서초구 방배중앙로29길 3 , 3층 일부 (방배동)",
    "lat": "37.4964183",
    "lng": "126.9852741",
    "phoneNumber": "02-533-1059",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1320,
    "name": "기파랑문해원대치원중등관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로64길 5 , 4층 전체 (대치동, 라이온스빌딩)",
    "lat": "37.497902",
    "lng": "127.0526595",
    "phoneNumber": "02-555-8100",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1321,
    "name": "마이아틀리에미술학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 강남대로92길 31 , 2층 (역삼동)",
    "lat": "37.4994382",
    "lng": "127.0299152",
    "phoneNumber": "02-508-5803",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1322,
    "name": "비전21앤(N)관독서실",
    "학원종류": "평생직업교육학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 삼성로63길 21 , 2층,3층 (대치동)",
    "lat": "37.4994418",
    "lng": "127.0584264",
    "phoneNumber": "02-556-2055",
    "교습과정": "독서실(일반인)",
    "isFinish": ""
  },
  {
    "number": 1323,
    "name": "버밍엄영어전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 나루터로 43 , 5층 일부 (잠원동)",
    "lat": "37.5152578",
    "lng": "127.0146863",
    "phoneNumber": "02-537-8553",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1324,
    "name": "주한영국문화원영러너서초어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 서초중앙로24길 27 , 122호일부,123호일부,135호~139호 (서초동)",
    "lat": "37.4954055",
    "lng": "127.0164657",
    "phoneNumber": "02-3702-0600",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1325,
    "name": "해커스해외대학입시전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 서초대로73길 12 , 7층 일부 (서초동, 세계빌딩)",
    "lat": "37.4985905",
    "lng": "127.0258499",
    "phoneNumber": "02-569-7467",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1326,
    "name": "마루국어논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 잠원로 24 , 308호 (반포동, 반포자이주구중심상가1동)",
    "lat": "37.5071093",
    "lng": "127.0098804",
    "phoneNumber": "02-537-5397",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1327,
    "name": "씨엠에스(CMS)대치고등1관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 336 201호, 401호 일부, 402호 (대치동, 한림빌딩)",
    "lat": "37.5016654",
    "lng": "127.0598058",
    "phoneNumber": "02-565-1833",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1328,
    "name": "나무독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 도곡로18길 4 , 2층~4층 (도곡동)",
    "lat": "37.4911515999999",
    "lng": "127.0379446",
    "phoneNumber": "02-3461-9188",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1329,
    "name": "피아이국제관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 삼성로64길 51 3층 일부, 4층 일부(대치동)",
    "lat": "37.5011262",
    "lng": "127.0644719",
    "phoneNumber": "02-554-7550",
    "교습과정": "외국어",
    "isFinish": ""
  },
  {
    "number": 1330,
    "name": "제이발레스튜디오학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 서초구 서초중앙로24길 15 , 4층 (서초동)",
    "lat": "37.4949451",
    "lng": "127.0151182",
    "phoneNumber": "02-532-1701",
    "교습과정": "무용(전통무용,현대무용)",
    "isFinish": ""
  },
  {
    "number": 1331,
    "name": "집단지성학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로 245 , 5층 (반포동)",
    "lat": "37.5033532",
    "lng": "127.0107932",
    "phoneNumber": "02-532-1213",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1332,
    "name": "황액터스학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 서초구 강남대로101길 27 , 2층,3층 (잠원동, 샘빌딩)",
    "lat": "37.5169961",
    "lng": "127.0180206",
    "phoneNumber": "070-8163-3932",
    "교습과정": "연기(연극,뮤지컬,오페라)",
    "isFinish": ""
  },
  {
    "number": 1333,
    "name": "메리앤지네일아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 도산대로1길 40 , 3층 (신사동)",
    "lat": "37.5193666",
    "lng": "127.0196072",
    "phoneNumber": "02-540-2674",
    "교습과정": "이·미용",
    "isFinish": ""
  },
  {
    "number": 1334,
    "name": "용문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초대로51길 16 , 4층 (서초동, 영림)",
    "lat": "37.4953718",
    "lng": "127.0144585",
    "phoneNumber": "02-3486-8637",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1335,
    "name": "런업입시연기학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 강남대로95길 19-4 , 2층 일부 (잠원동, 호영빌딩)",
    "lat": "37.5135921",
    "lng": "127.0186625",
    "phoneNumber": "02-518-1247",
    "교습과정": "연극",
    "isFinish": ""
  },
  {
    "number": 1336,
    "name": "가온국악보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 개포로22길 80 , 3,4층 (개포동)",
    "lat": "37.474708",
    "lng": "127.0519791",
    "phoneNumber": "02-576-3362",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1337,
    "name": "아이비셉트학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 논현로175길 63 , 3층 일부 (신사동)",
    "lat": "37.5240154",
    "lng": "127.0239103",
    "phoneNumber": "02-544-9302",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1338,
    "name": "하우투스터디과학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로8길 13 , 1층 (반포동, 항교빌딩)",
    "lat": "37.5017655",
    "lng": "127.0101071",
    "phoneNumber": "070-7724-7020",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1339,
    "name": "스카이로학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 일원로 95 , 602호 (일원동, 신영프라자)",
    "lat": "37.4856021",
    "lng": "127.0835726",
    "phoneNumber": "02-445-7790",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1340,
    "name": "폴라나어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 학동로97길 20 , 4층 일부 (청담동, 성호빌딩)",
    "lat": "37.5212011",
    "lng": "127.0554736",
    "phoneNumber": "02-514-0573",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1341,
    "name": "모두스만화애니전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 선릉로82길 15 , 2층 (대치동)",
    "lat": "37.502828",
    "lng": "127.0512489",
    "phoneNumber": "02-569-7113",
    "교습과정": "미술",
    "isFinish": "완료"
  },
  {
    "number": 1342,
    "name": "람아트스쿨학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 서초구 서초대로54길 29-17 , 1층 (서초동, 글로리아빌딩)",
    "lat": "37.4932358",
    "lng": "127.0170691",
    "phoneNumber": "02-521-7370",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1343,
    "name": "닥터필로스대치학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로16길 6 , 2층전체 (개포동)",
    "lat": "37.4838236999999",
    "lng": "127.0601066",
    "phoneNumber": "02-577-4960",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1344,
    "name": "대치프라우드7학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 도곡로 418 , 7층 (대치동, 강원빌딩)",
    "lat": "37.4970089",
    "lng": "127.0562594",
    "phoneNumber": "02-566-0509",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1345,
    "name": "아하김일래수학전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2909 , 402호, 403호, 405호 (대치동, 여천빌딩)",
    "lat": "37.4922077",
    "lng": "127.0573813",
    "phoneNumber": "02-555-3276",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1346,
    "name": "숙명킨더아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 강남대로8길 23-11 , 1층,2층,3층,4층 (양재동)",
    "lat": "37.4686639",
    "lng": "127.0416845",
    "phoneNumber": "02-574-3293",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1347,
    "name": "제이에스(JS)연기아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 테헤란로70길 10 , 5층 (대치동, 동헌빌딩)",
    "lat": "37.5049932",
    "lng": "127.053187",
    "phoneNumber": "02-569-0077",
    "교습과정": "연극",
    "isFinish": ""
  },
  {
    "number": 1348,
    "name": "원일아이숲어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 광평로10길 15 , 1층,2층 (일원동)",
    "lat": "37.482024",
    "lng": "127.0821324",
    "phoneNumber": "02-574-2646",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1349,
    "name": "고수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로 229 , 4층일부 (반포동)",
    "lat": "37.502108",
    "lng": "127.0113454",
    "phoneNumber": "02-595-3177",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1350,
    "name": "스페라학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동작대로 160 , 201호 (방배동)",
    "lat": "37.4906572",
    "lng": "126.9829888",
    "phoneNumber": "-",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1351,
    "name": "어린이현대미술교육연구소-빅피쉬세곡미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 헌릉로 569  , 605호 (세곡동)",
    "lat": "37.4657816",
    "lng": "127.1011914",
    "phoneNumber": "02-451-3414",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1352,
    "name": "대치전진학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로64길 9 , 4층 (대치동, 대성빌딩)",
    "lat": "37.5004504",
    "lng": "127.0531429",
    "phoneNumber": "02-567-0203",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1353,
    "name": "신대산영어전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 효령로 184 , 3층 (방배동, 유신빌딩)",
    "lat": "37.4824614",
    "lng": "127.0041881",
    "phoneNumber": "02-3473-2185",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1354,
    "name": "더엠브릿지영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 양재대로2길 116-6  , 401호 (우면동)",
    "lat": "37.4564765999999",
    "lng": "127.0154524",
    "phoneNumber": "02-592-5111",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1355,
    "name": "상신학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 개포로22길 40 , 2층 (개포동)",
    "lat": "37.4765464",
    "lng": "127.0493226",
    "phoneNumber": "02-804-2236",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1356,
    "name": "이룸학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로78길 22 , 206호 (대치동, 대치삼성아파트)",
    "lat": "37.4965682",
    "lng": "127.0588507",
    "phoneNumber": "02-555-4720",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1357,
    "name": "서초이화음악학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 서초구 헌릉로8길 9-8 , 6층 603호 (내곡동)",
    "lat": "37.4567002",
    "lng": "127.0599137",
    "phoneNumber": "02-576-6009",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1358,
    "name": "링크(LINK)물리학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로71길 16 , 4층 (대치동)",
    "lat": "37.5021692",
    "lng": "127.0575619",
    "phoneNumber": "02-558-1868",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1359,
    "name": "이지에듀학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 강남대로10길 23 , 2층 (양재동)",
    "lat": "37.4687339",
    "lng": "127.0406548",
    "phoneNumber": "02-571-8170",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 1360,
    "name": "소도스카이학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 반포대로26길 75 , 2층 (서초동)",
    "lat": "37.4916863",
    "lng": "127.0130819",
    "phoneNumber": "02-6053-3131",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1361,
    "name": "문릿꽃꽂이학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 도산대로17길 36 , 2층 (신사동)",
    "lat": "37.5210591",
    "lng": "127.0240668",
    "phoneNumber": "02-3474-1028",
    "교습과정": "공예(종이접기,꽃꽂이,꽃기예)",
    "isFinish": ""
  },
  {
    "number": 1362,
    "name": "아이큐브학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로52길 14 , 302호, 303호 (역삼동, 도곡프라자)",
    "lat": "37.4985291",
    "lng": "127.0479489",
    "phoneNumber": "02-555-5105",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1363,
    "name": "신대찬학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 50 , 3층 307호 (반포동)",
    "lat": "37.5017761999999",
    "lng": "126.9901541",
    "phoneNumber": "02-537-6281",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1364,
    "name": "오은정국어논술전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 219 , 8동 4층 6~8호 (잠원동, 반포쇼핑타운)",
    "lat": "37.5074568",
    "lng": "127.0078376",
    "phoneNumber": "02-536-1686",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1365,
    "name": "김동하영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 도곡로 450 , 5층 (대치동, 덕산빌딩)",
    "lat": "37.4981124",
    "lng": "127.0597594",
    "phoneNumber": "02-564-9515",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": "완료"
  },
  {
    "number": 1366,
    "name": "안스스피치학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 서초구 동광로 28  , 3층 (방배동)",
    "lat": "37.4909347",
    "lng": "126.9860775",
    "phoneNumber": "02-536-7967",
    "교습과정": "화술",
    "isFinish": ""
  },
  {
    "number": 1367,
    "name": "러닝포리스트(Learning Forest)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로30길 17 , 804호 (신사동, 이소니프라자)",
    "lat": "37.5262629",
    "lng": "127.0294934",
    "phoneNumber": "02-547-1025",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1368,
    "name": "소도스카이원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 반포대로26길 75 , 4층 (서초동)",
    "lat": "37.4916863",
    "lng": "127.0130819",
    "phoneNumber": "02-6053-3131",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1369,
    "name": "엘라인발레학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 선릉로125길 8 4층 401호(논현동)",
    "lat": "37.5150432",
    "lng": "127.0412566",
    "phoneNumber": "02-6200-6988",
    "교습과정": "무용",
    "isFinish": ""
  },
  {
    "number": 1370,
    "name": "플로포즈꽃예술학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 논현로64길 19 , 3층 (역삼동)",
    "lat": "37.4937373",
    "lng": "127.042109",
    "phoneNumber": "070-7504-3099",
    "교습과정": "공예(종이접기,꽃꽂이,꽃기예)",
    "isFinish": ""
  },
  {
    "number": 1371,
    "name": "강남대성별관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 서초대로52길 28 , 1층일부, 4층,5층,6층 (서초동, 대성학원)",
    "lat": "37.4925569",
    "lng": "127.0144617",
    "phoneNumber": "02-585-9600",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1372,
    "name": "옥스포드아카데미(OXFORD ACADEMY)어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 언주로172길 13 , 2층 (신사동)",
    "lat": "37.5279252",
    "lng": "127.0350059",
    "phoneNumber": "02-511-7155",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1373,
    "name": "브러쉬온학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 선릉로 643 , 5층 (논현동, 풍전빌딩)",
    "lat": "37.5139245",
    "lng": "127.0421812",
    "phoneNumber": "02-000-0000",
    "교습과정": "디자인",
    "isFinish": ""
  },
  {
    "number": 1374,
    "name": "엠에스씨브레인컨설팅학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 영동대로50길 10 , 2층 (대치동)",
    "lat": "37.4985403",
    "lng": "127.0699374",
    "phoneNumber": "02-557-9864",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1375,
    "name": "서준학원지혜관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 효령로 186 , 2층 (방배동)",
    "lat": "37.482492",
    "lng": "127.0043567",
    "phoneNumber": "02-525-1229",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1376,
    "name": "프리나발레핏학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 선릉로93길 7 , 4층 (역삼동)",
    "lat": "37.5052722",
    "lng": "127.0478332",
    "phoneNumber": "02-000-0000",
    "교습과정": "무용(전통무용,현대무용)",
    "isFinish": ""
  },
  {
    "number": 1377,
    "name": "포워드싱킹(ForwardThinking)독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 서초구 고무래로 22 , 5층일부 (반포동, 쌍동빌딩 서관)",
    "lat": "37.5025115",
    "lng": "127.0107221",
    "phoneNumber": "02-593-5911",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1378,
    "name": "자유의날개국어논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 효령로46길 5 , 4층501호 (서초동)",
    "lat": "37.483309",
    "lng": "127.0090104",
    "phoneNumber": "02-525-0982",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1379,
    "name": "드림오브엑터스아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 봉은사로37길 22 , 1층 (논현동)",
    "lat": "37.5097779",
    "lng": "127.0363394",
    "phoneNumber": "02-000-0000",
    "교습과정": "연기(연극,뮤지컬,오페라)",
    "isFinish": ""
  },
  {
    "number": 1380,
    "name": "소다뮤직아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 서초구 서초대로48길 107 , 1층 (서초동)",
    "lat": "37.488242",
    "lng": "127.0126567",
    "phoneNumber": "02-588-0164",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1381,
    "name": "그린램프라이브러리개포독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 개포로 615 , 8층 일부 (개포동, 석탑프라자)",
    "lat": "37.4926936",
    "lng": "127.0756284",
    "phoneNumber": "02-459-5911",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1382,
    "name": "동의엠성인고시학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "인문사회(대)",
    "학원주소\t": "서울특별시 강남구 언주로81길 56 , 2층 (역삼동, 대명빌딩)",
    "lat": "37.4992522999999",
    "lng": "127.0391658",
    "phoneNumber": "02-3453-7419",
    "교습과정": "대학편입",
    "isFinish": ""
  },
  {
    "number": 1383,
    "name": "박문각강남고시1별관학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "인문사회(대)",
    "학원주소\t": "서울특별시 서초구 강남대로61길 19 , 301호,302호,305호 (서초동)",
    "lat": "37.4985124",
    "lng": "127.0247111",
    "phoneNumber": "02-3476-3670",
    "교습과정": "성인고시",
    "isFinish": ""
  },
  {
    "number": 1384,
    "name": "매쓰포인트수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로34길 11 , 405호 (신사동, 압구정스퀘어)",
    "lat": "37.5273895",
    "lng": "127.030957",
    "phoneNumber": "02-557-9864",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1385,
    "name": "이수정국어논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로62길 29 , 4층 (대치동)",
    "lat": "37.4979282",
    "lng": "127.054936",
    "phoneNumber": "02-563-1471",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 1386,
    "name": "김강산댄스스튜디오학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 선릉로161길 11 , 4층 (신사동)",
    "lat": "37.527175",
    "lng": "127.039389",
    "phoneNumber": "02-549-9444",
    "교습과정": "댄스",
    "isFinish": ""
  },
  {
    "number": 1387,
    "name": "컬쳐컴플렉스어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 테헤란로20길 15 , 201호 일부 (역삼동, 메이플라워멤버스빌오피스텔)",
    "lat": "37.4987108",
    "lng": "127.0347437",
    "phoneNumber": "02-000-0000",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 1388,
    "name": "라스트보컬학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 언주로134길 35 , 502호, 503호 (논현동)",
    "lat": "37.5173141",
    "lng": "127.0383862",
    "phoneNumber": "02-6404-0200",
    "교습과정": "실용음악(성악)",
    "isFinish": ""
  },
  {
    "number": 1389,
    "name": "마풀원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 선릉로119길 15 , 4층일부 (논현동)",
    "lat": "37.5132325999999",
    "lng": "127.0413396",
    "phoneNumber": "02-1670-8853",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1390,
    "name": "휴몬랩에듀8학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로69길 20 , 2층 (대치동)",
    "lat": "37.501505",
    "lng": "127.0575296",
    "phoneNumber": "02-6486-8882",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 1391,
    "name": "더(The)강한학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 323 , 6층 (대치동, 삼주빌딩)",
    "lat": "37.5006127",
    "lng": "127.0596197",
    "phoneNumber": "02-417-0909",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1392,
    "name": "작은별음악학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 서초구 서초중앙로31길 6-9 , 5층일부 (반포동)",
    "lat": "37.5005049",
    "lng": "127.0112256",
    "phoneNumber": "02-3477-3367",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1393,
    "name": "조영준연기학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 테헤란로27길 18 , 8층 (역삼동)",
    "lat": "37.5025697",
    "lng": "127.0379343",
    "phoneNumber": "02-552-5603",
    "교습과정": "연기(연극,뮤지컬,오페라)",
    "isFinish": ""
  },
  {
    "number": 1394,
    "name": "뷰미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 서초구 방배로 98 , 4층 (방배동, JUNOFFICE)",
    "lat": "37.483137",
    "lng": "126.9968595",
    "phoneNumber": "02-522-2533",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1395,
    "name": "스파크어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 고무래로 14 , 2층 (반포동, 베뉴타워)",
    "lat": "37.50329",
    "lng": "127.0101243",
    "phoneNumber": "02-594-5030",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1396,
    "name": "서초관러닝어취브수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 효령로 182-7 2층(방배동)",
    "lat": "37.4823166",
    "lng": "127.0042319",
    "phoneNumber": "02-586-0603",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1397,
    "name": "유학미술핸섬아트학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 봉은사로29길 21 , 5층 502호(대장상 4층)(논현동)",
    "lat": "37.5087892",
    "lng": "127.0340095",
    "phoneNumber": "02-515-9492",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1398,
    "name": "모아트스튜디오(MO ART STUDIO)실용취미미술학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 테헤란로8길 28 , 2층 (역삼동, 송강원빌딩)",
    "lat": "37.4970443",
    "lng": "127.0317718",
    "phoneNumber": "02-554-4503",
    "교습과정": "무용(전통무용,현대무용)",
    "isFinish": ""
  },
  {
    "number": 1399,
    "name": "미래한국인학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 444 , 5층 (대치동, 일억조빌딩)",
    "lat": "37.4979898",
    "lng": "127.0591563",
    "phoneNumber": "02-555-4434",
    "교습과정": "보습",
    "isFinish": "완료"
  },
  {
    "number": 1400,
    "name": "베르나더스아카데미(BERNARDUS ACADEMY)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로 108 , 204호 (신사동)",
    "lat": "37.5229191",
    "lng": "127.0205789",
    "phoneNumber": "02-516-0164",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1401,
    "name": "세정스카이학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 446 , 4층 (대치동, 우전타워)",
    "lat": "37.4979979",
    "lng": "127.059403",
    "phoneNumber": "02-553-1010",
    "교습과정": "보습",
    "isFinish": "완료"
  },
  {
    "number": 1402,
    "name": "올검정고시원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초대로78길 52 , 3층일부 (서초동, 강남역인앤인)",
    "lat": "37.4932229",
    "lng": "127.0287364",
    "phoneNumber": "02-1644-9050",
    "교습과정": "검정",
    "isFinish": ""
  },
  {
    "number": 1403,
    "name": "대치마스터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 336 , 202호 (대치동, 한림빌딩)",
    "lat": "37.506127",
    "lng": "127.0600466",
    "phoneNumber": "02-565-1152",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1404,
    "name": "시대인재7관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 516 , 311호,312호 (대치동, 삼성상가)",
    "lat": "37.4992034",
    "lng": "127.0630995",
    "phoneNumber": "02-567-1109",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1405,
    "name": "브이에스엠(VSM)보컬아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 역삼로17길 54 , 2층 (역삼동)",
    "lat": "37.4983055",
    "lng": "127.036576",
    "phoneNumber": "02-000-0000",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1406,
    "name": "뷰쎄아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 학동로45길 8 , 401호 (논현동, 유화빌딩)",
    "lat": "37.5168066",
    "lng": "127.0381271",
    "phoneNumber": "02-541-4547",
    "교습과정": "이·미용",
    "isFinish": ""
  },
  {
    "number": 1407,
    "name": "드림댄스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 서초대로77길 9 , 8층802호 (서초동, 강남 누드죤빌딩)",
    "lat": "37.4985841",
    "lng": "127.0262226",
    "phoneNumber": "070-4203-7915",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 1408,
    "name": "오르다샘앤클래스반포학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 서초중앙로 227 , 2층일부 (반포동)",
    "lat": "37.5019044",
    "lng": "127.0114351",
    "phoneNumber": "02-535-3885",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 1409,
    "name": "오투학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 강남대로85길 5 , 9층일부 (반포동, 대유빌딩)",
    "lat": "37.5073821",
    "lng": "127.0225998",
    "phoneNumber": "02-548-4961",
    "교습과정": "연극",
    "isFinish": ""
  },
  {
    "number": 1410,
    "name": "박민제엔씨에스(NCS)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 개포로 512 , 601호 (개포동, 개포종합상가)",
    "lat": "37.4893133",
    "lng": "127.0689409",
    "phoneNumber": "02-459-0977",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1411,
    "name": "그린램프라이브러리대치캠퍼스독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 삼성로 150 , 202-1호 (대치동, 한보미도맨션208동)",
    "lat": "37.4925906",
    "lng": "127.066184",
    "phoneNumber": "02-563-5911",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1412,
    "name": "다원교육자사관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 301 , 2층 (대치동, 하늘도시)",
    "lat": "37.499102",
    "lng": "127.0604069",
    "phoneNumber": "02-3454-1162",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1413,
    "name": "다같이미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 역삼로 403 , 2층 (대치동)",
    "lat": "37.5008665",
    "lng": "127.0511936",
    "phoneNumber": "02-501-7264",
    "교습과정": "미술",
    "isFinish": "완료"
  },
  {
    "number": 1414,
    "name": "청담윈수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로132길 41 , 4층일부 (청담동)",
    "lat": "37.5186619",
    "lng": "127.0445609",
    "phoneNumber": "02-546-3285",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1415,
    "name": "시대인재반포센터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 반포대로 287 , 301호, 416~419호 (반포동, 래미안퍼스티지 중심상가)",
    "lat": "37.5044951",
    "lng": "127.0007548",
    "phoneNumber": "02-535-2373",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1416,
    "name": "스카이에듀수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 헌릉로 569 , 604호 (세곡동)",
    "lat": "37.4657816",
    "lng": "127.1011914",
    "phoneNumber": "070-4120-2205",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1417,
    "name": "키즈스피치예소스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 서초중앙로31길 6-3 , 8층일부 (반포동, 삼우빌딩)",
    "lat": "37.5000996",
    "lng": "127.0113176",
    "phoneNumber": "02-3478-9116",
    "교습과정": "화술",
    "isFinish": ""
  },
  {
    "number": 1418,
    "name": "수학시간학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동광로19길 16 , 2층 (방배동)",
    "lat": "37.4932564",
    "lng": "126.9893076",
    "phoneNumber": "02-532-8979",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1419,
    "name": "뮤직라이브러리원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 서초구 반포대로 58 , 101동 1404호 (서초동, 서초아트자이)",
    "lat": "37.4856214",
    "lng": "127.0114381",
    "phoneNumber": "02-574-8111",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1420,
    "name": "대치이데아학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 516 , 301호 (대치동, 삼성상가)",
    "lat": "37.4992034",
    "lng": "127.0630995",
    "phoneNumber": "02-555-7647",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1421,
    "name": "티에이치(TH)액팅아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 효령로 220 , 3층전체 (서초동)",
    "lat": "37.4832164",
    "lng": "127.0081848",
    "phoneNumber": "02-511-9651",
    "교습과정": "연극",
    "isFinish": ""
  },
  {
    "number": 1422,
    "name": "시대인재3관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로57길 36 , 3층 전체(대치동)",
    "lat": "37.4975513",
    "lng": "127.058383",
    "phoneNumber": "02-552-2373",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1423,
    "name": "에듀시크릿학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로64길 8 , 3층 (대치동)",
    "lat": "37.4977228",
    "lng": "127.0531038",
    "phoneNumber": "02-6080-7227",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 1424,
    "name": "건택사단연기학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 압구정로54길 22 , 3층 (신사동)",
    "lat": "37.5264664",
    "lng": "127.0391406",
    "phoneNumber": "02-511-4104",
    "교습과정": "연극",
    "isFinish": ""
  },
  {
    "number": 1425,
    "name": "아람플러스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 효령로 384 , 2층(서초동)",
    "lat": "37.4875715",
    "lng": "127.0259361",
    "phoneNumber": "02-588-3848",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1426,
    "name": "안보라스터디학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 408 , 509호 (대치동, 디마크 빌딩)",
    "lat": "37.4966281",
    "lng": "127.055214",
    "phoneNumber": "02-556-8383",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1427,
    "name": "에스에이치(SH)김선희영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 봉은사로57길 59 , 2층 (삼성동)",
    "lat": "37.5146018",
    "lng": "127.0437307",
    "phoneNumber": "02-6247-8586",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1428,
    "name": "한국전통발효아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 서초구 남부순환로333길 36 , 4층 (서초동)",
    "lat": "37.484057",
    "lng": "127.0210845",
    "phoneNumber": "02-6120-0258",
    "교습과정": "식음료품(바리스타,소믈리에)",
    "isFinish": ""
  },
  {
    "number": 1429,
    "name": "한국꽃예술학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 서초구 동산로 10 , 4층 402호, 403호 (양재동)",
    "lat": "37.4691467",
    "lng": "127.0409439",
    "phoneNumber": "02-6368-0707",
    "교습과정": "공예(종이접기,꽃꽂이,꽃기예)",
    "isFinish": ""
  },
  {
    "number": 1430,
    "name": "더블유(W)방송연기학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 서초중앙로 42 , 8층801호 (서초동, 블루핀타워)",
    "lat": "37.4857592",
    "lng": "127.0160952",
    "phoneNumber": "02-2039-2275",
    "교습과정": "연극",
    "isFinish": ""
  },
  {
    "number": 1431,
    "name": "유비스카이학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로64길 9 , 2층 (대치동, 대성빌딩)",
    "lat": "37.5004504",
    "lng": "127.0531429",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1432,
    "name": "세인트폴서울학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 서초중앙로31길 14-8 , 1층,3층일부 (반포동, 나호)",
    "lat": "37.5002439",
    "lng": "127.0110299",
    "phoneNumber": "02-3486-2000",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1433,
    "name": "세인트폴프리페라토리서울(Saint Paul Preparatory Seoul)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 서초중앙로31길 14-8 , 2층,3층일부 (반포동, 나호)",
    "lat": "37.5002439",
    "lng": "127.0110299",
    "phoneNumber": "02-3486-2000",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1434,
    "name": "더프린키피아영재교육아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로71길 29 , 2층 (대치동)",
    "lat": "37.5015299",
    "lng": "127.0565389",
    "phoneNumber": "02-3453-1133",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1435,
    "name": "힘멜학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로43길 42 , 1층,2층 (잠원동, 어린이집)",
    "lat": "37.5118748",
    "lng": "127.0176435",
    "phoneNumber": "02-540-7300",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1436,
    "name": "플레온학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로63길 23 , 4층 일부 (대치동)",
    "lat": "37.4984448",
    "lng": "127.0537651",
    "phoneNumber": "02-553-3500",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1437,
    "name": "리상논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 531 , 3층일부 (대치동, 청우빌딩)",
    "lat": "37.5040778",
    "lng": "127.0610134",
    "phoneNumber": "02-734-9971",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1438,
    "name": "케이씨아이에듀원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 도곡로78길 22 , 303호 일부(대치동,대치삼성아파트)",
    "lat": "37.4965682",
    "lng": "127.0588507",
    "phoneNumber": "02-555-2157",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1439,
    "name": "누나영아카데미어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 서초대로78길 30 , 5~6층 (서초동)",
    "lat": "37.4951207",
    "lng": "127.0279608",
    "phoneNumber": "02-6053-5884",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 1440,
    "name": "대치세종학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로75길 40 , 2층 (대치동)",
    "lat": "37.5027892",
    "lng": "127.054916",
    "phoneNumber": "02-555-7300",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1441,
    "name": "도신아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 학동로 140 , 4층 (논현동)",
    "lat": "37.5123459",
    "lng": "127.0263124",
    "phoneNumber": "02-511-5127",
    "교습과정": "이·미용",
    "isFinish": ""
  },
  {
    "number": 1442,
    "name": "상위권수학자이학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 잠원로 24 , 203호 및 220호 (반포동)",
    "lat": "37.5071264",
    "lng": "127.0098413",
    "phoneNumber": "02-535-2100",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1443,
    "name": "돈키학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 도산대로6길 9 , 1층 (논현동)",
    "lat": "37.5161239",
    "lng": "127.0218306",
    "phoneNumber": "02-549-6952",
    "교습과정": "연극",
    "isFinish": ""
  },
  {
    "number": 1444,
    "name": "웨스턴영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 반포대로 287 , 339호 (반포동, 래미안퍼스티지 중심상가)",
    "lat": "37.5044951",
    "lng": "127.0007548",
    "phoneNumber": "02-3478-5053",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1445,
    "name": "대치상승영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 347 , 302호 (대치동, 대일빌딩)",
    "lat": "37.5025385",
    "lng": "127.0585559",
    "phoneNumber": "02-567-3138",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1446,
    "name": "토즈스터디센터대청역독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 개포로 623 , 234호일부 (개포동, 대청타워)",
    "lat": "37.4943072",
    "lng": "127.0795092",
    "phoneNumber": "02-445-5554",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1447,
    "name": "윤도영통합과학시스템학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로61길 22 , 4층 (대치동)",
    "lat": "37.4991092",
    "lng": "127.058612",
    "phoneNumber": "02-567-4031",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1448,
    "name": "미도한뜻음악학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 삼성로 150 , 307호 일부 (대치동, 한보미도맨션)",
    "lat": "37.4925906",
    "lng": "127.066184",
    "phoneNumber": "02-567-3549",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1449,
    "name": "케이튜터수학압구정관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로20길 7 , 3층 (신사동)",
    "lat": "37.5248542",
    "lng": "127.0248516",
    "phoneNumber": "02-549-3110",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1450,
    "name": "스타에듀학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동산로 61 , 2층 (양재동, 선진빌딩)",
    "lat": "37.4720886",
    "lng": "127.0455125",
    "phoneNumber": "02-574-8077",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1451,
    "name": "청미르무용학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 학동로 411 , 201호 (청담동, 원일빌딩)",
    "lat": "37.5181161",
    "lng": "127.0446457",
    "phoneNumber": "02-549-9070",
    "교습과정": "무용",
    "isFinish": ""
  },
  {
    "number": 1452,
    "name": "이루다수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로10길 17 , 602호 (반포동, 동호빌딩)",
    "lat": "37.5012315",
    "lng": "127.0104245",
    "phoneNumber": "02-595-7844",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1453,
    "name": "서울방송연기아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 논현로150길 34 , 3층 (논현동)",
    "lat": "37.519685",
    "lng": "127.0312393",
    "phoneNumber": "02-2285-1868",
    "교습과정": "영화",
    "isFinish": ""
  },
  {
    "number": 1454,
    "name": "엘브라운통합영재관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로64길 46 , 5층 (대치동)",
    "lat": "37.5007554",
    "lng": "127.0642647",
    "phoneNumber": "02-561-7889",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1455,
    "name": "스카이에듀원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 강남대로 388 , 14층일부 (역삼동, 강남센타)",
    "lat": "37.4974076",
    "lng": "127.0283491",
    "phoneNumber": "070-4652-6461",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1456,
    "name": "알엑스(RX)수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2909 , 501호 (대치동, 여천빌딩)",
    "lat": "37.4921842",
    "lng": "127.0574083",
    "phoneNumber": "02-555-1744",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1457,
    "name": "엠아이서초어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 서초중앙로31길 6-3 , 6층 (반포동, 지지반포빌딩)",
    "lat": "37.5000996",
    "lng": "127.0113176",
    "phoneNumber": "02-539-2400",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1458,
    "name": "잉글리쉬101영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 바우뫼로 20 , 3층 (우면동, 고호빌딩)",
    "lat": "37.4699988",
    "lng": "127.0252928",
    "phoneNumber": "02-577-0705",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1459,
    "name": "에이플러스스피치학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 논현로 522 , 3층 (역삼동, 용마빌딩)",
    "lat": "37.5031269",
    "lng": "127.0361323",
    "phoneNumber": "02-539-7732",
    "교습과정": "화술",
    "isFinish": ""
  },
  {
    "number": 1460,
    "name": "콴다일로5관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 323 , 5층 (대치동, 삼주빌딩)",
    "lat": "37.5006127",
    "lng": "127.0596197",
    "phoneNumber": "02-557-0178",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1461,
    "name": "아이즈(IZE)영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 340 , 204,205호 (대치동)",
    "lat": "37.5001813",
    "lng": "127.0515487",
    "phoneNumber": "02-556-5995",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 1462,
    "name": "플레이코딩아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 선릉로64길 8 , 7층 (대치동)",
    "lat": "37.4977228",
    "lng": "127.0531038",
    "phoneNumber": "02-539-1113",
    "교습과정": "컴퓨터(소)",
    "isFinish": "완료"
  },
  {
    "number": 1463,
    "name": "블리스댄스스포츠학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 강남대로150길 11 , 3층 (논현동)",
    "lat": "37.5160519999999",
    "lng": "127.0208052",
    "phoneNumber": "-",
    "교습과정": "댄스",
    "isFinish": ""
  },
  {
    "number": 1464,
    "name": "미독수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 520 , 3층 (대치동, 무진빌딩)",
    "lat": "37.4994149",
    "lng": "127.0634446",
    "phoneNumber": "02-554-4050",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1465,
    "name": "요감동미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 선릉로72길 35 , 4층 (대치동)",
    "lat": "37.5009252",
    "lng": "127.0538935",
    "phoneNumber": "02-539-1028",
    "교습과정": "미술",
    "isFinish": "완료"
  },
  {
    "number": 1466,
    "name": "멘토스테이블(Mentors'Table)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로34길 34 , 3층 (신사동)",
    "lat": "37.5258633",
    "lng": "127.0304942",
    "phoneNumber": "02-3444-0511",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1467,
    "name": "밸류인수학대치본원학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로77길 2 , 3층전체 (대치동)",
    "lat": "37.5028387",
    "lng": "127.0566719",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1468,
    "name": "스터디케어독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 언주로 317 , 203호,204호 (역삼동)",
    "lat": "37.4961557",
    "lng": "127.0453744",
    "phoneNumber": "02-0000-0000",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1469,
    "name": "서리풀랩독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 서초구 명달로 52-9 , 4층 (서초동)",
    "lat": "37.4823789",
    "lng": "127.0054578",
    "phoneNumber": "02-582-0985",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1470,
    "name": "서초크라센어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 서초중앙로 209 , 2층전체,5층1호 (반포동, 해성빌딩)",
    "lat": "37.5003122",
    "lng": "127.0117761",
    "phoneNumber": "02-6261-8280",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1471,
    "name": "뉴오투미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 선릉로86길 6-6 2층(대치동)",
    "lat": "37.5027487",
    "lng": "127.0504205",
    "phoneNumber": "02-569-1821",
    "교습과정": "미술",
    "isFinish": "완료"
  },
  {
    "number": 1472,
    "name": "김병완칼리지학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 테헤란로83길 51 3층(삼성동)",
    "lat": "37.5106937",
    "lng": "127.0563873",
    "phoneNumber": "070-4156-6036",
    "교습과정": "출판",
    "isFinish": ""
  },
  {
    "number": 1473,
    "name": "싸이매쓰학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 347 , 202호 (대치동)",
    "lat": "37.5025385",
    "lng": "127.0585559",
    "phoneNumber": "02-557-3560",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1474,
    "name": "이서희과학탐구학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로78길 13 , 1층 (대치동)",
    "lat": "37.5016635",
    "lng": "127.0572498",
    "phoneNumber": "02-569-0551",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1475,
    "name": "발레플러스발레학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 서초구 강남대로79길 10 , 2층 (반포동)",
    "lat": "37.5053121",
    "lng": "127.0232155",
    "phoneNumber": "02-549-0878",
    "교습과정": "무용(전통무용,현대무용)",
    "isFinish": ""
  },
  {
    "number": 1476,
    "name": "이영준아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 서초구 서초중앙로 75 , 3층일부 301호 (서초동)",
    "lat": "37.4885072",
    "lng": "127.0143065",
    "phoneNumber": "02-535-6354",
    "교습과정": "경매",
    "isFinish": ""
  },
  {
    "number": 1477,
    "name": "얼라이브댄스스튜디오학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 논현로161길 13 , 3층 (신사동)",
    "lat": "37.523335",
    "lng": "127.0270202",
    "phoneNumber": "02-548-4757",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 1478,
    "name": "이든수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 519 , 6층 (대치동)",
    "lat": "37.5000709",
    "lng": "127.0629888",
    "phoneNumber": "02-3454-0492",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1479,
    "name": "수자담수학전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동광로10길 2 , 3층 (방배동)",
    "lat": "37.4908356",
    "lng": "126.9858857",
    "phoneNumber": "02-535-4111",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1480,
    "name": "이도국어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 444 2층(대치동)",
    "lat": "37.4980113",
    "lng": "127.0591722",
    "phoneNumber": "02-535-9579",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 1481,
    "name": "영어설계소대치2캠퍼스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로64길 18 , 4층전체 (대치동, 대치 936.15 빌딩)",
    "lat": "37.4979058",
    "lng": "127.0537428",
    "phoneNumber": "02-2651-1809",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1482,
    "name": "한국사의달인원격교습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 강남대로 340 , 8층일부 (역삼동,경원빌딩)",
    "lat": "37.4935555",
    "lng": "127.0302509",
    "phoneNumber": "070-8733-0505",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1483,
    "name": "맥스수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로62길 32-2 , 3층 (대치동)",
    "lat": "37.49768",
    "lng": "127.0550939",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1484,
    "name": "엠오엠수학전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로18길 5 , 302호 (신사동)",
    "lat": "37.5246005",
    "lng": "127.0244014",
    "phoneNumber": "02-512-8698",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1485,
    "name": "산김영준국어논술전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 100 , 208호, 209호, 301~305호 (반포동)",
    "lat": "37.5030753",
    "lng": "126.9956677",
    "phoneNumber": "02-536-0575",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1486,
    "name": "강남엔(N)플러스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 언주로 325 , 3층일부 (역삼동)",
    "lat": "37.4969157",
    "lng": "127.0449922",
    "phoneNumber": "02-562-2510",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1487,
    "name": "제이매쓰수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 사평대로2길 22 , 3층 (방배동)",
    "lat": "37.4977389",
    "lng": "126.9856418",
    "phoneNumber": "02-595-0598",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1488,
    "name": "다원스타학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 511 , 6층 (대치동)",
    "lat": "37.4996664",
    "lng": "127.0622284",
    "phoneNumber": "02-2652-1162",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1489,
    "name": "입시창조적소수미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 서초구 서초중앙로 251 , 4층,5층 (반포동)",
    "lat": "37.5038239",
    "lng": "127.0105378",
    "phoneNumber": "02-532-5324",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1490,
    "name": "올댓발레학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 삼성로 155 , 515,516호 (대치동)",
    "lat": "37.4938284",
    "lng": "127.062941",
    "phoneNumber": "02-557-9703",
    "교습과정": "무용(전통무용,현대무용)",
    "isFinish": ""
  },
  {
    "number": 1491,
    "name": "지에스피(GSP)영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로34길 11 , 208호 (신사동)",
    "lat": "37.5273895",
    "lng": "127.030957",
    "phoneNumber": "02-547-7776",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1492,
    "name": "에디스프렙어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 테헤란로81길 10 , 401호 (삼성동)",
    "lat": "37.5079246",
    "lng": "127.0572842",
    "phoneNumber": "02-555-3873",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1493,
    "name": "대치수능선배2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 424 , 6층일부 (대치동)",
    "lat": "37.5010752",
    "lng": "127.0534432",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1494,
    "name": "세한와이즈컨설팅학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 테헤란로64길 16-9 , 2층 (대치동)",
    "lat": "37.5035994",
    "lng": "127.0506315",
    "phoneNumber": "02-3453-2526",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 1495,
    "name": "러셀바른공부자습전용관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 남부순환로 2942 , 5층,6층일부,7층일부 (대치동)",
    "lat": "37.4935818",
    "lng": "127.0623994",
    "phoneNumber": "02-2138-1010",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1496,
    "name": "그린램프라이브러리압구정캠퍼스독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 압구정로34길 11 , 203호-205호일부 (신사동)",
    "lat": "37.5273895",
    "lng": "127.030957",
    "phoneNumber": "02-516-5911",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1497,
    "name": "플라이매쓰(FLY MATH)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 나루터로 43 , 5층4호 (잠원동)",
    "lat": "37.5152578",
    "lng": "127.0146863",
    "phoneNumber": "02-595-7969",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1498,
    "name": "씽크씽크아트랩미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 선릉로108길 53 , 3층 (삼성동)",
    "lat": "37.5108749",
    "lng": "127.0484237",
    "phoneNumber": "02-515-5119",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1499,
    "name": "꾸메땅스카이학습코칭학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 개포로 250 , 4층 (개포동)",
    "lat": "37.4788918",
    "lng": "127.0498857",
    "phoneNumber": "02-2038-3757",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1500,
    "name": "맘스(moms)수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초대로53길 27 , 4층,5층 (서초동)",
    "lat": "37.4965994",
    "lng": "127.0140801",
    "phoneNumber": "02-595-0090",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1501,
    "name": "김영플러스여학생전용관학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "인문사회(대)",
    "학원주소\t": "서울특별시 서초구 강남대로 419 , 11층 (서초동, 파고다타워)",
    "lat": "37.4998564",
    "lng": "127.0261723",
    "phoneNumber": "02-567-7033",
    "교습과정": "대학편입",
    "isFinish": ""
  },
  {
    "number": 1502,
    "name": "코어과학수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초대로 81 , 가동 4층 (방배동)",
    "lat": "37.4872104",
    "lng": "126.9910438",
    "phoneNumber": "02-6404-1100",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1503,
    "name": "토브153연기학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 논현로131길 10 , 4층 (논현동)",
    "lat": "37.5145549",
    "lng": "127.0294521",
    "phoneNumber": "02-514-2016",
    "교습과정": "연극",
    "isFinish": ""
  },
  {
    "number": 1504,
    "name": "교대그로티학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로22길 46 , 2층 (서초동)",
    "lat": "37.4933184",
    "lng": "127.0165704",
    "phoneNumber": "02-6263-0982",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1505,
    "name": "전회경영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2911 , 401호 일부 (대치동)",
    "lat": "37.49246",
    "lng": "127.0579272",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1506,
    "name": "뜨는별엔터테이먼트학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 논현로72길 21 , 3층 (역삼동)",
    "lat": "37.4961233999999",
    "lng": "127.0411209",
    "phoneNumber": "02-6734-8977",
    "교습과정": "연극",
    "isFinish": ""
  },
  {
    "number": 1507,
    "name": "용감한컴퍼니원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 테헤란로 146 , 11층일부 (역삼동)",
    "lat": "37.4999942",
    "lng": "127.0354155",
    "phoneNumber": "02-2038-0222",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1508,
    "name": "제이민아트스터디예술대학입시종합학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 테헤란로6길 46 , 301호일부 (역삼동)",
    "lat": "37.4956949",
    "lng": "127.0314437",
    "phoneNumber": "02-557-0771",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1509,
    "name": "대치한뜻음악학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 남부순환로 2917 , 303호일부,304호 (대치동)",
    "lat": "37.4931481",
    "lng": "127.0590766",
    "phoneNumber": "02-562-3549",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1510,
    "name": "압구정크라센어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 논현로168길 18 , 1층 전체 (신사동, 동신빌딩)",
    "lat": "37.5238067",
    "lng": "127.0296884",
    "phoneNumber": "02-541-8280",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1511,
    "name": "더블에이트연기학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 서초구 강남대로95길 48-5 , 2층 (잠원동)",
    "lat": "37.5129718",
    "lng": "127.0173611",
    "phoneNumber": "02-572-3000",
    "교습과정": "연기(연극,뮤지컬,오페라)",
    "isFinish": ""
  },
  {
    "number": 1512,
    "name": "어썸팩토리서초플레이스독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 서초구 고무래로 90-7 , 3층9호 (서초동)",
    "lat": "37.4999482",
    "lng": "127.0174429",
    "phoneNumber": "02-536-0909",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1513,
    "name": "세곡에이프릴어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 자곡로 120 , 503호,504호,505호 (자곡동)",
    "lat": "37.4721173",
    "lng": "127.0965093",
    "phoneNumber": "02-459-7775",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1514,
    "name": "서초청담클루빌어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 바우뫼로 101 , 201호일부,202호 (양재동)",
    "lat": "37.475123",
    "lng": "127.03212",
    "phoneNumber": "070-5097-3379",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1515,
    "name": "한율학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로3길 8 , 307호 (반포동)",
    "lat": "37.5021022",
    "lng": "126.9869475",
    "phoneNumber": "02-593-3803",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1516,
    "name": "대치해솔학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 324 , 201~203호 (대치동)",
    "lat": "37.5008476",
    "lng": "127.0601302",
    "phoneNumber": "02-553-9501",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1517,
    "name": "로앤장수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로 6-7 , 3층 (반포동)",
    "lat": "37.5035792",
    "lng": "127.0092796",
    "phoneNumber": "02-595-2234",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1518,
    "name": "더아이노블강남본원어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 남부순환로378길 20 , 2층,3층,4층,5층일부 (도곡동)",
    "lat": "37.4849877",
    "lng": "127.0461185",
    "phoneNumber": "02-577-0579",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1519,
    "name": "수능프로젝트학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 학동로1길 21 , 2층 (논현동)",
    "lat": "37.5128231",
    "lng": "127.0216591",
    "phoneNumber": "02-3447-1024",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1520,
    "name": "압구정위드피아노학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 선릉로 833 , 4층일부 (신사동)",
    "lat": "37.5265111",
    "lng": "127.0399376",
    "phoneNumber": "02-000-0000",
    "교습과정": "실용음악(성악)",
    "isFinish": ""
  },
  {
    "number": 1521,
    "name": "전원주니어미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 서초구 반포대로 287 , 303호,314호,315호 (반포동)",
    "lat": "37.5043394",
    "lng": "127.0008523",
    "phoneNumber": "02-535-9589",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1522,
    "name": "김정에듀학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 동광로 61 , 2층, 3층 (방배동)",
    "lat": "37.4925331",
    "lng": "126.9892716",
    "phoneNumber": "02-534-5757",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1523,
    "name": "올마이티캠퍼스4관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로68길 17 , 2층 (대치동)",
    "lat": "37.4993664",
    "lng": "127.0530655",
    "phoneNumber": "02-564-1121",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1524,
    "name": "이투스투포세븐강남학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 테헤란로4길 28 , 13층 (역삼동)",
    "lat": "37.4965132",
    "lng": "127.0300705",
    "phoneNumber": "02-566-0247",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1525,
    "name": "올바른수학과학전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 자곡로 120 , 501호, 502호 (자곡동)",
    "lat": "37.4721173",
    "lng": "127.0965093",
    "phoneNumber": "02-3414-6003",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1526,
    "name": "파인만영재고센터1관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 반포대로 304 , 4층일부 403호 (잠원동)",
    "lat": "37.5061614",
    "lng": "127.0010832",
    "phoneNumber": "02-532-1230",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1527,
    "name": "크레오(CREO)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 남부순환로 2909 , 8층일부 (대치동)",
    "lat": "37.4922077",
    "lng": "127.0573813",
    "phoneNumber": "02-563-0579",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1528,
    "name": "더수시입시컨설팅학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로69길 15 , 4층일부 (대치동)",
    "lat": "37.5013456",
    "lng": "127.0580509",
    "phoneNumber": "02-501-5573",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1529,
    "name": "잠룡승천학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2941 , 대치프라자 605,606호 (대치동)",
    "lat": "37.4942268",
    "lng": "127.0617852",
    "phoneNumber": "02-565-9562",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1530,
    "name": "수학에미친사람들서초학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 남부순환로315길 104 , 6층 (서초동)",
    "lat": "37.4830805",
    "lng": "127.0075157",
    "phoneNumber": "02-585-0045",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1531,
    "name": "탑티어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2935 , 2층일부 (대치동)",
    "lat": "37.4940247",
    "lng": "127.0613442",
    "phoneNumber": "02-501-5665",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1532,
    "name": "미래탐구중등학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로64길 5 5층 (대치동)",
    "lat": "37.497902",
    "lng": "127.0526595",
    "phoneNumber": "02-501-1599",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 1533,
    "name": "프랜들리에듀학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로68길 19 , 3층 (대치동)",
    "lat": "37.4994047",
    "lng": "127.0531876",
    "phoneNumber": "02-569-9713",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1534,
    "name": "크레마(crema)수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로30길 23 , 202호 (신사동)",
    "lat": "37.5259481999999",
    "lng": "127.0294613",
    "phoneNumber": "02-540-7234",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1535,
    "name": "영재체험수학서초학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로10길 19 , 6층 (반포동)",
    "lat": "37.5010172",
    "lng": "127.0102811",
    "phoneNumber": "02-533-4501",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1536,
    "name": "개념폴리아삼성청담관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로119길 14 , 4층 (삼성동)",
    "lat": "37.5160444",
    "lng": "127.0503312",
    "phoneNumber": "02-515-1547",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1537,
    "name": "생각하는두꺼비수학5관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 사임당로 151 , 218호,219호,404호 (서초동, 대한무지개종합상가)",
    "lat": "37.4923671",
    "lng": "127.0258472",
    "phoneNumber": "02-599-7773",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1538,
    "name": "흑과백조소학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 선릉로 418 , 5층 (대치동)",
    "lat": "37.502253",
    "lng": "127.0503185",
    "phoneNumber": "02-6403-2153",
    "교습과정": "미술",
    "isFinish": "완료"
  },
  {
    "number": 1539,
    "name": "꼬레아트미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 선릉로72길 12 , 2층 (대치동)",
    "lat": "37.5001703",
    "lng": "127.0522837",
    "phoneNumber": "02-562-8191",
    "교습과정": "미술",
    "isFinish": "완료"
  },
  {
    "number": 1540,
    "name": "서정음악학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 서초구 서래로8길 7 , 3층 (반포동)",
    "lat": "37.4987429",
    "lng": "126.9989342",
    "phoneNumber": "02-535-1550",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1541,
    "name": "압구정함수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로20길 15 , 302호 (신사동)",
    "lat": "37.5248229",
    "lng": "127.0254241",
    "phoneNumber": "02-3444-8824",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1542,
    "name": "엠앤엠수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 521 , 201호 (대치동)",
    "lat": "37.5000321",
    "lng": "127.0632277",
    "phoneNumber": "02-558-2584",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1543,
    "name": "글로벌잡코리아학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 테헤란로7길 7 , 5층일부 (역삼동)",
    "lat": "37.4996222",
    "lng": "127.0305148",
    "phoneNumber": "02-6203-1755",
    "교습과정": "항공승무원",
    "isFinish": ""
  },
  {
    "number": 1544,
    "name": "리얼코딩아바타원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 테헤란로39길 41 , 지하 (역삼동)",
    "lat": "37.5051454",
    "lng": "127.0405314",
    "phoneNumber": "02-557-9404",
    "교습과정": "컴퓨터(소)",
    "isFinish": ""
  },
  {
    "number": 1545,
    "name": "이안학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동산로12길 3 , 4층 (양재동)",
    "lat": "37.4716261",
    "lng": "127.0452893",
    "phoneNumber": "02-571-5273",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1546,
    "name": "르자당학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 논현로159길 48-3 , 2층·3층 (신사동)",
    "lat": "37.5221869",
    "lng": "127.0240824",
    "phoneNumber": "02-586-4010",
    "교습과정": "공예(종이접기,꽃꽂이,꽃기예)",
    "isFinish": ""
  },
  {
    "number": 1547,
    "name": "회화랑미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 역삼로64길 9 , 5층전체 (대치동, 대성빌딩)",
    "lat": "37.5004504",
    "lng": "127.0531429",
    "phoneNumber": "02-555-6446",
    "교습과정": "미술",
    "isFinish": "완료"
  },
  {
    "number": 1548,
    "name": "위드발레학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 테헤란로25길 15-5 , 2층 (역삼동)",
    "lat": "37.5016218",
    "lng": "127.0348241",
    "phoneNumber": "02-6052-5209",
    "교습과정": "무용(전통무용,현대무용)",
    "isFinish": ""
  },
  {
    "number": 1549,
    "name": "아이크리스마스어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 명달로20길 21 , 1층 및 2층 (서초동)",
    "lat": "37.4861259",
    "lng": "127.0053575",
    "phoneNumber": "02-512-1225",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1550,
    "name": "디자인쌤미술학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 서초구 서초중앙로20길 24 , 2층 (서초동)",
    "lat": "37.4922377",
    "lng": "127.0154078",
    "phoneNumber": "02-569-0815",
    "교습과정": "무용(전통무용,현대무용)",
    "isFinish": ""
  },
  {
    "number": 1551,
    "name": "스킬서포트교육센터컴퓨터학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 삼성로95길 15 , 7층 일부 (삼성동)",
    "lat": "37.5077573",
    "lng": "127.0545287",
    "phoneNumber": "02-6346-7200",
    "교습과정": "컴퓨터(정보처리,통신기기,인터넷,소프트웨어)",
    "isFinish": ""
  },
  {
    "number": 1552,
    "name": "더(THE)틴트미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 선릉로82길 13 , 3층,4층 (대치동)",
    "lat": "37.5027711",
    "lng": "127.051077",
    "phoneNumber": "02-558-8281",
    "교습과정": "미술",
    "isFinish": "완료"
  },
  {
    "number": 1553,
    "name": "멀홀랜드액팅스튜디오학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 언주로134길 18 , 2층 (논현동)",
    "lat": "37.5166107",
    "lng": "127.0370171",
    "phoneNumber": "02-3444-5553",
    "교습과정": "연극",
    "isFinish": ""
  },
  {
    "number": 1554,
    "name": "오티피(OTP)영어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 테헤란로8길 26 , 3층 (역삼동)",
    "lat": "37.4971925",
    "lng": "127.0316861",
    "phoneNumber": "02-553-0504",
    "교습과정": "통역(성인)",
    "isFinish": ""
  },
  {
    "number": 1555,
    "name": "세영학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 177 , 3동, 5층 5호일부,6호일부,30호일부,31호,32호 (잠원동, 반포쇼핑타운)",
    "lat": "37.5061225",
    "lng": "127.0036962",
    "phoneNumber": "02-537-8305",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1556,
    "name": "쌩뚱영어2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로64길 24 , 3층 (대치동)",
    "lat": "37.4981312",
    "lng": "127.0542485",
    "phoneNumber": "02-556-7110",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1557,
    "name": "에이탑트레이닝시스템학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 삼성로145길 16 , 3층 (청담동)",
    "lat": "37.5225961",
    "lng": "127.0469289",
    "phoneNumber": "02-6246-7775",
    "교습과정": "실용음악(성악)",
    "isFinish": ""
  },
  {
    "number": 1558,
    "name": "강남스즈키음악학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 서초구 사임당로 101 , 4층 (서초동)",
    "lat": "37.4904324",
    "lng": "127.0207878",
    "phoneNumber": "02-6497-8900",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1559,
    "name": "토즈스터디센터논현독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 선릉로129길 16 , 3층일부 (논현동)",
    "lat": "37.5163586",
    "lng": "127.0402263",
    "phoneNumber": "02-2038-8889",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1560,
    "name": "서초우면소마학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 태봉로 70 , 503호 (우면동)",
    "lat": "37.4645285",
    "lng": "127.0255453",
    "phoneNumber": "02-574-2357",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1561,
    "name": "달꿈음악학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 자곡로 120 , 401호, 402호 (자곡동)",
    "lat": "37.4721173",
    "lng": "127.0965093",
    "phoneNumber": "02-445-1122",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1562,
    "name": "엘루씨뷰티아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 강남대로132길 59 , 4층일부 (논현동)",
    "lat": "37.5135109",
    "lng": "127.0258454",
    "phoneNumber": "02-543-1163",
    "교습과정": "이·미용",
    "isFinish": ""
  },
  {
    "number": 1563,
    "name": "엘뮤음악학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 자곡로 106 , 405호 (자곡동)",
    "lat": "37.4719211",
    "lng": "127.0950026",
    "phoneNumber": "02-445-1775",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1564,
    "name": "이케이(EK)아트미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 테헤란로4길 38-4 , 5층 (역삼동, 태양빌딩)",
    "lat": "37.4959565",
    "lng": "127.0302668",
    "phoneNumber": "02-555-1220",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1565,
    "name": "마로학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 언주로94길 15 , 3층, 5층 (역삼동)",
    "lat": "37.5044766",
    "lng": "127.0434719",
    "phoneNumber": "02-552-3255",
    "교습과정": "이·미용",
    "isFinish": ""
  },
  {
    "number": 1566,
    "name": "제이비제주국제보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 664 , 312호 (삼성동)",
    "lat": "37.5158959",
    "lng": "127.0422861",
    "phoneNumber": "02-3446-0582",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1567,
    "name": "과학의진수학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 177 , 반포쇼핑타운3동 5층7호일부,8호,9호,10호일부 (잠원동)",
    "lat": "37.5060582",
    "lng": "127.0033885",
    "phoneNumber": "02-536-6369",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1568,
    "name": "생각하는두꺼비수학7관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 177 , 2층 39호~44호, 86호~91호 일부(잠원동)",
    "lat": "37.5060471",
    "lng": "127.0039106",
    "phoneNumber": "02-536-0567",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1569,
    "name": "최상위권수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 225 , 301호 (도곡동)",
    "lat": "37.4902694",
    "lng": "127.0471433",
    "phoneNumber": "02-571-1900",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1570,
    "name": "온더데스크도곡독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 도곡로 182 , 10층일부 (도곡동)",
    "lat": "37.4915335",
    "lng": "127.039323",
    "phoneNumber": "02-2057-0979",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1571,
    "name": "프로픽아카데미게임그래픽학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 테헤란로 109 , 8층 전체 (역삼동, 강남제일빌딩)",
    "lat": "37.498794",
    "lng": "127.0289942",
    "phoneNumber": "02-6080-0226",
    "교습과정": "게임",
    "isFinish": ""
  },
  {
    "number": 1572,
    "name": "생각의숲국어논술전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 30 , 201호,402호 (개포동)",
    "lat": "37.4826789",
    "lng": "127.0611803",
    "phoneNumber": "02-573-6148",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1573,
    "name": "유엠웨딩드레스아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 삼성로 726 , 5층 일부 (청담동)",
    "lat": "37.5205322",
    "lng": "127.0496679",
    "phoneNumber": "02-540-5006",
    "교습과정": "디자인",
    "isFinish": ""
  },
  {
    "number": 1574,
    "name": "홀리프레이즈음악학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 서초구 방배중앙로 157 , B동 4층,5층 (방배동, 대흥빌딩)",
    "lat": "37.4931817",
    "lng": "126.9862095",
    "phoneNumber": "070-8886-8647",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1575,
    "name": "와이앤파트너스학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 논현로87길 25 , 7층 (역삼동)",
    "lat": "37.4993268",
    "lng": "127.034765",
    "phoneNumber": "02-1588-4731",
    "교습과정": "금융",
    "isFinish": ""
  },
  {
    "number": 1576,
    "name": "차홍아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 학동로33길 42 , 1층,2층 (논현동)",
    "lat": "37.5175769",
    "lng": "127.0322524",
    "phoneNumber": "02-3445-8523",
    "교습과정": "이·미용",
    "isFinish": ""
  },
  {
    "number": 1577,
    "name": "조건반사영어원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로 110 , B1-176호 (서초동, 서초동롯데캐슬메디치)",
    "lat": "37.4915908",
    "lng": "127.0145123",
    "phoneNumber": "02-6304-0246",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1578,
    "name": "대치파인만입시관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 150 , 310호 (대치동, 한보미도맨션)",
    "lat": "37.4925906",
    "lng": "127.066184",
    "phoneNumber": "02-567-0969",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1579,
    "name": "퓨쳐플랜학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로64길 22 , 2층 (대치동)",
    "lat": "37.4995919",
    "lng": "127.0532085",
    "phoneNumber": "02-332-6980",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 1580,
    "name": "정영어학원인문관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2941 , 404호 (대치동)",
    "lat": "37.4942268",
    "lng": "127.0617852",
    "phoneNumber": "02-3414-3388",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 1581,
    "name": "주연학원3관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 334 , 301호 일부 (대치동)",
    "lat": "37.4995931",
    "lng": "127.0516807",
    "phoneNumber": "02-501-1738",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 1582,
    "name": "어썸팩토리방배독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 서초구 방배로 242 , 2층 (방배동)",
    "lat": "37.4946981",
    "lng": "126.9895932",
    "phoneNumber": "02-534-9177",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1583,
    "name": "리드101자곡영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 자곡로 106 , 205호, 206호 (자곡동)",
    "lat": "37.4719211",
    "lng": "127.0950026",
    "phoneNumber": "02-451-5101",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1584,
    "name": "홀릭학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 테헤란로 108 , 4층 일부 (역삼동)",
    "lat": "37.4979753",
    "lng": "127.0288996",
    "phoneNumber": "02-553-8205",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1585,
    "name": "엑스매쓰(XMATH)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로64길 7 , 201호 (대치동)",
    "lat": "37.4979741",
    "lng": "127.0528926",
    "phoneNumber": "02-566-0419",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 1586,
    "name": "족집게어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 역삼로63길 6 , 4,5층 (대치동)",
    "lat": "37.501588",
    "lng": "127.0525941",
    "phoneNumber": "02-577-0582",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": "완료"
  },
  {
    "number": 1587,
    "name": "에스엠엠에이(SMMA)아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 학동로20길 32 , 2층,3층,4층 (논현동)",
    "lat": "37.5113987",
    "lng": "127.0279823",
    "phoneNumber": "02-597-2222",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1588,
    "name": "뉴파인반포고등관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 162 , 7층일부 (반포동)",
    "lat": "37.5048882",
    "lng": "127.0020908",
    "phoneNumber": "02-517-0304",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1589,
    "name": "아미고발레학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 압구정로 113-22 , 2층3-3호,3-4호 (압구정동)",
    "lat": "37.5247099",
    "lng": "127.0196554",
    "phoneNumber": "02-512-7608",
    "교습과정": "무용",
    "isFinish": ""
  },
  {
    "number": 1590,
    "name": "혜인즈블라썸플로리스트화훼학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 학동로8길 9 3층(논현동)",
    "lat": "37.5113227999999",
    "lng": "127.0244664",
    "phoneNumber": "02-540-5436",
    "교습과정": "공예(종이접기,꽃꽂이,꽃기예)",
    "isFinish": ""
  },
  {
    "number": 1591,
    "name": "플라즈마고등에스(S)관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 삼성로71길 7 , 2층 및 3층 (대치동)",
    "lat": "37.5021276",
    "lng": "127.0583283",
    "phoneNumber": "02-557-5442",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1592,
    "name": "사실주의연기학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 논현로131길 12 , 2층,3층전체 (논현동)",
    "lat": "37.5144966",
    "lng": "127.0292517",
    "phoneNumber": "02-545-0502",
    "교습과정": "연기(연극,뮤지컬,오페라)",
    "isFinish": ""
  },
  {
    "number": 1593,
    "name": "광림샤이닝키즈학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 논현로163길 33 , 1층일부 (신사동)",
    "lat": "37.5238869",
    "lng": "127.0251531",
    "phoneNumber": "02-2015-1101",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1594,
    "name": "시대인재수학스쿨별관2학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 434 , 3층일부 (대치동)",
    "lat": "37.4976364",
    "lng": "127.0579549",
    "phoneNumber": "02-538-3372",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1595,
    "name": "더리얼학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 서초구 방배천로 66 , 4층 일부 402호 (방배동)",
    "lat": "37.4824638",
    "lng": "126.9829614",
    "phoneNumber": "-",
    "교습과정": "화술",
    "isFinish": ""
  },
  {
    "number": 1596,
    "name": "크레마고등수학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로 132 , 3층 일부 (신사동)",
    "lat": "37.5242325",
    "lng": "127.0232383",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1597,
    "name": "다원교육고등관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 501 , 203호, 204호 (대치동)",
    "lat": "37.4993898",
    "lng": "127.061127",
    "phoneNumber": "02-3454-1162",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1598,
    "name": "고등학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 501 , 301호,302호,303호,304호(SM TOWER) (대치동)",
    "lat": "37.4993898",
    "lng": "127.061127",
    "phoneNumber": "02-3454-1162",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1599,
    "name": "파워영재학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 515 , 404호 (대치동, 한도산업사옥)",
    "lat": "37.4998352",
    "lng": "127.0626495",
    "phoneNumber": "02-508-6567",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1600,
    "name": "공감영재아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배중앙로9길 4 , 2층 (방배동)",
    "lat": "37.480929",
    "lng": "126.9929876",
    "phoneNumber": "02-2038-3305",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1601,
    "name": "두각하늘관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 301 , 401호 (대치동)",
    "lat": "37.499102",
    "lng": "127.0604069",
    "phoneNumber": "02-566-9992",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 1602,
    "name": "김종율부동산아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 테헤란로8길 25 3층 1호(역삼동)",
    "lat": "37.4972898",
    "lng": "127.032158",
    "phoneNumber": "02-4126-0001",
    "교습과정": "부동산",
    "isFinish": ""
  },
  {
    "number": 1603,
    "name": "렉시스강남2캠퍼스학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 강남대로53길 7 13층(서초동)",
    "lat": "37.494251",
    "lng": "127.0282336",
    "phoneNumber": "02-588-4901",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 1604,
    "name": "하노버음악학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 남부순환로363길 11 , 401호 (도곡동)",
    "lat": "37.4859244",
    "lng": "127.0379017",
    "phoneNumber": "02-529-2129",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1605,
    "name": "터키문화원커리어업학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 반포대로 98 , 2층전체 (서초동, 일신빌딩)",
    "lat": "37.489087",
    "lng": "127.0094251",
    "phoneNumber": "02-3452-8182",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 1606,
    "name": "서초애니스타만화학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 서초구 방배로 84 3층 (방배동)",
    "lat": "37.4820134",
    "lng": "126.9976476",
    "phoneNumber": "02-588-2850",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1607,
    "name": "생각이룸독서논술국어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 사임당로 139 , 202호, 301호 (서초동)",
    "lat": "37.4917696",
    "lng": "127.0248585",
    "phoneNumber": "02-521-8995",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1608,
    "name": "숲컴퍼니연기학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 서초구 남부순환로 2644 , 2층 (양재동)",
    "lat": "37.4850721",
    "lng": "127.0397745",
    "phoneNumber": "02-576-5764",
    "교습과정": "연기(연극,뮤지컬,오페라)",
    "isFinish": ""
  },
  {
    "number": 1609,
    "name": "제이디씨(JDC)무용학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 밤고개로21길 73 , 4층 401호 (율현동)",
    "lat": "37.4742539999999",
    "lng": "127.1143812",
    "phoneNumber": "02-446-7351",
    "교습과정": "무용",
    "isFinish": ""
  },
  {
    "number": 1610,
    "name": "시대인재4관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 428 , 4층 (대치동)",
    "lat": "37.4974415999999",
    "lng": "127.0573512",
    "phoneNumber": "02-552-2373",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1611,
    "name": "시대인재서바이벌관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 도곡로 510 , 2층 1호,2호(대치동)",
    "lat": "37.4989119",
    "lng": "127.0619546",
    "phoneNumber": "02-552-2373",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1612,
    "name": "세빛관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 반포대로 300-3 , 4층 일부 (잠원동, 상화빌딩)",
    "lat": "37.505789",
    "lng": "127.0012603",
    "phoneNumber": "02-535-1245",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1613,
    "name": "김도현뉴미디어영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 340 , 801호, 802호, 803호 (대치동, 대치 EM 프라자)",
    "lat": "37.5001553",
    "lng": "127.0513254",
    "phoneNumber": "02-538-6686",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1614,
    "name": "시대인재커피관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로57길 22 , 3층일부 (대치동)",
    "lat": "37.4978398",
    "lng": "127.0592568",
    "phoneNumber": "02-552-2373",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 1615,
    "name": "케이알(KR)부동산아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 서초구 서초대로46길 109 , 5층 (서초동)",
    "lat": "37.4902276",
    "lng": "127.013974",
    "phoneNumber": "02-582-7242",
    "교습과정": "부동산",
    "isFinish": ""
  },
  {
    "number": 1616,
    "name": "경제적자유아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 서초구 사임당로 173 , 1402호 (서초동, 서전빌딩)",
    "lat": "37.4927943",
    "lng": "127.0285544",
    "phoneNumber": "02-000-0000",
    "교습과정": "금융",
    "isFinish": ""
  },
  {
    "number": 1617,
    "name": "어스플러스연기학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 강남대로 530 , 2층,3층 (논현동)",
    "lat": "37.5094334",
    "lng": "127.0226216",
    "phoneNumber": "02-6205-4100",
    "교습과정": "연극",
    "isFinish": ""
  },
  {
    "number": 1618,
    "name": "미래탐구청은1관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 434 , 4층일부 (대치동)",
    "lat": "37.4976364",
    "lng": "127.0579549",
    "phoneNumber": "02-557-5442",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1619,
    "name": "늘푸른큰키나무학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로64길 15-14 , 3층 (대치동)",
    "lat": "37.4989487",
    "lng": "127.0533074",
    "phoneNumber": "02-556-7624",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1620,
    "name": "과학의맥학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로 114 , 4층 (신사동)",
    "lat": "37.5232774",
    "lng": "127.021304",
    "phoneNumber": "02-515-1103",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1621,
    "name": "아이비젠코리아학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로30길 17 , 307호 (신사동, 이소니프라자)",
    "lat": "37.5262629",
    "lng": "127.0294934",
    "phoneNumber": "02-541-7869",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1622,
    "name": "수퍼(super)매쓰(math)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배로10길 4 , 4층 (방배동)",
    "lat": "37.4809103",
    "lng": "126.9983321",
    "phoneNumber": "02-6084-1517",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1623,
    "name": "서울중앙음악학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 서초구 동산로 44 , 2층 (양재동, 선빌딩)",
    "lat": "37.4711131",
    "lng": "127.0438378",
    "phoneNumber": "02-593-5999",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1624,
    "name": "강남잉글리쉬아카데미어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 언주로164길 12 , 1층,2층,3층 일부,4층 일부 (신사동)",
    "lat": "37.525153",
    "lng": "127.0343807",
    "phoneNumber": "02-5179-864",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1625,
    "name": "타임사진학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 언주로113길 13 , 2층,3층 (논현동)",
    "lat": "37.509201",
    "lng": "127.0363098",
    "phoneNumber": "02-545-5457",
    "교습과정": "사진",
    "isFinish": ""
  },
  {
    "number": 1626,
    "name": "이병훈교육연구소진로진학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 423 , 5층 (대치동)",
    "lat": "37.5015633999999",
    "lng": "127.0532216",
    "phoneNumber": "02-566-9745",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 1627,
    "name": "아폴론교육학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로93길 9 , 6층 일부 (대치동)",
    "lat": "37.5008373",
    "lng": "127.0645016",
    "phoneNumber": "02-515-9211",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 1628,
    "name": "유엠(UM)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 개포로82길 11 , 302호,303호 (개포동)",
    "lat": "37.4885331",
    "lng": "127.0674474",
    "phoneNumber": "02-3411-8889",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1629,
    "name": "에스에듀학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로32길 25 , 2층 (신사동)",
    "lat": "37.5260448",
    "lng": "127.0300503",
    "phoneNumber": "02-549-1233",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1630,
    "name": "피에스아이아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 논현로161길 13 , 5층 (신사동)",
    "lat": "37.523335",
    "lng": "127.0270202",
    "phoneNumber": "02-540-2273",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1631,
    "name": "서초키마학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배로42길 20 , 2층 (방배동)",
    "lat": "37.4949176999999",
    "lng": "126.9896217",
    "phoneNumber": "02-6409-6785",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1632,
    "name": "비다이미술학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 역삼로3길 17-6 , 7층 (역삼동)",
    "lat": "37.4947016",
    "lng": "127.0305955",
    "phoneNumber": "02-566-1383",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1633,
    "name": "서울아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 삼성로64길 16 ,1~4층 (대치동, 서울아카데미)",
    "lat": "37.5000192",
    "lng": "127.0617824",
    "phoneNumber": "02-554-1690",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1634,
    "name": "에스비에스(SBS)아카데미게임학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 서초구 강남대로69길 8 8층 우측(동쪽), 9층 전체(서초동)",
    "lat": "37.5018395",
    "lng": "127.0246454",
    "phoneNumber": "02-539-8555",
    "교습과정": "게임",
    "isFinish": ""
  },
  {
    "number": 1635,
    "name": "압구정소수서원학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로18길 5 , 2층 전체 (신사동)",
    "lat": "37.5246005",
    "lng": "127.0244014",
    "phoneNumber": "02-512-9008",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1636,
    "name": "미생바둑학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 테헤란로2길 21 , 302호 (역삼동)",
    "lat": "37.4968242",
    "lng": "127.0294078",
    "phoneNumber": "02-000-0000",
    "교습과정": "바둑",
    "isFinish": ""
  },
  {
    "number": 1637,
    "name": "메르뷰미용학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 학동로 332 , 2층 (논현동)",
    "lat": "37.5163413",
    "lng": "127.0391997",
    "phoneNumber": "02-511-9006",
    "교습과정": "이·미용",
    "isFinish": ""
  },
  {
    "number": 1638,
    "name": "홍성민영어에듀학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로62길 13 , 2층 (대치동)",
    "lat": "37.4975063",
    "lng": "127.0535739",
    "phoneNumber": "02-2052-0582",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 1639,
    "name": "러닝스푼즈학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 강남대로94길 15 , 3층,4층 (역삼동)",
    "lat": "37.4996351",
    "lng": "127.0285951",
    "phoneNumber": "02-3445-5170",
    "교습과정": "컴퓨터(정보처리,통신기기,인터넷,소프트웨어)",
    "isFinish": ""
  },
  {
    "number": 1640,
    "name": "더매쓰(THE MATH)수학전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 중앙로 582 , 501호 (우면동)",
    "lat": "37.4571331",
    "lng": "127.0153261",
    "phoneNumber": "02-3462-5007",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1641,
    "name": "모다랩패션디자인학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 언주로172길 14 , 3층 (신사동)",
    "lat": "37.5276336",
    "lng": "127.0348904",
    "phoneNumber": "02-3444-5231",
    "교습과정": "디자인",
    "isFinish": ""
  },
  {
    "number": 1642,
    "name": "곽샘음악학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 압구정로 113-22 , 2층2호 (압구정동)",
    "lat": "37.5247099",
    "lng": "127.0196554",
    "phoneNumber": "02-514-7877",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1643,
    "name": "파인즈영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로28길 22-5 , 1층일부 (신사동)",
    "lat": "37.5250123",
    "lng": "127.0271808",
    "phoneNumber": "02-511-7257",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1644,
    "name": "다원국어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 406 , 4층 (대치동, 서림빌딩)",
    "lat": "37.5035054",
    "lng": "127.0587764",
    "phoneNumber": "02-562-3399",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1645,
    "name": "김정준국어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로77길 7 , 2층전체 (대치동)",
    "lat": "37.4988033",
    "lng": "127.0583171",
    "phoneNumber": "02-508-7737",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1646,
    "name": "대치메카학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 428 , 6층 (대치동)",
    "lat": "37.4974415999999",
    "lng": "127.0573512",
    "phoneNumber": "02-568-5202",
    "교습과정": "보습",
    "isFinish": "완료"
  },
  {
    "number": 1647,
    "name": "디자인고흐신관미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 선릉로82길 9 , 3층전체, 5층전체 (대치동)",
    "lat": "37.5027028",
    "lng": "127.0508677",
    "phoneNumber": "02-554-7345",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1648,
    "name": "제이엠케이에듀케이션(JMK EDUCATION)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 325 , 4층 (역삼동)",
    "lat": "37.4961785",
    "lng": "127.0515117",
    "phoneNumber": "02-515-1862",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1649,
    "name": "예섬에스관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 도곡로 413 , 201,205,206호 (대치동, 삼환 SO GOOD)",
    "lat": "37.4975956",
    "lng": "127.0557613",
    "phoneNumber": "02-558-8822",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 1650,
    "name": "탑클래스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동광로 9 , 3층 (방배동)",
    "lat": "37.4910429",
    "lng": "126.9840457",
    "phoneNumber": "02-592-5111",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1651,
    "name": "디자인고흐본관미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 선릉로82길 9 , 2층일부, 4층전체 (대치동)",
    "lat": "37.5027028",
    "lng": "127.0508677",
    "phoneNumber": "02-552-1345",
    "교습과정": "미술",
    "isFinish": "완료"
  },
  {
    "number": 1652,
    "name": "별사탕연기학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 언주로87길 43 , 8층 (역삼동)",
    "lat": "37.5006565",
    "lng": "127.039666",
    "phoneNumber": "02-1522-9032",
    "교습과정": "연극",
    "isFinish": ""
  },
  {
    "number": 1653,
    "name": "디와이에스강인학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로74길 7 , 2층 (대치동, 송암빌딩)",
    "lat": "37.5014063",
    "lng": "127.0553218",
    "phoneNumber": "02-566-5646",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 1654,
    "name": "에듀그룹맥스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로64길 18 , 6층 (대치동)",
    "lat": "37.4979058",
    "lng": "127.0537428",
    "phoneNumber": "02-539-7052",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1655,
    "name": "해법수학교실반포학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로31길 6-3 , 7층 전체 (반포동, 지지반포빌딩)",
    "lat": "37.5000996",
    "lng": "127.0113176",
    "phoneNumber": "02-6711-2581",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1656,
    "name": "극한스피킹학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 서초대로73길 7 , 4층, 5층 (서초동)",
    "lat": "37.4981412",
    "lng": "127.0253117",
    "phoneNumber": "02-1644-8605",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 1657,
    "name": "강남완전학습관학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "인문사회(대)",
    "학원주소\t": "서울특별시 서초구 서초대로78길 48 , 8층 전체 (서초동, 송림빌딩)",
    "lat": "37.4934302",
    "lng": "127.0285142",
    "phoneNumber": "02-525-2341",
    "교습과정": "대학편입",
    "isFinish": ""
  },
  {
    "number": 1658,
    "name": "씨엠에스(CMS)중등1관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 345 , 3층 (대치동)",
    "lat": "37.5023034",
    "lng": "127.0586846",
    "phoneNumber": "02-563-0330",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1659,
    "name": "학원,날개를달다학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 462 , 3층 (대치동)",
    "lat": "37.502626",
    "lng": "127.0578107",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1660,
    "name": "에이펙스에듀학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로64길 41 , 201호,202호 (대치동)",
    "lat": "37.5010033999999",
    "lng": "127.063646",
    "phoneNumber": "02-501-4933",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1661,
    "name": "바른아트센터미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 논현로164길 21 , 2층, 3층 (신사동)",
    "lat": "37.5234461",
    "lng": "127.0299841",
    "phoneNumber": "02-545-4200",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1662,
    "name": "엠엘씨(MLC)영어전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도산대로27길 26 , 4층 401호(신사동)",
    "lat": "37.5213596",
    "lng": "127.0275947",
    "phoneNumber": "02-542-7686",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1663,
    "name": "대치메이드수능관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 430 , 4층일부 (대치동)",
    "lat": "37.4975062",
    "lng": "127.0575512",
    "phoneNumber": "02-538-7474",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 1664,
    "name": "하이원학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2941 , 405호,406호 (대치동)",
    "lat": "37.4942268",
    "lng": "127.0617852",
    "phoneNumber": "02-557-1150",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1665,
    "name": "라인액팅스쿨학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 학동로33길 8 , 3층 (논현동)",
    "lat": "37.5163751",
    "lng": "127.0323538",
    "phoneNumber": "02-543-6353",
    "교습과정": "연극",
    "isFinish": ""
  },
  {
    "number": 1666,
    "name": "엔디에이취(NDH)발성교정아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 서초구 동산로14길 2 , 1층일부 뒷편 (양재동)",
    "lat": "37.4719317",
    "lng": "127.0461648",
    "phoneNumber": "02-573-3601",
    "교습과정": "화술",
    "isFinish": ""
  },
  {
    "number": 1667,
    "name": "방배캠퍼스현재어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 서초대로 25 , 4층 일부, 5층 일부(방배동)",
    "lat": "37.4860846",
    "lng": "126.9851893",
    "phoneNumber": "02-592-4177",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1668,
    "name": "코딩골드스쿨컴퓨터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 삼성로 212 , 은마상가B동301-3호 (대치동)",
    "lat": "37.4954127",
    "lng": "127.0636485",
    "phoneNumber": "02-569-9383",
    "교습과정": "컴퓨터(소)",
    "isFinish": ""
  },
  {
    "number": 1669,
    "name": "진선생구반포관영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 반포대로 300 , 7층 일부 (잠원동, 덕성빌딩)",
    "lat": "37.505956",
    "lng": "127.0011819",
    "phoneNumber": "02-591-7396",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1670,
    "name": "그로튼아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 도곡로 418 , 5층 (대치동)",
    "lat": "37.4970089",
    "lng": "127.0562594",
    "phoneNumber": "02-555-5009",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": "완료"
  },
  {
    "number": 1671,
    "name": "러셀강남독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 서초구 사임당로 178 , 206~208호,212~213호,301~309호 (서초동)",
    "lat": "37.4921331",
    "lng": "127.0291018",
    "phoneNumber": "02-6954-1010",
    "교습과정": "독서실",
    "isFinish": ""
  },
  {
    "number": 1672,
    "name": "씨아이티코드아카데미(CIT Code Academy)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 압구정로32길 11 , 2층206호 (신사동)",
    "lat": "37.5269161",
    "lng": "127.0302159",
    "phoneNumber": "02-540-2922",
    "교습과정": "컴퓨터(소)",
    "isFinish": ""
  },
  {
    "number": 1673,
    "name": "러셀강남학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 사임당로 178 , 201호~205호,209호~211호 (서초동)",
    "lat": "37.4921331",
    "lng": "127.0291018",
    "phoneNumber": "02-6954-1010",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1674,
    "name": "서초소마2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로 12 , 3층일부 (반포동)",
    "lat": "37.5034699",
    "lng": "127.0100711",
    "phoneNumber": "02-3280-0400",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1675,
    "name": "오른수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로87길 6 , 2층 (대치동)",
    "lat": "37.5001879",
    "lng": "127.0634454",
    "phoneNumber": "02-558-2584",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1676,
    "name": "서준학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 효령로 173 , 3층,4층 (서초동)",
    "lat": "37.4826915",
    "lng": "127.0029652",
    "phoneNumber": "02-585-0766",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1677,
    "name": "수학을삼키다학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동작대로 160 , 2층 (방배동)",
    "lat": "37.4906572",
    "lng": "126.9829888",
    "phoneNumber": "02-532-0608",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1678,
    "name": "키아나연기학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 논현로 554 , 4층일부 (역삼동)",
    "lat": "37.5055488",
    "lng": "127.0350697",
    "phoneNumber": "02-512-4131",
    "교습과정": "연극",
    "isFinish": ""
  },
  {
    "number": 1679,
    "name": "이맥스잉글리시(eMAX Englsih)어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 삼성로51길 42 , 2층 (대치동)",
    "lat": "37.4955965",
    "lng": "127.0586987",
    "phoneNumber": "02-568-0021",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1680,
    "name": "이지에듀원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 강남대로10길 23 , 1층 영빌딩 (양재동)",
    "lat": "37.4687339",
    "lng": "127.0406548",
    "phoneNumber": "02-554-9595",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1681,
    "name": "이후미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 서초구 고무래로10길 23 2층 일부(반포동)",
    "lat": "37.5006573",
    "lng": "127.0101895",
    "phoneNumber": "02-595-1122",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1682,
    "name": "원어비국어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로64길 15 , 3층 (대치동)",
    "lat": "37.4981389",
    "lng": "127.0534401",
    "phoneNumber": "02-554-9595",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1683,
    "name": "생각하는황소3관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 448 , 5층 (대치동)",
    "lat": "37.5019986",
    "lng": "127.0562288",
    "phoneNumber": "02-566-5496",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1684,
    "name": "수학스쿨(SCHOOL)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 50 , 308 (반포동)",
    "lat": "37.5017761999999",
    "lng": "126.9901541",
    "phoneNumber": "02-508-1246",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1685,
    "name": "묵연전통채색화학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 선릉로155길 25 , 5층 전체 (신사동)",
    "lat": "37.5255951",
    "lng": "127.0374953",
    "phoneNumber": "02-000-0000",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1686,
    "name": "대치명인스카이수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로64길 18 , 5층 전체 (대치동, 대치 936.15 빌딩)",
    "lat": "37.4979058",
    "lng": "127.0537428",
    "phoneNumber": "02-563-2233",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1687,
    "name": "엘앤케이(LNK)스터디브릭스보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 성촌1길 26 , 303호,304호 (우면동)",
    "lat": "37.4653735",
    "lng": "127.0212759",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1688,
    "name": "엘이피아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 언주로114길 15-3 , 2층, 3층, 4층 (논현동)",
    "lat": "37.5103277",
    "lng": "127.0386896",
    "phoneNumber": "02-511-5119",
    "교습과정": "모델",
    "isFinish": ""
  },
  {
    "number": 1689,
    "name": "김용철화실미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 남부순환로 2921 , 3층9호 (대치동,남서울종합상가)",
    "lat": "37.4936059",
    "lng": "127.0597001",
    "phoneNumber": "02-540-1430",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1690,
    "name": "당근영어원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 강남대로 488 , 6층 일부 (논현동, 대남빌딩)",
    "lat": "37.5058766",
    "lng": "127.0242897",
    "phoneNumber": "02-518-5468",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1691,
    "name": "유투엠대치원학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 헌릉로569길 27 , 203호, 204호 (세곡동)",
    "lat": "37.466796",
    "lng": "127.09879",
    "phoneNumber": "02-3476-3003",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1692,
    "name": "아토즈수리논구술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 227 , 5층일부 (대치동)",
    "lat": "37.4974041",
    "lng": "127.0612407",
    "phoneNumber": "02-568-1599",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1693,
    "name": "K&M수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로132길 13 , 3층 전체 (청담동)",
    "lat": "37.5182729",
    "lng": "127.0422036",
    "phoneNumber": "02-515-6040",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1694,
    "name": "919수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 205 , 2층 7,8,9,18,28,29,30,31,32(일부)호 (잠원동, 반포쇼핑타운)",
    "lat": "37.5069447",
    "lng": "127.0061471",
    "phoneNumber": "02-535-2643",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1695,
    "name": "개념폴리아서초관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로 225 , 5층 (반포동)",
    "lat": "37.5016579",
    "lng": "127.0115536",
    "phoneNumber": "02-591-4808",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1696,
    "name": "247에듀케어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 188 , 2층202호 (도곡동)",
    "lat": "37.487837",
    "lng": "127.0438359",
    "phoneNumber": "070-4116-0619",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1697,
    "name": "와이국어논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초대로51길 29 , 6층 (서초동)",
    "lat": "37.4963789",
    "lng": "127.0136798",
    "phoneNumber": "02-599-2052",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1698,
    "name": "엠비씨아카데미연극학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 논현로86길 29 , 5~6층 (역삼동, 대한사회복지회 Guest House)",
    "lat": "37.5005206",
    "lng": "127.0398021",
    "phoneNumber": "02-6951-1114",
    "교습과정": "연극",
    "isFinish": ""
  },
  {
    "number": 1699,
    "name": "코리아요리아트아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 서초구 서초대로78길 28 , 7층, 10층(서초동)",
    "lat": "37.4952936",
    "lng": "127.0278782",
    "phoneNumber": "02-1588-8335",
    "교습과정": "식음료품(바리스타,소믈리에)",
    "isFinish": ""
  },
  {
    "number": 1700,
    "name": "엘브라운(El.Brown)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로3길 8 ,413호 (반포동, 반포프라자)",
    "lat": "37.5021153",
    "lng": "126.9869086",
    "phoneNumber": "02-593-0533",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1701,
    "name": "매그나학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 150 , 320호(미도상가) (대치동)",
    "lat": "37.4933928",
    "lng": "127.0673501",
    "phoneNumber": "02-568-0599",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1702,
    "name": "판테라수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 408 , 507호, 508호(대치동)",
    "lat": "37.4966877",
    "lng": "127.0552639",
    "phoneNumber": "02-6365-0815",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1703,
    "name": "대치솔학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로72길 21 , 2층 (대치동)",
    "lat": "37.5005931",
    "lng": "127.0527845",
    "phoneNumber": "02-557-5288",
    "교습과정": "보습",
    "isFinish": "완료"
  },
  {
    "number": 1704,
    "name": "생각하는두꺼비수학3관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로8길 10 , 3층 전체 (반포동, 영원빌딩)",
    "lat": "37.5022711",
    "lng": "127.0101432",
    "phoneNumber": "02-599-7773",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1705,
    "name": "라라음악학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 서초구 중앙로 582 , 502~504호 (우면동)",
    "lat": "37.4632734",
    "lng": "127.0116906",
    "phoneNumber": "02-575-8776",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1706,
    "name": "아이엔어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 도곡로 526 , 3층,4층 (대치동)",
    "lat": "37.4995573",
    "lng": "127.0639286",
    "phoneNumber": "02-554-1231",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1707,
    "name": "구반포진선생어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 신반포로3길 8 , 321 401, 418 508 614 615 618호 (반포동, 반포프라자)",
    "lat": "37.5021153",
    "lng": "126.9869086",
    "phoneNumber": "02-591-7397",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1708,
    "name": "시대인재브릿지관부엉이라이브러리3독서실",
    "학원종류": "평생직업교육학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 도곡로 503 , 6층 (대치동, EYE PLUS 빌딩)",
    "lat": "37.4993869",
    "lng": "127.061403",
    "phoneNumber": "02-558-1061",
    "교습과정": "독서실(일반인)",
    "isFinish": ""
  },
  {
    "number": 1709,
    "name": "마루국어압구정학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로 162 , 203호,204호 (신사동)",
    "lat": "37.5262974",
    "lng": "127.0274473",
    "phoneNumber": "02-515-0020",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1710,
    "name": "시대인재브릿지관부엉이라이브러리2독서실",
    "학원종류": "평생직업교육학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 도곡로 503 , 5층 (대치동)",
    "lat": "37.4993869",
    "lng": "127.061403",
    "phoneNumber": "02-558-1060",
    "교습과정": "독서실(일반인)",
    "isFinish": ""
  },
  {
    "number": 1711,
    "name": "영본어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 도곡로 532 , 4층 (대치동)",
    "lat": "37.4997795",
    "lng": "127.0645688",
    "phoneNumber": "02-565-6537",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1712,
    "name": "네온댄스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 강남대로 545-21 , 2층 (반포동, 거림빌딩)",
    "lat": "37.5101073",
    "lng": "127.0202507",
    "phoneNumber": "02-545-1029",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 1713,
    "name": "414자기주도학습(SDL)원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 개포로110길 15 , 2층 202호 (일원동, 우성7차아파트)",
    "lat": "37.4922926",
    "lng": "127.0783273",
    "phoneNumber": "020-000-0000",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1714,
    "name": "아이씨씨텍스타일디자인학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 논현로149길 65 , 202호,302호 (논현동)",
    "lat": "37.5166923",
    "lng": "127.0235229",
    "phoneNumber": "02-549-1220",
    "교습과정": "디자인",
    "isFinish": ""
  },
  {
    "number": 1715,
    "name": "더블유프렙어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 압구정로28길 22-5 , 5층 (신사동)",
    "lat": "37.5250123",
    "lng": "127.0271808",
    "phoneNumber": "070-4138-1229",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1716,
    "name": "띵크앤리드도곡영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로365길 39 , 3층 (도곡동)",
    "lat": "37.4880389",
    "lng": "127.0397773",
    "phoneNumber": "02-574-0577",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1717,
    "name": "씨게이트압구정어학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 압구정로18길 25 , 3층 및 4층 일부 (신사동)",
    "lat": "37.5235062",
    "lng": "127.0253026",
    "phoneNumber": "02-778-0509",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 1718,
    "name": "창의적열정교육연구소학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 325 , 301호 (역삼동)",
    "lat": "37.4985755",
    "lng": "127.0515528",
    "phoneNumber": "02-555-7907",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 1719,
    "name": "엔티비(NTB)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 개포로22길 32 , 2층(개포동)",
    "lat": "37.4769979",
    "lng": "127.0488545",
    "phoneNumber": "02-573-2124",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1720,
    "name": "시대인재수학스쿨별관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 434 , 2층 (대치동)",
    "lat": "37.4976364",
    "lng": "127.0579549",
    "phoneNumber": "02-552-2373",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 1721,
    "name": "대치잉글리쉬파크어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 영동대로 229 , 2~3층 (대치동)",
    "lat": "37.4995718",
    "lng": "127.0674703",
    "phoneNumber": "02-581-7082",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1722,
    "name": "평정수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 명달로 52-9 , 3층 (서초동)",
    "lat": "37.4823789",
    "lng": "127.0054578",
    "phoneNumber": "02-597-6998",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1723,
    "name": "대찬시대학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 432 , 6층일부 (대치동)",
    "lat": "37.4975707",
    "lng": "127.0577513",
    "phoneNumber": "02-554-5451",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1724,
    "name": "매그너스수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2911-1 , 2층 일부 (대치동)",
    "lat": "37.4927102",
    "lng": "127.0577477",
    "phoneNumber": "02-558-4808",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1725,
    "name": "블랙칸댄스학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 테헤란로14길 25 , 2층 (역삼동)",
    "lat": "37.4977702",
    "lng": "127.0340079",
    "phoneNumber": "02-000-0000",
    "교습과정": "댄스",
    "isFinish": ""
  },
  {
    "number": 1726,
    "name": "토즈스터디센터세곡독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 헌릉로569길 27 , 302호, 304호일부 (세곡동)",
    "lat": "37.466796",
    "lng": "127.09879",
    "phoneNumber": "02-445-4647",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1727,
    "name": "비바댄스스포츠학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 학동로4길 14 , 2층 (논현동)",
    "lat": "37.5105086",
    "lng": "127.0230432",
    "phoneNumber": "02-518-6969",
    "교습과정": "댄스",
    "isFinish": ""
  },
  {
    "number": 1728,
    "name": "숨마투스선릉학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로72길 8 , 4층 (대치동, 은성빌딩)",
    "lat": "37.500009",
    "lng": "127.0518623",
    "phoneNumber": "02-6929-2030",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1729,
    "name": "펀웨이어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 논현로63길 62 , 1층 전체(101호, 102호), 2층 일부(202호) (역삼동, 성원빌딩)",
    "lat": "37.4916059",
    "lng": "127.0359728",
    "phoneNumber": "02-556-7238",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1730,
    "name": "핀스피치면접학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 서초구 사임당로 175 , 3층301호일부(302호) (서초동, 갤럭시타워)",
    "lat": "37.4929461",
    "lng": "127.0286946",
    "phoneNumber": "02-420-1771",
    "교습과정": "화술",
    "isFinish": ""
  },
  {
    "number": 1731,
    "name": "에이비(ab)프렙영미유학미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 봉은사로4길 22 , 2층 (역삼동)",
    "lat": "37.5033813",
    "lng": "127.0263822",
    "phoneNumber": "02-1522-2052",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1732,
    "name": "케이씨아이중국어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로78길 22 , 상가동 제301호,302호 일부, 303호 일부(대치동, 대치삼성아파트)",
    "lat": "37.4963866",
    "lng": "127.058402",
    "phoneNumber": "02-555-0974",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1733,
    "name": "남선생과학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 510 , 3층4호 (대치동)",
    "lat": "37.4989119",
    "lng": "127.0619546",
    "phoneNumber": "02-565-1679",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1734,
    "name": "씨엠에스(CMS)서초영재관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로 18-4 , 2층 (반포동)",
    "lat": "37.5029862",
    "lng": "127.0101362",
    "phoneNumber": "02-595-1280",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1735,
    "name": "맨투맨권수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로365길 38 , 3층 (도곡동)",
    "lat": "37.4877892",
    "lng": "127.039948",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1736,
    "name": "페디아플러스방배학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배로 225 , 2층일부 (방배동)",
    "lat": "37.4931814",
    "lng": "126.9898381",
    "phoneNumber": "02-6341-1454",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1737,
    "name": "지스퀘어모델아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 언주로165길 9 , 1층 (신사동)",
    "lat": "37.5257722",
    "lng": "127.0323455",
    "phoneNumber": "02-547-2228",
    "교습과정": "모델",
    "isFinish": ""
  },
  {
    "number": 1738,
    "name": "윌로우잉글리쉬(Willow English)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 529 , 2층 (대치동)",
    "lat": "37.5040245",
    "lng": "127.0608626",
    "phoneNumber": "02-566-7071",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1739,
    "name": "에듀코치개별지도대치한티학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로64길 11-4 , 3층, 4층 (대치동)",
    "lat": "37.4982444",
    "lng": "127.0531917",
    "phoneNumber": "02-563-0201",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1740,
    "name": "에스엠프리메드센터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 역삼로 464-1 , 2층,3층 (대치동)",
    "lat": "37.5025741",
    "lng": "127.0582523",
    "phoneNumber": "02-566-7119",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1741,
    "name": "청담뷰티학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 선릉로162길 11 , 청담동 (청담동)",
    "lat": "37.5224255",
    "lng": "127.0468094",
    "phoneNumber": "02-6952-0708",
    "교습과정": "이·미용",
    "isFinish": ""
  },
  {
    "number": 1742,
    "name": "티앤엠(T&M)미술학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 테헤란로4길 29 . 3층(역삼동)",
    "lat": "37.4965879",
    "lng": "127.0305731",
    "phoneNumber": "02-000-0000",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1743,
    "name": "메타코드디자인미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 역삼로 408 , 1층전체(101호·102호·103호) (대치동)",
    "lat": "37.500657",
    "lng": "127.0519524",
    "phoneNumber": "02-508-2411",
    "교습과정": "미술",
    "isFinish": "완료"
  },
  {
    "number": 1744,
    "name": "천년의미소베이스캠프미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 서초구 효령로33길 23 2층(방배동)",
    "lat": "37.482364",
    "lng": "126.9976605",
    "phoneNumber": "02-522-9908",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1745,
    "name": "픽스아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 521 401호, 402호, 403호 (대치동)",
    "lat": "37.5000321",
    "lng": "127.0632277",
    "phoneNumber": "02-3454-0492",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1746,
    "name": "네이처탐구전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 177 , 29호일부,30호,31호일부,33~37호(3층) (잠원동)",
    "lat": "37.5061225",
    "lng": "127.0036962",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1747,
    "name": "오피아학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 강남대로55길 9-11 , 7층 (서초동)",
    "lat": "37.4950853",
    "lng": "127.0277384",
    "phoneNumber": "02-582-0558",
    "교습과정": "통역(성인)",
    "isFinish": ""
  },
  {
    "number": 1748,
    "name": "사관등용문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 516 , 306호 일부 및 307호 전체 (대치동)",
    "lat": "37.4992034",
    "lng": "127.0630995",
    "phoneNumber": "02-552-7441",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1749,
    "name": "강남뷰티미(美)아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 선릉로89길 7 , 3층 (역삼동)",
    "lat": "37.5034406",
    "lng": "127.0487801",
    "phoneNumber": "02-558-3379",
    "교습과정": "이·미용",
    "isFinish": ""
  },
  {
    "number": 1750,
    "name": "오르비바이(by)매시브내신관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 삼성로61길 15 , 2,3층 (대치동, 킴스타워)",
    "lat": "37.499055",
    "lng": "127.0591369",
    "phoneNumber": "02-522-0207",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1751,
    "name": "탑리딩영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2941 , 601호 (대치동, 대치탑프라자)",
    "lat": "37.4942268",
    "lng": "127.0617852",
    "phoneNumber": "02-569-6572",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1752,
    "name": "인트로만화학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 선릉로72길 8 3층(대치동)",
    "lat": "37.500009",
    "lng": "127.0518623",
    "phoneNumber": "02-556-0920",
    "교습과정": "만화",
    "isFinish": "완료"
  },
  {
    "number": 1753,
    "name": "함영원명품수학관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2937 , 2층 (대치동)",
    "lat": "37.4941325",
    "lng": "127.0615797",
    "phoneNumber": "02-501-5702",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1754,
    "name": "시대인재농협관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 233 , 3층일부(308호, 309호, 310호) (대치동, 신사빌딩)",
    "lat": "37.4977699",
    "lng": "127.0606416",
    "phoneNumber": "02-569-1106",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1755,
    "name": "오면꽃예술학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 강남대로92길 13 , 6층일부 (역삼동, Jerry''s planet Building)",
    "lat": "37.4989916",
    "lng": "127.0285788",
    "phoneNumber": "02-558-8640",
    "교습과정": "공예(종이접기,꽃꽂이,꽃기예)",
    "isFinish": ""
  },
  {
    "number": 1756,
    "name": "아워스터디(OUR STUDY)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 510 , 2층 4호 및 5호 (대치동)",
    "lat": "37.4989119",
    "lng": "127.0619546",
    "phoneNumber": "02-557-0987",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1757,
    "name": "서울뮤직센터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 논현로149길 63 , 2층 (논현동)",
    "lat": "37.5167621",
    "lng": "127.0236449",
    "phoneNumber": "02-512-1077",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1758,
    "name": "하비스트학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 강남대로53길 7 , 애니타워 1401호 (서초동)",
    "lat": "37.494251",
    "lng": "127.0282336",
    "phoneNumber": "02-6242-2421",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1759,
    "name": "칸미디어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 바우뫼로 179 , 2층 201호, 5층 501호 (양재동)",
    "lat": "37.4786577",
    "lng": "127.0395887",
    "phoneNumber": "-",
    "교습과정": "전자상거래",
    "isFinish": ""
  },
  {
    "number": 1760,
    "name": "봄온아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 강남대로 584 , 3층 일부 (논현동)",
    "lat": "37.513958",
    "lng": "127.0206632",
    "phoneNumber": "02-706-5144",
    "교습과정": "방송",
    "isFinish": ""
  },
  {
    "number": 1761,
    "name": "톤연기학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 강남대로95길 40 , 2층전체, 3층302호 (잠원동, 광운빌딩)",
    "lat": "37.5134264",
    "lng": "127.0177701",
    "phoneNumber": "02-517-5600",
    "교습과정": "연극",
    "isFinish": ""
  },
  {
    "number": 1762,
    "name": "아트멘토유학미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 서초구 반포대로 287 , 404호 (반포동, 래미안퍼스티지 중심상가)",
    "lat": "37.5044951",
    "lng": "127.0007548",
    "phoneNumber": "02-000-0000",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1763,
    "name": "포커스영화학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 강남대로43길 15 , 3층 (서초동)",
    "lat": "37.4873888",
    "lng": "127.0315128",
    "phoneNumber": "070-7746-9090",
    "교습과정": "연극",
    "isFinish": ""
  },
  {
    "number": 1764,
    "name": "아이비프랩(IB PREP)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로34길 34 , 4층 (신사동)",
    "lat": "37.5258633",
    "lng": "127.0304942",
    "phoneNumber": "02-514-8082",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1765,
    "name": "강남르몽드어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 강남대로94길 21 , 3층 일부 (역삼동)",
    "lat": "37.499745",
    "lng": "127.0289618",
    "phoneNumber": "02-554-8279",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 1766,
    "name": "반앤반어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 압구정로 226 , 4층 (신사동)",
    "lat": "37.528661",
    "lng": "127.0325542",
    "phoneNumber": "02-512-2133",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1767,
    "name": "이지국어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로66길 9 , 3층 (대치동)",
    "lat": "37.4986482",
    "lng": "127.0527102",
    "phoneNumber": "02-563-3199",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1768,
    "name": "위대한학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 501 , B102호 일부, B103호 전부 (대치동, SM TOWER)",
    "lat": "37.4993898",
    "lng": "127.061127",
    "phoneNumber": "02-577-7959",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1769,
    "name": "브릭스(Brix)어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 압구정로30길 17 7층 702호 703호 (신사동)",
    "lat": "37.5263249",
    "lng": "127.0295435",
    "phoneNumber": "02-3444-9861",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1770,
    "name": "코듀크리에이티브반포센터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 동광로 9 , 2층 전체 (방배동)",
    "lat": "37.4910429",
    "lng": "126.9840457",
    "phoneNumber": "02-533-4316",
    "교습과정": "컴퓨터(소)",
    "isFinish": ""
  },
  {
    "number": 1771,
    "name": "카타르시스연기학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 신반포로47길 19 , 2층,3층 (잠원동, 태영빌딩)",
    "lat": "37.5115132",
    "lng": "127.0191718",
    "phoneNumber": "02-511-6663",
    "교습과정": "연극",
    "isFinish": ""
  },
  {
    "number": 1772,
    "name": "메리메리아트인스티튜트학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 압구정로42길 32 , 5층 (신사동)",
    "lat": "37.5268048",
    "lng": "127.0347295",
    "phoneNumber": "02-564-7779",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1773,
    "name": "서초어반트리독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 서초구 서운로 220 , 대치프라자5층 (서초동)",
    "lat": "37.5027349",
    "lng": "127.0217858",
    "phoneNumber": "02-0000-0000",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1774,
    "name": "스토리봄원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 578 , 7층 733호 (삼성동)",
    "lat": "37.5100827",
    "lng": "127.0441707",
    "phoneNumber": "02-554-1998",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1775,
    "name": "프린스턴리뷰학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 압구정로 208 , 3층 일부 (신사동, 본경빌딩)",
    "lat": "37.527596",
    "lng": "127.0298545",
    "phoneNumber": "02-6954-1601",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1776,
    "name": "스카이입시교육학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 341 5층 501호(대치동)",
    "lat": "37.4895698",
    "lng": "127.0571597",
    "phoneNumber": "02-508-6172",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1777,
    "name": "알파관하이원학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2941 , 403호 (대치동)",
    "lat": "37.4942268",
    "lng": "127.0617852",
    "phoneNumber": "02-552-1930",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1778,
    "name": "키(KEY)과학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 213 , 반포쇼핑타운7동 202호,521호 (잠원동)",
    "lat": "37.5072627",
    "lng": "127.0071911",
    "phoneNumber": "02-595-3660",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1779,
    "name": "압구정국어논술2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 논현로168길 20 , 3~4층 (신사동)",
    "lat": "37.5237245",
    "lng": "127.0298696",
    "phoneNumber": "02-3444-1776",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1780,
    "name": "스파크수학과학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 414 , 3층 전체 (대치동)",
    "lat": "37.500885",
    "lng": "127.0524706",
    "phoneNumber": "02-511-4865",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 1781,
    "name": "오르다샘앤클래스역삼점학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 언주로 337 , 동영문화센터 3층 (역삼동)",
    "lat": "37.497839",
    "lng": "127.0442979",
    "phoneNumber": "02-566-6716",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 1782,
    "name": "플러스아츠학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 언주로157길 13 , 2층 (신사동)",
    "lat": "37.5237814",
    "lng": "127.0317536",
    "phoneNumber": "02-544-7930",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1783,
    "name": "닥터매쓰바른학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서운로 207 , 205호, 213호, 214호 (서초동)",
    "lat": "37.5014855",
    "lng": "127.0216975",
    "phoneNumber": "02-555-2224",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1784,
    "name": "규연수학전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 212 , 3층301-6호 (대치동,은마아파트상가)",
    "lat": "37.495511",
    "lng": "127.0637579",
    "phoneNumber": "02-2051-7776",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1785,
    "name": "그레이드원대치10관수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 184 , 401호 (도곡동)",
    "lat": "37.4879814",
    "lng": "127.0453988",
    "phoneNumber": "02-573-3303",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1786,
    "name": "발레앤코강남서초학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 서초구 방배로 202 , 4층 (방배동)",
    "lat": "37.4915559",
    "lng": "126.9915951",
    "phoneNumber": "02-533-0317",
    "교습과정": "무용(전통무용,현대무용)",
    "isFinish": ""
  },
  {
    "number": 1787,
    "name": "아임프롬보컬학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 서초구 강남대로101안길 17 , 301호일부,305호 (잠원동)",
    "lat": "37.5161042",
    "lng": "127.0178105",
    "phoneNumber": "070-7761-6629",
    "교습과정": "실용음악(성악)",
    "isFinish": ""
  },
  {
    "number": 1788,
    "name": "스토리에듀케이션학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 사임당로 50 , 2층(서초동)",
    "lat": "37.4883834",
    "lng": "127.015559",
    "phoneNumber": "02-591-7263",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1789,
    "name": "코리아제2캠퍼스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 강남대로55길 9-11 , 5층 (서초동, 시원빌딩)",
    "lat": "37.4950853",
    "lng": "127.0277384",
    "phoneNumber": "02-3486-0089",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 1790,
    "name": "시대인재신관부엉이라이브러리3독서실",
    "학원종류": "평생직업교육학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 삼성로51길 11 , 5층전체 (대치동)",
    "lat": "37.496256",
    "lng": "127.060622",
    "phoneNumber": "02-538-2321",
    "교습과정": "독서실(일반인)",
    "isFinish": ""
  },
  {
    "number": 1791,
    "name": "개념폴리아서초2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로33길 6-6 , 1층 (반포동)",
    "lat": "37.5017832",
    "lng": "127.0111446",
    "phoneNumber": "02-595-4808",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1792,
    "name": "현상훈수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로63길 9 , 3층, 4층 (대치동)",
    "lat": "37.4997715",
    "lng": "127.0593678",
    "phoneNumber": "02-3452-3338",
    "교습과정": "입시·논술",
    "isFinish": ""
  },
  {
    "number": 1793,
    "name": "윤앤고입시컨설팅학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로64길 4 102호, 202호, 203호(대치동)",
    "lat": "37.5007735",
    "lng": "127.0526709",
    "phoneNumber": "02-556-0510",
    "교습과정": "진학상담지도",
    "isFinish": "완료"
  },
  {
    "number": 1794,
    "name": "아이원이앤엠학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 서초대로34가길 6 , 2층 (방배동)",
    "lat": "37.4882421999999",
    "lng": "126.9982699",
    "phoneNumber": "02-2055-1830",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 1795,
    "name": "플랜에이프리미엄독서실",
    "학원종류": "평생직업교육학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 서초구 서초중앙로24길 20 , 3층 (서초동)",
    "lat": "37.4947434",
    "lng": "127.0156886",
    "phoneNumber": "02-3143-0909",
    "교습과정": "독서실(일반인)",
    "isFinish": ""
  },
  {
    "number": 1796,
    "name": "에듀코치개별지도서초2학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 남부순환로315길 104 , 3층일부 (서초동)",
    "lat": "37.4830805",
    "lng": "127.0075157",
    "phoneNumber": "02-538-5147",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1797,
    "name": "반포파인만중등관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로31길 14-13 , 3층일부 (반포동)",
    "lat": "37.5007214",
    "lng": "127.010468",
    "phoneNumber": "02-537-7762",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1798,
    "name": "레슨포케이아트연극영화학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 강남대로95길 87 , 2층 일부(201호), 4층(잠원동)",
    "lat": "37.5116674",
    "lng": "127.0161672",
    "phoneNumber": "02-511-3488",
    "교습과정": "연극",
    "isFinish": ""
  },
  {
    "number": 1799,
    "name": "예중예고예인학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 선릉로 414 , 6층 (대치동)",
    "lat": "37.5018819",
    "lng": "127.0504984",
    "phoneNumber": "02-539-1225",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1800,
    "name": "대치메카2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 516 , 302~305호 (대치동)",
    "lat": "37.4992034",
    "lng": "127.0630995",
    "phoneNumber": "070-5168-9279",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1801,
    "name": "정연입시컨설팅학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 417 , 5층일부(502호) (대치동)",
    "lat": "37.5013862",
    "lng": "127.0526773",
    "phoneNumber": "02-501-7191",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 1802,
    "name": "아이씨유학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 464-2 , 3층 (대치동)",
    "lat": "37.5025331999999",
    "lng": "127.0580578",
    "phoneNumber": "02-565-0255",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1803,
    "name": "반포파인만고등2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 반포대로 304 202호(잠원동)",
    "lat": "37.5061614",
    "lng": "127.0010832",
    "phoneNumber": "02-548-1755",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1804,
    "name": "북스토리학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로33길 14 , 5층 1호 (반포동)",
    "lat": "37.5010747",
    "lng": "127.0106354",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1805,
    "name": "엠원학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 남부순환로315길 100 , 4층 (서초동, 대광빌딩)",
    "lat": "37.4829183",
    "lng": "127.0075349",
    "phoneNumber": "02-522-4862",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1806,
    "name": "레히연기로드학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 방배천로16길 17 , 3층 (방배동)",
    "lat": "37.4822831",
    "lng": "126.9837306",
    "phoneNumber": "02-525-2951",
    "교습과정": "연극",
    "isFinish": ""
  },
  {
    "number": 1807,
    "name": "비움앤채움뷰티아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 논현로168길 32 , 유니드빌딩 6층 (신사동)",
    "lat": "37.52332",
    "lng": "127.0306953",
    "phoneNumber": "02-515-1288",
    "교습과정": "이·미용",
    "isFinish": ""
  },
  {
    "number": 1808,
    "name": "조은모수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 444 , 402호 (대치동)",
    "lat": "37.501894",
    "lng": "127.055663",
    "phoneNumber": "02-568-6827",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 1809,
    "name": "라플라스챌린지관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 학동로56길 35 , 2층 (삼성동)",
    "lat": "37.5149378",
    "lng": "127.0431834",
    "phoneNumber": "02-546-1006",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1810,
    "name": "런스팀로봇코딩학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 삼성로 155 , 301호 (대치동)",
    "lat": "37.4938284",
    "lng": "127.062941",
    "phoneNumber": "02-566-2013",
    "교습과정": "로봇",
    "isFinish": ""
  },
  {
    "number": 1811,
    "name": "해율국악학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 개포로22길 72 , 5층 일부(개포동)",
    "lat": "37.4748781",
    "lng": "127.0511031",
    "phoneNumber": "02-573-3745",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1812,
    "name": "메이크에이학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 논현로153길 24 , 끌레르빌1 201호 (신사동)",
    "lat": "37.521066",
    "lng": "127.0262024",
    "phoneNumber": "02-000-0000",
    "교습과정": "실용음악(성악)",
    "isFinish": ""
  },
  {
    "number": 1813,
    "name": "뷰티랩아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 서초구 강남대로 615 , 2층 (잠원동, 금정빌딩)",
    "lat": "37.5166298",
    "lng": "127.0189002",
    "phoneNumber": "02-6263-1415",
    "교습과정": "이·미용",
    "isFinish": ""
  },
  {
    "number": 1814,
    "name": "코모리치헤어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 논현로64길 17 , 나승빌딩 3층,5층 (역삼동)",
    "lat": "37.4937597",
    "lng": "127.0419644",
    "phoneNumber": "02-565-1041",
    "교습과정": "이·미용",
    "isFinish": ""
  },
  {
    "number": 1815,
    "name": "링구아엠영어전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로31길 14-9 , 103호 (반포동)",
    "lat": "37.5003655",
    "lng": "127.0104565",
    "phoneNumber": "02-593-0552",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1816,
    "name": "생각하는황소서초2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로10길 26 , 3층일부 (반포동)",
    "lat": "37.5006911",
    "lng": "127.0096776",
    "phoneNumber": "02-533-5496",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1817,
    "name": "소미아트서초센터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 서초구 서초중앙로33길 14 , 5층 3호 (반포동)",
    "lat": "37.5010747",
    "lng": "127.0106354",
    "phoneNumber": "02-6213-6100",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1818,
    "name": "광태수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 219 , 5층 505호,506호,507호,509호,510호,511호,512호 (잠원동, 반포쇼핑타운)",
    "lat": "37.5074568",
    "lng": "127.0078376",
    "phoneNumber": "02-595-3988",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1819,
    "name": "발레끌레망아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 헌릉로 569 , 6층606호 (세곡동,강남리더스프라자)",
    "lat": "37.4657816",
    "lng": "127.1011914",
    "phoneNumber": "02-445-8008",
    "교습과정": "무용",
    "isFinish": ""
  },
  {
    "number": 1820,
    "name": "더끌림미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 선릉로 414 , 2층 3층 (대치동)",
    "lat": "37.5018819",
    "lng": "127.0504984",
    "phoneNumber": "02-563-5787",
    "교습과정": "미술",
    "isFinish": "완료"
  },
  {
    "number": 1821,
    "name": "엘피(LP)보컬학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 강남대로98길 20 , 6층 (역삼동)",
    "lat": "37.5007728",
    "lng": "127.0282535",
    "phoneNumber": "02-2052-0150",
    "교습과정": "실용음악(성악)",
    "isFinish": ""
  },
  {
    "number": 1822,
    "name": "김영편입연고대전문관학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "인문사회(대)",
    "학원주소\t": "서울특별시 서초구 서초대로78길 48 , 9층전체 (서초동, 송림빌딩)",
    "lat": "37.4934302",
    "lng": "127.0285142",
    "phoneNumber": "02-522-1144",
    "교습과정": "대학편입",
    "isFinish": ""
  },
  {
    "number": 1823,
    "name": "생각하는두꺼비수학4관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 189 , 3층 12호, 13호(잠원동)",
    "lat": "37.506522",
    "lng": "127.005481",
    "phoneNumber": "02-599-7773",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1824,
    "name": "메인트레이닝센터학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 논현로97길 13-9 , 2층·3층 (역삼동)",
    "lat": "37.5027228",
    "lng": "127.0347442",
    "phoneNumber": "02-567-5454",
    "교습과정": "연기(연극,뮤지컬,오페라)",
    "isFinish": ""
  },
  {
    "number": 1825,
    "name": "압구정융합국어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 언주로167길 35 , 4층 (신사동)",
    "lat": "37.5263754",
    "lng": "127.0302672",
    "phoneNumber": "02-2039-6363",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1826,
    "name": "릴드당스발레학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 서초구 서초대로26길 19 , 201호,401호 (방배동, 브라운스톤방배)",
    "lat": "37.4868035",
    "lng": "126.9951266",
    "phoneNumber": "02-000-0000",
    "교습과정": "무용(전통무용,현대무용)",
    "isFinish": ""
  },
  {
    "number": 1827,
    "name": "에스(S)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 반포대로 300 , 6층 일부 (잠원동)",
    "lat": "37.505956",
    "lng": "127.0011819",
    "phoneNumber": "02-566-7428",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1828,
    "name": "코프디자인플로리스트학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 서초구 강남대로18길 5 , 4층 (양재동)",
    "lat": "37.4720668",
    "lng": "127.0391487",
    "phoneNumber": "02-529-1551",
    "교습과정": "공예(종이접기,꽃꽂이,꽃기예)",
    "isFinish": ""
  },
  {
    "number": 1829,
    "name": "최우식과학전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로3길 8 , 4층일부 411호,412호 (반포동, 반포프라자)",
    "lat": "37.5021153",
    "lng": "126.9869086",
    "phoneNumber": "02-534-9873",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1830,
    "name": "그린램프라이브러리서초캠퍼스독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 서초구 효령로 190 , 4층 일부 (서초동)",
    "lat": "37.4825607",
    "lng": "127.0050443",
    "phoneNumber": "02-521-5911",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1831,
    "name": "비이케이프렙에이(BEK PREP-A)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 역삼로 244 , 1층일부(101호)2층전체3층일부(301호~305호)4층전체5층전체 (역삼동, 더 브리티시 프렙)",
    "lat": "37.4974218",
    "lng": "127.0430621",
    "phoneNumber": "02-6335-5339",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1832,
    "name": "방배맑은숲국어논술전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 효령로 229 , 304호 (서초동)",
    "lat": "37.4838885",
    "lng": "127.0089812",
    "phoneNumber": "02-3477-4240",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1833,
    "name": "에임과학(AimSCIENCE)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로 140 3층 302호, 4층 전체(신사동)",
    "lat": "37.524637",
    "lng": "127.0239957",
    "phoneNumber": "02-6365-0352",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1834,
    "name": "효성수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 313 , 4층 (대치동)",
    "lat": "37.4998263",
    "lng": "127.0600673",
    "phoneNumber": "02-556-7004",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1835,
    "name": "라듀원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 테헤란로 134 , 1701호 (역삼동)",
    "lat": "37.4994355",
    "lng": "127.0335909",
    "phoneNumber": "02-2015-7700",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1836,
    "name": "아트포스유학미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 선릉로86길 7 , 3층 일부 (대치동)",
    "lat": "37.503303",
    "lng": "127.0503179",
    "phoneNumber": "02-3444-6070",
    "교습과정": "미술",
    "isFinish": "완료"
  },
  {
    "number": 1837,
    "name": "네오캣(NEO CAT)미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 선릉로 422 , 5층일부 (대치동)",
    "lat": "37.502693",
    "lng": "127.0501749",
    "phoneNumber": "02-558-3301",
    "교습과정": "미술",
    "isFinish": "완료"
  },
  {
    "number": 1838,
    "name": "더킹고등수학전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 415 , 2층일부 (대치동)",
    "lat": "37.501434",
    "lng": "127.052328",
    "phoneNumber": "02-554-3927",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1839,
    "name": "에스비에스(SBS)아카데미컴퓨터아트강남2캠퍼스학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 서초구 서초대로77길 3 , 604호일부, 605~609호 (서초동)",
    "lat": "37.4979437",
    "lng": "127.0265374",
    "phoneNumber": "02-530-8555",
    "교습과정": "컴퓨터(정보처리,통신기기,인터넷,소프트웨어)",
    "isFinish": ""
  },
  {
    "number": 1840,
    "name": "포이어아카데미문화예술학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 서초구 동광로19길 15 , 3층 (방배동)",
    "lat": "37.4930984999999",
    "lng": "126.9891351",
    "phoneNumber": "02-533-2141",
    "교습과정": "무용(전통무용,현대무용)",
    "isFinish": ""
  },
  {
    "number": 1841,
    "name": "수학에미친사람들방배관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동광로 11 , 3층,4층 (방배동)",
    "lat": "37.4910468",
    "lng": "126.9841925",
    "phoneNumber": "02-3477-0043",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1842,
    "name": "필즈더클래식학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로99길 16 , 2층 전체 (대치동)",
    "lat": "37.5018594",
    "lng": "127.0660032",
    "phoneNumber": "02-566-7853",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1843,
    "name": "인그라피학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 강남대로122길 41 , 2층 (논현동)",
    "lat": "37.5088267",
    "lng": "127.0262678",
    "phoneNumber": "02-3462-5420",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1844,
    "name": "제이디엠영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 반포대로 287 , 402호 (반포동)",
    "lat": "37.5043394",
    "lng": "127.0008523",
    "phoneNumber": "02-592-7101",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1845,
    "name": "뮤닥터댄스학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 강남대로94길 70 , 4층 (역삼동)",
    "lat": "37.5006547",
    "lng": "127.0328462",
    "phoneNumber": "02-1661-4369",
    "교습과정": "댄스",
    "isFinish": ""
  },
  {
    "number": 1846,
    "name": "수학을삼키다2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동광로 1 , 2층 (방배동)",
    "lat": "37.4910721",
    "lng": "126.9830254",
    "phoneNumber": "02-532-0608",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1847,
    "name": "서초네이처학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 태봉로2길 60 , 상가동 201호,202호 (우면동, 서초네이처힐3단지)",
    "lat": "37.4640807",
    "lng": "127.0276936",
    "phoneNumber": "02-529-6060",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1848,
    "name": "하이퍼리뷰학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로68길 18 , 3층, 4층 (대치동)",
    "lat": "37.4991658",
    "lng": "127.0532032",
    "phoneNumber": "02-562-5315",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 1849,
    "name": "대치파인만고등2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 212 , A동 315-1호,315-2호 (대치동, 은마아파트)",
    "lat": "37.4974176",
    "lng": "127.0653272",
    "phoneNumber": "02-563-6880",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1850,
    "name": "띵킹(Think-Eng)어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 선릉로64길 15-8 , 2층, 4층, 5층(대치동)",
    "lat": "37.4986023",
    "lng": "127.0534792",
    "phoneNumber": "02-558-3179",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1851,
    "name": "기파랑문해원대치원글쓰기센터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로64길 18 , 3층 (대치동)",
    "lat": "37.4979058",
    "lng": "127.0537428",
    "phoneNumber": "02-564-0101",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1852,
    "name": "아트브루학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 논현로 409 , 301호 (역삼동)",
    "lat": "37.4965134",
    "lng": "127.0385722",
    "phoneNumber": "02-2052-3412",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1853,
    "name": "골든캠퍼스학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 서초구 사임당로17길 60 , 1층 (서초동)",
    "lat": "37.4917781",
    "lng": "127.0170827",
    "phoneNumber": "02-6242-5000",
    "교습과정": "부동산",
    "isFinish": ""
  },
  {
    "number": 1854,
    "name": "릴리프아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 봉은사로37길 28 , 4층 (논현동)",
    "lat": "37.5100534",
    "lng": "127.0359577",
    "phoneNumber": "02-511-2340",
    "교습과정": "연극",
    "isFinish": ""
  },
  {
    "number": 1855,
    "name": "제니영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동산로 60 , 3층 (양재동)",
    "lat": "37.4716809",
    "lng": "127.0454469",
    "phoneNumber": "02-6052-4460",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1856,
    "name": "반포서래보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 사평대로26길 38 , 302호 (반포동)",
    "lat": "37.4985056",
    "lng": "126.9989223",
    "phoneNumber": "02-594-1325",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1857,
    "name": "학고재학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로63길 32 , 1층,2층전체 (대치동, 원탑빌딩)",
    "lat": "37.4990112",
    "lng": "127.0538263",
    "phoneNumber": "02-552-0551",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1858,
    "name": "딱이만큼영어연구소학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 언주로 514 , 4층 (역삼동)",
    "lat": "37.5046496",
    "lng": "127.0422031",
    "phoneNumber": "02-538-0711",
    "교습과정": "통역(성인)",
    "isFinish": ""
  },
  {
    "number": 1859,
    "name": "디랩코딩학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 영동대로 229 , 6층 (대치동)",
    "lat": "37.4995718",
    "lng": "127.0674703",
    "phoneNumber": "02-2088-1901",
    "교습과정": "소프트웨어",
    "isFinish": ""
  },
  {
    "number": 1860,
    "name": "파머스영어학원웰라캠퍼스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동광로 56-12 , 2층 (방배동)",
    "lat": "37.4916176",
    "lng": "126.9890101",
    "phoneNumber": "02-599-1939",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1861,
    "name": "강남리더스중고등학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 헌릉로 569 , 602호 (세곡동)",
    "lat": "37.4657816",
    "lng": "127.1011914",
    "phoneNumber": "02-459-1114",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1862,
    "name": "생각이크는수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로77길 8 , 1~3층(대치동)",
    "lat": "37.5030791",
    "lng": "127.0565483",
    "phoneNumber": "02-554-1977",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1863,
    "name": "선릉위드피아노학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 삼성로91길 36 , 9층 (삼성동)",
    "lat": "37.5065817",
    "lng": "127.0533547",
    "phoneNumber": "-",
    "교습과정": "실용음악(성악)",
    "isFinish": ""
  },
  {
    "number": 1864,
    "name": "서초더(THE)강한학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로 209 , 7층 2호 (반포동)",
    "lat": "37.5003122",
    "lng": "127.0117761",
    "phoneNumber": "02-595-1400",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1865,
    "name": "깊은생각엠로고스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 321 , 3층 및 4층 (대치동)",
    "lat": "37.500479",
    "lng": "127.0596904",
    "phoneNumber": "02-565-0526",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1866,
    "name": "글로리수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로62길 32-2 , 2층 (대치동)",
    "lat": "37.49768",
    "lng": "127.0550939",
    "phoneNumber": "02-555-5536",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1867,
    "name": "크리에이티브랭귀지컨설팅어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 효령로33길 70 , 3층,4층 (방배동)",
    "lat": "37.4844171",
    "lng": "126.996571",
    "phoneNumber": "02-000-0000",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 1868,
    "name": "케이에스트레이닝센터연기학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 선릉로153길 8 , 3층 (신사동)",
    "lat": "37.5249689",
    "lng": "127.0388587",
    "phoneNumber": "02-6212-2468",
    "교습과정": "연극",
    "isFinish": ""
  },
  {
    "number": 1869,
    "name": "인마이제이독서실",
    "학원종류": "평생직업교육학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 강남대로94길 51-8 2층(역삼동)",
    "lat": "37.5008559",
    "lng": "127.0312957",
    "phoneNumber": "02-515-4641",
    "교습과정": "독서실(일반인)",
    "isFinish": ""
  },
  {
    "number": 1870,
    "name": "쏜교육컨설팅원격교습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 학동로2길 19 , 2층 A2115호 (논현동)",
    "lat": "37.510146",
    "lng": "127.0229181",
    "phoneNumber": "02-000-0000",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 1871,
    "name": "서초지니엠국어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로33길 8 , 3층 전체 (반포동)",
    "lat": "37.5013204",
    "lng": "127.0110911",
    "phoneNumber": "02-535-2148",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1872,
    "name": "프리픽스댄스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 논현로 745 , 3층 (논현동)",
    "lat": "37.5183157",
    "lng": "127.02839",
    "phoneNumber": "02-518-1470",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 1873,
    "name": "수분과열미용학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 서초구 강남대로83길 34 , 2층일부 (반포동)",
    "lat": "37.5058675999999",
    "lng": "127.0217603",
    "phoneNumber": "02-2068-4886",
    "교습과정": "이·미용",
    "isFinish": ""
  },
  {
    "number": 1874,
    "name": "일등공신원격교습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 테헤란로 521 , 29층 36호 (삼성동, 파르나스타워)",
    "lat": "37.5100567",
    "lng": "127.0613285",
    "phoneNumber": "02-512-7000",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 1875,
    "name": "생각하는황소서초학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로10길 26 , 3층일부 (반포동)",
    "lat": "37.5006911",
    "lng": "127.0096776",
    "phoneNumber": "02-558-5496",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1876,
    "name": "알티씨에듀(RTC Edu)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로10길 5 , 601호 (반포동)",
    "lat": "37.5021117",
    "lng": "127.0109189",
    "phoneNumber": "02-536-5632",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1877,
    "name": "이루다스피치온라인강의학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 서초중앙로 48 , 2층 일부 (서초동)",
    "lat": "37.4862658",
    "lng": "127.0158287",
    "phoneNumber": "02-6959-2923",
    "교습과정": "화술",
    "isFinish": ""
  },
  {
    "number": 1878,
    "name": "대치리드인유주코칭국어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로93길 9 , 3층 (대치동)",
    "lat": "37.5008373",
    "lng": "127.0645016",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1879,
    "name": "르네드뮤제학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 서초구 사평대로45길 10-25 , 404호 (반포동, 베리타스타운)",
    "lat": "37.5066782",
    "lng": "127.013939",
    "phoneNumber": "02-537-4568",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1880,
    "name": "공부하는날학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 자곡로 114 , 403호,404호 (자곡동)",
    "lat": "37.4720223",
    "lng": "127.0960065",
    "phoneNumber": "02-3414-6003",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1881,
    "name": "솔데스크강남학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 봉은사로 119 , 4층전체,5층일부 (논현동, 성옥빌딩)",
    "lat": "37.5054446",
    "lng": "127.0266779",
    "phoneNumber": "022-1383-370",
    "교습과정": "컴퓨터(정보처리,통신기기,인터넷,소프트웨어)",
    "isFinish": ""
  },
  {
    "number": 1882,
    "name": "모듈러(Modular)학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 강남대로160길 26 , 2층 (신사동)",
    "lat": "37.5197062",
    "lng": "127.0209116",
    "phoneNumber": "02-6406-8902",
    "교습과정": "디자인",
    "isFinish": ""
  },
  {
    "number": 1883,
    "name": "서초채움학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 태봉로 68 , 201호,202호 (우면동)",
    "lat": "37.4643318",
    "lng": "127.0253336",
    "phoneNumber": "02-572-0283",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1884,
    "name": "자곡가우스수학전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 자곡로 114 , 203호 (자곡동)",
    "lat": "37.4720223",
    "lng": "127.0960065",
    "phoneNumber": "02-3411-9100",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1885,
    "name": "뿌리수학영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 밤고개로 219 , 204호 (자곡동)",
    "lat": "37.4747226",
    "lng": "127.1070295",
    "phoneNumber": "02-445-9199",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1886,
    "name": "3옥타브장인보컬학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 서초구 서초대로78길 36 , 5층 501호(서초동)",
    "lat": "37.4947876",
    "lng": "127.0281223",
    "phoneNumber": "02-566-2848",
    "교습과정": "실용음악(성악)",
    "isFinish": ""
  },
  {
    "number": 1887,
    "name": "다른수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로112길 74 , 201호, 202호 (삼성동, 그라나다)",
    "lat": "37.5126259",
    "lng": "127.0496291",
    "phoneNumber": "02-3444-1230",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1888,
    "name": "메이킷코드랩학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 삼성로 155 , 501호 및 502호 (대치동)",
    "lat": "37.4901314",
    "lng": "127.0585502",
    "phoneNumber": "02-6243-5000",
    "교습과정": "컴퓨터(소)",
    "isFinish": ""
  },
  {
    "number": 1889,
    "name": "대훈학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로61길 18 , 3층 (대치동)",
    "lat": "37.4991996",
    "lng": "127.0589307",
    "phoneNumber": "02-569-7277",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1890,
    "name": "영탑보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로72길 13 , 2층 (대치동)",
    "lat": "37.5003784",
    "lng": "127.0522277",
    "phoneNumber": "02-068-0587",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 1891,
    "name": "다원교육고등학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 501 , 4층전체(401호·402호·403호·404호) (대치동, SM TOWER)",
    "lat": "37.4993898",
    "lng": "127.061127",
    "phoneNumber": "02-3454-1162",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1892,
    "name": "두각비전관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 438 , 3,4층 (대치동)",
    "lat": "37.4978146",
    "lng": "127.0584142",
    "phoneNumber": "02-556-2700",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1893,
    "name": "새움라이브러리독서실",
    "학원종류": "평생직업교육학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 도곡로 505 , 2층 (대치동)",
    "lat": "37.4995633",
    "lng": "127.0616676",
    "phoneNumber": "02-562-1063",
    "교습과정": "독서실(일반인)",
    "isFinish": ""
  },
  {
    "number": 1894,
    "name": "람아트학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 압구정로28길 22-9 , 3층,4층 (신사동)",
    "lat": "37.5250369",
    "lng": "127.0267791",
    "phoneNumber": "02-511-7370",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1895,
    "name": "하늘을나는그림책압구정학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 언주로 817 , 3층 및 4층 (신사동)",
    "lat": "37.5232001",
    "lng": "127.0328493",
    "phoneNumber": "02-514-9997",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 1896,
    "name": "수학의힘대치1본원학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 221 , 2층(대치동)",
    "lat": "37.4967029",
    "lng": "127.061731",
    "phoneNumber": "02-539-5439",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1897,
    "name": "리트머스미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 선릉로76길 30 , 2층 (대치동)",
    "lat": "37.5019153",
    "lng": "127.053055",
    "phoneNumber": "02-333-0669",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1898,
    "name": "네오캣(NEO CAT)디자인관미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 역삼로63길 5 , 2층 (대치동)",
    "lat": "37.5015024",
    "lng": "127.0522091",
    "phoneNumber": "02-556-7633",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1899,
    "name": "서일영수전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 바우뫼로7길 3 , 7층 전체 (우면동, 중평빌딩)",
    "lat": "37.4704918",
    "lng": "127.0250788",
    "phoneNumber": "02-529-0184",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 1900,
    "name": "한누네학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로115길 27 , 2층 (논현동)",
    "lat": "37.5116623",
    "lng": "127.04078",
    "phoneNumber": "02-6081-7004",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1901,
    "name": "지(Gi)독한수학(Math)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 개포로 252 , 3층 일부 (개포동, 진성빌딩)",
    "lat": "37.478922",
    "lng": "127.0500777",
    "phoneNumber": "02-579-1989",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1902,
    "name": "정인영어수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로 90-7 , 3층 1호 (서초동)",
    "lat": "37.4999482",
    "lng": "127.0174429",
    "phoneNumber": "02-596-9918",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1903,
    "name": "프랜시스파커어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 도곡로 528 , 1층~7층 (대치동)",
    "lat": "37.4950878",
    "lng": "127.0476626",
    "phoneNumber": "02-566-5020",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1904,
    "name": "서초라이즈어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 고무래로10길 26 , 2층 (반포동)",
    "lat": "37.5006911",
    "lng": "127.0096776",
    "phoneNumber": "02-3477-7473",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1905,
    "name": "잼코딩학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 선릉로64길 17 , 디앤비빌딩 501호 (대치동)",
    "lat": "37.4982437",
    "lng": "127.0536538",
    "phoneNumber": "02-6941-0563",
    "교습과정": "컴퓨터(소)",
    "isFinish": ""
  },
  {
    "number": 1906,
    "name": "김승국통역학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 테헤란로4길 38-4 , 4층일부 (역삼동)",
    "lat": "37.4959565",
    "lng": "127.0302668",
    "phoneNumber": "02-6941-0579",
    "교습과정": "통역(성인)",
    "isFinish": ""
  },
  {
    "number": 1907,
    "name": "투디제이(2DJ)댄스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 방배로37길 11 , 2층 (방배동)",
    "lat": "37.4935211",
    "lng": "126.9891467",
    "phoneNumber": "02-000-0000",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 1908,
    "name": "더원학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로71길 14 2층, 3층(대치동)",
    "lat": "37.5022183",
    "lng": "127.0577128",
    "phoneNumber": "02-508-5336",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1909,
    "name": "이피유(EP.U)영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로119길 29 , 2층 (삼성동)",
    "lat": "37.5154511",
    "lng": "127.0490909",
    "phoneNumber": "02-543-5059",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1910,
    "name": "에듀엠에스헤어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 언주로 631 , 1층 일부 (논현동)",
    "lat": "37.5128437",
    "lng": "127.0350644",
    "phoneNumber": "02-000-0000",
    "교습과정": "이·미용",
    "isFinish": ""
  },
  {
    "number": 1911,
    "name": "비엠지(BMG)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 219 , 205호 (잠원동)",
    "lat": "37.5074568",
    "lng": "127.0078376",
    "phoneNumber": "02-536-9777",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1912,
    "name": "부강독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 삼성로61길 32-1, 1층-2층 (대치동)",
    "lat": "37.4989328",
    "lng": "127.057655",
    "phoneNumber": "02-557-7815",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": "완료"
  },
  {
    "number": 1913,
    "name": "뉴이데아학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 520, 1층 (대치동, 무진빌딩)",
    "lat": "37.4994149",
    "lng": "127.0634446",
    "phoneNumber": "02-552-4555",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1914,
    "name": "런연기학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 봉은사로112길 27 , 3층일부 (삼성동)",
    "lat": "37.5131772",
    "lng": "127.0651014",
    "phoneNumber": "02-2039-7140",
    "교습과정": "연기(연극,뮤지컬,오페라)",
    "isFinish": ""
  },
  {
    "number": 1915,
    "name": "행꿈사아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 서초구 서초중앙로18길 43 , 2층 전체·3층 일부 (서초동)",
    "lat": "37.4916995",
    "lng": "127.0167151",
    "phoneNumber": "02-3471-8883",
    "교습과정": "경매",
    "isFinish": ""
  },
  {
    "number": 1916,
    "name": "프리픽스댄스2관학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 도산대로28길 16 , 3층 (논현동)",
    "lat": "37.5182362",
    "lng": "127.0281496",
    "phoneNumber": "02-518-1470",
    "교습과정": "댄스",
    "isFinish": ""
  },
  {
    "number": 1917,
    "name": "지앤와이(G&Y)미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 서초구 강남대로 188 , , 5층 (양재동, 화승빌딩)",
    "lat": "37.481367",
    "lng": "127.0378786",
    "phoneNumber": "02-5751-230",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1918,
    "name": "시대인재수학스쿨2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로58길 9 , , 2층 (대치동)",
    "lat": "37.498729",
    "lng": "127.0620103",
    "phoneNumber": "02-552-2373",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1919,
    "name": "아이비랩(IB LAB)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 언주로167길 36 , 1층전체·2층전체 (신사동, 압구정O.K빌딩)",
    "lat": "37.526616",
    "lng": "127.0303007",
    "phoneNumber": "02-3444-2677",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1920,
    "name": "한수연과학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배로37길 7 , 2층 (방배동)",
    "lat": "37.4935825",
    "lng": "126.9892965",
    "phoneNumber": "02-533-7466",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1921,
    "name": "오픈유어뮤직학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 서초구 바우뫼로 14 , , 3층 (우면동)",
    "lat": "37.4695426",
    "lng": "127.024882",
    "phoneNumber": "02-571-5680",
    "교습과정": "실용음악(성악)",
    "isFinish": ""
  },
  {
    "number": 1922,
    "name": "아이비프렙온라인강의학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 압구정로34길 34 , 4층 일부 (신사동)",
    "lat": "37.5258633",
    "lng": "127.0304942",
    "phoneNumber": "02-514-8082",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 1923,
    "name": "샤인댄스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 논현로175길 59-4 , 2층,3층 (신사동, 의봉빌딩)",
    "lat": "37.524061",
    "lng": "127.0241441",
    "phoneNumber": "02-3444-1253",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 1924,
    "name": "참즐거운독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 삼성로64길 41 , 203호 및 204호 (대치동)",
    "lat": "37.5010033999999",
    "lng": "127.063646",
    "phoneNumber": "02-000-0000",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1925,
    "name": "대치와송학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로69길 17 , 2층 201호 (대치동)",
    "lat": "37.5012775",
    "lng": "127.0578445",
    "phoneNumber": "02-568-0264",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1926,
    "name": "코스메틱앤스파트레이닝센터학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 압구정로72길 8 , 2층 일부 (청담동)",
    "lat": "37.5261288",
    "lng": "127.0450311",
    "phoneNumber": "02-561-5564",
    "교습과정": "이·미용",
    "isFinish": ""
  },
  {
    "number": 1927,
    "name": "국어의시작조미현학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 밤고개로 231 , 209호 일부 (율현동, 훼미리타운A동)",
    "lat": "37.4738184",
    "lng": "127.107303",
    "phoneNumber": "02-3411-5027",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1928,
    "name": "코어영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 청두곶길 55 , 2층 (방배동)",
    "lat": "37.4817116",
    "lng": "126.9853515",
    "phoneNumber": "02-6397-7007",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1929,
    "name": "플랫나인댄스학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 서초구 효령로34길 76 , 4층 402호 (방배동)",
    "lat": "37.4784777",
    "lng": "127.0009118",
    "phoneNumber": "02-000-0000",
    "교습과정": "댄스",
    "isFinish": ""
  },
  {
    "number": 1930,
    "name": "공터영어서초힐스센터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 중앙로 582 , 6층 602호,603호 (우면동)",
    "lat": "37.4588363",
    "lng": "127.0115926",
    "phoneNumber": "02-574-5505",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1931,
    "name": "헤리티지아트유학미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 압구정로42길 35 , 3층 (신사동)",
    "lat": "37.5266174",
    "lng": "127.0349408",
    "phoneNumber": "02-514-1116",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1932,
    "name": "브이에스랩컴퓨터아트학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 강남대로154길 39 , 3층 (신사동)",
    "lat": "37.5185723",
    "lng": "127.0221419",
    "phoneNumber": "02-555-3652",
    "교습과정": "컴퓨터(정보처리,통신기기,인터넷,소프트웨어)",
    "isFinish": ""
  },
  {
    "number": 1933,
    "name": "바른법률에이치알(HR)학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "인문사회(대)",
    "학원주소\t": "서울특별시 강남구 영동대로85길 9 , 4층(대치동)",
    "lat": "37.5070938",
    "lng": "127.0629096",
    "phoneNumber": "02-1588-6127",
    "교습과정": "성인고시",
    "isFinish": ""
  },
  {
    "number": 1934,
    "name": "선배스터디센터독서실",
    "학원종류": "평생직업교육학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 서초구 서초대로78길 52 , 5층 일부 (서초동, 강남역 인앤인)",
    "lat": "37.4932229",
    "lng": "127.0287364",
    "phoneNumber": "02-565-5010",
    "교습과정": "독서실(일반인)",
    "isFinish": ""
  },
  {
    "number": 1935,
    "name": "학고재독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 도곡로63길 32 , 3층·4층 전체 (대치동, 원탑빌딩)",
    "lat": "37.4990112",
    "lng": "127.0538263",
    "phoneNumber": "02-552-0551",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": "완료"
  },
  {
    "number": 1936,
    "name": "맘스에듀케어서초우솔캠퍼스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 양재대로2길 116-19 , 2층 203호 (우면동)",
    "lat": "37.4568719",
    "lng": "127.0159853",
    "phoneNumber": "02-6959-0515",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1937,
    "name": "더인에듀학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 봉은사로 121 , 5층 (논현동, 대종빌딩)",
    "lat": "37.5055215",
    "lng": "127.0268903",
    "phoneNumber": "02-3474-8415",
    "교습과정": "컴퓨터(정보처리,통신기기,인터넷,소프트웨어)",
    "isFinish": ""
  },
  {
    "number": 1938,
    "name": "박기호논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 415 3,4층 (대치동)",
    "lat": "37.4975647",
    "lng": "127.0560022",
    "phoneNumber": "02-562-6559",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 1939,
    "name": "다니엘랩학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 언주로172길 12 , 5층,복층 (신사동)",
    "lat": "37.527635",
    "lng": "127.0346697",
    "phoneNumber": "02-3444-0085",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1940,
    "name": "이비에스뷰티아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 서초구 동작대로 130 , 3층 (방배동)",
    "lat": "37.4880172",
    "lng": "126.9826344",
    "phoneNumber": "02-595-5300",
    "교습과정": "이·미용",
    "isFinish": ""
  },
  {
    "number": 1941,
    "name": "뮤엠영어폴리오국어논술대치캠퍼스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로74길 25 , 2층 (대치동)",
    "lat": "37.5001796",
    "lng": "127.0551957",
    "phoneNumber": "02-555-0904",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1942,
    "name": "대한논리독서논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로10길 27 , 302호 (반포동)",
    "lat": "37.5003314",
    "lng": "127.0101783",
    "phoneNumber": "02-595-8214",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1943,
    "name": "스터디브릭스입시관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 317 , 4층 (대치동, 우석빌딩)",
    "lat": "37.5001845",
    "lng": "127.0598429",
    "phoneNumber": "02-564-5166",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1944,
    "name": "더큰생각수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로 6-3 , 601호 (반포동, 삼공빌딩)",
    "lat": "37.5037609",
    "lng": "127.009859",
    "phoneNumber": "02-6953-0773",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1945,
    "name": "로얄클래식음악학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 강남대로120길 38 , 2층 (논현동)",
    "lat": "37.50761",
    "lng": "127.0264424",
    "phoneNumber": "02-549-2549",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1946,
    "name": "연세제타학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 자곡로 108 , 4층 403호 (자곡동)",
    "lat": "37.4719652",
    "lng": "127.0953764",
    "phoneNumber": "02-445-2246",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1947,
    "name": "엘브라운제2캠퍼스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로64길 46 , 3층 (대치동, 오송빌딩)",
    "lat": "37.5007554",
    "lng": "127.0642647",
    "phoneNumber": "02-593-0533",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1948,
    "name": "티스쿨학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "인문사회(대)",
    "학원주소\t": "서울특별시 강남구 도산대로19길 10 , 202호 (신사동, 현우빌딩)",
    "lat": "37.5194147",
    "lng": "127.0255123",
    "phoneNumber": "02-6384-3220",
    "교습과정": "경영",
    "isFinish": ""
  },
  {
    "number": 1949,
    "name": "권쌤쇼호스트학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 서초구 방배로23길 19 , 2층 (방배동)",
    "lat": "37.4861286",
    "lng": "126.9933275",
    "phoneNumber": "02-522-9223",
    "교습과정": "화술",
    "isFinish": ""
  },
  {
    "number": 1950,
    "name": "맥스러닝랩학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초대로53길 15 2층 전체(서초동)",
    "lat": "37.495548",
    "lng": "127.0146411",
    "phoneNumber": "02-532-0868",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1951,
    "name": "엔닷어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 고무래로 6-10 , 4층 일부 (반포동)",
    "lat": "37.5038822",
    "lng": "127.0091071",
    "phoneNumber": "02-000-0000",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1952,
    "name": "인스튜디오학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 강남대로152길 23 , 3층 301호 (신사동)",
    "lat": "37.5177075",
    "lng": "127.0212312",
    "phoneNumber": "02-508-7946",
    "교습과정": "디자인",
    "isFinish": ""
  },
  {
    "number": 1953,
    "name": "액터스웨이브연기아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 역삼로3길 11 , 신관3층 (역삼동)",
    "lat": "37.4942157",
    "lng": "127.0311672",
    "phoneNumber": "070-7862-1107",
    "교습과정": "연기(연극,뮤지컬,오페라)",
    "isFinish": ""
  },
  {
    "number": 1954,
    "name": "입사미미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 선릉로 565 , 2층 일부 (역삼동, 한국빌딩)",
    "lat": "37.5000995",
    "lng": "127.033466",
    "phoneNumber": "02-0333-1463",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1955,
    "name": "한국정보보호교육학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 강남구 남부순환로 2645 , 5층 501호 (도곡동, 한독빌딩)",
    "lat": "37.485604",
    "lng": "127.0391288",
    "phoneNumber": "02-921-1465",
    "교습과정": "컴퓨터(정보처리,통신기기,인터넷,소프트웨어)",
    "isFinish": ""
  },
  {
    "number": 1956,
    "name": "이투스ECI원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 남부순환로 2547 , 3층일부 A호 (서초동)",
    "lat": "37.4843054",
    "lng": "127.0290946",
    "phoneNumber": "02-414-9001",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1957,
    "name": "골든스트리트학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "인문사회(대)",
    "학원주소\t": "서울특별시 강남구 언주로81길 42 , 4층 일부 (역삼동)",
    "lat": "37.4995642",
    "lng": "127.0401285",
    "phoneNumber": "02-6952-0275",
    "교습과정": "경영",
    "isFinish": ""
  },
  {
    "number": 1958,
    "name": "발레앤모델(BALLET&MODEL)어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 강남대로 292 , 4층 일부 (도곡동, 뱅뱅빌딩)",
    "lat": "37.4893499",
    "lng": "127.0320995",
    "phoneNumber": "02-578-0509",
    "교습과정": "무용",
    "isFinish": ""
  },
  {
    "number": 1959,
    "name": "패스트캠퍼스강남학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 강남대로 364 , 10층 및 11층 (역삼동, 미왕빌딩)",
    "lat": "37.4955525",
    "lng": "127.0292924",
    "phoneNumber": "02-517-0648",
    "교습과정": "컴퓨터(정보처리,통신기기,인터넷,소프트웨어)",
    "isFinish": ""
  },
  {
    "number": 1960,
    "name": "이에프인터내셔널랭귀지캠퍼스코리아학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 언주로157길 11 1층~6층",
    "lat": "37.5237907",
    "lng": "127.031965",
    "phoneNumber": "02-6979-9699",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1961,
    "name": "잇올스파르타관리형프리미엄독서실",
    "학원종류": "평생직업교육학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 강남대로78길 12 , 5층,6층일부 (역삼동, 예미프레스티지)",
    "lat": "37.4948619",
    "lng": "127.0303579",
    "phoneNumber": "02-2039-0871",
    "교습과정": "독서실(일반인)",
    "isFinish": ""
  },
  {
    "number": 1962,
    "name": "잇올스파르타독학재수학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 강남대로78길 12 , 6층 일부 (역삼동, 예미프레스티지)",
    "lat": "37.4948619",
    "lng": "127.0303579",
    "phoneNumber": "02-2039-0871",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1963,
    "name": "윤도영본관3학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로61길 22 , 3층 (대치동)",
    "lat": "37.4991092",
    "lng": "127.058612",
    "phoneNumber": "02-6205-0909",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1964,
    "name": "시대인재특목센터2학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 329 , 2~3층 (대치동, 진선빌딩)",
    "lat": "37.5010216",
    "lng": "127.0594045",
    "phoneNumber": "02-565-2373",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1965,
    "name": "더매쓰Junior수학전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 양재대로2길 116-6 , 5층 501호 (우면동)",
    "lat": "37.4564765999999",
    "lng": "127.0154524",
    "phoneNumber": "02-579-5007",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1966,
    "name": "사당건축토목학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 서초구 방배천로8길 5 , 4층 (방배동, 대왕빌딩)",
    "lat": "37.4807745",
    "lng": "126.9829639",
    "phoneNumber": "02-6213-0700",
    "교습과정": "건축",
    "isFinish": ""
  },
  {
    "number": 1967,
    "name": "스카이미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 선릉로76길 26 ,3층 (대치동)",
    "lat": "37.5017991",
    "lng": "127.0526984",
    "phoneNumber": "02-539-0555",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1968,
    "name": "에이치에스학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 방배로 285 , 9층 (방배동, 한샘빌딩)",
    "lat": "37.4979204",
    "lng": "126.9866478",
    "phoneNumber": "070-4352-4237",
    "교습과정": "디자인",
    "isFinish": ""
  },
  {
    "number": 1969,
    "name": "그린섬프리어미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 선릉로 340 , 9층전체 (대치동, 대치 EM 프라자)",
    "lat": "37.5001553",
    "lng": "127.0513254",
    "phoneNumber": "02-501-6131",
    "교습과정": "미술",
    "isFinish": "완료"
  },
  {
    "number": 1970,
    "name": "리드윈학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초대로78길 36 , 8층 전체 (서초동, 강남지웰타워)",
    "lat": "37.4947876",
    "lng": "127.0281223",
    "phoneNumber": "02-6329-1018",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1971,
    "name": "사고력수학시매쓰학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 408 , 307호, 308호, 506호(대치동) (대치동, 디마크 빌딩)",
    "lat": "37.4966877",
    "lng": "127.0552639",
    "phoneNumber": "02-557-0815",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1972,
    "name": "제이프랩스쿨어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 역삼로 448 , 1층 (대치동, 황우거빌딩)",
    "lat": "37.5019986",
    "lng": "127.0562288",
    "phoneNumber": "02-6959-2040",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1973,
    "name": "이화엘음악학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 개포로22길 94 , 4층 (개포동)",
    "lat": "37.475177",
    "lng": "127.0529859",
    "phoneNumber": "-",
    "교습과정": "음악",
    "isFinish": ""
  },
  {
    "number": 1974,
    "name": "뉴턴지니어스센터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 사임당로 50 , 3층2호 (서초동)",
    "lat": "37.4883834",
    "lng": "127.015559",
    "phoneNumber": "02-525-1905",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1975,
    "name": "조민규영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로72길 64 , 401호 (대치동)",
    "lat": "37.5007902",
    "lng": "127.0633786",
    "phoneNumber": "02-558-0524",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1976,
    "name": "잉크(ink)미술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 역삼로 423 , 4층 (대치동, 화남빌딩)",
    "lat": "37.5015633999999",
    "lng": "127.0532216",
    "phoneNumber": "02-501-7265",
    "교습과정": "미술",
    "isFinish": "완료"
  },
  {
    "number": 1977,
    "name": "인생뮤직학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 논현로167길 19 , 2층 (신사동)",
    "lat": "37.5244905",
    "lng": "127.026487",
    "phoneNumber": "000-0000-0000",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1978,
    "name": "수학의미래학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로78길 18 , 3층 (대치동)",
    "lat": "37.501327",
    "lng": "127.0571143",
    "phoneNumber": "02-2039-7225",
    "교습과정": "보습",
    "isFinish": "완료"
  },
  {
    "number": 1979,
    "name": "휘실용음악학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 언주로168길 7 , 4층 (신사동)",
    "lat": "37.5265841999999",
    "lng": "127.0342204",
    "phoneNumber": "02-453-7750",
    "교습과정": "실용음악(성악)",
    "isFinish": ""
  },
  {
    "number": 1980,
    "name": "배우앤배움키즈센터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 사평대로57길 135 , 6층 (반포동, 우호빌딩)",
    "lat": "37.5098697",
    "lng": "127.0206348",
    "phoneNumber": "02-540-3988",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 1981,
    "name": "지필드(G-FIELD)영재교육학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 460-2 , 4층 (대치동)",
    "lat": "37.502404",
    "lng": "127.0576734",
    "phoneNumber": "02-3453-7772",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1982,
    "name": "시리우스감마학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 505 , 2층 (대치동)",
    "lat": "37.5034652999999",
    "lng": "127.0591428",
    "phoneNumber": "02-553-5202",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1983,
    "name": "맘끄취미미술학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "기예(대)",
    "학원주소\t": "서울특별시 강남구 삼성로86길 14 , 4층 (대치동)",
    "lat": "37.5057218",
    "lng": "127.0586286",
    "phoneNumber": "02-501-6070",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1984,
    "name": "리진교육학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 458 , 6층 601호 (대치동, 정일빌딩)",
    "lat": "37.4984543",
    "lng": "127.0604313",
    "phoneNumber": "02-2043-2999",
    "교습과정": "입시·논술",
    "isFinish": "완료"
  },
  {
    "number": 1985,
    "name": "칼라항공아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 서초구 사임당로 175 , 301호 (서초동, 갤럭시타워)",
    "lat": "37.4928947",
    "lng": "127.0287118",
    "phoneNumber": "02-584-2018",
    "교습과정": "항공승무원",
    "isFinish": ""
  },
  {
    "number": 1986,
    "name": "하우솔교육센터학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 서초구 남부순환로350길 8 , 2층(양재동)",
    "lat": "37.4841714",
    "lng": "127.0353282",
    "phoneNumber": "02-472-5002",
    "교습과정": "컴퓨터(정보처리,통신기기,인터넷,소프트웨어)",
    "isFinish": ""
  },
  {
    "number": 1987,
    "name": "수학이랑노는토끼(BPM)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 150 , 3층 319호일부 (대치동, 한보미도맨션)",
    "lat": "37.4933928",
    "lng": "127.0673501",
    "phoneNumber": "000-0000-0000",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1988,
    "name": "비연성장반포황지원국어논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 사평대로2길 20 , 2층 (방배동, 석탑빌딩)",
    "lat": "37.4977537",
    "lng": "126.9858553",
    "phoneNumber": "02-591-0907",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1989,
    "name": "너나들이국어논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 명달로 51 , 4층 (방배동, 부흥빌딩)",
    "lat": "37.4819435",
    "lng": "127.004645",
    "phoneNumber": "02-3487-2123",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1990,
    "name": "현문국어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로31길 6-3 , 10층 (반포동, 삼우빌딩)",
    "lat": "37.5000996",
    "lng": "127.0113176",
    "phoneNumber": "02-3478-6443",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1991,
    "name": "사만다아카데미학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 서초구 서초대로77길 15 , 3층 (서초동)",
    "lat": "37.4989899",
    "lng": "127.026209",
    "phoneNumber": "000-0000-0000",
    "교습과정": "이·미용",
    "isFinish": ""
  },
  {
    "number": 1992,
    "name": "대찬바론학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로57길 28 , 2층 전체 (대치동)",
    "lat": "37.4976861",
    "lng": "127.0587286",
    "phoneNumber": "02-539-1002",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1993,
    "name": "아이비더탑학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 강남대로94길 34 , 6층 (역삼동)",
    "lat": "37.4997536",
    "lng": "127.0300107",
    "phoneNumber": "070-4100-7221",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 1994,
    "name": "서초예음음악학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 서초중앙로33길 14 , 104-2호 (반포동)",
    "lat": "37.5010747",
    "lng": "127.0106354",
    "phoneNumber": "02-595-8095",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 1995,
    "name": "그레이드원학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 515 , 207호 (대치동, 한도산업사옥)",
    "lat": "37.4998352",
    "lng": "127.0626495",
    "phoneNumber": "02-539-0900",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 1996,
    "name": "비상에듀써밋학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 412 , 2층 (대치동)",
    "lat": "37.5017178",
    "lng": "127.0505772",
    "phoneNumber": "02-539-4199",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 1997,
    "name": "서울미술스튜디오학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "예능(대)",
    "학원주소\t": "서울특별시 강남구 도곡로 184 , 403호 (도곡동, 신호빌딩)",
    "lat": "37.4917395",
    "lng": "127.0396045",
    "phoneNumber": "02-578-1524",
    "교습과정": "미술",
    "isFinish": ""
  },
  {
    "number": 1998,
    "name": "마크영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 510 , 2층 3호 (대치동, 성창빌딩)",
    "lat": "37.4989119",
    "lng": "127.0619546",
    "phoneNumber": "02-501-0102",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 1999,
    "name": "이노블스대치영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2936 , 2층 202호, 3층 302호 (대치동)",
    "lat": "37.4926756",
    "lng": "127.0592123",
    "phoneNumber": "02-566-0579",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2826,
    "name": "씨이씨영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 나루터로 37 , 301호 전체 (잠원동, 신사쇼핑센터)",
    "lat": "37.5153948",
    "lng": "127.0141461",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2827,
    "name": "두각케이(K)관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 422 3층(대치동)",
    "lat": "37.4972615",
    "lng": "127.0567378",
    "phoneNumber": "02-556-2700",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2828,
    "name": "서초압구정국어논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로31길 6-3 , 1층 (반포동, 지지반포빌딩)",
    "lat": "37.5000996",
    "lng": "127.0113176",
    "phoneNumber": "02-591-9595",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2829,
    "name": "수수배학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로63길 27 , 2층 (대치동, 시온빌딩)",
    "lat": "37.4987844",
    "lng": "127.0535968",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2830,
    "name": "써밋잉글리시아카데미(Summit English Academy)2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로10길 12 , 4층 (반포동)",
    "lat": "37.5017462",
    "lng": "127.0103455",
    "phoneNumber": "02-599-1529",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2831,
    "name": "이루다방배어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 방배로31길 36 , 2층,3층 (방배동)",
    "lat": "37.4904969",
    "lng": "126.9895551",
    "phoneNumber": "02-6248-1500",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 2832,
    "name": "엘루시도어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 삼성로119길 8 , 1층 105호, 2층 201호 (삼성동, 강남대학교 청담 카이로스 빌딩)",
    "lat": "37.5162454",
    "lng": "127.0506339",
    "phoneNumber": "02-541-0979",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 2833,
    "name": "리베르타스스칼라스컬리지프랩학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 봉은사로69길 37 , 3층 2호 (삼성동, 부일빌딩)",
    "lat": "37.5142946",
    "lng": "127.0482743",
    "phoneNumber": "02-0000-0000",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 2835,
    "name": "빅토리영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초대로 30 , 201호, 401호 (방배동, 현진빌딩)",
    "lat": "37.4855468",
    "lng": "126.9857617",
    "phoneNumber": "02-588-0579",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 2837,
    "name": "해피클래스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 28 , 2층 (개포동, 일영빌딩)",
    "lat": "37.4792967",
    "lng": "127.0449655",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2838,
    "name": "케이튜터반포수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동작대로 222 , 2층 (방배동, 목은빌딩)",
    "lat": "37.496349",
    "lng": "126.983221",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2839,
    "name": "논당학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로 6-7 , 1층 (반포동, 경화빌딩)",
    "lat": "37.5035792",
    "lng": "127.0092796",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2840,
    "name": "프리미어소마학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 314 , 4층 일부 (대치동, 보양빌딩)",
    "lat": "37.5000166",
    "lng": "127.0606578",
    "phoneNumber": "02-555-1309",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2841,
    "name": "픽처북아지트학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로69길 5 , 2층 (대치동)",
    "lat": "37.5019692",
    "lng": "127.0537153",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2843,
    "name": "픽셀아카데미온라인원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 압구정로32길 11 , 2층 204호 (신사동, 캐럴라인타워)",
    "lat": "37.5269161",
    "lng": "127.0302159",
    "phoneNumber": "02-6949-2939",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 2844,
    "name": "수학의기술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로71길 34 , 3층 (대치동)",
    "lat": "37.5016541",
    "lng": "127.0561169",
    "phoneNumber": "02-562-2383",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 2849,
    "name": "뉴파인반포서경관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동광로 23 , 2~4층 (방배동, 효성빌딩)",
    "lat": "37.4911165",
    "lng": "126.9855634",
    "phoneNumber": "02-532-0304",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2850,
    "name": "솔에듀프렙학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 도산대로35길 21 , 2층, 3층 (신사동)",
    "lat": "37.5221437999999",
    "lng": "127.0302618",
    "phoneNumber": "02-3445-2226",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 2851,
    "name": "하베르만영재수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 324 , 7층 (대치동, SH타워)",
    "lat": "37.4985229",
    "lng": "127.0521012",
    "phoneNumber": "02-3454-2700",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 2852,
    "name": "GLP아카데미(GLPEnglishAcademy)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로71길 21 , 1층, 3층, 4층(대치동)",
    "lat": "37.5017752",
    "lng": "127.0571942",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2854,
    "name": "1교시수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2941 , 3층 301-1호 (대치동, 대치탑프라자)",
    "lat": "37.4942268",
    "lng": "127.0617852",
    "phoneNumber": "02-555-4136",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2858,
    "name": "아폴론교육원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 테헤란로86길 15 , 3층 302호 (대치동, 동구빌딩)",
    "lat": "37.5064486",
    "lng": "127.0595016",
    "phoneNumber": "02-0000-0000",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 2859,
    "name": "곰수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 개포로22길 9 , 4층 (개포동)",
    "lat": "37.4783145",
    "lng": "127.0479848",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2860,
    "name": "키잉글리쉬(키프랩)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 효령로 398 , 1층 (서초동, 서초 케이미 빌딩)",
    "lat": "37.4879916",
    "lng": "127.0274069",
    "phoneNumber": "02-584-0160",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2861,
    "name": "에이치프랩아카데미(Hprep Academy)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 선릉로72길 10-12 , 101호,402호 (대치동, 프린스빌딩)",
    "lat": "37.4994433",
    "lng": "127.052337",
    "phoneNumber": "02-553-8737",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 2862,
    "name": "디스토리중등학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 155 , 605호 (대치동, 대치퍼스트빌딩)",
    "lat": "37.4937674",
    "lng": "127.0629078",
    "phoneNumber": "02-566-0525",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2863,
    "name": "에이씨에이강남학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 광평로10길 6 1~2층(근린상가동별채)(일원동,한솔마을아파트)",
    "lat": "37.4821885",
    "lng": "127.077953",
    "phoneNumber": "02-576-8233",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 2864,
    "name": "브라가밸리어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 동광로 55 , 2층, 3층 (방배동, 금강장여관)",
    "lat": "37.4922933",
    "lng": "126.988664",
    "phoneNumber": "02-3477-2752",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 2865,
    "name": "삼광잉글리쉬에듀학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로36길 8 , 4층 (신사동)",
    "lat": "37.5279868",
    "lng": "127.0312994",
    "phoneNumber": "02-516-2021",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2866,
    "name": "교사에관하여원격학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "인문사회(대)",
    "학원주소\t": "서울특별시 강남구 강남대로84길 23 , 1703-2호 (역삼동, 한라클래식오피스텔)",
    "lat": "37.4971347",
    "lng": "127.0303771",
    "phoneNumber": "02-000-0000",
    "교습과정": "성인고시",
    "isFinish": ""
  },
  {
    "number": 2868,
    "name": "메가스터디SW입시센터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 테헤란로1길 16 , 3층,4층 (역삼동)",
    "lat": "37.499438",
    "lng": "127.0279387",
    "phoneNumber": "02-558-1250",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 2870,
    "name": "라온교육학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 402 , 201호 (대치동)",
    "lat": "37.5008108",
    "lng": "127.0510086",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2873,
    "name": "강남구룡스마트플레이스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 개포로 265 , 402호 (개포동, 개포동 메디시스빌딩)",
    "lat": "37.4809469",
    "lng": "127.0529676",
    "phoneNumber": "02-577-2090",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2874,
    "name": "김예찌수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 151 , 306호 (대치동, 선경아파트)",
    "lat": "37.4920987",
    "lng": "127.0625605",
    "phoneNumber": "02-558-2441",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2875,
    "name": "리틀팝수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로29길 16 , 4층 (반포동)",
    "lat": "37.4989626",
    "lng": "127.0107021",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2878,
    "name": "와이키즈서초본원학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 고무래로 22 , 2층 일부 (반포동, 쌍동빌딩 서관)",
    "lat": "37.5025115",
    "lng": "127.0107221",
    "phoneNumber": "02-2033-8800",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 2879,
    "name": "유스트학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로34길 11 , 3층 (신사동, 압구정스퀘어)",
    "lat": "37.5273895",
    "lng": "127.030957",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2880,
    "name": "가인서초학종관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 명달로 25 , 3층 (방배동, 우성빌딩 2)",
    "lat": "37.47965",
    "lng": "127.0057112",
    "phoneNumber": "02-532-8533",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2881,
    "name": "대치파인만고등관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 212 , A블럭 303호 (대치동, 은마아파트)",
    "lat": "37.4974176",
    "lng": "127.0653272",
    "phoneNumber": "02-548-1755",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2882,
    "name": "스마트해법수학개포스마트플레이스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 8 , 지하1층 2호,3호 (개포동, 래미안블레스티지)",
    "lat": "37.4812262",
    "lng": "127.0643915",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 2883,
    "name": "엘학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 성촌1길 6 , 3층 302호 (우면동)",
    "lat": "37.4658322",
    "lng": "127.0224119",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2885,
    "name": "라포에듀학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 443 , 2층 (대치동)",
    "lat": "37.5022311",
    "lng": "127.0554155",
    "phoneNumber": "02-6952-4488",
    "교습과정": "진학상담지도",
    "isFinish": "완료"
  },
  {
    "number": 2888,
    "name": "얼라이언스원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 강남대로98길 11 , 4층 일부(좌측) (역삼동, 메트로 빌딩)",
    "lat": "37.5008831",
    "lng": "127.027485",
    "phoneNumber": "02-6339-1111",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 2889,
    "name": "아카로드영재센터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로99길 16 , 3층 (대치동)",
    "lat": "37.5018594",
    "lng": "127.0660032",
    "phoneNumber": "02-3453-5587",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2890,
    "name": "대공교육학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로71길 20 , 2층 (대치동)",
    "lat": "37.5020151",
    "lng": "127.05723",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2891,
    "name": "제이슨(Jason)영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로66길 7 , 2층 201호, 202호 (대치동)",
    "lat": "37.4985947",
    "lng": "127.0525089",
    "phoneNumber": "02-555-0355",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 2892,
    "name": "영어랩학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 테헤란로70길 14-12 , 2~3층 전체 (대치동)",
    "lat": "37.5042433",
    "lng": "127.0528163",
    "phoneNumber": "02-2631-5220",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 2893,
    "name": "변리사스쿨원격학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "인문사회(대)",
    "학원주소\t": "서울특별시 강남구 강남대로94길 51-10 4층(역삼동)",
    "lat": "37.5010524",
    "lng": "127.0312147",
    "phoneNumber": "02-566-9600",
    "교습과정": "성인고시",
    "isFinish": ""
  },
  {
    "number": 2895,
    "name": "서초티오티(TOT)반포2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로 6-10 , 7층 701호 (반포동)",
    "lat": "37.5038822",
    "lng": "127.0091071",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보통교과",
    "isFinish": ""
  },
  {
    "number": 2897,
    "name": "백산학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로81길 5 , 3층 301호 (대치동)",
    "lat": "37.5036562",
    "lng": "127.0590709",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2898,
    "name": "티제이인스티튜트(TJ INSTITUTE)어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 논현로168길 36 , 204호 (신사동, 안국빌딩)",
    "lat": "37.5232126999999",
    "lng": "127.0309526",
    "phoneNumber": "02-512-7774",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 2899,
    "name": "언어산책학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 논현로26길 18-5 , 2층 (도곡동)",
    "lat": "37.4823049",
    "lng": "127.044596",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2905,
    "name": "제이포커스잉글리시방배2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동광로19길 19 , 4층 일부 401호(방배동, 그랜드빌딩)",
    "lat": "37.493438",
    "lng": "126.9889159",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2906,
    "name": "리드인지인학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로31길 20 4층 (반포동, 인원빌딩)",
    "lat": "37.4996861",
    "lng": "127.0101579",
    "phoneNumber": "02-533-2352",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2907,
    "name": "메타아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 압구정로 228 , 4층 (신사동, 대웅빌딩)",
    "lat": "37.5286822",
    "lng": "127.0327997",
    "phoneNumber": "02-000-0000",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 2909,
    "name": "윌비스강남센터독서실",
    "학원종류": "평생직업교육학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 테헤란로19길 27 , 2층, 301호, 302호(역삼동)",
    "lat": "37.5017669",
    "lng": "127.0328599",
    "phoneNumber": "-",
    "교습과정": "독서실(일반인)",
    "isFinish": ""
  },
  {
    "number": 2910,
    "name": "강남하이탑학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 테헤란로8길 32 , 5층 (역삼동)",
    "lat": "37.4967153",
    "lng": "127.0319056",
    "phoneNumber": "02-539-5888",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2911,
    "name": "엠아이메타버스원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 선릉로94길 11 , 2층 일부 (삼성동, 삼성2빌딩)",
    "lat": "37.5061726",
    "lng": "127.049394",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2912,
    "name": "리베라입시전문원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 남부순환로 2652 , 6층 601호 (양재동, 대명빌딩)",
    "lat": "37.4851603",
    "lng": "127.0408559",
    "phoneNumber": "02-0000-0000",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 2915,
    "name": "다원초중등1관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로76길 5 , 2층,3층 (대치동)",
    "lat": "37.5040708",
    "lng": "127.0588014",
    "phoneNumber": "02-562-3399",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2916,
    "name": "다원초중등2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로76길 5 , 4층,5층 (대치동)",
    "lat": "37.5040708",
    "lng": "127.0588014",
    "phoneNumber": "02-562-3399",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2921,
    "name": "서울상문수학전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 명달로 58 , 3층 302호 (서초동)",
    "lat": "37.4825161",
    "lng": "127.0048122",
    "phoneNumber": "02-598-0304",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2922,
    "name": "트리플(TRIPLE)어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 압구정로30길 17 , 403호,404호 (신사동, 이소니프라자)",
    "lat": "37.5262629",
    "lng": "127.0294934",
    "phoneNumber": "02-3445-3303",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 2923,
    "name": "수학깡패학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로64길 17 , 5층 502호 (대치동, 디앤비빌딩)",
    "lat": "37.4982437",
    "lng": "127.0536538",
    "phoneNumber": "02-557-4565",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2924,
    "name": "스마트해법수학영어서초방배스마트플레이스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 효령로33길 59 , 2층 (방배동, 대안빌딩)",
    "lat": "37.48385",
    "lng": "126.9966585",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2926,
    "name": "대치심슨어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 남부순환로 2947 , 5층일부 (대치동, 대원빌딩)",
    "lat": "37.4945248",
    "lng": "127.062584",
    "phoneNumber": "02-0000-0000",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 2927,
    "name": "한미ibt원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 테헤란로 142 , 아크플레이스 5층 129호 (역삼동, 캐피탈타워)",
    "lat": "37.4997187",
    "lng": "127.0348982",
    "phoneNumber": "02-0000-0000",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 2928,
    "name": "입시왕아카데미온원격교습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 사임당로8길 16 , 3층 (서초동, 성재빌딩)",
    "lat": "37.487911",
    "lng": "127.0153379",
    "phoneNumber": "070-8805-5030",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2932,
    "name": "대치동리즈집현전원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 테헤란로 431 , 8층 S8023호(삼성동)",
    "lat": "37.5065995",
    "lng": "127.0541343",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2933,
    "name": "이응학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로57길 5 , 1층, 4층 (대치동)",
    "lat": "37.4980215",
    "lng": "127.0606264",
    "phoneNumber": "-",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 2934,
    "name": "최홍국어논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 213 , 2층 1호 (잠원동, 반포쇼핑타운)",
    "lat": "37.5072627",
    "lng": "127.0071911",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2935,
    "name": "기파랑문해원압구정학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 논현로175길 63 , 4층1호 (신사동)",
    "lat": "37.5240154",
    "lng": "127.0239103",
    "phoneNumber": "02-517-2030",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2936,
    "name": "은지호영감수학수능2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로62길 5 , 2층 (대치동)",
    "lat": "37.497328",
    "lng": "127.0530862",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 2937,
    "name": "서초베리타스수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초대로 389 , 204호,209호,214호,218호 (서초동, 진흥상가)",
    "lat": "37.4973452",
    "lng": "127.0226142",
    "phoneNumber": "02-592-0101",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2938,
    "name": "아트프렙학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 도산대로35길 24-1 1층, 2층(신사동)",
    "lat": "37.5223816",
    "lng": "127.0306365",
    "phoneNumber": "02-0000-0000",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 2939,
    "name": "오엠지댄스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 신반포로45길 9-20 , 1층 (잠원동, 대원빌딩)",
    "lat": "37.5109937",
    "lng": "127.0183095",
    "phoneNumber": "02-000-0000",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 2940,
    "name": "닥터정프라임영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 사임당로 143 , 311호,312호 (서초동, Cross 143)",
    "lat": "37.4918829",
    "lng": "127.0252346",
    "phoneNumber": "02-587-4520",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2942,
    "name": "아이이엠(IEM)잉글리시아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 고무래로10길 26 601호(반포동)",
    "lat": "37.5006911",
    "lng": "127.0096776",
    "phoneNumber": "-",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 2943,
    "name": "독한국어원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 강남대로53길 8 , 11층 1-15호 (서초동, 스타크 강남빌딩)",
    "lat": "37.4945363",
    "lng": "127.0280183",
    "phoneNumber": "02-1668-5537",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 2944,
    "name": "시대인재더블유(W)관부엉이라이브러리5독서실",
    "학원종류": "평생직업교육학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 삼성로 337 , 9층 (대치동)",
    "lat": "37.4991887",
    "lng": "127.0633458",
    "phoneNumber": "02-568-2372",
    "교습과정": "독서실(일반인)",
    "isFinish": ""
  },
  {
    "number": 2945,
    "name": "시대인재더블유(W)관부엉이라이브러리6독서실",
    "학원종류": "평생직업교육학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 삼성로 337 , 10층 (대치동)",
    "lat": "37.4991887",
    "lng": "127.0633458",
    "phoneNumber": "02-568-2372",
    "교습과정": "독서실(일반인)",
    "isFinish": ""
  },
  {
    "number": 2946,
    "name": "시대인재더블유(W)관부엉이라이브러리독서실",
    "학원종류": "평생직업교육학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 삼성로 337 , 2층 (대치동)",
    "lat": "37.4991887",
    "lng": "127.0633458",
    "phoneNumber": "02-568-2372",
    "교습과정": "독서실(일반인)",
    "isFinish": ""
  },
  {
    "number": 2947,
    "name": "시대인재더블유(W)관부엉이라이브러리2독서실",
    "학원종류": "평생직업교육학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 삼성로 337 , 3층 (대치동)",
    "lat": "37.4991887",
    "lng": "127.0633458",
    "phoneNumber": "02-568-2372",
    "교습과정": "독서실(일반인)",
    "isFinish": ""
  },
  {
    "number": 2948,
    "name": "시대인재더블유(W)관부엉이라이브러리3독서실",
    "학원종류": "평생직업교육학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 삼성로 337 , 4층 (대치동)",
    "lat": "37.4991887",
    "lng": "127.0633458",
    "phoneNumber": "02-568-2372",
    "교습과정": "독서실(일반인)",
    "isFinish": ""
  },
  {
    "number": 2949,
    "name": "시대인재더블유(W)관부엉이라이브러리4독서실",
    "학원종류": "평생직업교육학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 삼성로 337 , 5층 (대치동)",
    "lat": "37.4991887",
    "lng": "127.0633458",
    "phoneNumber": "02-568-2372",
    "교습과정": "독서실(일반인)",
    "isFinish": ""
  },
  {
    "number": 2953,
    "name": "잼코딩서초학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "정보",
    "학원주소\t": "서울특별시 서초구 서초중앙로 40-6 , 3층,4층 (서초동, 우림빌딩)",
    "lat": "37.4856696",
    "lng": "127.016459",
    "phoneNumber": "02-6953-0563",
    "교습과정": "정보교과",
    "isFinish": ""
  },
  {
    "number": 2954,
    "name": "유에스아이에스(USIS)어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 서초대로70길 32 , 신관 2층일부 (서초동, 코오롱스포렉스)",
    "lat": "37.493857",
    "lng": "127.0233637",
    "phoneNumber": "02-2135-3877",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 2955,
    "name": "대치수능선배스터디학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 424 , 3층 일부 (대치동, 진영빌딩)",
    "lat": "37.5010752",
    "lng": "127.0534432",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2956,
    "name": "기파랑문해원대치원3관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 422 , 4층 (대치동, 세림빌딩)",
    "lat": "37.4972615",
    "lng": "127.0567378",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 2957,
    "name": "더자람종합학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 38 , 6층 (개포동, 오성빌딩)",
    "lat": "37.483184",
    "lng": "127.0604062",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2961,
    "name": "그루터기수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 155 , 511호, 512호 (대치동, 대치퍼스트빌딩)",
    "lat": "37.4951112",
    "lng": "127.0698937",
    "phoneNumber": "02-563-9613",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2964,
    "name": "압구정파인만중3의치대관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 압구정로32길 23 , 1층일부, 2~3층 (신사동)",
    "lat": "37.5262125",
    "lng": "127.0300613",
    "phoneNumber": "02-548-1755",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2965,
    "name": "씨에스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로 110 3층 303호(신사동)",
    "lat": "37.5229663",
    "lng": "127.0209482",
    "phoneNumber": "02-517-8141",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 2966,
    "name": "우리샘수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 자곡로 114 503호,504호(자곡동)",
    "lat": "37.4720223",
    "lng": "127.0960065",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2967,
    "name": "바모스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로69길 15 , 4층 402호 (대치동, 에덴빌딩)",
    "lat": "37.5013456",
    "lng": "127.0580509",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2969,
    "name": "다원매쓰아이수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로63길 15 , 4층, 5층, 6층 (대치동)",
    "lat": "37.4994464",
    "lng": "127.0588033",
    "phoneNumber": "02-557-0314",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2970,
    "name": "아이작반포직영학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로 8 , 5층 (반포동, 닥터로빈 빌딩)",
    "lat": "37.50366",
    "lng": "127.010008",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 2971,
    "name": "뉴에라아카데미(NEW ERA ACADEMY)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로36길 12 , 202호 (신사동, 메디컬뱅크)",
    "lat": "37.5276627",
    "lng": "127.0313419",
    "phoneNumber": "02-3443-2555",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2972,
    "name": "압구정페르마수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 논현로171길 15 , 401~2호 (신사동, 카로시티1)",
    "lat": "37.5255134",
    "lng": "127.0270724",
    "phoneNumber": "02-540-7077",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 2973,
    "name": "서초크라센2관어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 서초중앙로31길 6-3 , 5층 (반포동, 지지반포빌딩)",
    "lat": "37.5000996",
    "lng": "127.0113176",
    "phoneNumber": "02-6261-8280",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2974,
    "name": "에이엠비(AMB)자기주도센터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배중앙로 210 , 401호 (방배동)",
    "lat": "37.4978742",
    "lng": "126.9853956",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2975,
    "name": "돌파수학2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 441 , 4층 (대치동)",
    "lat": "37.5022141",
    "lng": "127.0551232",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2976,
    "name": "시프트공부클리닉학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로76길 4 , 201호, 302호 (대치동, 코람벤처타운)",
    "lat": "37.5012319",
    "lng": "127.0510034",
    "phoneNumber": "02-556-1131",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2980,
    "name": "유니패스원격학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "인문사회(대)",
    "학원주소\t": "서울특별시 강남구 논현로79길 62 , 603호 (역삼동)",
    "lat": "37.5053029",
    "lng": "127.0288672",
    "phoneNumber": "02-000-0000",
    "교습과정": "성인고시",
    "isFinish": ""
  },
  {
    "number": 2983,
    "name": "앳더블유(@W)어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 삼성로 319 , 2층, 3층, 6층 (대치동, 금강빌딩)",
    "lat": "37.4987668",
    "lng": "127.0583525",
    "phoneNumber": "02-000-0000",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 2986,
    "name": "위드미애프터스쿨학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로24길 55 , 305호 (서초동, 서초플라자)",
    "lat": "37.4961565",
    "lng": "127.0193719",
    "phoneNumber": "070-8648-1631",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2987,
    "name": "서울아카데미압구정학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 압구정로 201 , 교육연구시설 1~2층 전체 (압구정동, 현대아파트)",
    "lat": "37.5296583",
    "lng": "127.0308297",
    "phoneNumber": "02-567-0579",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 2991,
    "name": "핀란드라이브러리압구정직영학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로 312 , 3층 301호 (신사동)",
    "lat": "37.528757",
    "lng": "127.0355137",
    "phoneNumber": "02-522-8899",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2992,
    "name": "공부선배원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 봉은사로5길 6 , 3층 (논현동)",
    "lat": "37.5056094",
    "lng": "127.0264236",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 2993,
    "name": "그릿(Grit)영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로6길 10 , 3층 (개포동)",
    "lat": "37.4826693",
    "lng": "127.0618301",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2994,
    "name": "김신홍학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로71길 9 , 4층 (대치동)",
    "lat": "37.5020912",
    "lng": "127.0581508",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2995,
    "name": "오름국어논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 개포로 512 , 307호, 501호 (개포동, 개포종합상가)",
    "lat": "37.4892714",
    "lng": "127.0688177",
    "phoneNumber": "02-3411-2030",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2996,
    "name": "수행과수능서초학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로 253 , 3층 (반포동)",
    "lat": "37.5039559",
    "lng": "127.0104668",
    "phoneNumber": "02-6953-2120",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2998,
    "name": "대치플투스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로71길 19 3층, 4층(대치동)",
    "lat": "37.5018308",
    "lng": "127.0573774",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 2999,
    "name": "글도학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 언주로167길 34 , 1층 (신사동, 우리빌딩)",
    "lat": "37.5266094",
    "lng": "127.0304576",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3000,
    "name": "더웨이영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로62길 37 , 5층 (대치동)",
    "lat": "37.4977724",
    "lng": "127.0545696",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3001,
    "name": "서울유에듀원격학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 남부순환로356길 18-5 , 이음빌딩 4층 전체 (양재동)",
    "lat": "37.4840363",
    "lng": "127.0375617",
    "phoneNumber": "02-3471-1505",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 3004,
    "name": "세훈학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 강남대로51길 10 , 205호, 206호 (서초동, 강남효성해링턴타워)",
    "lat": "37.4912348999999",
    "lng": "127.0290758",
    "phoneNumber": "02-523-7752",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3005,
    "name": "독학재수현우혁논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로24길 5 , 5층(서초동)",
    "lat": "37.494698",
    "lng": "127.0143601",
    "phoneNumber": "02-599-9697",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3006,
    "name": "함영원입시전문2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2941 , 2층 203호 (대치동, 대치탑프라자)",
    "lat": "37.4942268",
    "lng": "127.0617852",
    "phoneNumber": "02-501-1711",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3007,
    "name": "유니브원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 삼성로 554 , 1층 (삼성동)",
    "lat": "37.5111351",
    "lng": "127.0547725",
    "phoneNumber": "02-508-8866",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3009,
    "name": "제니에듀케이션학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동산로 60 , 4층 (양재동, 화성빌딩)",
    "lat": "37.4716809",
    "lng": "127.0454469",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3011,
    "name": "매쓰넛수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로 26 , 3층 303호 (반포동, 쌍동빌딩)",
    "lat": "37.5023326",
    "lng": "127.0111857",
    "phoneNumber": "02-534-1288",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3016,
    "name": "클라디반포관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로 6-10 , 602호 (반포동)",
    "lat": "37.5038822",
    "lng": "127.0091071",
    "phoneNumber": "02-594-3222",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3017,
    "name": "주식회사에이블수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 개포로 615 , 8층 801호 (개포동, 석탑프라자)",
    "lat": "37.4926936",
    "lng": "127.0756284",
    "phoneNumber": "02-2088-8772",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3019,
    "name": "에이원수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로78길 14 , 3층 301호 (대치동, 리더캐슬)",
    "lat": "37.5015377",
    "lng": "127.0570047",
    "phoneNumber": "02-568-5419",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 3020,
    "name": "수학의길리드인국어논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 사임당로 151 , 202호, 205~208호, 503호(서초동)",
    "lat": "37.4923671",
    "lng": "127.0258472",
    "phoneNumber": "02-6954-0935",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3022,
    "name": "다움수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로78길 15 , 5층 (대치동)",
    "lat": "37.5015424",
    "lng": "127.057313",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3023,
    "name": "와이키즈대치개포학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 선릉로 38 , 7층 전체 (개포동, 오성빌딩)",
    "lat": "37.483184",
    "lng": "127.0604062",
    "phoneNumber": "02-0000-0000",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 3024,
    "name": "더탑학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 개포로 508 , 403호 (개포동, 소망빌딩)",
    "lat": "37.4892091",
    "lng": "127.0679609",
    "phoneNumber": "02-458-0508",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3025,
    "name": "펜로즈아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로93길 12 , 우성상가 302호 (대치동, 래미안 대치 하이스턴)",
    "lat": "37.500937",
    "lng": "127.0653883",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3026,
    "name": "에듀조선NIE논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로73길 13 , 3층 (대치동)",
    "lat": "37.498738",
    "lng": "127.0569719",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3027,
    "name": "탑잉글리쉬학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동산로 71 , 5층 1호 (양재동, 마승빌딩)",
    "lat": "37.4723486",
    "lng": "127.0463163",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3028,
    "name": "기파랑중등관반포학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로 229 , 6층 일부 (반포동)",
    "lat": "37.502108",
    "lng": "127.0113454",
    "phoneNumber": "02-599-2030",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3029,
    "name": "그레이드원수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 519 , 3층 일부 (대치동, 구공빌딩)",
    "lat": "37.5000709",
    "lng": "127.0629888",
    "phoneNumber": "02-558-3168",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3030,
    "name": "혜음국어영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로78길 14 , 201호 전체 (대치동, 리더캐슬)",
    "lat": "37.5014911",
    "lng": "127.0569929",
    "phoneNumber": "02-538-1113",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 3031,
    "name": "국어자신감학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 논현로175길 59-6 , 2층 (신사동)",
    "lat": "37.5239546",
    "lng": "127.0242293",
    "phoneNumber": "02-533-0682",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3032,
    "name": "리비어(REVERE)어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 도산대로23길 42 , 1층~5층 (신사동)",
    "lat": "37.5200556",
    "lng": "127.0256389",
    "phoneNumber": "02-540-4277",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3033,
    "name": "리드101개포구룡학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 38 , 2층 (개포동, 오성빌딩)",
    "lat": "37.483184",
    "lng": "127.0604062",
    "phoneNumber": "02-573-7101",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3034,
    "name": "얼티밋커리어그룹학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "직업기술",
    "학원주소\t": "서울특별시 서초구 서초대로46길 89 , 2층 전체 (서초동, 희원BD)",
    "lat": "37.4901464",
    "lng": "127.0129708",
    "phoneNumber": "070-4365-8312",
    "교습과정": "직업상담",
    "isFinish": ""
  },
  {
    "number": 3035,
    "name": "서리풀고등관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 효령로40길 11 , 2층 (서초동)",
    "lat": "37.4824461",
    "lng": "127.0060252",
    "phoneNumber": "02-598-0304",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3036,
    "name": "유일수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로77길 5 , 2층전체 (대치동)",
    "lat": "37.5028175",
    "lng": "127.0563475",
    "phoneNumber": "02-565-4936",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3037,
    "name": "칼비테영재학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 선릉로138길 18 , 301호, 302호(청담동)",
    "lat": "37.5193033",
    "lng": "127.0420491",
    "phoneNumber": "020-00-0000",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 3038,
    "name": "비이씨영국에듀학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 서초중앙로22길 87 , 3층 전체 (서초동)",
    "lat": "37.4942758",
    "lng": "127.0186944",
    "phoneNumber": "02-548-0979",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3040,
    "name": "압구정짱솔학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 논현로175길 25 , 2층 202호 (신사동, 다보빌딩)",
    "lat": "37.5254304",
    "lng": "127.0266876",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3041,
    "name": "키투러닝(KEY2LEARNING)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로 90-7 , 4층 412호 (서초동, 서초쇼핑)",
    "lat": "37.4999482",
    "lng": "127.0174429",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3044,
    "name": "필즈더클래식원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 고무래로10길 17 , 502호 (반포동, 동호빌딩)",
    "lat": "37.5012315",
    "lng": "127.0104245",
    "phoneNumber": "02-566-7853",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3045,
    "name": "정수아수능전문국어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로68길 18 , 2층 전체 (대치동)",
    "lat": "37.4991658",
    "lng": "127.0532032",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 3046,
    "name": "수(SUE)영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 영동대로 16 , 912동 1층 7호, 8호(일원동,상록 스타힐스)",
    "lat": "37.4882004",
    "lng": "127.0758235",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3048,
    "name": "에듀아고라원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 강남대로84길 8 , 6층 일부 (역삼동, 우인빌딩)",
    "lat": "37.4964685",
    "lng": "127.0293367",
    "phoneNumber": "02-0000-0000",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3049,
    "name": "클러스(CLUS)원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 선릉로 305 , 한티KR타워 8층(역삼동)",
    "lat": "37.4966422",
    "lng": "127.0524101",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3050,
    "name": "해커스경영아카데미제1별관독서실",
    "학원종류": "평생직업교육학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 서초구 서초대로73길 7 , 6층 일부 (서초동)",
    "lat": "37.4981412",
    "lng": "127.0253117",
    "phoneNumber": "02-0000-0000",
    "교습과정": "독서실(일반인)",
    "isFinish": ""
  },
  {
    "number": 3051,
    "name": "에스에스아이서초(SSISEOCHO)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 서초대로 224 , 1~2층 (서초동)",
    "lat": "37.4910352",
    "lng": "127.0068196",
    "phoneNumber": "02-598-2510",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3052,
    "name": "에스에스아이서초(SSISEOCHO)주니어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 서초대로 224 , 3층 (서초동)",
    "lat": "37.4910352",
    "lng": "127.0068196",
    "phoneNumber": "02-566-2510",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3053,
    "name": "대치프라이드제이어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 남부순환로 2911 , 501호 (대치동, 청우빌딩)",
    "lat": "37.49246",
    "lng": "127.0579272",
    "phoneNumber": "02-508-2684",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3058,
    "name": "대치감성교육학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 456 , 1층,2층 (대치동, PEACE 빌딩)",
    "lat": "37.5024272",
    "lng": "127.0572068",
    "phoneNumber": "02-538-0907",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3059,
    "name": "이앤케이국어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로126길 16 , 2층 전체 (삼성동)",
    "lat": "37.5153246",
    "lng": "127.0434625",
    "phoneNumber": "02-517-6244",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3060,
    "name": "철벽수학전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로34길 11 , 506호 (신사동, 압구정스퀘어)",
    "lat": "37.5273895",
    "lng": "127.030957",
    "phoneNumber": "02-3442-0008",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3064,
    "name": "이엠에이영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 헌릉로569길 25 , 202호 (세곡동)",
    "lat": "37.4667957",
    "lng": "127.0990587",
    "phoneNumber": "-",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3065,
    "name": "생각하는황소5관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 448 , 2층 (대치동, 황우거빌딩)",
    "lat": "37.5019986",
    "lng": "127.0562288",
    "phoneNumber": "02-565-5496",
    "교습과정": "보습",
    "isFinish": "완료"
  },
  {
    "number": 3066,
    "name": "나름교육학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로72길 5 , 3층 (대치동)",
    "lat": "37.5026664",
    "lng": "127.0596142",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3067,
    "name": "에듀플렉스에듀코치개별지도서초그랑자이학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서운로11길 35 , 2층 201호 (서초동, 서흥빌딩)",
    "lat": "37.4873933999999",
    "lng": "127.0266355",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3068,
    "name": "역사화랑2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로64길 14 , 4층일부 403호 404호 (대치동)",
    "lat": "37.497798",
    "lng": "127.0534412",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3069,
    "name": "수능선배학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초대로78길 52 , 5층 일부 (서초동, 강남역 인앤인)",
    "lat": "37.4932229",
    "lng": "127.0287364",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3073,
    "name": "에이프렙원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 사임당로 173 , 8층 일부 (서초동, 서전빌딩)",
    "lat": "37.4927943",
    "lng": "127.0285544",
    "phoneNumber": "02-6959-9788",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3075,
    "name": "델탑수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로77길 2 , 4층 전체 (대치동)",
    "lat": "37.5028387",
    "lng": "127.0566719",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3076,
    "name": "깊은생각상담센터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 457 , 1층 101호 (대치동, 진흥빌딩)",
    "lat": "37.4990346",
    "lng": "127.0602191",
    "phoneNumber": "02-565-0526",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3077,
    "name": "함수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2937 , 3층 전체 (대치동, 까치빌딩)",
    "lat": "37.4941325",
    "lng": "127.0615797",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3078,
    "name": "윤경민국어전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 자곡로 106 , 4층 406호 (자곡동, S-플라자)",
    "lat": "37.4719211",
    "lng": "127.0950026",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3080,
    "name": "에듀윌편입학원인문계전문관학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "인문사회(대)",
    "학원주소\t": "서울특별시 강남구 테헤란로2길 27 , 301호, 302호 일부 (역삼동, 패스트파이브빌딩)",
    "lat": "37.4965546",
    "lng": "127.0296354",
    "phoneNumber": "-",
    "교습과정": "대학편입",
    "isFinish": ""
  },
  {
    "number": 3081,
    "name": "새봄국어원격학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "인문사회(대)",
    "학원주소\t": "서울특별시 서초구 서초대로 398 , 7층 743호 (서초동, BNK디지털타워)",
    "lat": "37.496646",
    "lng": "127.0251292",
    "phoneNumber": "02-0000-0000",
    "교습과정": "성인고시",
    "isFinish": ""
  },
  {
    "number": 3082,
    "name": "케이엔에스(KNS)초등관어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 도곡로 515 , 3층 301호 (대치동, 한도산업사옥)",
    "lat": "37.4998352",
    "lng": "127.0626495",
    "phoneNumber": "02-0000-0000",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3083,
    "name": "아카로드블루학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 영동대로 231 3층",
    "lat": "37.4997861",
    "lng": "127.0673274",
    "phoneNumber": "02-3453-5587",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3085,
    "name": "시대인재반포센터2학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 반포대로 287 , 501호, 502-1호, 502-2호, 503호, 504호(반포동)",
    "lat": "37.5043394",
    "lng": "127.0008523",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3086,
    "name": "몰입스파르타관리형독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 개포로82길 13-9 , 4층 405~408호 (개포동, 세종빌딩)",
    "lat": "37.4886373",
    "lng": "127.0677765",
    "phoneNumber": "070-8820-1125",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3089,
    "name": "본질수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로62길 17 , 6층 전체 (대치동)",
    "lat": "37.4976008999999",
    "lng": "127.0538766",
    "phoneNumber": "02-558-2622",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3090,
    "name": "결국이루는학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 논현로71길 21 2~4층(역삼동)",
    "lat": "37.4945454",
    "lng": "127.037856",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3092,
    "name": "대치베스트어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 선릉로64길 11-2 , 2층, 6층 (대치동)",
    "lat": "37.4980851",
    "lng": "127.0532687",
    "phoneNumber": "02-556-3510",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3093,
    "name": "보감학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로64길 11-15 , 1층, 2층 (대치동)",
    "lat": "37.4988592",
    "lng": "127.052612",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3094,
    "name": "인아이디씽크원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 논현로159길 22-1 , 302호 (신사동)",
    "lat": "37.5230935",
    "lng": "127.0260188",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3095,
    "name": "세연입시원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 봉은사로 174 , 407호 (역삼동, 호텔코스모스)",
    "lat": "37.5067484",
    "lng": "127.0331176",
    "phoneNumber": "-",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3097,
    "name": "제시잉글리쉬스쿨원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 테헤란로6길 33 , 5층 (역삼동)",
    "lat": "37.4964372",
    "lng": "127.0314211",
    "phoneNumber": "02-553-5575",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3098,
    "name": "시대인재반포센터수학스쿨별관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 195 , 5층 10, 11, 12호(잠원동, 반포쇼핑타운5동)",
    "lat": "37.5066949",
    "lng": "127.0054918",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3099,
    "name": "에이엠씨(amc)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 논현로175길 61 , 3층 (신사동)",
    "lat": "37.5241663",
    "lng": "127.0240588",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3100,
    "name": "(주)산에듀김영준국어논술전문프리미엄관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로62길 32-2 , 5층 (대치동, 대아빌딩)",
    "lat": "37.49768",
    "lng": "127.0550939",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 3101,
    "name": "서초메가스터디독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 서초구 서초중앙로22길 17 , 6층, 7층 전체, 9층 일부 (서초동)",
    "lat": "37.4933187",
    "lng": "127.014641",
    "phoneNumber": "02-535-5678",
    "교습과정": "독서실",
    "isFinish": ""
  },
  {
    "number": 3103,
    "name": "다락방창작학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 강남대로99길 21 , 4층 (잠원동, 영구빌딩)",
    "lat": "37.5149935",
    "lng": "127.0183471",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3104,
    "name": "아이비펜타원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 나루터로 59 , 4층 419호 (잠원동, 라성빌딩)",
    "lat": "37.5153463",
    "lng": "127.0164631",
    "phoneNumber": "02-0000-0000",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3107,
    "name": "뉴파인반포고특별관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로33길 14 , 4층 (반포동)",
    "lat": "37.5010747",
    "lng": "127.0106354",
    "phoneNumber": "02-599-0304",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3108,
    "name": "더와이즈리딩학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 태봉로 62 , 203호 (우면동, 네이처프라자)",
    "lat": "37.4640472",
    "lng": "127.0250245",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3109,
    "name": "잉글리쉬웰원격학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 강남대로44길 7 , 216호 (도곡동, 글수레빌딩)",
    "lat": "37.4858308",
    "lng": "127.0341712",
    "phoneNumber": "02-6241-0530",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 3110,
    "name": "대치동서울대과외원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 테헤란로82길 15 , 1103호 (대치동)",
    "lat": "37.5060315",
    "lng": "127.0582357",
    "phoneNumber": "02-552-5338",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3112,
    "name": "심화랑수학원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 테헤란로4길 6 , 304호 일부 (역삼동, 강남역 센트럴 푸르지오 시티)",
    "lat": "37.4977256",
    "lng": "127.0292972",
    "phoneNumber": "-",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3113,
    "name": "오대교수능연구소입시학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 541 , 6층(대치동)",
    "lat": "37.5009607",
    "lng": "127.0665565",
    "phoneNumber": "02-558-8034",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3115,
    "name": "진에듀영재관대치제4지점학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 336 , 501호 (대치동, 한림빌딩)",
    "lat": "37.506127",
    "lng": "127.0600466",
    "phoneNumber": "02-563-5050",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3116,
    "name": "겟앤씨어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 서초중앙로31길 6-3 , 9층 (반포동, 지지반포빌딩)",
    "lat": "37.5000996",
    "lng": "127.0113176",
    "phoneNumber": "02-0000-0000",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3117,
    "name": "일심수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 사평대로2길 19-19 , 3층 303호  (방배동)",
    "lat": "37.4969222",
    "lng": "126.9862503",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3118,
    "name": "에반아카데미강남센터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 밤고개로 227 , B동 206호 전체 (자곡동, 훼미리타운)",
    "lat": "37.4741019",
    "lng": "127.1071826",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3119,
    "name": "민선생영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 177 , 3동 5층 15, 16, 17호 (잠원동)",
    "lat": "37.5061225",
    "lng": "127.0036962",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3127,
    "name": "신태풍영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 명달로 51 , 6층 (방배동, 부흥빌딩)",
    "lat": "37.4819435",
    "lng": "127.004645",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3129,
    "name": "대치강안교육스터디학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 영동대로85길 20-9 , 5층, 7층 전체 (대치동)",
    "lat": "37.507507",
    "lng": "127.0615828",
    "phoneNumber": "02-553-5205",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3130,
    "name": "로그엔코딩학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "정보",
    "학원주소\t": "서울특별시 강남구 언주로174길 17 , 3층 일부 북동측호 (신사동)",
    "lat": "37.5284771",
    "lng": "127.0354125",
    "phoneNumber": "02-540-1628",
    "교습과정": "정보교과",
    "isFinish": ""
  },
  {
    "number": 3132,
    "name": "대치두다학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로77길 7 , 5층 전체 (대치동)",
    "lat": "37.4988033",
    "lng": "127.0583171",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 3133,
    "name": "태솔학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로132길 62 , 2층전체 (청담동)",
    "lat": "37.5187721",
    "lng": "127.0462975",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3134,
    "name": "오늘의공부학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초대로53길 28 , 1층 전체 (서초동, 백석빌딩)",
    "lat": "37.4966335",
    "lng": "127.014356",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3138,
    "name": "상상미학N2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로86길 12 , 5층 일부 501호(건축물대장상 지상 6층) (대치동)",
    "lat": "37.5031278",
    "lng": "127.0508928",
    "phoneNumber": "-",
    "교습과정": "보습",
    "isFinish": "완료"
  },
  {
    "number": 3139,
    "name": "세븐힐즈학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 강남대로162길 41-20 , 3층 전체 (신사동)",
    "lat": "37.521901",
    "lng": "127.0211758",
    "phoneNumber": "02-0000-0000",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 3141,
    "name": "미래엔초코원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 신반포로 321 , 2층  (잠원동, 미래엔)",
    "lat": "37.5107028",
    "lng": "127.0187811",
    "phoneNumber": "-",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3142,
    "name": "새샘과학전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 효령로 214 , 4층 (서초동, 삼양빌딩)",
    "lat": "37.4831243",
    "lng": "127.0077129",
    "phoneNumber": "02-6014-4252",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3143,
    "name": "혜기에듀원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 강남대로 364 , 1322호 (역삼동, 미왕빌딩)",
    "lat": "37.4955525",
    "lng": "127.0292924",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3144,
    "name": "더브릿지학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동작대로 138 , 2층전체, 3층전체 (방배동)",
    "lat": "37.4889488",
    "lng": "126.9827577",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3145,
    "name": "하이웨이학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로92길 7 , 3층 (대치동)",
    "lat": "37.5040155",
    "lng": "127.0629798",
    "phoneNumber": "02-566-2989",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3146,
    "name": "대치폴리매그넷어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 영동대로 318 , 4층전체, 5층전체 (대치동)",
    "lat": "37.5030354",
    "lng": "127.067046",
    "phoneNumber": "02-6953-7659",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3148,
    "name": "패트릭에듀원격학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 신반포로47길 30 , 2층 전체 (잠원동, 풍년빌딩)",
    "lat": "37.5121078",
    "lng": "127.0192382",
    "phoneNumber": "-",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 3149,
    "name": "수서정상수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 밤고개로 219 , 2층 201호, 202호 (자곡동, 강남블루지움)",
    "lat": "37.4747226",
    "lng": "127.1070295",
    "phoneNumber": "02-445-6500",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3150,
    "name": "뷰티풀마인드고등관수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로64길 11-15 , 5층 501호 전체 (대치동)",
    "lat": "37.4988592",
    "lng": "127.052612",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3151,
    "name": "효자원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로72길 3 , B1층 (대치동, 월드스포츠센타)",
    "lat": "37.502669",
    "lng": "127.0593989",
    "phoneNumber": "02-1599-8884",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3152,
    "name": "서초SCE어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 서초중앙로 225 , 3층 (반포동, 남도빌딩)",
    "lat": "37.5016579",
    "lng": "127.0115536",
    "phoneNumber": "02-0000-0000",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3154,
    "name": "한울수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로63길 27 , 3층 (대치동, 시온빌딩)",
    "lat": "37.4987844",
    "lng": "127.0535968",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3156,
    "name": "메이플베어강남어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 선릉로10길 18-4 , 2층,3층,4층일부 (개포동)",
    "lat": "37.4837054",
    "lng": "127.0614047",
    "phoneNumber": "02-0000-0000",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3157,
    "name": "수시컨설팅바른학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 개포로82길 13-9 , 403호 (개포동, 세종빌딩)",
    "lat": "37.4886373",
    "lng": "127.0677765",
    "phoneNumber": "02-2135-2249",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3158,
    "name": "(주)크레버스청담어학원서초제2지점학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로10길 27 , 4층 402호 (반포동, 주호빌딩)",
    "lat": "37.5003314",
    "lng": "127.0101783",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3159,
    "name": "토브에듀케어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 개포로 516 , 개포주공7단지 상가 201-7호 (개포동, 개포주공아파트)",
    "lat": "37.4888759",
    "lng": "127.0716679",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3160,
    "name": "에스엠유니버스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 영동대로 217 2층, 3층, 4층(대치동)",
    "lat": "37.4991887",
    "lng": "127.0633458",
    "phoneNumber": "02-518-9810",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 3161,
    "name": "브라이트마인드학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 언주로30길 13 , 9층 902호 (도곡동, 대림아크로빌, 대림아크로텔)",
    "lat": "37.4881202",
    "lng": "127.0510778",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3162,
    "name": "위드액터스연기학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 논현로72길 29 , 2층 201호 (역삼동, RICHNOA VILL)",
    "lat": "37.4963848",
    "lng": "127.0416532",
    "phoneNumber": "02-0000-0000",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 3164,
    "name": "플라즈마대치학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 341 , 2층 (대치동, 인애빌딩)",
    "lat": "37.5018551",
    "lng": "127.058911",
    "phoneNumber": "02-557-5442",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3165,
    "name": "이데아아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도산대로25길 37 2층(신사동)",
    "lat": "37.5219551",
    "lng": "127.0261133",
    "phoneNumber": "02-6207-2727",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3166,
    "name": "서울아이비영어원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 논현로132길 13 , 4층 4173호 (논현동)",
    "lat": "37.5152717",
    "lng": "127.0316026",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3168,
    "name": "잉클링스어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 서래로 17 , 501호 (반포동, 럭스빌딩)",
    "lat": "37.496695",
    "lng": "126.9980149",
    "phoneNumber": "02-6953-0840",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3169,
    "name": "파인만엠수학압구정캠퍼스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로32길 23 , 4층 (신사동)",
    "lat": "37.5262125",
    "lng": "127.0300613",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3172,
    "name": "앤디프랩원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 도산대로 145 , 1202호 (신사동, 인우빌딩(INWOO))",
    "lat": "37.5185356",
    "lng": "127.0244178",
    "phoneNumber": "02-000-0000",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3174,
    "name": "청담아카데미영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 학동로63길 8 , 2층 전체 (청담동)",
    "lat": "37.5185516",
    "lng": "127.0450114",
    "phoneNumber": "02-546-0579",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3178,
    "name": "그레이드원5관수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 408 , 505호 (대치동, 디마크 빌딩)",
    "lat": "37.4966281",
    "lng": "127.055214",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 3181,
    "name": "에스티엘에듀원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 강남대로 584 , 6층 394호 (논현동, 성일빌딩)",
    "lat": "37.513958",
    "lng": "127.0206632",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3182,
    "name": "자람영재수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 반포대로 300 , 8층 706호 (잠원동, 덕성빌딩)",
    "lat": "37.505956",
    "lng": "127.0011819",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3186,
    "name": "대치스마트보카학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로64길 11-15 , 4층 401호 (대치동)",
    "lat": "37.4988592",
    "lng": "127.052612",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3187,
    "name": "날개달기레전드학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로62길 37 , 2층 전체 (대치동)",
    "lat": "37.4977724",
    "lng": "127.0545696",
    "phoneNumber": "02-529-9501",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3192,
    "name": "관우쌤과세상을품은교육(세품교)입시컨설팅원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 영동대로85길 20-7 (대치동) 5층 524호",
    "lat": "37.5073855",
    "lng": "127.0616476",
    "phoneNumber": "02-0000-0000",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3194,
    "name": "따뜻한수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 개포로 512 , 308호, 310호 (개포동, 개포종합상가)",
    "lat": "37.4892714",
    "lng": "127.0688177",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3195,
    "name": "아이리드원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 테헤란로82길 15 , 11층 1007호 (대치동)",
    "lat": "37.5060315",
    "lng": "127.0582357",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3198,
    "name": "애플과학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 189 , 402,409,415,416호 (잠원동, 반포쇼핑타운)",
    "lat": "37.5065127",
    "lng": "127.0047106",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3199,
    "name": "블루플랜학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 명달로 53 , 2층 전체 (방배동)",
    "lat": "37.4822407",
    "lng": "127.0044622",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3201,
    "name": "대치수능선배학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 424 , 2층 일부 (대치동, 진영빌딩)",
    "lat": "37.5010752",
    "lng": "127.0534432",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3202,
    "name": "수학싸부원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 헌릉로 176 , 4층 409호 일부(좌측) (내곡동, 서울영동농협종합시설)",
    "lat": "37.4564771999999",
    "lng": "127.0593952",
    "phoneNumber": "00-1544-7827",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3203,
    "name": "비에이치(BH)영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로63길 8 , 301호 (대치동, 에벤에셀)",
    "lat": "37.5000803",
    "lng": "127.0594826",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3204,
    "name": "뉴튼아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 논현로135길 10 , 1층일부,2층전체,3층일부 (논현동)",
    "lat": "37.5156126",
    "lng": "127.028912",
    "phoneNumber": "02-0000-0000",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3209,
    "name": "아만(AMAN)어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 압구정로 214 , 204호, 205호 (신사동, 현대종합상가빌딩)",
    "lat": "37.5279527",
    "lng": "127.0307698",
    "phoneNumber": "02-6956-5556",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3210,
    "name": "해법수학교실압구정학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 언주로167길 38 , 4층 (신사동)",
    "lat": "37.5266224999999",
    "lng": "127.0301064",
    "phoneNumber": "02-6207-4111",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3211,
    "name": "스텝원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 테헤란로2길 27 , 11층 1115호 (역삼동, 패스트파이브빌딩)",
    "lat": "37.4965546",
    "lng": "127.0296354",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3213,
    "name": "플레이팩토매쓰앤사고력학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 개포로82길 13-9 , 305호, 306호 (개포동, 세종빌딩)",
    "lat": "37.4886373",
    "lng": "127.0677765",
    "phoneNumber": "02-0000-0000",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 3214,
    "name": "한백학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 사임당로 151 , 4층 401호 (서초동, 대한무지개종합상가)",
    "lat": "37.4923671",
    "lng": "127.0258472",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3215,
    "name": "옥토퍼스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동산로 61 , 3층 전체 (양재동, 선진빌딩)",
    "lat": "37.4720886",
    "lng": "127.0455125",
    "phoneNumber": "070-8878-8209",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3218,
    "name": "김광진영어원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 역삼로73길 14 , 3층 303호 (대치동)",
    "lat": "37.5029116",
    "lng": "127.055283",
    "phoneNumber": "02-558-2526",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3220,
    "name": "영감수학고등관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로63길 36 , 4층 (대치동, CNK)",
    "lat": "37.4992995",
    "lng": "127.0536862",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 3221,
    "name": "엠에듀원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 도산대로37길 8 , 2층 (신사동)",
    "lat": "37.5215429",
    "lng": "127.0315806",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3223,
    "name": "필즈더클래식압구정센터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 논현로168길 18 , 601호 (신사동, 동신빌딩)",
    "lat": "37.5243974",
    "lng": "127.0298895",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3224,
    "name": "얼라이언스에듀케이션(Alliance Education)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 강남대로98길 11 , 4층 일부(우측) (역삼동, 메트로 빌딩)",
    "lat": "37.5008831",
    "lng": "127.027485",
    "phoneNumber": "02-6339-1111",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3225,
    "name": "벌리츠어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 테헤란로83길 15 , 2층 (삼성동, 제이엠빌딩)",
    "lat": "37.5084133",
    "lng": "127.0571905",
    "phoneNumber": "02-3453-0353",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 3226,
    "name": "투영맨엘셋(LSAT)원격학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 법원로3길 19 , 2층 D137호 (서초동, 양지원)",
    "lat": "37.493046",
    "lng": "127.0084307",
    "phoneNumber": "-",
    "교습과정": "성인고시",
    "isFinish": ""
  },
  {
    "number": 3230,
    "name": "프렙마스터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 언주로 874 , 8층 일부(신사동, 쌍봉빌딩)",
    "lat": "37.5285405",
    "lng": "127.0340485",
    "phoneNumber": "02-3444-2001",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3231,
    "name": "문원스마트리딩온원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 도곡로 509 , B1층 (대치동, 문원빌딩)",
    "lat": "37.4995866",
    "lng": "127.0620542",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3232,
    "name": "대치이강프리미엄학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 삼성로71길 11-3 , 1층, 4~6층(대치동)",
    "lat": "37.5019523",
    "lng": "127.0582259",
    "phoneNumber": "02-6101-0068",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3234,
    "name": "바로액터스연기학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 봉은사로37길 31 , 3층 (논현동)",
    "lat": "37.5101823",
    "lng": "127.0355734",
    "phoneNumber": "02-6949-1611",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 3237,
    "name": "에듀파크학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로46길 5-6 4층 406호",
    "lat": "37.5279733",
    "lng": "127.0372002",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3242,
    "name": "이스트랩어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 개포로36길 14 , 1~3층(개포동)",
    "lat": "37.4785665",
    "lng": "127.0513062",
    "phoneNumber": "02-0000-0000",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3245,
    "name": "누나영아카데미원격학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 서초대로78길 30 7층",
    "lat": "37.4951207",
    "lng": "127.0279608",
    "phoneNumber": "02-6053-5881",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 3246,
    "name": "잇올스파르타대치독학재수학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 428 2층 일부 (대치동)",
    "lat": "37.5012827",
    "lng": "127.0539228",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3247,
    "name": "잇올스파르타대치관리형독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 역삼로 428 , 2층 일부, 3층, 4층 (대치동)",
    "lat": "37.5012827",
    "lng": "127.0539228",
    "phoneNumber": "02-2039-5272",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": "완료"
  },
  {
    "number": 3248,
    "name": "올마이티캠퍼스3관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로68길 19 2층",
    "lat": "37.4994047",
    "lng": "127.0531876",
    "phoneNumber": "02-566-9011",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 3250,
    "name": "아침밥공부원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 논현로16길 20-10 , 2층 202호(개포동)",
    "lat": "37.4762469",
    "lng": "127.0484118",
    "phoneNumber": "02-566-5780",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3251,
    "name": "오픽패스원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 테헤란로82길 15 , 926호(대치동)",
    "lat": "37.5060315",
    "lng": "127.0582357",
    "phoneNumber": "02-0000-0000",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3252,
    "name": "아이스피크개포어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 삼성로 14 401호(개포자이프레지던스상가)",
    "lat": "37.4855370999999",
    "lng": "127.0714351",
    "phoneNumber": "02-566-0906",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3255,
    "name": "상운수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 사임당로 151 222호, 226호",
    "lat": "37.4923671",
    "lng": "127.0258472",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3256,
    "name": "메타프랩학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 논현로164길 25 2층",
    "lat": "37.5232932",
    "lng": "127.0303073",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3257,
    "name": "엄기엽수학논술전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로69길 15 502호(대치동)",
    "lat": "37.4901314",
    "lng": "127.0585502",
    "phoneNumber": "02-554-3070",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3259,
    "name": "일공이클래스원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 강남대로 368 4층 일부 (역삼동)",
    "lat": "37.4957163",
    "lng": "127.0292141",
    "phoneNumber": "02-0000-0000",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3260,
    "name": "월스트리트잉글리시강남어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 강남대로84길 16 9층(역삼동)",
    "lat": "37.4966779",
    "lng": "127.0299896",
    "phoneNumber": "02-783-6457",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 3261,
    "name": "아카로드레드학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 영동대로 231 , 4층(대치동)",
    "lat": "37.4997861",
    "lng": "127.0673274",
    "phoneNumber": "02-6204-5586",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3262,
    "name": "대치돌파2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 441 , 3층 일부(대치동)",
    "lat": "37.5022141",
    "lng": "127.0551232",
    "phoneNumber": "02-553-3378",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3263,
    "name": "혜성과학탐구학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로63길 8 201호(대치동,에벤에셀)",
    "lat": "37.5000803",
    "lng": "127.0594826",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3265,
    "name": "파란국어반포점학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 213 , 501~504호(잠원동)",
    "lat": "37.5072627",
    "lng": "127.0071911",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3266,
    "name": "심화랑수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로78길 21 , 2층(대치동)",
    "lat": "37.5011118",
    "lng": "127.0575386",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3269,
    "name": "원네스트원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 강남대로51길 10 , 비1층 108-21(서초동)",
    "lat": "37.4912348999999",
    "lng": "127.0290758",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3273,
    "name": "승승장구수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로 238 225호, 226호, 227호 전체 (반포동)",
    "lat": "37.5029529",
    "lng": "127.0120638",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3274,
    "name": "이강프리미엄독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 삼성로71길 11-3 , 2~3층(대치동)",
    "lat": "37.5019523",
    "lng": "127.0582259",
    "phoneNumber": "02-6101-0068",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3277,
    "name": "파서블에듀원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 테헤란로25길 20 , 1501호(역삼동)",
    "lat": "37.5016367",
    "lng": "127.0356339",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3278,
    "name": "웅진북클럽더라이브러리(TheLibrary)대치학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 408 , 306호 (대치동)",
    "lat": "37.4966877",
    "lng": "127.0552639",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 3280,
    "name": "박정규과학연구소원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 사평대로 18 3층 301호(방배동)",
    "lat": "37.4981855",
    "lng": "126.9863984",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3281,
    "name": "아키차일드학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 방배로32길 55 1층(방배동)",
    "lat": "37.4778829",
    "lng": "127.000334",
    "phoneNumber": "02-6080-2458",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 3282,
    "name": "이지아카데미원격학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "인문사회(대)",
    "학원주소\t": "서울특별시 서초구 서초대로24길 48 , 3층 일부(방배동)",
    "lat": "37.4853737",
    "lng": "126.9940479",
    "phoneNumber": "02-0000-0000",
    "교습과정": "대학편입",
    "isFinish": ""
  },
  {
    "number": 3283,
    "name": "대치엠에스지영재교육학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로71길 22 , 3층, 4층(대치동)",
    "lat": "37.501967",
    "lng": "127.0570787",
    "phoneNumber": "02-553-2584",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3284,
    "name": "엘리하이원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 효령로 321 8층 전체(서초동)",
    "lat": "37.4861473",
    "lng": "127.0191221",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3285,
    "name": "엘리하이키즈원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 효령로 321 2층 일부(서초동)",
    "lat": "37.4861473",
    "lng": "127.0191221",
    "phoneNumber": "02-3498-4159",
    "교습과정": "기타(중)",
    "isFinish": ""
  },
  {
    "number": 3287,
    "name": "피케이(PK)독학재수대치본원학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 424 5층 일부(대치동)",
    "lat": "37.5010752",
    "lng": "127.0534432",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 3288,
    "name": "더브리티시프리프렙강남학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 도곡로 187 2~5층(역삼동)",
    "lat": "37.4950878",
    "lng": "127.0476626",
    "phoneNumber": "02-6083-1273",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3289,
    "name": "에스엔티(SNT)토론학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 도곡로 519 (대치동)",
    "lat": "37.5000709",
    "lng": "127.0629888",
    "phoneNumber": "02-000-0000",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3292,
    "name": "아미영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로6길 20 3층(개포동)",
    "lat": "37.4831181",
    "lng": "127.0624589",
    "phoneNumber": "02-576-0010",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3294,
    "name": "동제편입원격학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "인문사회(대)",
    "학원주소\t": "서울특별시 서초구 강남대로53길 8 8-109호 (서초동)",
    "lat": "37.4945363",
    "lng": "127.0280183",
    "phoneNumber": "02-555-6601",
    "교습과정": "대학편입",
    "isFinish": ""
  },
  {
    "number": 3295,
    "name": "융합인재학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 사평대로 150 202, 203, 204, 212, 213, 214, 215, 216호(반포동)",
    "lat": "37.5004321",
    "lng": "127.0007142",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3296,
    "name": "에쓰디씨1학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 동광로8길 1 2층, 3층 (방배동)",
    "lat": "37.4907908",
    "lng": "126.9856807",
    "phoneNumber": "02-593-3366",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3297,
    "name": "에쓰디씨2학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 동광로 21 2층, 3층(방배동)",
    "lat": "37.4910447",
    "lng": "126.9853262",
    "phoneNumber": "02-593-3366",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3301,
    "name": "퍼펙트제이댄스스튜디오글로벌센터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 사평대로55길 139 , 4층(반포동)",
    "lat": "37.5100184",
    "lng": "127.0199397",
    "phoneNumber": "02-0000-0000",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 3304,
    "name": "에더블빌리지가든어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 봉은사로49길 37-5 지하1층, 지상1~2층(논현동)",
    "lat": "37.5123984",
    "lng": "127.0409531",
    "phoneNumber": "02-000-0000",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3305,
    "name": "칸관리형독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 선릉로 227 , 501호 일부의 좌측(도곡동)",
    "lat": "37.4958321",
    "lng": "127.0527291",
    "phoneNumber": "02-6954-0913",
    "교습과정": "독서실",
    "isFinish": ""
  },
  {
    "number": 3307,
    "name": "아이매쓰학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로18길 19 3층(신사동)",
    "lat": "37.5238091",
    "lng": "127.0249922",
    "phoneNumber": "02-000-0000",
    "교습과정": "보통교과",
    "isFinish": ""
  },
  {
    "number": 3308,
    "name": "교대타임독학재수학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초대로 341 , 4층 일부, 5층 전체(서초동)",
    "lat": "37.4955032",
    "lng": "127.018753",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3310,
    "name": "수학작가학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 441 시상빌딩 1층(대치동)",
    "lat": "37.5022141",
    "lng": "127.0551232",
    "phoneNumber": "-",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3311,
    "name": "대치청연외고관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로64길 45 201호(대치동)",
    "lat": "37.5009632",
    "lng": "127.0639676",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3315,
    "name": "청담국어논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로112길 71 4층(삼성동)",
    "lat": "37.5128403",
    "lng": "127.0493073",
    "phoneNumber": "02-543-8667",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3317,
    "name": "이든수학2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 520 4층(대치동)",
    "lat": "37.4994149",
    "lng": "127.0634446",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3318,
    "name": "인웨이즈어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 언주로 866 , 3층(신사동)",
    "lat": "37.5276085",
    "lng": "127.033949",
    "phoneNumber": "02-546-9199",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3319,
    "name": "대치동이룸영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로64길 15-6 3층(대치동,동원빌딩)",
    "lat": "37.4984495",
    "lng": "127.0535558",
    "phoneNumber": "070-4252-1556",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3320,
    "name": "심앤김국수시대국어관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 명달로 58 301호(서초동)",
    "lat": "37.4825161",
    "lng": "127.0048122",
    "phoneNumber": "02-3234-9688",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3321,
    "name": "엠베스트에스이(SE)강남일원센터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 일원로5길 30 2층 좌측일부(일원동)",
    "lat": "37.4915382",
    "lng": "127.0831998",
    "phoneNumber": "-",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3322,
    "name": "빅루트아카데미연기학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 서초중앙로2길 68 2층(서초동)",
    "lat": "37.4845602",
    "lng": "127.0210242",
    "phoneNumber": "02-0000-0000",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 3325,
    "name": "챔피언수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로62길 27-3 , 3층(대치동)",
    "lat": "37.4979911",
    "lng": "127.0546888",
    "phoneNumber": "02-539-3324",
    "교습과정": "보습",
    "isFinish": "완료"
  },
  {
    "number": 3326,
    "name": "리드인대치센터독서논술국어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2941 6층 604호(대치동)",
    "lat": "37.4942268",
    "lng": "127.0617852",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3327,
    "name": "라라엘어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 도곡로 160 4~6층(도곡동)",
    "lat": "37.4910381",
    "lng": "127.0374518",
    "phoneNumber": "02-578-9991",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3328,
    "name": "에그릿원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 테헤란로8길 37 6층 일부(전면부)(역삼동)",
    "lat": "37.4966013",
    "lng": "127.0325739",
    "phoneNumber": "02-1644-1248",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3329,
    "name": "김지현수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2936 , 206호 일부(대치동)",
    "lat": "37.4933573",
    "lng": "127.0619092",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3330,
    "name": "프리매쓰원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 마방로6길 13 4층 4226호 (양재동)",
    "lat": "37.4751692",
    "lng": "127.0422496",
    "phoneNumber": "02-0000-0000",
    "교습과정": "기타(중)",
    "isFinish": ""
  },
  {
    "number": 3332,
    "name": "길포드아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 남부순환로356길 85 (양재동)",
    "lat": "37.481296",
    "lng": "127.0389485",
    "phoneNumber": "02-000-0000",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3333,
    "name": "메타에듀(METAEDU)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로365길 39 5층(도곡동)",
    "lat": "37.4880389",
    "lng": "127.0397773",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3336,
    "name": "서초방배소마학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 사평대로2길 16 (방배동)",
    "lat": "37.4978437",
    "lng": "126.9859789",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3337,
    "name": "아이에스이(ISE)영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 460-2 2층 (대치동)",
    "lat": "37.502404",
    "lng": "127.0576734",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3339,
    "name": "리피치원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 서초대로78길 36 9층 901호(서초동)",
    "lat": "37.4947876",
    "lng": "127.0281223",
    "phoneNumber": "-",
    "교습과정": "기타(중)",
    "isFinish": ""
  },
  {
    "number": 3342,
    "name": "서초크라센방배고등2관영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 명달로9길 5 5층 전체(방배동)",
    "lat": "37.4818986",
    "lng": "127.0044796",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3343,
    "name": "브로드웨이뮤지컬센터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 논현로121길 12 2층(논현동)",
    "lat": "37.5111292",
    "lng": "127.0308688",
    "phoneNumber": "-",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 3344,
    "name": "오라수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로10길 12 2층, 3층(반포동)",
    "lat": "37.5017462",
    "lng": "127.0103455",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3345,
    "name": "의치약생기부전문관리원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 테헤란로78길 14-6 , 6층 605호(대치동)",
    "lat": "37.505322",
    "lng": "127.0549631",
    "phoneNumber": "02-0000-0000",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3346,
    "name": "메이드학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로57길 31 3층(대치동)",
    "lat": "37.4973219",
    "lng": "127.0585426",
    "phoneNumber": "02-561-8973",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3348,
    "name": "대치세이노학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로57길 31 2층(대치동)",
    "lat": "37.4973219",
    "lng": "127.0585426",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3349,
    "name": "대치세이드입시컨설팅학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로57길 31 4층, 5층 일부(대치동)",
    "lat": "37.4973219",
    "lng": "127.0585426",
    "phoneNumber": "-",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3351,
    "name": "팀알버트학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 논현로168길 47 2층(신사동)",
    "lat": "37.5233474",
    "lng": "127.0319867",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3352,
    "name": "한선영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 고무래로10길 27 1층 일부(반포동)",
    "lat": "37.5003314",
    "lng": "127.0101783",
    "phoneNumber": "-",
    "교습과정": "외국어",
    "isFinish": ""
  },
  {
    "number": 3353,
    "name": "더베스트영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동산로 69 2층(양재동)",
    "lat": "37.4722949",
    "lng": "127.046151",
    "phoneNumber": "070-4006-7177",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3354,
    "name": "돌파수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 416 , 2층, 4층, 5층, 6층(대치동)",
    "lat": "37.5009356",
    "lng": "127.0526234",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 3355,
    "name": "다비수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동산로 82 , 2층 전체 (양재동)",
    "lat": "37.4727846",
    "lng": "127.0476307",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3356,
    "name": "배우앤배움입시센터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 사평대로53길 107 5층, 6층(반포동)",
    "lat": "37.5088952",
    "lng": "127.0197021",
    "phoneNumber": "02-540-3507",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 3358,
    "name": "컬럼비아잉글리쉬인스티튜트(COLUMBIAENGLISHINSTITUTE)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 151 301호의 일부 3/4(대치동,선경아파트)",
    "lat": "37.501332",
    "lng": "127.0746512",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3359,
    "name": "아이작입시전문원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 테헤란로64길 13 , 제O605B호(대치동,선릉역 풍림아이원레몬)",
    "lat": "37.5041457",
    "lng": "127.051482",
    "phoneNumber": "02-0000-0000",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3361,
    "name": "수리원수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 반포대로 291 , 4층 411호, 412호(반포동)",
    "lat": "37.5047428",
    "lng": "126.9950006",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보통교과",
    "isFinish": ""
  },
  {
    "number": 3363,
    "name": "깊은생각김성호수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 520 2층(대치동)",
    "lat": "37.4994149",
    "lng": "127.0634446",
    "phoneNumber": "02-569-7702",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3364,
    "name": "뉴파인초중등강남관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 사임당로 158 502호(서초동)",
    "lat": "37.4918367",
    "lng": "127.0271678",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3365,
    "name": "리딩코치영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로365길 36 2층(도곡동)",
    "lat": "37.4876018",
    "lng": "127.0398772",
    "phoneNumber": "-",
    "교습과정": "보통교과",
    "isFinish": ""
  },
  {
    "number": 3366,
    "name": "문해와수리학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "",
    "학원주소\t": "서울특별시 강남구 선릉로64길 17 , 4층(대치동)",
    "lat": "37.4982437",
    "lng": "127.0536538",
    "phoneNumber": "02-555-2225",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3368,
    "name": "수놀음수능교육센터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로64길 15-8 3층(대치동)",
    "lat": "37.4986023",
    "lng": "127.0534792",
    "phoneNumber": "02-556-9916",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3369,
    "name": "넥스트닥(NEXTDOC)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 삼성로71길 18 5층(대치동)",
    "lat": "37.5021118",
    "lng": "127.0573859",
    "phoneNumber": "02-567-9155",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3370,
    "name": "유리스타즈아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 서초중앙로24길 55 , 203호, 209호(서초동)",
    "lat": "37.4961565",
    "lng": "127.0193719",
    "phoneNumber": "02-0000-0000",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 3373,
    "name": "이타적인간의이기적공부법학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로 8 6층 (반포동)",
    "lat": "37.50366",
    "lng": "127.010008",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3374,
    "name": "써니국어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 반포대로 291 , 442, 446, 447호(반포동)",
    "lat": "37.4955764",
    "lng": "127.0056948",
    "phoneNumber": "02-591-3877",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3375,
    "name": "국어하는사람들학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로71길 29 4층(대치동)",
    "lat": "37.5015299",
    "lng": "127.0565389",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 3378,
    "name": "이든영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로10길 10 5층(반포동)",
    "lat": "37.5018993",
    "lng": "127.0104491",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3379,
    "name": "강남타임독학재수학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 사임당로 175 , 5층 501호~503호(서초동)",
    "lat": "37.4929461",
    "lng": "127.0286946",
    "phoneNumber": "02-6954-2486",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3382,
    "name": "엠아이엔케이(MINK)수학과학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로63길 25 (대치동)",
    "lat": "37.498657",
    "lng": "127.0536619",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3384,
    "name": "대치투에스에듀학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 331 4층(역삼동)",
    "lat": "37.4964861",
    "lng": "127.0522022",
    "phoneNumber": "02-564-2279",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3387,
    "name": "대치이강프리미엄엠에스1학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 352 2층 (201호, 202호)  (대치동)",
    "lat": "37.5030229",
    "lng": "127.05911",
    "phoneNumber": "02-6101-0068",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3388,
    "name": "강남삼성학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로69길 7 4층(역삼동)",
    "lat": "37.4984477",
    "lng": "127.051206",
    "phoneNumber": "02-3452-3450",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3390,
    "name": "대치해법수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 447 4층 일부(A호)(대치동)",
    "lat": "37.4987688",
    "lng": "127.0593926",
    "phoneNumber": "02-564-4222",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 3391,
    "name": "윤도영별관2학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로77길 8 2층 전체 (대치동)",
    "lat": "37.4989048",
    "lng": "127.058679",
    "phoneNumber": "02-567-4767",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3392,
    "name": "윤도영별관3학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로77길 8 (대치동)",
    "lat": "37.4989048",
    "lng": "127.058679",
    "phoneNumber": "02-567-4767",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3393,
    "name": "윤도영별관4학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로77길 8 , 4층 전체(대치동)",
    "lat": "37.4989048",
    "lng": "127.058679",
    "phoneNumber": "02-567-4767",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3394,
    "name": "윤도영별관5학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로77길 8 , 5층 전체(대치동)",
    "lat": "37.4989048",
    "lng": "127.058679",
    "phoneNumber": "02-567-4767",
    "교습과정": "보습",
    "isFinish": "완료"
  },
  {
    "number": 3395,
    "name": "깊은생각수학의원리3관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 233 , 4층 일부 (508호 ~ 511호) (대치동)",
    "lat": "37.4933928",
    "lng": "127.0673501",
    "phoneNumber": "02-562-4070",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3396,
    "name": "포디엄에듀학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로34길 11 504호, 505호(신사동)",
    "lat": "37.5273895",
    "lng": "127.030957",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3397,
    "name": "얼짱수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 개포로82길 13-11 , 301호(개포동)",
    "lat": "37.4887258",
    "lng": "127.0681319",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3398,
    "name": "편입엔편입학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "인문사회(대)",
    "학원주소\t": "서울특별시 서초구 서초대로77길 24 1층, 1101호, 1102호(서초동)",
    "lat": "37.5000238",
    "lng": "127.0259874",
    "phoneNumber": "02-0000-0000",
    "교습과정": "대학편입",
    "isFinish": ""
  },
  {
    "number": 3400,
    "name": "서리풀글로벌아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 청두곶길 70 , 1층, 2층(방배동)",
    "lat": "37.4828586",
    "lng": "126.9855994",
    "phoneNumber": "02-534-7233",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 3402,
    "name": "케이엔에스(KNS)초등2관영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 515 4층 401호(대치동)",
    "lat": "37.4998352",
    "lng": "127.0626495",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3403,
    "name": "스터디앤아트컨설팅학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로76길 40 2층(대치동)",
    "lat": "37.5021507",
    "lng": "127.0537655",
    "phoneNumber": "02-555-0513",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3404,
    "name": "윤도영본관6학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로61길 22 6층(대치동)",
    "lat": "37.4991092",
    "lng": "127.058612",
    "phoneNumber": "02-567-4767",
    "교습과정": "보습",
    "isFinish": "완료"
  },
  {
    "number": 3405,
    "name": "콴다일로3관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 311 , 1층(대치동)",
    "lat": "37.4996418",
    "lng": "127.0601672",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3408,
    "name": "에이에이에이(AAA)유학원격학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 강남대로 438 , 503~506호(역삼동)",
    "lat": "37.501652",
    "lng": "127.0263751",
    "phoneNumber": "02-0000-0000",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 3409,
    "name": "대치잉글리쉬파크도산어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 언주로164길 16 1층, 2층(신사동,윤빌딩)",
    "lat": "37.5252749",
    "lng": "127.0347946",
    "phoneNumber": "02-515-0782",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3410,
    "name": "에듀프렌즈아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동광로49길 64 지하1층(반포동)",
    "lat": "37.4960643",
    "lng": "127.0015598",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3412,
    "name": "아지트(AZT)수학과학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로31길 20 5층, 6층(반포동)",
    "lat": "37.4996861",
    "lng": "127.0101579",
    "phoneNumber": "02-595-4579",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3413,
    "name": "스코관리형독학재수학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로69길 10 301호(대치동)",
    "lat": "37.5022247",
    "lng": "127.0540136",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3414,
    "name": "엘브라운앤드원학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로64길 46 4층 일부(좌측)(대치동)",
    "lat": "37.5007554",
    "lng": "127.0642647",
    "phoneNumber": "02-563-0533",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3415,
    "name": "비아이비(BIB)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배로 91 , 3층 전체(방배동)",
    "lat": "37.4824269",
    "lng": "126.9966908",
    "phoneNumber": "02-584-5425",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3420,
    "name": "에스온수리영재아카데미수학센터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 554 , 5층(대치동)",
    "lat": "37.5045268999999",
    "lng": "127.0637441",
    "phoneNumber": "-",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3421,
    "name": "강남대성제4퀀텀라이브러리독서실",
    "학원종류": "평생직업교육학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 테헤란로4길 45 3층, 7층 (역삼동)",
    "lat": "37.4955286",
    "lng": "127.0310687",
    "phoneNumber": "02-581-7888",
    "교습과정": "독서실(일반인)",
    "isFinish": ""
  },
  {
    "number": 3423,
    "name": "두각창비관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 501 5층(501~504호)(대치동)",
    "lat": "37.4993898",
    "lng": "127.061127",
    "phoneNumber": "02-556-2733",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3424,
    "name": "플라즈마고등3관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로71길 7 , 4층(대치동)",
    "lat": "37.5021276",
    "lng": "127.0583283",
    "phoneNumber": "02-557-5442",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3426,
    "name": "소도스카이입시학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초대로50길 40 , 3층 (서초동)",
    "lat": "37.4914815",
    "lng": "127.0131129",
    "phoneNumber": "02-6053-3131",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3429,
    "name": "소마사고력수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 효령로 403 4층 401호 전체 (서초동)",
    "lat": "37.4890871",
    "lng": "127.0261778",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3430,
    "name": "일류수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로 253 , 5층(반포동)",
    "lat": "37.5039559",
    "lng": "127.0104668",
    "phoneNumber": "02-593-0213",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3431,
    "name": "청담스칼라학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로149길 5 , 202호(청담동)",
    "lat": "37.5232523",
    "lng": "127.0472656",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3433,
    "name": "에이플러스영어수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 개포로22길 98 , 2층(개포동)",
    "lat": "37.4753427",
    "lng": "127.053248",
    "phoneNumber": "02-577-8977",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3434,
    "name": "시크릿프랩학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 개포로15길 8 , 2층(개포동)",
    "lat": "37.4790042",
    "lng": "127.0454015",
    "phoneNumber": "-",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3435,
    "name": "키사서초1관어학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 사임당로23길 30 , 1층(서초동)",
    "lat": "37.4915978",
    "lng": "127.0208992",
    "phoneNumber": "02-523-0509",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3436,
    "name": "키사서초2관어학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 사임당로23길 32 , 1~2층(서초동)",
    "lat": "37.4919054",
    "lng": "127.0209189",
    "phoneNumber": "02-523-0509",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3437,
    "name": "최상위하다학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 사임당로 151 , 5층 2호 전체(서초동)",
    "lat": "37.4923671",
    "lng": "127.0258472",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3438,
    "name": "디앤에이댄스스튜디오학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 봉은사로30길 70 , 3층 전체 (역삼동)",
    "lat": "37.5029987",
    "lng": "127.0366967",
    "phoneNumber": "02-0000-0000",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 3439,
    "name": "뉴파인동덕특별관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 효령로2길 9 , 4층 일부(방배동)",
    "lat": "37.4765182",
    "lng": "126.986922",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3440,
    "name": "대찬학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 432 3층 일부(대치동)",
    "lat": "37.4975707",
    "lng": "127.0577513",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3441,
    "name": "대찬V학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 432 5층 일부(대치동)",
    "lat": "37.4975707",
    "lng": "127.0577513",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 3442,
    "name": "책나무독서논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 227 ,  301-2호(도곡동)",
    "lat": "37.4902694",
    "lng": "127.0471433",
    "phoneNumber": "02-574-4005",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3444,
    "name": "반포이엠수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 177 , 반포쇼핑타운 3동 5층 10호일부, 11호, 12호, 13호, 14호일부(잠원동)",
    "lat": "37.5060582",
    "lng": "127.0033885",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3445,
    "name": "가인프라임관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 반포대로 287 , 325호, 326호(반포동)",
    "lat": "37.5043394",
    "lng": "127.0008523",
    "phoneNumber": "02-532-8522",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3446,
    "name": "브라운편입학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "인문사회(대)",
    "학원주소\t": "서울특별시 강남구 테헤란로4길 28 , 9층(역삼동)",
    "lat": "37.4965132",
    "lng": "127.0300705",
    "phoneNumber": "02-565-1381",
    "교습과정": "대학편입",
    "isFinish": ""
  },
  {
    "number": 3447,
    "name": "엠에스씨학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로71길 9 , 5층(대치동)",
    "lat": "37.5020912",
    "lng": "127.0581508",
    "phoneNumber": "02-557-9864",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3448,
    "name": "제이포커스매쓰학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동광로19길 19 , 2층(방배동)",
    "lat": "37.493438",
    "lng": "126.9889159",
    "phoneNumber": "02-532-3140",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3449,
    "name": "브레인코칭원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 테헤란로82길 15 11층 551호(대치동)",
    "lat": "37.5060315",
    "lng": "127.0582357",
    "phoneNumber": "-",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3450,
    "name": "대치아이작수능사고력학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 323 1층(대치동)",
    "lat": "37.5006127",
    "lng": "127.0596197",
    "phoneNumber": "-",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3451,
    "name": "오르다국어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로29길 23 2층 전체(반포동)",
    "lat": "37.4985513",
    "lng": "127.0095208",
    "phoneNumber": "-",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3452,
    "name": "매쓰테라피원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 논현로132길 13 , 4층 4739호(논현동)",
    "lat": "37.5152717",
    "lng": "127.0316026",
    "phoneNumber": "-",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3453,
    "name": "지엠(GM)수학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 헌릉로569길 23 , 301호(세곡동)",
    "lat": "37.4668009",
    "lng": "127.0992395",
    "phoneNumber": "-",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3457,
    "name": "드림댄스아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 강남대로 578 (논현동)",
    "lat": "37.5136787",
    "lng": "127.0317124",
    "phoneNumber": "070-4203-7915",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 3458,
    "name": "생각의힘수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동작대로 198 , 4층 일부(방배동)",
    "lat": "37.4942847",
    "lng": "126.9831867",
    "phoneNumber": "02-533-0931",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3459,
    "name": "시대인재H관부엉이라이브러리독서실",
    "학원종류": "평생직업교육학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 도곡로 453 2층(대치동)",
    "lat": "37.4989394",
    "lng": "127.0599205",
    "phoneNumber": "02-000-0000",
    "교습과정": "독서실(일반인)",
    "isFinish": ""
  },
  {
    "number": 3460,
    "name": "시대인재H관부엉이라이브러리2독서실",
    "학원종류": "평생직업교육학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 도곡로 453 3층(대치동)",
    "lat": "37.4989394",
    "lng": "127.0599205",
    "phoneNumber": "02-000-0000",
    "교습과정": "독서실(일반인)",
    "isFinish": ""
  },
  {
    "number": 3461,
    "name": "대치720이과전문관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 논현로1길 13 , 2층(양재동)",
    "lat": "37.4719694",
    "lng": "127.0500749",
    "phoneNumber": "02-1899-6160",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3462,
    "name": "위드러너입시전문원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 남부순환로335길 35 , 3층 303호 A06호(서초동)",
    "lat": "37.4841315",
    "lng": "127.0215358",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3463,
    "name": "시대인재H관부엉이라이브러리3독서실",
    "학원종류": "평생직업교육학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 도곡로 453 , 4층(대치동)",
    "lat": "37.4989394",
    "lng": "127.0599205",
    "phoneNumber": "02-0000-0000",
    "교습과정": "독서실(일반인)",
    "isFinish": ""
  },
  {
    "number": 3464,
    "name": "시대인재H관부엉이라이브러리4독서실",
    "학원종류": "평생직업교육학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 도곡로 453 , 5층, 6층(대치동)",
    "lat": "37.4989394",
    "lng": "127.0599205",
    "phoneNumber": "02-0000-0000",
    "교습과정": "독서실(일반인)",
    "isFinish": "완료"
  },
  {
    "number": 3465,
    "name": "논술인강원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로85길 39 , 3층 308호(대치동)",
    "lat": "37.5042562",
    "lng": "127.0541147",
    "phoneNumber": "02-501-3558",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3467,
    "name": "크림슨수학원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 테헤란로86길 15 , 3층 3118호(대치동)",
    "lat": "37.5064486",
    "lng": "127.0595016",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3468,
    "name": "에스엔티(SNT)예고아르떼학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 521 , 1층 101호, 102호, 103호(대치동)",
    "lat": "37.5000321",
    "lng": "127.0632277",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3470,
    "name": "상상독학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 416 1층, 2층(대치동)",
    "lat": "37.4991887",
    "lng": "127.0633458",
    "phoneNumber": "02-501-0577",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3473,
    "name": "퀸스칼리지어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 서초대로 141-19 , 1층, 2층(방배동)",
    "lat": "37.4894106",
    "lng": "126.9982022",
    "phoneNumber": "02-0000-0000",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3475,
    "name": "입시위키스터디센터입시학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로69길 7 5층 전체(역삼동)",
    "lat": "37.4984477",
    "lng": "127.051206",
    "phoneNumber": "-",
    "교습과정": "진학지도",
    "isFinish": ""
  },
  {
    "number": 3476,
    "name": "올마이티캠퍼스원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 테헤란로 406 A동 1913호,1914호(대치동)",
    "lat": "37.5044068",
    "lng": "127.0497041",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 3477,
    "name": "두각이룸관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 442 6층 601호(대치동)",
    "lat": "37.4979348",
    "lng": "127.0588248",
    "phoneNumber": "02-556-2700",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3478,
    "name": "더킹스아카데미원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 논현로168길 36 , 3층 28호(신사동)",
    "lat": "37.5232126999999",
    "lng": "127.0309526",
    "phoneNumber": "02-0000-0000",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3480,
    "name": "리정멘탈영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 184 601호 (도곡동)",
    "lat": "37.4879814",
    "lng": "127.0453988",
    "phoneNumber": "-",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3481,
    "name": "대치알파학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로58길 39 , 3층 301호(대치동)",
    "lat": "37.4994486",
    "lng": "127.0642747",
    "phoneNumber": "02-563-1477",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3484,
    "name": "포레스트레인아카데미어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 논현로152길 23 2층(신사동)",
    "lat": "37.5214898",
    "lng": "127.0301615",
    "phoneNumber": "02-6011-9131",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3485,
    "name": "와이즈잉글리쉬학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 논현로159길 23 3층(신사동)",
    "lat": "37.5228326",
    "lng": "127.0262683",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3486,
    "name": "612어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 강남대로 399 8층(서초동)",
    "lat": "37.4982763",
    "lng": "127.026863",
    "phoneNumber": "02-000-0000",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 3487,
    "name": "서초압구정국어논술고등관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로31길 6-9 , 401호(반포동)",
    "lat": "37.5005049",
    "lng": "127.0112256",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3488,
    "name": "강남대치관러닝어취브학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 언주로 313 , 202호, 204호(역삼동)",
    "lat": "37.4956565",
    "lng": "127.0456069",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3491,
    "name": "리드인국어논술제2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로24길 55 402호(서초동)",
    "lat": "37.4961565",
    "lng": "127.0193719",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3492,
    "name": "베리타스에스판검관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로62길 9 2층(대치동)",
    "lat": "37.4974494999999",
    "lng": "127.0534675",
    "phoneNumber": "02-564-5557",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3493,
    "name": "에스에듀세곡학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 헌릉로 569 202호(세곡동)",
    "lat": "37.4657816",
    "lng": "127.1011914",
    "phoneNumber": "-",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3495,
    "name": "정통어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 남부순환로 2909 , 508호, 509호(대치동)",
    "lat": "37.4922077",
    "lng": "127.0573813",
    "phoneNumber": "02-555-6565",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3496,
    "name": "반포체리군단국어논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로3길 8 606호(반포동)",
    "lat": "37.5021022",
    "lng": "126.9869475",
    "phoneNumber": "02-3487-3660",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3497,
    "name": "미래탐구영재특목센터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 325 2층(대치동)",
    "lat": "37.5007467",
    "lng": "127.059549",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3501,
    "name": "클라이피에듀센터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 352 , 401호, 502호(대치동)",
    "lat": "37.4901314",
    "lng": "127.0585502",
    "phoneNumber": "02-553-0901",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3503,
    "name": "하이스카이학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로7길 17 , 6층(역삼동)",
    "lat": "37.4917443",
    "lng": "127.0342848",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3504,
    "name": "두각대성원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 테헤란로4길 38-4 , 2층 일부 (역삼동)",
    "lat": "37.4959565",
    "lng": "127.0302668",
    "phoneNumber": "070-4349-3355",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3509,
    "name": "사이언스아카데미원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 영동대로 602 (삼성동,삼성동 미켈란 107)",
    "lat": "37.5145426",
    "lng": "127.0606852",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3510,
    "name": "나우잉글리쉬영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로28길 22-10 301호(신사동)",
    "lat": "37.5252628",
    "lng": "127.0268712",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3511,
    "name": "민트수학보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 150 , 308호(대치동,한보종합상가)",
    "lat": "37.4933928",
    "lng": "127.0673501",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3512,
    "name": "대치파인만중등관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 150 , 304호 (대치동, 한보미도맨션)",
    "lat": "37.4925906",
    "lng": "127.066184",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3515,
    "name": "엘루시도영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 반포대로 291 , 4층 426호, 427호, 428호(반포동)",
    "lat": "37.4955764",
    "lng": "127.0056948",
    "phoneNumber": "02-3478-7650",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3516,
    "name": "내일도국어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 성촌1길 20 3층 301호(우면동)",
    "lat": "37.4655124",
    "lng": "127.021701",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3518,
    "name": "리드인독서논술국어방배이수학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 청두곶길 38-2 , 2층(방배동)",
    "lat": "37.4799996",
    "lng": "126.9854469",
    "phoneNumber": "02-598-3689",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3521,
    "name": "김영편입의대전문관학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "인문사회(대)",
    "학원주소\t": "서울특별시 서초구 서초대로78길 48 13층 일부(서초동)",
    "lat": "37.4934895",
    "lng": "127.0285991",
    "phoneNumber": "02-000-0000",
    "교습과정": "대학편입",
    "isFinish": ""
  },
  {
    "number": 3526,
    "name": "유일수학2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로77길 6 , 3층 (대치동)",
    "lat": "37.5029578",
    "lng": "127.0566095",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3530,
    "name": "잉크레더블영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로365길 43 111호(도곡동)",
    "lat": "37.4876219",
    "lng": "127.0395944",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3533,
    "name": "메이저맵진로진학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로75길 33 , 2층(대치동)",
    "lat": "37.5027509",
    "lng": "127.0556381",
    "phoneNumber": "02-353-5025",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3535,
    "name": "띵크앤리드맥스영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 효령로 403 521호, 522호(서초동, 서초동그랑자이 그랑몰)",
    "lat": "37.4890871",
    "lng": "127.0261778",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3537,
    "name": "테스트네이션(TEST-NATION)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 학동로30길 34 2층(논현동)",
    "lat": "37.5119432",
    "lng": "127.032514",
    "phoneNumber": "070-4245-9428",
    "교습과정": "외국어",
    "isFinish": ""
  },
  {
    "number": 3540,
    "name": "꿈짜수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로64길 11-5 201호(대치동)",
    "lat": "37.4983086",
    "lng": "127.0528655",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3541,
    "name": "꿈짜수학2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로64길 11-5 203호(대치동)",
    "lat": "37.4983086",
    "lng": "127.0528655",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3543,
    "name": "러닝랩원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 사임당로8길 13 402-93A호(서초동)",
    "lat": "37.4879302",
    "lng": "127.015649",
    "phoneNumber": "02-0000-0000",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3544,
    "name": "프리미어에듀원격학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 강남대로 309 11층8호(서초동)",
    "lat": "37.4905906",
    "lng": "127.0304516",
    "phoneNumber": "02-0000-0000",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 3545,
    "name": "공부의습관을잡아주는노정현수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 성촌1길 20 , 2층 201호(우면동)",
    "lat": "37.4655124",
    "lng": "127.021701",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3547,
    "name": "72시간공부캠프재수학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 사임당로 13 , 2층(서초동)",
    "lat": "37.4876905",
    "lng": "127.0116184",
    "phoneNumber": "02-1644-8695",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3548,
    "name": "젠지글로벌프렙학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 선릉로111길 6 , 1층 일부(좌측), 2층 전체(논현동)",
    "lat": "37.5110419",
    "lng": "127.0429529",
    "phoneNumber": "02-6713-3443",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3549,
    "name": "숨마스프렙학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 도산대로37길 5 4층5층(신사동)",
    "lat": "37.5212799",
    "lng": "127.0313081",
    "phoneNumber": "02-0000-0000",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3556,
    "name": "에스앤에스아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 논현로176길 22 2층(신사동)",
    "lat": "37.5272745",
    "lng": "127.0303366",
    "phoneNumber": "02-540-2705",
    "교습과정": "외국어",
    "isFinish": ""
  },
  {
    "number": 3559,
    "name": "대치파인만중2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 150 , 318호(대치동,한보미도맨션)",
    "lat": "37.4925906",
    "lng": "127.066184",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3561,
    "name": "시대인재에스(S)관부엉이라이브러리2독서실",
    "학원종류": "평생직업교육학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 삼성로57길 7 , 4층~6층(대치동)",
    "lat": "37.4979703",
    "lng": "127.0604757",
    "phoneNumber": "-",
    "교습과정": "독서실(일반인)",
    "isFinish": ""
  },
  {
    "number": 3562,
    "name": "룩스메아(Lux Mea)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로72길 10-12 3층 301호(대치동)",
    "lat": "37.4994433",
    "lng": "127.052337",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3563,
    "name": "잇셀프(itself)수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로63길 16 , 2층(대치동)",
    "lat": "37.498017",
    "lng": "127.0543059",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 3564,
    "name": "더노벨컨설팅학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도산대로6길 14 2층(논현동)",
    "lat": "37.5157284",
    "lng": "127.0216975",
    "phoneNumber": "02-6925-1260",
    "교습과정": "진학지도",
    "isFinish": ""
  },
  {
    "number": 3566,
    "name": "로고스멘토학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로24길 11 , 5층(서초동)",
    "lat": "37.494957",
    "lng": "127.0149147",
    "phoneNumber": "02-535-2283",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3567,
    "name": "뉴마스터즈아카데미(New Masters Academy)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로34길 11 , 602호(신사동, 압구정스퀘어)",
    "lat": "37.5273895",
    "lng": "127.030957",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3568,
    "name": "클레버댄스아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 압구정로34길 14 201호(신사동)",
    "lat": "37.5272356",
    "lng": "127.0305764",
    "phoneNumber": "02-409-1737",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 3569,
    "name": "브레인밸리특목관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로72길 9 , 2~5층(대치동)",
    "lat": "37.5020468",
    "lng": "127.0616573",
    "phoneNumber": "02-561-0196",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3570,
    "name": "이디비(EDB)어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 강남대로92길 13 7층 일부,8층 일부(역삼동)",
    "lat": "37.4990416",
    "lng": "127.0285148",
    "phoneNumber": "-",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 3572,
    "name": "프랩학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 언주로 313 (역삼동)",
    "lat": "37.5000776",
    "lng": "127.0385419",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3573,
    "name": "기파랑중등2관반포학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로8길 9 , 3층(반포동)",
    "lat": "37.5019759",
    "lng": "127.0102486",
    "phoneNumber": "02-593-2033",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3574,
    "name": "대치필2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 150 , 306호(대치동,한보미도맨션)",
    "lat": "37.4925906",
    "lng": "127.066184",
    "phoneNumber": "02-569-5164",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3575,
    "name": "브이하다입시학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동광로 68 2층(방배동)",
    "lat": "37.4924826",
    "lng": "126.9900687",
    "phoneNumber": "02-594-1335",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3580,
    "name": "콴다일로온라인원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 선릉로 428 17층 101호(대치동)",
    "lat": "37.5034457",
    "lng": "127.0498534",
    "phoneNumber": "02-6959-9233",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3582,
    "name": "도어즈연극연출아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 논현로28길 48 , 2층(도곡동)",
    "lat": "37.4843183",
    "lng": "127.045718",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3584,
    "name": "골든타임수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로72길 3 5층(대치동)",
    "lat": "37.502669",
    "lng": "127.0593989",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3585,
    "name": "아이씨엠영재교육학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로64길 32 3층(대치동)",
    "lat": "37.5004196",
    "lng": "127.0630716",
    "phoneNumber": "02-508-0420",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3587,
    "name": "코리아대학입시컨설팅학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로76길 22 2층(대치동)",
    "lat": "37.5042734",
    "lng": "127.0601842",
    "phoneNumber": "02-000-0000",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3590,
    "name": "엠아이고입컨설팅학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로94길 11 , 3층(삼성동)",
    "lat": "37.5061726",
    "lng": "127.049394",
    "phoneNumber": "-",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3594,
    "name": "바룸국어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 524 , 3층(대치동)",
    "lat": "37.4995124",
    "lng": "127.0637515",
    "phoneNumber": "02-574-5526",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3595,
    "name": "책나무대치개포독서논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 28 , 7층(개포동)",
    "lat": "37.4823209",
    "lng": "127.0613457",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3596,
    "name": "대치열린학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로63길 17 4층 401호(대치동)",
    "lat": "37.4995695",
    "lng": "127.0587383",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3598,
    "name": "동의엠성인고시원격학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 강남대로53길 8 6-157호(서초동)",
    "lat": "37.4945363",
    "lng": "127.0280183",
    "phoneNumber": "02-3453-7932",
    "교습과정": "성인고시",
    "isFinish": ""
  },
  {
    "number": 3599,
    "name": "대찬에스(S)관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로70길 5 3층, 4층, 5층(대치동)",
    "lat": "37.4970053",
    "lng": "127.0566182",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 3600,
    "name": "담엑터스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 주흥11길 30 (반포동) 2층, 3층",
    "lat": "37.5074101",
    "lng": "127.0181168",
    "phoneNumber": "-",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 3601,
    "name": "책나무대치독서논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 155 5층 509호, 510호(대치동)",
    "lat": "37.4944062",
    "lng": "127.0651765",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3602,
    "name": "하이웨이합격연구소원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로78길 22 205호 (대치동,대치삼성아파트 상가동)",
    "lat": "37.4965682",
    "lng": "127.0588507",
    "phoneNumber": "02-000-0000",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3603,
    "name": "아이워크옹클원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 언주로30길 13 C동 20층 2006호(도곡동,대림아크로빌, 대림아크로텔)",
    "lat": "37.4882525",
    "lng": "127.0511163",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3606,
    "name": "아이브레인아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 언주로 314 , 203호, 205호(역삼동)",
    "lat": "37.4959548",
    "lng": "127.0466573",
    "phoneNumber": "02-555-9678",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3608,
    "name": "서초프라임학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배로20길 34-4 , 2층, 3층(방배동)",
    "lat": "37.4861402",
    "lng": "126.9968386",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3611,
    "name": "압구정탑주니어영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 논현로176길 20 , 2층(신사동)",
    "lat": "37.5272323",
    "lng": "127.0301438",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3614,
    "name": "서초골든타임학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배로 245 2층 203호(방배동)",
    "lat": "37.4947875",
    "lng": "126.9888737",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3615,
    "name": "에피토미원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 테헤란로82길 15 (대치동) 11층 240호",
    "lat": "37.5060315",
    "lng": "127.0582357",
    "phoneNumber": "-",
    "교습과정": "진학지도",
    "isFinish": ""
  },
  {
    "number": 3616,
    "name": "서초대학가는길학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 효령로26길 9-12 , 2층(방배동)",
    "lat": "37.4801579",
    "lng": "126.9956358",
    "phoneNumber": "02-1522-1239",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3617,
    "name": "제이엠케이에듀케이션(JMK Education)어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 논현로155길 9 , 1층, 2층(신사동)",
    "lat": "37.5217043",
    "lng": "127.0272862",
    "phoneNumber": "-",
    "교습과정": "외국어",
    "isFinish": ""
  },
  {
    "number": 3619,
    "name": "세인트폴대치아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 역삼로 427 304호 400호 403호 601호(대치동)",
    "lat": "37.5017317",
    "lng": "127.0536855",
    "phoneNumber": "02-568-3345",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": "완료"
  },
  {
    "number": 3620,
    "name": "에어포유아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 강남대로 617 3층 202호(잠원동)",
    "lat": "37.5168713",
    "lng": "127.0186812",
    "phoneNumber": "02-0000-0000",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3621,
    "name": "이피유(EP.U)프렙학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로119길 45 , 3층(삼성동)",
    "lat": "37.5150848",
    "lng": "127.047825",
    "phoneNumber": "02-540-2287",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3622,
    "name": "헤브론영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로10길 23 , 3층(반포동)",
    "lat": "37.5006573",
    "lng": "127.0101895",
    "phoneNumber": "02-599-5553",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3623,
    "name": "돌파수학3관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 447 , 2층 일부, 5층 일부(1호)(대치동)",
    "lat": "37.5023983",
    "lng": "127.0559204",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습",
    "isFinish": "완료"
  },
  {
    "number": 3624,
    "name": "책나무개포독서논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 개포로22길 92 2층(개포동)",
    "lat": "37.4750941",
    "lng": "127.0528549",
    "phoneNumber": "02-578-5004",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3625,
    "name": "장문원격보습학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 봉은사로 302  101동 501호(역삼동)",
    "lat": "37.5086751",
    "lng": "127.0394774",
    "phoneNumber": "070-4115-0713",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3626,
    "name": "대치동입시컨설팅축최합에듀원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 테헤란로82길 15 11층 516호(대치동)",
    "lat": "37.5060315",
    "lng": "127.0582357",
    "phoneNumber": "070-8080-1519",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3629,
    "name": "올바른인재학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 언주로6길 10 1층,2층(개포동)",
    "lat": "37.4778502",
    "lng": "127.0581432",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3631,
    "name": "엠스트원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 테헤란로64길 13 , O301호(대치동,선릉역 풍림아이원레몬)",
    "lat": "37.5041457",
    "lng": "127.051482",
    "phoneNumber": "02-564-2110",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3633,
    "name": "엘브라운엠학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로64길 49 , 2층, 3층(대치동)",
    "lat": "37.5005966",
    "lng": "127.0625196",
    "phoneNumber": "02-3453-5587",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3634,
    "name": "영인에듀일본입시연구소원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 강남대로84길 23 1507-1호(역삼동)",
    "lat": "37.4971347",
    "lng": "127.0303771",
    "phoneNumber": "02-6959-1558",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3635,
    "name": "생각부터영어로학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로62길 9 (대치동) 4층",
    "lat": "37.4974494999999",
    "lng": "127.0534675",
    "phoneNumber": "-",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3637,
    "name": "큐브아카데미원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 반포대로 100 , 4층 402호(서초동)",
    "lat": "37.4892413",
    "lng": "127.0092675",
    "phoneNumber": "070-4633-0422",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3638,
    "name": "알고(Algo)원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 서운로6길 26 4층 4481호(서초동)",
    "lat": "37.485609",
    "lng": "127.0307989",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3640,
    "name": "헬린스잉글리쉬스튜디오(Helyn's English Studio)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로29길 16 5층(반포동)",
    "lat": "37.4989626",
    "lng": "127.0107021",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3641,
    "name": "피엔제이(PnJ)수학이좋다학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 반포대로 291 , 308호, 541호(반포동)",
    "lat": "37.4955764",
    "lng": "127.0056948",
    "phoneNumber": "02-595-7662",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3642,
    "name": "대치스터디학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로64길 32 , 2층(대치동)",
    "lat": "37.5004196",
    "lng": "127.0630716",
    "phoneNumber": "-",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3644,
    "name": "개포영독학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로6길 19 , 2층(개포동)",
    "lat": "37.4833390999999",
    "lng": "127.0624277",
    "phoneNumber": "02-578-4213",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3645,
    "name": "에이엠비(AMB)수학3관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배중앙로 200 (방배동) 4층",
    "lat": "37.4970245",
    "lng": "126.9856094",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3646,
    "name": "엔터스카이학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동광로 15 3층 2호(방배동)",
    "lat": "37.4910525",
    "lng": "126.9845609",
    "phoneNumber": "02-0000-0000",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3649,
    "name": "다즐영재교육학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 331 , 6층 601호 전체 (역삼동)",
    "lat": "37.4964861",
    "lng": "127.0522022",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3650,
    "name": "파레토프렙어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 압구정로30길 23 , 501호(신사동)",
    "lat": "37.5259481999999",
    "lng": "127.0294613",
    "phoneNumber": "02-000-0000",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3651,
    "name": "씨제스예술아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 언주로81길 26 3층(역삼동)",
    "lat": "37.4999162",
    "lng": "127.0415704",
    "phoneNumber": "02-539-0902",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 3654,
    "name": "강남킹스키즈어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 도곡로73길 31-1 , 2층, 3층(대치동)",
    "lat": "37.499847",
    "lng": "127.0562672",
    "phoneNumber": "02-3453-3453",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3657,
    "name": "반포특별관영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로 209 8층 801호(반포동)",
    "lat": "37.5003122",
    "lng": "127.0117761",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3659,
    "name": "수만휘스파르타강남역삼점학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 언주로 325 5층 일부(역삼동)",
    "lat": "37.4969157",
    "lng": "127.0449922",
    "phoneNumber": "02-569-1022",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3660,
    "name": "명성학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로 90-7 408호, 511호(서초동)",
    "lat": "37.4999482",
    "lng": "127.0174429",
    "phoneNumber": "02-3476-7399",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3662,
    "name": "대치다른수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로68길 8 , 4층, 5층(대치동)",
    "lat": "37.4988948",
    "lng": "127.0523641",
    "phoneNumber": "-",
    "교습과정": "보습",
    "isFinish": "완료"
  },
  {
    "number": 3663,
    "name": "책나무반포독서논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로 10-6 4층 402호(반포동)",
    "lat": "37.5035613",
    "lng": "127.0097219",
    "phoneNumber": "02-533-7779",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3664,
    "name": "더힐즈아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서래로 13 , 3층 301호(반포동)",
    "lat": "37.4962547",
    "lng": "126.9979698",
    "phoneNumber": "02-2135-6555",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3665,
    "name": "더드림아카데미(The Dream Academy)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 일원로14길 25 , 304호(일원동)",
    "lat": "37.4838689",
    "lng": "127.0808707",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3667,
    "name": "씨엠에스서초고등관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 사평대로20길 3 1층(반포동)",
    "lat": "37.4991483",
    "lng": "126.9972125",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3668,
    "name": "책나무도성초점학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로52길 14 (역삼동) 206호, 207호, 208호",
    "lat": "37.4985291",
    "lng": "127.0479489",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3669,
    "name": "돋을볕국어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로71길 20 3층 301호(대치동)",
    "lat": "37.5020151",
    "lng": "127.05723",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3671,
    "name": "디케이(DK)엠(M)수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로63길 7-5 , 2층, 3층(대치동)",
    "lat": "37.4995822",
    "lng": "127.0596698",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3674,
    "name": "대치델탑수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로77길 2 1층(대치동)",
    "lat": "37.5028387",
    "lng": "127.0566719",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3675,
    "name": "옵티마수학전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동광로 82-1 , 5층(방배동)",
    "lat": "37.4930896",
    "lng": "126.9915737",
    "phoneNumber": "-",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3677,
    "name": "세이드학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 511 , 3층(대치동)",
    "lat": "37.4996664",
    "lng": "127.0622284",
    "phoneNumber": "02-553-8973",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3679,
    "name": "이노블스강남영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로64길 12 6층 일부(대치동)",
    "lat": "37.4977814999999",
    "lng": "127.0532843",
    "phoneNumber": "02-566-0577",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3682,
    "name": "닥터(Dr.)현케이팝(K-POP)연구소학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 방배중앙로29길 21 401호(방배동)",
    "lat": "37.4964003",
    "lng": "126.9843346",
    "phoneNumber": "-",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 3683,
    "name": "에임과학반포관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로 18-4 6층 일부 정면(반포동)",
    "lat": "37.5029862",
    "lng": "127.0101362",
    "phoneNumber": "02-549-3737",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3684,
    "name": "압구정파인만삼성특별관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 학동로68길 7 , 206호, 207호, 208호(삼성동)",
    "lat": "37.5174448",
    "lng": "127.0467984",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3685,
    "name": "케이피에스에듀원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 강남대로53길 8 , 10층 19호(서초동)",
    "lat": "37.4945363",
    "lng": "127.0280183",
    "phoneNumber": "02-0000-0000",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3686,
    "name": "하이미대원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 테헤란로64길 13 1004호(대치동,선릉역 풍림아이원레몬)",
    "lat": "37.5041457",
    "lng": "127.051482",
    "phoneNumber": "-",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3687,
    "name": "코칭아카데미관리형독학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 318 201-1호(대치동)",
    "lat": "37.4980894",
    "lng": "127.0524088",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3688,
    "name": "케빈아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도산대로25길 15-9 1층(신사동)",
    "lat": "37.5204592",
    "lng": "127.0270338",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3690,
    "name": "오어댄스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 효령로 276 (서초동) 3층 303호",
    "lat": "37.4843873",
    "lng": "127.0144634",
    "phoneNumber": "-",
    "교습과정": "기타(중)",
    "isFinish": ""
  },
  {
    "number": 3691,
    "name": "모든에듀케이션학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 522 3층(대치동)",
    "lat": "37.4994597",
    "lng": "127.063584",
    "phoneNumber": "02-558-8034",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3692,
    "name": "101영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동광로 41 501호(방배동)",
    "lat": "37.4917512",
    "lng": "126.9872429",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3693,
    "name": "함성수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배중앙로 117 , 201호(방배동)",
    "lat": "37.4895726",
    "lng": "126.9873148",
    "phoneNumber": "-",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3694,
    "name": "띵크앤리드더대치영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2909 6층 603호(대치동)",
    "lat": "37.4922077",
    "lng": "127.0573813",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3695,
    "name": "디어퍼아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 압구정로30길 17 , 301호~302호(신사동)",
    "lat": "37.5263249",
    "lng": "127.0295435",
    "phoneNumber": "02-6958-7724",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3696,
    "name": "에듀플랜학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로64길 24 4층(대치동)",
    "lat": "37.4981312",
    "lng": "127.0542485",
    "phoneNumber": "02-000-0000",
    "교습과정": "보통교과",
    "isFinish": "완료"
  },
  {
    "number": 3697,
    "name": "대치디딤학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로63길 17 3층 301호-302호(대치동)",
    "lat": "37.4995695",
    "lng": "127.0587383",
    "phoneNumber": "02-6954-1132",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3698,
    "name": "파레토프렙아이비어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 압구정로34길 32 2층(신사동)",
    "lat": "37.5260396",
    "lng": "127.0305058",
    "phoneNumber": "-",
    "교습과정": "외국어",
    "isFinish": ""
  },
  {
    "number": 3699,
    "name": "레나과학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로75길 13 4층(대치동)",
    "lat": "37.5033037",
    "lng": "127.0572239",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3701,
    "name": "서초티오티(TOT)반포4관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로 8 , 2층(반포동)",
    "lat": "37.50366",
    "lng": "127.010008",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3702,
    "name": "큐리어스대치지점학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 150 321호(대치동,한보미도맨션)",
    "lat": "37.4925906",
    "lng": "127.066184",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3703,
    "name": "페트라영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 464-2 4층(대치동)",
    "lat": "37.5025331999999",
    "lng": "127.0580578",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3705,
    "name": "임기세수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동작대로 172 202호(방배동)",
    "lat": "37.4920142",
    "lng": "126.983247",
    "phoneNumber": "02-534-5559",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3706,
    "name": "미쌤영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동광로12가길 42 , 3층(방배동)",
    "lat": "37.4875536",
    "lng": "126.9826088",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3707,
    "name": "하이츠방배캠퍼스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동광로 19 3층(방배동, 삼전빌딩)",
    "lat": "37.4909886",
    "lng": "126.9851376",
    "phoneNumber": "02-595-5777",
    "교습과정": "보통교과",
    "isFinish": ""
  },
  {
    "number": 3708,
    "name": "뉴파인강남중등관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서운로11길 34 , 2층(서초동)",
    "lat": "37.4875884",
    "lng": "127.0265964",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3709,
    "name": "스터디피티원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로68길 17 1층, 102호(대치동)",
    "lat": "37.4993664",
    "lng": "127.0530655",
    "phoneNumber": "-",
    "교습과정": "보습",
    "isFinish": "완료"
  },
  {
    "number": 3710,
    "name": "그린램프라이브러리서초반포캠퍼스관리형독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 서초구 고무래로10길 26 7층 701호(반포동)",
    "lat": "37.5006911",
    "lng": "127.0096776",
    "phoneNumber": "02-000-0000",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3711,
    "name": "기파랑문해원대치원중등2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로64길 17 , 2층(대치동)",
    "lat": "37.4982437",
    "lng": "127.0536538",
    "phoneNumber": "-",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3712,
    "name": "수펙트럼수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 328 , 3층 1-4호(대치동)",
    "lat": "37.500753",
    "lng": "127.0746559",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3714,
    "name": "강남라라영어원격학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 선릉로 529 2층 2198호(역삼동)",
    "lat": "37.5066454",
    "lng": "127.0472246",
    "phoneNumber": "-",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 3715,
    "name": "한걸음입시논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로58길 13 , 3층(대치동)",
    "lat": "37.498845",
    "lng": "127.0623716",
    "phoneNumber": "02-552-9268",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3717,
    "name": "세이지바이디레이블원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 테헤란로 503 15층 1522호(삼성동)",
    "lat": "37.5073978",
    "lng": "127.0571913",
    "phoneNumber": "-",
    "교습과정": "외국어",
    "isFinish": ""
  },
  {
    "number": 3718,
    "name": "파인만영재고센터5관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 반포대로 304 , 7층 703호(잠원동)",
    "lat": "37.5061614",
    "lng": "127.0010832",
    "phoneNumber": "02-548-1755",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3719,
    "name": "제이엘씨잉글리시아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 40 5층(개포동)",
    "lat": "37.4832411999999",
    "lng": "127.0602378",
    "phoneNumber": "02-571-2571",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3720,
    "name": "시대인재원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로61길 8 1층 102호(대치동)",
    "lat": "37.4994602",
    "lng": "127.0597352",
    "phoneNumber": "02-1522-0568",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 3721,
    "name": "김앤최잘하는수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 남부순환로339길 72 4층 좌측(서초동, 목전빌딩)",
    "lat": "37.486172",
    "lng": "127.0214925",
    "phoneNumber": "-",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3722,
    "name": "원솔루션(onesolution)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 546 , 2층 201호(대치동)",
    "lat": "37.5042425",
    "lng": "127.0628906",
    "phoneNumber": "02-0000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3724,
    "name": "뉴튼아카데미제2캠퍼스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 도산대로26길 51 2층~4층(논현동)",
    "lat": "37.5158920999999",
    "lng": "127.0290356",
    "phoneNumber": "02-000-0000",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3725,
    "name": "기파랑국풀반포학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 반포대로 300 5층 1호의 좌측(잠원동)",
    "lat": "37.505956",
    "lng": "127.0011819",
    "phoneNumber": "02-532-3040",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3726,
    "name": "청진학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 논현로6길 13 , 3층 301호(개포동)",
    "lat": "37.4734966",
    "lng": "127.0505819",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3727,
    "name": "대치동지략원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 도곡로73길 13 103호(대치동)",
    "lat": "37.498738",
    "lng": "127.0569719",
    "phoneNumber": "02-000-0000",
    "교습과정": "진학상담지도",
    "isFinish": "완료"
  },
  {
    "number": 3728,
    "name": "대치에듀학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로63길 34 3층(대치동, 요안빌딩)",
    "lat": "37.4991366",
    "lng": "127.0537643",
    "phoneNumber": "-",
    "교습과정": "보습",
    "isFinish": "완료"
  },
  {
    "number": 3732,
    "name": "닥공독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 삼성로 315 4층·5층(대치동)",
    "lat": "37.4999536",
    "lng": "127.059922",
    "phoneNumber": "02-0000-0000",
    "교습과정": "독서실",
    "isFinish": ""
  },
  {
    "number": 3733,
    "name": "공부력수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 40 3층(개포동)",
    "lat": "37.4832411999999",
    "lng": "127.0602378",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3735,
    "name": "토피아어학원서초캠퍼스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 동광로 19 2층 5층(방배동)",
    "lat": "37.4910294",
    "lng": "126.9851359",
    "phoneNumber": "02-000-0000",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3736,
    "name": "핀란드문해력연구소문해사고관대치개포학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 40 4층(개포동)",
    "lat": "37.4832411999999",
    "lng": "127.0602378",
    "phoneNumber": "02-573-8873",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3737,
    "name": "세정대치관4층학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로63길 15-3 4층, (대치동)",
    "lat": "37.499511",
    "lng": "127.0589958",
    "phoneNumber": "02-567-0606",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3738,
    "name": "더뉴에듀케이션학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 언주로 850 3층(신사동)",
    "lat": "37.5263506",
    "lng": "127.0337175",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3739,
    "name": "클라라에듀학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로18길 8 3층 (신사동) ",
    "lat": "37.5242768",
    "lng": "127.0242794",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3740,
    "name": "청담메타씨어터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 강남구 선릉로132길 39 4층(청담동)",
    "lat": "37.5186631",
    "lng": "127.0443742",
    "phoneNumber": "02-539-3123",
    "교습과정": "기타(소)",
    "isFinish": ""
  },
  {
    "number": 3741,
    "name": "그린램프라이브러리한티캠퍼스관리형독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 역삼로52길 14 5층 501호~508호(역삼동)",
    "lat": "37.4985291",
    "lng": "127.0479489",
    "phoneNumber": "-",
    "교습과정": "독서실",
    "isFinish": ""
  },
  {
    "number": 3742,
    "name": "솔루션(Solution)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 452 301호(대치동)",
    "lat": "37.5021937",
    "lng": "127.056668",
    "phoneNumber": "-",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3743,
    "name": "김대장수학전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 반포대로 287 , 201-2호, 201-3호, 201-4호(반포동)",
    "lat": "37.5043394",
    "lng": "127.0008523",
    "phoneNumber": "02-535-3383",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3745,
    "name": "반포새움2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로 195 4층 8-1호, 9~12호, 19호, 20호, 21호 일부(우측)(잠원동, 반포쇼핑타운5동)",
    "lat": "37.5065891",
    "lng": "127.0052661",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3749,
    "name": "킨더링고프렙학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 논현로161길 13 601호(신사동)",
    "lat": "37.5243974",
    "lng": "127.0298895",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3750,
    "name": "리트챔에듀학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 언주로167길 35 , 3층(신사동)",
    "lat": "37.5263754",
    "lng": "127.0302672",
    "phoneNumber": "02-547-0137",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3751,
    "name": "매쓰파인더수학전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 효령로 202 , 4층(서초동)",
    "lat": "37.4828743",
    "lng": "127.0064093",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3752,
    "name": "진짜수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배로35길 41 3층(방배동)",
    "lat": "37.4921074",
    "lng": "126.9873013",
    "phoneNumber": "-",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3755,
    "name": "세정양지관3층학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로77길 14 , 302호(대치동)",
    "lat": "37.4992943",
    "lng": "127.0585913",
    "phoneNumber": "02-567-0606",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3757,
    "name": "피아이내신관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로64길 47 1층(대치동)",
    "lat": "37.5010124",
    "lng": "127.064121",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3758,
    "name": "대치학당학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 453 , 4층 402호(대치동)",
    "lat": "37.5026853",
    "lng": "127.056752",
    "phoneNumber": "-",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3759,
    "name": "애로우잉글리시원격학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 도산대로30길 13 4층(논현동)",
    "lat": "37.5190271",
    "lng": "127.0297705",
    "phoneNumber": "02-422-7124",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 3760,
    "name": "메사(MESA)인재라임트리관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로71길 18 6층(대치동)",
    "lat": "37.5021118",
    "lng": "127.0573859",
    "phoneNumber": "02-538-0101",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3763,
    "name": "브라이트마인즈영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로23길 78-15 1층, 2층(잠원동)",
    "lat": "37.512048",
    "lng": "127.0055769",
    "phoneNumber": "-",
    "교습과정": "입시·논술",
    "isFinish": ""
  },
  {
    "number": 3764,
    "name": "영누프라임원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 테헤란로 322 서관 11층 1201호(역삼동)",
    "lat": "37.5029732",
    "lng": "127.0465325",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3766,
    "name": "엠에스(MS)더함수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2933 3층 301호(대치동)",
    "lat": "37.4938988",
    "lng": "127.0610428",
    "phoneNumber": "02-501-1770",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3768,
    "name": "비욘드에듀케이션(Beyondeducation)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 논현로161길 13 , 4층(신사동)",
    "lat": "37.523335",
    "lng": "127.0270202",
    "phoneNumber": "-",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3769,
    "name": "대치다원영재5관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 343 5층 전체(대치동)",
    "lat": "37.5021222",
    "lng": "127.0587731",
    "phoneNumber": "02-3454-0492",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3771,
    "name": "띵크올리오학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 신반포로47길 18-6 , 4층 전체 (잠원동)",
    "lat": "37.51152",
    "lng": "127.0197778",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3772,
    "name": "대치다원영재4관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 343 1층 101호, 4층(대치동)",
    "lat": "37.5021222",
    "lng": "127.0587731",
    "phoneNumber": "02-3454-0492",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3776,
    "name": "대치창의열정3관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 343 3층 전체(대치동)",
    "lat": "37.5021222",
    "lng": "127.0587731",
    "phoneNumber": "02-3454-3366",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3777,
    "name": "대치창의열정2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 343 , 2층(대치동)",
    "lat": "37.5021222",
    "lng": "127.0587731",
    "phoneNumber": "02-3454-3366",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3778,
    "name": "강남이엠에이영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 헌릉로569길 25 , 2층 201호(세곡동)",
    "lat": "37.4667957",
    "lng": "127.0990587",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3779,
    "name": "대치개선교육6관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 343 6층 전체(대치동)",
    "lat": "37.5021222",
    "lng": "127.0587731",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3781,
    "name": "제이엘프랩스쿨(JLprepschool)원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 논현로168길 36 3층 325호(신사동)",
    "lat": "37.5232126999999",
    "lng": "127.0309526",
    "phoneNumber": "-",
    "교습과정": "외국어",
    "isFinish": ""
  },
  {
    "number": 3782,
    "name": "대치개선교육7관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 343 7층 전체(대치동)",
    "lat": "37.5021222",
    "lng": "127.0587731",
    "phoneNumber": "02-3454-0495",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3783,
    "name": "황금열쇠학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 404 , 2층 201호(대치동)",
    "lat": "37.5005204",
    "lng": "127.0514247",
    "phoneNumber": "02-567-0153",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3784,
    "name": "공명학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초대로 28 4층(방배동)",
    "lat": "37.4855242",
    "lng": "126.9855463",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3785,
    "name": "에듀셀파독학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 413 5층 일부(대치동)",
    "lat": "37.5012531",
    "lng": "127.0521636",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3786,
    "name": "페이스청담학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 학동로59길 24 1~4층(청담동,청담동 36-1 제1,2종근린생활시설)",
    "lat": "37.5188297",
    "lng": "127.0445253",
    "phoneNumber": "02-512-2373",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3787,
    "name": "에쓰디씨3학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 동광로10길 2 , 2층(방배동)",
    "lat": "37.4908356",
    "lng": "126.9858857",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3788,
    "name": "미래를향한수학컨설팅타임브릿지학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배중앙로 82 2층, 5층(방배동)",
    "lat": "37.4869561",
    "lng": "126.989488",
    "phoneNumber": "02-462-7698",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3790,
    "name": "홍생수원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로31길 6-9 ,4층 402호 (반포동)",
    "lat": "37.5005049",
    "lng": "127.0112256",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3792,
    "name": "송림서초관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 명달로9길 4 3층(방배동)",
    "lat": "37.4821362",
    "lng": "127.004506",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3793,
    "name": "윌비스한림법학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "인문사회(대)",
    "학원주소\t": "서울특별시 강남구 테헤란로19길 20 2~3층(역삼동)",
    "lat": "37.5013833",
    "lng": "127.0333938",
    "phoneNumber": "-",
    "교습과정": "성인고시",
    "isFinish": ""
  },
  {
    "number": 3795,
    "name": "대치클립학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로64길 12 5층(대치동)",
    "lat": "37.4977814999999",
    "lng": "127.0532843",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3796,
    "name": "톡플레이스(Talk Place)어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 반포대로30길 66 , 6층(서초동)",
    "lat": "37.4924031",
    "lng": "127.0121709",
    "phoneNumber": "-",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 3798,
    "name": "미적공간학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로76길 26 2층(대치동)",
    "lat": "37.5017991",
    "lng": "127.0526984",
    "phoneNumber": "-",
    "교습과정": "진학상담지도",
    "isFinish": "완료"
  },
  {
    "number": 3799,
    "name": "이스트랩3030어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 개포로22길 46 3층 301호(개포동)",
    "lat": "37.4762542",
    "lng": "127.0496255",
    "phoneNumber": "-",
    "교습과정": "외국어",
    "isFinish": ""
  },
  {
    "number": 3802,
    "name": "마스터아이비학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 압구정로36길 12 501호(신사동)",
    "lat": "37.5276627",
    "lng": "127.0313419",
    "phoneNumber": "-",
    "교습과정": "외국어",
    "isFinish": ""
  },
  {
    "number": 3803,
    "name": "푸른아카데미서초캠퍼스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 명달로8길 21 , 3층 (서초동)",
    "lat": "37.4818244999999",
    "lng": "127.0063355",
    "phoneNumber": "-",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3804,
    "name": "비콘키즈에듀학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 논현로161길 57 4~5층(신사동)",
    "lat": "37.5222439",
    "lng": "127.023709",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3807,
    "name": "퍼스러너학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로8길 13 , 3층 전체(개포동)",
    "lat": "37.4832696",
    "lng": "127.0617437",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3809,
    "name": "어쎈디움학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로76길 30 , 4층 전체(대치동)",
    "lat": "37.5019153",
    "lng": "127.053055",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3810,
    "name": "미술탐구학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로63길 5 , 4층(대치동)",
    "lat": "37.5015024",
    "lng": "127.0522091",
    "phoneNumber": "02-556-3690",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3812,
    "name": "반포점짱솔학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로 215 2층 일부(반포동)",
    "lat": "37.5008237",
    "lng": "127.0116599",
    "phoneNumber": "02-595-0995",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3816,
    "name": "에스피더블유에이(SPWA)아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "기타(대)",
    "학원주소\t": "서울특별시 서초구 신반포로47길 16 , 2층(잠원동)",
    "lat": "37.5114625",
    "lng": "127.0195905",
    "phoneNumber": "-",
    "교습과정": "기타(중)",
    "isFinish": ""
  },
  {
    "number": 3817,
    "name": "누보영어원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 강남대로 354 , 11층 934호(역삼동)",
    "lat": "37.4946494",
    "lng": "127.0297257",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3818,
    "name": "이든수학3관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 532 , 5층 501호(대치동)",
    "lat": "37.4997795",
    "lng": "127.0645688",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3819,
    "name": "더에스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로63길 26 , 2층(대치동)",
    "lat": "37.4987188",
    "lng": "127.053969",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3820,
    "name": "노벨학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 논현로 404 , 3층 3호(역삼동)",
    "lat": "37.4962202",
    "lng": "127.039397",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3822,
    "name": "삼광잉글리쉬에듀대치학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로64길 15-13 1층, 2층(대치동)",
    "lat": "37.4988744",
    "lng": "127.0530745",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3823,
    "name": "개념상상서초관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 명달로9길 6 2층 전체, 3층 일부(방배동)",
    "lat": "37.4821422",
    "lng": "127.0042854",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3825,
    "name": "메이저프렙어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 도곡로99길 16 5층(대치동)",
    "lat": "37.5018594",
    "lng": "127.0660032",
    "phoneNumber": "02-547-1643",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3826,
    "name": "세정입시관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 선릉로64길 8-1 , 2층, 5층, 6층(대치동)",
    "lat": "37.4975995",
    "lng": "127.0531668",
    "phoneNumber": "02-567-0606",
    "교습과정": "진학상담지도",
    "isFinish": "완료"
  },
  {
    "number": 3828,
    "name": "유로스쿨원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 선릉로 428 15층 111호(대치동)",
    "lat": "37.5034457",
    "lng": "127.0498534",
    "phoneNumber": "02-000-0000",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3829,
    "name": "시그랩스수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로62길 17 ,4층 (대치동)",
    "lat": "37.4976008999999",
    "lng": "127.0538766",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 3830,
    "name": "센티움2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로 144 , 301호(신사동)",
    "lat": "37.5249575",
    "lng": "127.0246028",
    "phoneNumber": "02-543-9095",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3831,
    "name": "역사화랑서초학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 고무래로10길 26 503호(반포동)",
    "lat": "37.5006911",
    "lng": "127.0096776",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3832,
    "name": "베리타스변호사학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "인문사회(대)",
    "학원주소\t": "서울특별시 강남구 선릉로62길 9 301호, 302호, 501호(대치동)",
    "lat": "37.4974494999999",
    "lng": "127.0534675",
    "phoneNumber": "02-564-5557",
    "교습과정": "성인고시",
    "isFinish": "완료"
  },
  {
    "number": 3833,
    "name": "대치솔루션(SOLUTION)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 527 4층 일부(대치동)",
    "lat": "37.504033",
    "lng": "127.0606399",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3834,
    "name": "블루랩수학전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도산대로35길 39 , 401호(신사동)",
    "lat": "37.5234929999999",
    "lng": "127.0303445",
    "phoneNumber": "02-544-7707",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3835,
    "name": "맥스포텐수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 456-2 , 3층(대치동)",
    "lat": "37.5022767",
    "lng": "127.0572869",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3836,
    "name": "그리날다원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로76길 5-13 , 1층(대치동)",
    "lat": "37.5022652",
    "lng": "127.0505368",
    "phoneNumber": "02-538-3757",
    "교습과정": "진학지도",
    "isFinish": "완료"
  },
  {
    "number": 3837,
    "name": "프라임스톤컨설팅학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도산대로37길 19 , 3층(신사동)",
    "lat": "37.5223027",
    "lng": "127.0311474",
    "phoneNumber": "02-6209-2585",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3838,
    "name": "이현직학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로76길 30 3층(대치동)",
    "lat": "37.5019153",
    "lng": "127.053055",
    "phoneNumber": "02-441-5040",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3839,
    "name": "세이지프렙어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 논현로158길 8 2층(201호,202호)(신사동)",
    "lat": "37.5219803",
    "lng": "127.0290759",
    "phoneNumber": "02-000-0000",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3840,
    "name": "아트로직원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 서초구 서초중앙로8길 89-2 , 지하2층 6호(서초동)",
    "lat": "37.4871438",
    "lng": "127.0204655",
    "phoneNumber": "-",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3841,
    "name": "키즈스피치예소스대치센터학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 404 , 3층(대치동)",
    "lat": "37.5005204",
    "lng": "127.0514247",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 3842,
    "name": "피엘에스(PLS)영재교육학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 논현로10길 16 , 4층(개포동)",
    "lat": "37.4743159",
    "lng": "127.0499485",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3843,
    "name": "스타매쓰스터디학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 논현로175길 40 , 2층(신사동)",
    "lat": "37.5250912",
    "lng": "127.0253317",
    "phoneNumber": "02-515-2792",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3844,
    "name": "생크2학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 459 , 2층 일부 (대치동)",
    "lat": "37.5028727",
    "lng": "127.0573232",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3846,
    "name": "이튼프렙(ETONPREP)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로 108 2층(신사동)",
    "lat": "37.5229191",
    "lng": "127.0205789",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3849,
    "name": "수학의힘대치학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 221 , 3층(대치동)",
    "lat": "37.4967029",
    "lng": "127.061731",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3850,
    "name": "뉴런사이언스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 417 , 4층(대치동)",
    "lat": "37.5013862",
    "lng": "127.0526773",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 3854,
    "name": "모티브아카데미(MotivAcademy)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 압구정로30길 63 2층(신사동)",
    "lat": "37.5232284",
    "lng": "127.0291414",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3855,
    "name": "리틀러시문해력대치학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로64길 12 4층(대치동)",
    "lat": "37.4977814999999",
    "lng": "127.0532843",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3856,
    "name": "강남대성원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "종합(대)",
    "학원주소\t": "서울특별시 강남구 테헤란로4길 38-4 2층 일부(역삼동)",
    "lat": "37.4959565",
    "lng": "127.0302668",
    "phoneNumber": "02-581-7888",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3857,
    "name": "영어설계소대치학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로64길 17 , 3층(대치동)",
    "lat": "37.4982437",
    "lng": "127.0536538",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3858,
    "name": "독학재수의대선배강남서초관리형수능학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 효령로 202 2층(서초동)",
    "lat": "37.4828743",
    "lng": "127.0064093",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3860,
    "name": "에듀플렉스에듀코치개별지도대치별관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 212 B블록 301-11호(대치동,은마아파트)",
    "lat": "37.4974176",
    "lng": "127.0653272",
    "phoneNumber": "02-555-1623",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3861,
    "name": "드래그앤드롭원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 테헤란로78길 14-6 6층 TRAY612호(대치동)",
    "lat": "37.505322",
    "lng": "127.0549631",
    "phoneNumber": "02-6952-4420",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3862,
    "name": "에스알피(SRP)에듀원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 114 8층 32호(역삼동)",
    "lat": "37.4931589",
    "lng": "127.0316733",
    "phoneNumber": "02-6956-2434",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3863,
    "name": "엘리트신사어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 논현로152길 21 , 1층(신사동)",
    "lat": "37.5214085",
    "lng": "127.0297925",
    "phoneNumber": "-",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3864,
    "name": "지이엠어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 삼성로 14 교육연구시설동 1층, 2층(개포동,개포자이 프레지던스)",
    "lat": "37.4855370999999",
    "lng": "127.0714351",
    "phoneNumber": "-",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3867,
    "name": "브이씨에이(VCA)서울학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 압구정로30길 75 1~4층(신사동)",
    "lat": "37.5223657",
    "lng": "127.0290774",
    "phoneNumber": "02-556-3888",
    "교습과정": "외국어",
    "isFinish": ""
  },
  {
    "number": 3868,
    "name": "크리스스파르타토플어학원",
    "학원종류": "평생직업교육학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 강남대로92길 31 5층 일부(역삼동)",
    "lat": "37.4994382",
    "lng": "127.0299152",
    "phoneNumber": "02-6953-3677",
    "교습과정": "어학(성인)",
    "isFinish": ""
  },
  {
    "number": 3869,
    "name": "대치영독학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2909 2층 203호, 204호(대치동)",
    "lat": "37.4922077",
    "lng": "127.0573813",
    "phoneNumber": "02-578-6589",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3870,
    "name": "모아학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 논현로158길 28 1층(신사동)",
    "lat": "37.5219129",
    "lng": "127.030642",
    "phoneNumber": "-",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3871,
    "name": "에스알피(SRP)에듀학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 강남대로96길 16 4층 전체, 5층 일부(역삼동)",
    "lat": "37.4998161",
    "lng": "127.028318",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3872,
    "name": "솔로몬입시컨설팅학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로70길 28 2층(대치동)",
    "lat": "37.4996713",
    "lng": "127.054138",
    "phoneNumber": "-",
    "교습과정": "보통교과",
    "isFinish": ""
  },
  {
    "number": 3873,
    "name": "피에스유(PSU)유학컨설팅어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 논현로167길 19 3층 일부(신사동)",
    "lat": "37.5244905",
    "lng": "127.026487",
    "phoneNumber": "02-540-2510",
    "교습과정": "외국어",
    "isFinish": ""
  },
  {
    "number": 3874,
    "name": "이지스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2909 7층 703호(대치동)",
    "lat": "37.4922077",
    "lng": "127.0573813",
    "phoneNumber": "02-569-2168",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3875,
    "name": "아르덴영어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로72길 10-12 , 5층(대치동)",
    "lat": "37.4994433",
    "lng": "127.052337",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3876,
    "name": "책나무방배국어논술학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배중앙로 114 202호(방배동)",
    "lat": "37.4894396",
    "lng": "126.9878758",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3877,
    "name": "탑티어중고등관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 남부순환로 2941 602호 일부, 603호(대치동)",
    "lat": "37.4942268",
    "lng": "127.0617852",
    "phoneNumber": "02-561-0788",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3878,
    "name": "생각의탄생원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 강남대로94길 28 B2층 L3호(역삼동)",
    "lat": "37.4996247",
    "lng": "127.0295905",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3879,
    "name": "이음수학전문학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배로13길 19 3층 301호(방배동)",
    "lat": "37.4827038",
    "lng": "126.9954039",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3881,
    "name": "자언학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 언주로 120 , 401호 일부(도곡동)",
    "lat": "37.4867517",
    "lng": "127.051259",
    "phoneNumber": "02-2135-3318",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3882,
    "name": "포도클럽(PODO club)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 강남구 논현로153길 45 , 2~4층(신사동)",
    "lat": "37.5203336999999",
    "lng": "127.0245287",
    "phoneNumber": "02-790-8580",
    "교습과정": "실용외국어(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3883,
    "name": "포도아카데미학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 논현로153길 45 , 1층(신사동)",
    "lat": "37.5203336999999",
    "lng": "127.0245287",
    "phoneNumber": "02-790-8580",
    "교습과정": "보습",
    "isFinish": ""
  },
  {
    "number": 3884,
    "name": "돌파수학서초관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초중앙로 176 3~4층(서초동)",
    "lat": "37.4975085",
    "lng": "127.0131622",
    "phoneNumber": "02-533-3382",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3886,
    "name": "어라이벌수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 방배로 121 3층(방배동)",
    "lat": "37.4848787",
    "lng": "126.9951037",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3890,
    "name": "원(元)수학신관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로61길 15 (대치동, 킴스타워) 1층, 4층 전체",
    "lat": "37.499055",
    "lng": "127.0591369",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3891,
    "name": "대치글로리엔(N)수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 341 , 7층(대치동)",
    "lat": "37.5019016",
    "lng": "127.0589304",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3892,
    "name": "렉시스강남3캠퍼스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 강남대로53길 7 , 14층 1402호, 1403호, 1404호(서초동)",
    "lat": "37.494251",
    "lng": "127.0282336",
    "phoneNumber": "-",
    "교습과정": "외국어",
    "isFinish": ""
  },
  {
    "number": 3894,
    "name": "대치동사령부학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 460 , 1층 101호(대치동)",
    "lat": "37.5025547",
    "lng": "127.0575957",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3895,
    "name": "전기가오리독서논술원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로63길 26 , 301-2호(대치동)",
    "lat": "37.4987188",
    "lng": "127.053969",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3896,
    "name": "수학원리탐구학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 453 ,5층 502호(대치동)",
    "lat": "37.5026853",
    "lng": "127.056752",
    "phoneNumber": "02-561-1239",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3897,
    "name": "브레인밸리인재관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로72길 12 ,B101호, B102호, B103호(대치동,대치푸르지오써밋)",
    "lat": "37.5017783",
    "lng": "127.0616293",
    "phoneNumber": "02-561-0196",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3899,
    "name": "하이매쓰수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로 184 , 602호(도곡동)",
    "lat": "37.4879814",
    "lng": "127.0453988",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3900,
    "name": "수학대가학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도산대로17길 27 ,2층(신사동)",
    "lat": "37.5204978",
    "lng": "127.0241567",
    "phoneNumber": "02-549-5490",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3901,
    "name": "아이팩토리원격학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 도곡로77길 26 ,지하1층(대치동)",
    "lat": "37.4999822",
    "lng": "127.058129",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3904,
    "name": "시대인재트러스관2학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 312 (,3층, 4층(대치동)",
    "lat": "37.4998704",
    "lng": "127.0607488",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3905,
    "name": "시대인재트러스관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 312 2층(대치동)",
    "lat": "37.4998704",
    "lng": "127.0607488",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3906,
    "name": "시대인재트러스관3학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 312 5~7층(대치동)",
    "lat": "37.4998704",
    "lng": "127.0607488",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3908,
    "name": "에듀플렉스에듀코치개별지도대치2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 212 은마상가 A블록 305-2호(대치동)",
    "lat": "37.4954127",
    "lng": "127.0636485",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3912,
    "name": "박정은어학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 광평로31길 27 , 202호, 202-1호, 202-2호(수서동,삼성아파트)",
    "lat": "37.4848958",
    "lng": "127.0906778",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3914,
    "name": "잇올몰입관강남독학재수학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 강남대로78길 12 , 4층 일부(복도 우측)(역삼동)",
    "lat": "37.4948619",
    "lng": "127.0303579",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3915,
    "name": "잇올몰입관강남관리형독서실",
    "학원종류": "학교교과교습학원",
    "분야구분": "독서실",
    "학원주소\t": "서울특별시 강남구 강남대로78길 12 , 3층, 4층 일부(복도 좌측)(역삼동)",
    "lat": "37.4948619",
    "lng": "127.0303579",
    "phoneNumber": "-",
    "교습과정": "독서실(유아/초·중·고)",
    "isFinish": ""
  },
  {
    "number": 3916,
    "name": "아우라에듀3학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로 441 ,7층 701호(대치동)",
    "lat": "37.5022141",
    "lng": "127.0551232",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 3917,
    "name": "수능선배강남2호점학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초대로78길 50 , 5층 501호(서초동)",
    "lat": "37.4933606",
    "lng": "127.0286652",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3918,
    "name": "일공학원서초캠퍼스학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "국제화",
    "학원주소\t": "서울특별시 서초구 서초대로78길 36 , 6층 601호(서초동)",
    "lat": "37.4947876",
    "lng": "127.0281223",
    "phoneNumber": "02-523-1096",
    "교습과정": "외국어",
    "isFinish": ""
  },
  {
    "number": 3919,
    "name": "잇셀프수학2관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 309-1 , 6층 전체(역삼동)",
    "lat": "37.4970581",
    "lng": "127.0522491",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3921,
    "name": "해일입시컨설팅학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 남부순환로339길 60 , 3층 302호 일부(서초동)",
    "lat": "37.4857215",
    "lng": "127.021693",
    "phoneNumber": "-",
    "교습과정": "진학상담지도",
    "isFinish": ""
  },
  {
    "number": 3922,
    "name": "대치넥서스수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 역삼로64길 22 , 5층 501호(대치동)",
    "lat": "37.4995919",
    "lng": "127.0532085",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3923,
    "name": "마스터키수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 헌릉로 569 2층 201호(세곡동, 강남리더스프라자)",
    "lat": "37.4657816",
    "lng": "127.1011914",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3924,
    "name": "수학고래리드앤톡학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 서초구 서초대로19길 120 , 2층 일부(202호)(방배동)",
    "lat": "37.4918884",
    "lng": "126.9886557",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3925,
    "name": "에스엠씨프라임관학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 자곡로 108 , 502호, 503호(자곡동)",
    "lat": "37.4719652",
    "lng": "127.0953764",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3926,
    "name": "대치예원학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로64길 30 , 3~4층(대치동)",
    "lat": "37.5003215",
    "lng": "127.0628226",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": ""
  },
  {
    "number": 3927,
    "name": "안현수학학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 선릉로 402 301호(대치동)",
    "lat": "37.5008108",
    "lng": "127.0510086",
    "phoneNumber": "-",
    "교습과정": "보습·논술",
    "isFinish": "완료"
  },
  {
    "number": 3928,
    "name": "대치탑엠케이(MK)학원",
    "학원종류": "학교교과교습학원",
    "분야구분": "입시.검정 및 보습",
    "학원주소\t": "서울특별시 강남구 삼성로 225 , 4층 405호~406호 (대치동, 아주빌딩)",
    "lat": "37.4971281",
    "lng": "127.0614078",
    "phoneNumber": "02-538-0935",
    "교습과정": "보습·논술",
    "isFinish": ""
  }
];

export default mapdata3;